import { gql } from 'urql';
import * as Urql from 'urql';

      export const assertBrandedString : <T>(a: unknown) => asserts a is T = (a) => {
        if (typeof a !== 'string') throw new Error(`${a} is not string`);
      }
      
export type DateString = string & { __dateStringBrand: never };
export type TimestampString = string & { __timestampStringBrand: never };
export type UuidString = string & { __UuidStringBrand: never };
export type Event = 'open' | 'close';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: number;
  float8: number;
  timestamp: TimestampString;
  uuid: UuidString;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type InsertGuestExaineesDerivedInput = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type InsertGuestExamineeMailsOutput = {
  __typename?: 'InsertGuestExamineeMailsOutput';
  guestExamineeIds: Array<Scalars['uuid']>;
};

export type InsertGuestExamineesDerivedOutput = {
  __typename?: 'InsertGuestExamineesDerivedOutput';
  guestExamineeIds: Array<Scalars['uuid']>;
};

export type InsertMembershipsOneDerivedOutput = {
  __typename?: 'InsertMembershipsOneDerivedOutput';
  User?: Maybe<Users>;
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  groupInvitation?: Maybe<GroupInvitations>;
  ownership?: Maybe<Ownerships>;
  userId: Scalars['uuid'];
};

export type InsertStaffsOneDerivedOutput = {
  __typename?: 'InsertStaffsOneDerivedOutput';
  id: Scalars['uuid'];
  staffInvitation?: Maybe<StaffInvitations>;
  user?: Maybe<Users>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "diagnoses" */
export type Diagnoses = {
  __typename?: 'diagnoses';
  /** An object relationship */
  diagnosisType?: Maybe<DiagnosisTypes>;
  diagnosisTypeCode: Scalars['String'];
  /** An array relationship */
  eventDiagnoses: Array<EventDiagnoses>;
  /** An aggregate relationship */
  eventDiagnoses_aggregate: EventDiagnoses_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  questions: Array<Questions>;
  /** An aggregate relationship */
  questions_aggregate: Questions_Aggregate;
  /** An array relationship */
  scoreTypes: Array<ScoreTypes>;
  /** An aggregate relationship */
  scoreTypes_aggregate: ScoreTypes_Aggregate;
};


/** columns and relationships of "diagnoses" */
export type DiagnosesEventDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


/** columns and relationships of "diagnoses" */
export type DiagnosesEventDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


/** columns and relationships of "diagnoses" */
export type DiagnosesQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** columns and relationships of "diagnoses" */
export type DiagnosesQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** columns and relationships of "diagnoses" */
export type DiagnosesScoreTypesArgs = {
  distinct_on?: InputMaybe<Array<ScoreTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScoreTypes_Order_By>>;
  where?: InputMaybe<ScoreTypes_Bool_Exp>;
};


/** columns and relationships of "diagnoses" */
export type DiagnosesScoreTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ScoreTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScoreTypes_Order_By>>;
  where?: InputMaybe<ScoreTypes_Bool_Exp>;
};

/** aggregated selection of "diagnoses" */
export type Diagnoses_Aggregate = {
  __typename?: 'diagnoses_aggregate';
  aggregate?: Maybe<Diagnoses_Aggregate_Fields>;
  nodes: Array<Diagnoses>;
};

export type Diagnoses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Diagnoses_Aggregate_Bool_Exp_Count>;
};

export type Diagnoses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Diagnoses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Diagnoses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "diagnoses" */
export type Diagnoses_Aggregate_Fields = {
  __typename?: 'diagnoses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Diagnoses_Max_Fields>;
  min?: Maybe<Diagnoses_Min_Fields>;
};


/** aggregate fields of "diagnoses" */
export type Diagnoses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Diagnoses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "diagnoses" */
export type Diagnoses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Diagnoses_Max_Order_By>;
  min?: InputMaybe<Diagnoses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "diagnoses" */
export type Diagnoses_Arr_Rel_Insert_Input = {
  data: Array<Diagnoses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Diagnoses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "diagnoses". All fields are combined with a logical 'AND'. */
export type Diagnoses_Bool_Exp = {
  _and?: InputMaybe<Array<Diagnoses_Bool_Exp>>;
  _not?: InputMaybe<Diagnoses_Bool_Exp>;
  _or?: InputMaybe<Array<Diagnoses_Bool_Exp>>;
  diagnosisType?: InputMaybe<DiagnosisTypes_Bool_Exp>;
  diagnosisTypeCode?: InputMaybe<String_Comparison_Exp>;
  eventDiagnoses?: InputMaybe<EventDiagnoses_Bool_Exp>;
  eventDiagnoses_aggregate?: InputMaybe<EventDiagnoses_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  questions?: InputMaybe<Questions_Bool_Exp>;
  questions_aggregate?: InputMaybe<Questions_Aggregate_Bool_Exp>;
  scoreTypes?: InputMaybe<ScoreTypes_Bool_Exp>;
  scoreTypes_aggregate?: InputMaybe<ScoreTypes_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "diagnoses" */
export enum Diagnoses_Constraint {
  /** unique or primary key constraint on columns "id" */
  DiagnosesPkey = 'diagnoses_pkey'
}

/** input type for inserting data into table "diagnoses" */
export type Diagnoses_Insert_Input = {
  diagnosisType?: InputMaybe<DiagnosisTypes_Obj_Rel_Insert_Input>;
  diagnosisTypeCode?: InputMaybe<Scalars['String']>;
  eventDiagnoses?: InputMaybe<EventDiagnoses_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Questions_Arr_Rel_Insert_Input>;
  scoreTypes?: InputMaybe<ScoreTypes_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Diagnoses_Max_Fields = {
  __typename?: 'diagnoses_max_fields';
  diagnosisTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "diagnoses" */
export type Diagnoses_Max_Order_By = {
  diagnosisTypeCode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Diagnoses_Min_Fields = {
  __typename?: 'diagnoses_min_fields';
  diagnosisTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "diagnoses" */
export type Diagnoses_Min_Order_By = {
  diagnosisTypeCode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "diagnoses" */
export type Diagnoses_Mutation_Response = {
  __typename?: 'diagnoses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Diagnoses>;
};

/** input type for inserting object relation for remote table "diagnoses" */
export type Diagnoses_Obj_Rel_Insert_Input = {
  data: Diagnoses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Diagnoses_On_Conflict>;
};

/** on_conflict condition type for table "diagnoses" */
export type Diagnoses_On_Conflict = {
  constraint: Diagnoses_Constraint;
  update_columns?: Array<Diagnoses_Update_Column>;
  where?: InputMaybe<Diagnoses_Bool_Exp>;
};

/** Ordering options when selecting data from "diagnoses". */
export type Diagnoses_Order_By = {
  diagnosisType?: InputMaybe<DiagnosisTypes_Order_By>;
  diagnosisTypeCode?: InputMaybe<Order_By>;
  eventDiagnoses_aggregate?: InputMaybe<EventDiagnoses_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  questions_aggregate?: InputMaybe<Questions_Aggregate_Order_By>;
  scoreTypes_aggregate?: InputMaybe<ScoreTypes_Aggregate_Order_By>;
};

/** primary key columns input for table: diagnoses */
export type Diagnoses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "diagnoses" */
export enum Diagnoses_Select_Column {
  /** column name */
  DiagnosisTypeCode = 'diagnosisTypeCode',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "diagnoses" */
export type Diagnoses_Set_Input = {
  diagnosisTypeCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "diagnoses" */
export type Diagnoses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Diagnoses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Diagnoses_Stream_Cursor_Value_Input = {
  diagnosisTypeCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "diagnoses" */
export enum Diagnoses_Update_Column {
  /** column name */
  DiagnosisTypeCode = 'diagnosisTypeCode',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Diagnoses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Diagnoses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Diagnoses_Bool_Exp;
};

/** columns and relationships of "diagnosisTypes" */
export type DiagnosisTypes = {
  __typename?: 'diagnosisTypes';
  code: Scalars['String'];
  /** An array relationship */
  diagnoses: Array<Diagnoses>;
  /** An aggregate relationship */
  diagnoses_aggregate: Diagnoses_Aggregate;
};


/** columns and relationships of "diagnosisTypes" */
export type DiagnosisTypesDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<Diagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnoses_Order_By>>;
  where?: InputMaybe<Diagnoses_Bool_Exp>;
};


/** columns and relationships of "diagnosisTypes" */
export type DiagnosisTypesDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Diagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnoses_Order_By>>;
  where?: InputMaybe<Diagnoses_Bool_Exp>;
};

/** aggregated selection of "diagnosisTypes" */
export type DiagnosisTypes_Aggregate = {
  __typename?: 'diagnosisTypes_aggregate';
  aggregate?: Maybe<DiagnosisTypes_Aggregate_Fields>;
  nodes: Array<DiagnosisTypes>;
};

/** aggregate fields of "diagnosisTypes" */
export type DiagnosisTypes_Aggregate_Fields = {
  __typename?: 'diagnosisTypes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DiagnosisTypes_Max_Fields>;
  min?: Maybe<DiagnosisTypes_Min_Fields>;
};


/** aggregate fields of "diagnosisTypes" */
export type DiagnosisTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DiagnosisTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "diagnosisTypes". All fields are combined with a logical 'AND'. */
export type DiagnosisTypes_Bool_Exp = {
  _and?: InputMaybe<Array<DiagnosisTypes_Bool_Exp>>;
  _not?: InputMaybe<DiagnosisTypes_Bool_Exp>;
  _or?: InputMaybe<Array<DiagnosisTypes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  diagnoses?: InputMaybe<Diagnoses_Bool_Exp>;
  diagnoses_aggregate?: InputMaybe<Diagnoses_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "diagnosisTypes" */
export enum DiagnosisTypes_Constraint {
  /** unique or primary key constraint on columns "code" */
  DiagnosisTypesPkey = 'diagnosisTypes_pkey'
}

/** input type for inserting data into table "diagnosisTypes" */
export type DiagnosisTypes_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  diagnoses?: InputMaybe<Diagnoses_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type DiagnosisTypes_Max_Fields = {
  __typename?: 'diagnosisTypes_max_fields';
  code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DiagnosisTypes_Min_Fields = {
  __typename?: 'diagnosisTypes_min_fields';
  code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "diagnosisTypes" */
export type DiagnosisTypes_Mutation_Response = {
  __typename?: 'diagnosisTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DiagnosisTypes>;
};

/** input type for inserting object relation for remote table "diagnosisTypes" */
export type DiagnosisTypes_Obj_Rel_Insert_Input = {
  data: DiagnosisTypes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DiagnosisTypes_On_Conflict>;
};

/** on_conflict condition type for table "diagnosisTypes" */
export type DiagnosisTypes_On_Conflict = {
  constraint: DiagnosisTypes_Constraint;
  update_columns?: Array<DiagnosisTypes_Update_Column>;
  where?: InputMaybe<DiagnosisTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "diagnosisTypes". */
export type DiagnosisTypes_Order_By = {
  code?: InputMaybe<Order_By>;
  diagnoses_aggregate?: InputMaybe<Diagnoses_Aggregate_Order_By>;
};

/** primary key columns input for table: diagnosisTypes */
export type DiagnosisTypes_Pk_Columns_Input = {
  code: Scalars['String'];
};

/** select columns of table "diagnosisTypes" */
export enum DiagnosisTypes_Select_Column {
  /** column name */
  Code = 'code'
}

/** input type for updating data in table "diagnosisTypes" */
export type DiagnosisTypes_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "diagnosisTypes" */
export type DiagnosisTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DiagnosisTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DiagnosisTypes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
};

/** update columns of table "diagnosisTypes" */
export enum DiagnosisTypes_Update_Column {
  /** column name */
  Code = 'code'
}

export type DiagnosisTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DiagnosisTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: DiagnosisTypes_Bool_Exp;
};

/** columns and relationships of "eventAreaAssignments" */
export type EventAreaAssignments = {
  __typename?: 'eventAreaAssignments';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An object relationship */
  _eventArea?: Maybe<EventAreas>;
  /** An array relationship */
  _eventAreas: Array<EventAreas>;
  /** An aggregate relationship */
  _eventAreas_aggregate: EventAreas_Aggregate;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An object relationship */
  eventArea?: Maybe<EventAreas>;
  eventAreaId: Scalars['uuid'];
  eventId: Scalars['uuid'];
  /** An object relationship */
  events?: Maybe<Events>;
  groupId: Scalars['uuid'];
};


/** columns and relationships of "eventAreaAssignments" */
export type EventAreaAssignments_EventAreasArgs = {
  distinct_on?: InputMaybe<Array<EventAreas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreas_Order_By>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


/** columns and relationships of "eventAreaAssignments" */
export type EventAreaAssignments_EventAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreas_Order_By>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


/** columns and relationships of "eventAreaAssignments" */
export type EventAreaAssignments_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "eventAreaAssignments" */
export type EventAreaAssignments_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** aggregated selection of "eventAreaAssignments" */
export type EventAreaAssignments_Aggregate = {
  __typename?: 'eventAreaAssignments_aggregate';
  aggregate?: Maybe<EventAreaAssignments_Aggregate_Fields>;
  nodes: Array<EventAreaAssignments>;
};

export type EventAreaAssignments_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventAreaAssignments_Aggregate_Bool_Exp_Count>;
};

export type EventAreaAssignments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventAreaAssignments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventAreaAssignments" */
export type EventAreaAssignments_Aggregate_Fields = {
  __typename?: 'eventAreaAssignments_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EventAreaAssignments_Max_Fields>;
  min?: Maybe<EventAreaAssignments_Min_Fields>;
};


/** aggregate fields of "eventAreaAssignments" */
export type EventAreaAssignments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eventAreaAssignments" */
export type EventAreaAssignments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventAreaAssignments_Max_Order_By>;
  min?: InputMaybe<EventAreaAssignments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eventAreaAssignments" */
export type EventAreaAssignments_Arr_Rel_Insert_Input = {
  data: Array<EventAreaAssignments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAreaAssignments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eventAreaAssignments". All fields are combined with a logical 'AND'. */
export type EventAreaAssignments_Bool_Exp = {
  _and?: InputMaybe<Array<EventAreaAssignments_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _eventArea?: InputMaybe<EventAreas_Bool_Exp>;
  _eventAreas?: InputMaybe<EventAreas_Bool_Exp>;
  _eventAreas_aggregate?: InputMaybe<EventAreas_Aggregate_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _not?: InputMaybe<EventAreaAssignments_Bool_Exp>;
  _or?: InputMaybe<Array<EventAreaAssignments_Bool_Exp>>;
  eventArea?: InputMaybe<EventAreas_Bool_Exp>;
  eventAreaId?: InputMaybe<Uuid_Comparison_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventAreaAssignments" */
export enum EventAreaAssignments_Constraint {
  /** unique or primary key constraint on columns "eventAreaId", "eventId" */
  EventAreaAssignmentsPkey = 'eventAreaAssignments_pkey'
}

/** input type for inserting data into table "eventAreaAssignments" */
export type EventAreaAssignments_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _eventArea?: InputMaybe<EventAreas_Obj_Rel_Insert_Input>;
  _eventAreas?: InputMaybe<EventAreas_Arr_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  eventArea?: InputMaybe<EventAreas_Obj_Rel_Insert_Input>;
  eventAreaId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  events?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventAreaAssignments_Max_Fields = {
  __typename?: 'eventAreaAssignments_max_fields';
  eventAreaId?: Maybe<Scalars['uuid']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "eventAreaAssignments" */
export type EventAreaAssignments_Max_Order_By = {
  eventAreaId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventAreaAssignments_Min_Fields = {
  __typename?: 'eventAreaAssignments_min_fields';
  eventAreaId?: Maybe<Scalars['uuid']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "eventAreaAssignments" */
export type EventAreaAssignments_Min_Order_By = {
  eventAreaId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventAreaAssignments" */
export type EventAreaAssignments_Mutation_Response = {
  __typename?: 'eventAreaAssignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAreaAssignments>;
};

/** on_conflict condition type for table "eventAreaAssignments" */
export type EventAreaAssignments_On_Conflict = {
  constraint: EventAreaAssignments_Constraint;
  update_columns?: Array<EventAreaAssignments_Update_Column>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};

/** Ordering options when selecting data from "eventAreaAssignments". */
export type EventAreaAssignments_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _eventArea?: InputMaybe<EventAreas_Order_By>;
  _eventAreas_aggregate?: InputMaybe<EventAreas_Aggregate_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  eventArea?: InputMaybe<EventAreas_Order_By>;
  eventAreaId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  events?: InputMaybe<Events_Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventAreaAssignments */
export type EventAreaAssignments_Pk_Columns_Input = {
  eventAreaId: Scalars['uuid'];
  eventId: Scalars['uuid'];
};

/** select columns of table "eventAreaAssignments" */
export enum EventAreaAssignments_Select_Column {
  /** column name */
  EventAreaId = 'eventAreaId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId'
}

/** input type for updating data in table "eventAreaAssignments" */
export type EventAreaAssignments_Set_Input = {
  eventAreaId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "eventAreaAssignments" */
export type EventAreaAssignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventAreaAssignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAreaAssignments_Stream_Cursor_Value_Input = {
  eventAreaId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "eventAreaAssignments" */
export enum EventAreaAssignments_Update_Column {
  /** column name */
  EventAreaId = 'eventAreaId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId'
}

export type EventAreaAssignments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventAreaAssignments_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventAreaAssignments_Bool_Exp;
};

/** columns and relationships of "eventAreas" */
export type EventAreas = {
  __typename?: 'eventAreas';
  /** An array relationship */
  _eventAreaAssignments: Array<EventAreaAssignments>;
  /** An aggregate relationship */
  _eventAreaAssignments_aggregate: EventAreaAssignments_Aggregate;
  /** An array relationship */
  eventAreaAssignments: Array<EventAreaAssignments>;
  /** An aggregate relationship */
  eventAreaAssignments_aggregate: EventAreaAssignments_Aggregate;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "eventAreas" */
export type EventAreas_EventAreaAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


/** columns and relationships of "eventAreas" */
export type EventAreas_EventAreaAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


/** columns and relationships of "eventAreas" */
export type EventAreasEventAreaAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


/** columns and relationships of "eventAreas" */
export type EventAreasEventAreaAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};

/** aggregated selection of "eventAreas" */
export type EventAreas_Aggregate = {
  __typename?: 'eventAreas_aggregate';
  aggregate?: Maybe<EventAreas_Aggregate_Fields>;
  nodes: Array<EventAreas>;
};

export type EventAreas_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventAreas_Aggregate_Bool_Exp_Count>;
};

export type EventAreas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventAreas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventAreas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventAreas" */
export type EventAreas_Aggregate_Fields = {
  __typename?: 'eventAreas_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EventAreas_Max_Fields>;
  min?: Maybe<EventAreas_Min_Fields>;
};


/** aggregate fields of "eventAreas" */
export type EventAreas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventAreas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eventAreas" */
export type EventAreas_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventAreas_Max_Order_By>;
  min?: InputMaybe<EventAreas_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eventAreas" */
export type EventAreas_Arr_Rel_Insert_Input = {
  data: Array<EventAreas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAreas_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eventAreas". All fields are combined with a logical 'AND'. */
export type EventAreas_Bool_Exp = {
  _and?: InputMaybe<Array<EventAreas_Bool_Exp>>;
  _eventAreaAssignments?: InputMaybe<EventAreaAssignments_Bool_Exp>;
  _eventAreaAssignments_aggregate?: InputMaybe<EventAreaAssignments_Aggregate_Bool_Exp>;
  _not?: InputMaybe<EventAreas_Bool_Exp>;
  _or?: InputMaybe<Array<EventAreas_Bool_Exp>>;
  eventAreaAssignments?: InputMaybe<EventAreaAssignments_Bool_Exp>;
  eventAreaAssignments_aggregate?: InputMaybe<EventAreaAssignments_Aggregate_Bool_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventAreas" */
export enum EventAreas_Constraint {
  /** unique or primary key constraint on columns "id", "groupId" */
  EventAreasGroupIdIdKey = 'eventAreas_groupId_id_key',
  /** unique or primary key constraint on columns "name", "groupId" */
  EventAreasGroupIdNameKey = 'eventAreas_groupId_name_key',
  /** unique or primary key constraint on columns "id" */
  EventAreasPkey = 'eventAreas_pkey'
}

/** input type for inserting data into table "eventAreas" */
export type EventAreas_Insert_Input = {
  _eventAreaAssignments?: InputMaybe<EventAreaAssignments_Arr_Rel_Insert_Input>;
  eventAreaAssignments?: InputMaybe<EventAreaAssignments_Arr_Rel_Insert_Input>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventAreas_Max_Fields = {
  __typename?: 'eventAreas_max_fields';
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "eventAreas" */
export type EventAreas_Max_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventAreas_Min_Fields = {
  __typename?: 'eventAreas_min_fields';
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "eventAreas" */
export type EventAreas_Min_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventAreas" */
export type EventAreas_Mutation_Response = {
  __typename?: 'eventAreas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAreas>;
};

/** input type for inserting object relation for remote table "eventAreas" */
export type EventAreas_Obj_Rel_Insert_Input = {
  data: EventAreas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAreas_On_Conflict>;
};

/** on_conflict condition type for table "eventAreas" */
export type EventAreas_On_Conflict = {
  constraint: EventAreas_Constraint;
  update_columns?: Array<EventAreas_Update_Column>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};

/** Ordering options when selecting data from "eventAreas". */
export type EventAreas_Order_By = {
  _eventAreaAssignments_aggregate?: InputMaybe<EventAreaAssignments_Aggregate_Order_By>;
  eventAreaAssignments_aggregate?: InputMaybe<EventAreaAssignments_Aggregate_Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventAreas */
export type EventAreas_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "eventAreas" */
export enum EventAreas_Select_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "eventAreas" */
export type EventAreas_Set_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "eventAreas" */
export type EventAreas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventAreas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAreas_Stream_Cursor_Value_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "eventAreas" */
export enum EventAreas_Update_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type EventAreas_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventAreas_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventAreas_Bool_Exp;
};

/** columns and relationships of "eventBeginnings" */
export type EventBeginnings = {
  __typename?: 'eventBeginnings';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  timestamp: Scalars['timestamp'];
};


/** columns and relationships of "eventBeginnings" */
export type EventBeginnings_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "eventBeginnings" */
export type EventBeginnings_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** aggregated selection of "eventBeginnings" */
export type EventBeginnings_Aggregate = {
  __typename?: 'eventBeginnings_aggregate';
  aggregate?: Maybe<EventBeginnings_Aggregate_Fields>;
  nodes: Array<EventBeginnings>;
};

export type EventBeginnings_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventBeginnings_Aggregate_Bool_Exp_Count>;
};

export type EventBeginnings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventBeginnings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventBeginnings" */
export type EventBeginnings_Aggregate_Fields = {
  __typename?: 'eventBeginnings_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EventBeginnings_Max_Fields>;
  min?: Maybe<EventBeginnings_Min_Fields>;
};


/** aggregate fields of "eventBeginnings" */
export type EventBeginnings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eventBeginnings" */
export type EventBeginnings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventBeginnings_Max_Order_By>;
  min?: InputMaybe<EventBeginnings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eventBeginnings" */
export type EventBeginnings_Arr_Rel_Insert_Input = {
  data: Array<EventBeginnings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventBeginnings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eventBeginnings". All fields are combined with a logical 'AND'. */
export type EventBeginnings_Bool_Exp = {
  _and?: InputMaybe<Array<EventBeginnings_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _not?: InputMaybe<EventBeginnings_Bool_Exp>;
  _or?: InputMaybe<Array<EventBeginnings_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventBeginnings" */
export enum EventBeginnings_Constraint {
  /** unique or primary key constraint on columns "eventId", "groupId" */
  EventBeginningsGroupIdEventIdKey = 'eventBeginnings_groupId_eventId_key',
  /** unique or primary key constraint on columns "eventId" */
  EventBeginningsPkey = 'eventBeginnings_pkey'
}

/** input type for inserting data into table "eventBeginnings" */
export type EventBeginnings_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type EventBeginnings_Max_Fields = {
  __typename?: 'eventBeginnings_max_fields';
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "eventBeginnings" */
export type EventBeginnings_Max_Order_By = {
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventBeginnings_Min_Fields = {
  __typename?: 'eventBeginnings_min_fields';
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "eventBeginnings" */
export type EventBeginnings_Min_Order_By = {
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventBeginnings" */
export type EventBeginnings_Mutation_Response = {
  __typename?: 'eventBeginnings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventBeginnings>;
};

/** input type for inserting object relation for remote table "eventBeginnings" */
export type EventBeginnings_Obj_Rel_Insert_Input = {
  data: EventBeginnings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventBeginnings_On_Conflict>;
};

/** on_conflict condition type for table "eventBeginnings" */
export type EventBeginnings_On_Conflict = {
  constraint: EventBeginnings_Constraint;
  update_columns?: Array<EventBeginnings_Update_Column>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};

/** Ordering options when selecting data from "eventBeginnings". */
export type EventBeginnings_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventBeginnings */
export type EventBeginnings_Pk_Columns_Input = {
  eventId: Scalars['uuid'];
};

/** select columns of table "eventBeginnings" */
export enum EventBeginnings_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "eventBeginnings" */
export type EventBeginnings_Set_Input = {
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "eventBeginnings" */
export type EventBeginnings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventBeginnings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventBeginnings_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "eventBeginnings" */
export enum EventBeginnings_Update_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Timestamp = 'timestamp'
}

export type EventBeginnings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventBeginnings_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventBeginnings_Bool_Exp;
};

/** columns and relationships of "eventDiagnoses" */
export type EventDiagnoses = {
  __typename?: 'eventDiagnoses';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An array relationship */
  _examinationDiagnoses: Array<ExaminationDiagnoses>;
  /** An aggregate relationship */
  _examinationDiagnoses_aggregate: ExaminationDiagnoses_Aggregate;
  /** An object relationship */
  diagnosis: Diagnoses;
  diagnosisId: Scalars['uuid'];
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  /** An array relationship */
  examinationDiagnoses: Array<ExaminationDiagnoses>;
  /** An aggregate relationship */
  examinationDiagnoses_aggregate: ExaminationDiagnoses_Aggregate;
  groupId: Scalars['uuid'];
};


/** columns and relationships of "eventDiagnoses" */
export type EventDiagnoses_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "eventDiagnoses" */
export type EventDiagnoses_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "eventDiagnoses" */
export type EventDiagnoses_ExaminationDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


/** columns and relationships of "eventDiagnoses" */
export type EventDiagnoses_ExaminationDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


/** columns and relationships of "eventDiagnoses" */
export type EventDiagnosesExaminationDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


/** columns and relationships of "eventDiagnoses" */
export type EventDiagnosesExaminationDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};

/** aggregated selection of "eventDiagnoses" */
export type EventDiagnoses_Aggregate = {
  __typename?: 'eventDiagnoses_aggregate';
  aggregate?: Maybe<EventDiagnoses_Aggregate_Fields>;
  nodes: Array<EventDiagnoses>;
};

export type EventDiagnoses_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventDiagnoses_Aggregate_Bool_Exp_Count>;
};

export type EventDiagnoses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventDiagnoses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventDiagnoses" */
export type EventDiagnoses_Aggregate_Fields = {
  __typename?: 'eventDiagnoses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EventDiagnoses_Max_Fields>;
  min?: Maybe<EventDiagnoses_Min_Fields>;
};


/** aggregate fields of "eventDiagnoses" */
export type EventDiagnoses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eventDiagnoses" */
export type EventDiagnoses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventDiagnoses_Max_Order_By>;
  min?: InputMaybe<EventDiagnoses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eventDiagnoses" */
export type EventDiagnoses_Arr_Rel_Insert_Input = {
  data: Array<EventDiagnoses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventDiagnoses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eventDiagnoses". All fields are combined with a logical 'AND'. */
export type EventDiagnoses_Bool_Exp = {
  _and?: InputMaybe<Array<EventDiagnoses_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  _examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Bool_Exp>;
  _not?: InputMaybe<EventDiagnoses_Bool_Exp>;
  _or?: InputMaybe<Array<EventDiagnoses_Bool_Exp>>;
  diagnosis?: InputMaybe<Diagnoses_Bool_Exp>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventDiagnoses" */
export enum EventDiagnoses_Constraint {
  /** unique or primary key constraint on columns "diagnosisId", "eventId", "groupId" */
  EventDiagnosesEventIdDiagnosisIdGroupIdKey = 'eventDiagnoses_eventId_diagnosisId_groupId_key',
  /** unique or primary key constraint on columns "diagnosisId", "eventId" */
  EventDiagnosesPkey = 'eventDiagnoses_pkey'
}

/** input type for inserting data into table "eventDiagnoses" */
export type EventDiagnoses_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  _examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Arr_Rel_Insert_Input>;
  diagnosis?: InputMaybe<Diagnoses_Obj_Rel_Insert_Input>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']>;
  examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Arr_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventDiagnoses_Max_Fields = {
  __typename?: 'eventDiagnoses_max_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "eventDiagnoses" */
export type EventDiagnoses_Max_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventDiagnoses_Min_Fields = {
  __typename?: 'eventDiagnoses_min_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "eventDiagnoses" */
export type EventDiagnoses_Min_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventDiagnoses" */
export type EventDiagnoses_Mutation_Response = {
  __typename?: 'eventDiagnoses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventDiagnoses>;
};

/** input type for inserting object relation for remote table "eventDiagnoses" */
export type EventDiagnoses_Obj_Rel_Insert_Input = {
  data: EventDiagnoses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventDiagnoses_On_Conflict>;
};

/** on_conflict condition type for table "eventDiagnoses" */
export type EventDiagnoses_On_Conflict = {
  constraint: EventDiagnoses_Constraint;
  update_columns?: Array<EventDiagnoses_Update_Column>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};

/** Ordering options when selecting data from "eventDiagnoses". */
export type EventDiagnoses_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  _examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Order_By>;
  diagnosis?: InputMaybe<Diagnoses_Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventDiagnoses */
export type EventDiagnoses_Pk_Columns_Input = {
  diagnosisId: Scalars['uuid'];
  eventId: Scalars['uuid'];
};

/** select columns of table "eventDiagnoses" */
export enum EventDiagnoses_Select_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId'
}

/** input type for updating data in table "eventDiagnoses" */
export type EventDiagnoses_Set_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "eventDiagnoses" */
export type EventDiagnoses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventDiagnoses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventDiagnoses_Stream_Cursor_Value_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "eventDiagnoses" */
export enum EventDiagnoses_Update_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId'
}

export type EventDiagnoses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventDiagnoses_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventDiagnoses_Bool_Exp;
};

/** columns and relationships of "eventExaminationCounts" */
export type EventExaminationCounts = {
  __typename?: 'eventExaminationCounts';
  count?: Maybe<Scalars['bigint']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "eventExaminationCounts" */
export type EventExaminationCounts_Aggregate = {
  __typename?: 'eventExaminationCounts_aggregate';
  aggregate?: Maybe<EventExaminationCounts_Aggregate_Fields>;
  nodes: Array<EventExaminationCounts>;
};

/** aggregate fields of "eventExaminationCounts" */
export type EventExaminationCounts_Aggregate_Fields = {
  __typename?: 'eventExaminationCounts_aggregate_fields';
  avg?: Maybe<EventExaminationCounts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EventExaminationCounts_Max_Fields>;
  min?: Maybe<EventExaminationCounts_Min_Fields>;
  stddev?: Maybe<EventExaminationCounts_Stddev_Fields>;
  stddev_pop?: Maybe<EventExaminationCounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventExaminationCounts_Stddev_Samp_Fields>;
  sum?: Maybe<EventExaminationCounts_Sum_Fields>;
  var_pop?: Maybe<EventExaminationCounts_Var_Pop_Fields>;
  var_samp?: Maybe<EventExaminationCounts_Var_Samp_Fields>;
  variance?: Maybe<EventExaminationCounts_Variance_Fields>;
};


/** aggregate fields of "eventExaminationCounts" */
export type EventExaminationCounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventExaminationCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EventExaminationCounts_Avg_Fields = {
  __typename?: 'eventExaminationCounts_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "eventExaminationCounts". All fields are combined with a logical 'AND'. */
export type EventExaminationCounts_Bool_Exp = {
  _and?: InputMaybe<Array<EventExaminationCounts_Bool_Exp>>;
  _not?: InputMaybe<EventExaminationCounts_Bool_Exp>;
  _or?: InputMaybe<Array<EventExaminationCounts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type EventExaminationCounts_Max_Fields = {
  __typename?: 'eventExaminationCounts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type EventExaminationCounts_Min_Fields = {
  __typename?: 'eventExaminationCounts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "eventExaminationCounts". */
export type EventExaminationCounts_Order_By = {
  count?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** select columns of table "eventExaminationCounts" */
export enum EventExaminationCounts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId'
}

/** aggregate stddev on columns */
export type EventExaminationCounts_Stddev_Fields = {
  __typename?: 'eventExaminationCounts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventExaminationCounts_Stddev_Pop_Fields = {
  __typename?: 'eventExaminationCounts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventExaminationCounts_Stddev_Samp_Fields = {
  __typename?: 'eventExaminationCounts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "eventExaminationCounts" */
export type EventExaminationCounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventExaminationCounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventExaminationCounts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type EventExaminationCounts_Sum_Fields = {
  __typename?: 'eventExaminationCounts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type EventExaminationCounts_Var_Pop_Fields = {
  __typename?: 'eventExaminationCounts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventExaminationCounts_Var_Samp_Fields = {
  __typename?: 'eventExaminationCounts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventExaminationCounts_Variance_Fields = {
  __typename?: 'eventExaminationCounts_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "eventExpirations" */
export type EventExpirations = {
  __typename?: 'eventExpirations';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  timestamp: Scalars['timestamp'];
};


/** columns and relationships of "eventExpirations" */
export type EventExpirations_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "eventExpirations" */
export type EventExpirations_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** aggregated selection of "eventExpirations" */
export type EventExpirations_Aggregate = {
  __typename?: 'eventExpirations_aggregate';
  aggregate?: Maybe<EventExpirations_Aggregate_Fields>;
  nodes: Array<EventExpirations>;
};

export type EventExpirations_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventExpirations_Aggregate_Bool_Exp_Count>;
};

export type EventExpirations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventExpirations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventExpirations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventExpirations" */
export type EventExpirations_Aggregate_Fields = {
  __typename?: 'eventExpirations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EventExpirations_Max_Fields>;
  min?: Maybe<EventExpirations_Min_Fields>;
};


/** aggregate fields of "eventExpirations" */
export type EventExpirations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventExpirations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eventExpirations" */
export type EventExpirations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventExpirations_Max_Order_By>;
  min?: InputMaybe<EventExpirations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eventExpirations" */
export type EventExpirations_Arr_Rel_Insert_Input = {
  data: Array<EventExpirations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventExpirations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eventExpirations". All fields are combined with a logical 'AND'. */
export type EventExpirations_Bool_Exp = {
  _and?: InputMaybe<Array<EventExpirations_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _not?: InputMaybe<EventExpirations_Bool_Exp>;
  _or?: InputMaybe<Array<EventExpirations_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventExpirations" */
export enum EventExpirations_Constraint {
  /** unique or primary key constraint on columns "eventId", "groupId" */
  EventExpirationsGroupIdEventIdKey = 'eventExpirations_groupId_eventId_key',
  /** unique or primary key constraint on columns "eventId" */
  EventExpirationsPkey = 'eventExpirations_pkey'
}

/** input type for inserting data into table "eventExpirations" */
export type EventExpirations_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type EventExpirations_Max_Fields = {
  __typename?: 'eventExpirations_max_fields';
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "eventExpirations" */
export type EventExpirations_Max_Order_By = {
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventExpirations_Min_Fields = {
  __typename?: 'eventExpirations_min_fields';
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "eventExpirations" */
export type EventExpirations_Min_Order_By = {
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventExpirations" */
export type EventExpirations_Mutation_Response = {
  __typename?: 'eventExpirations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventExpirations>;
};

/** input type for inserting object relation for remote table "eventExpirations" */
export type EventExpirations_Obj_Rel_Insert_Input = {
  data: EventExpirations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventExpirations_On_Conflict>;
};

/** on_conflict condition type for table "eventExpirations" */
export type EventExpirations_On_Conflict = {
  constraint: EventExpirations_Constraint;
  update_columns?: Array<EventExpirations_Update_Column>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};

/** Ordering options when selecting data from "eventExpirations". */
export type EventExpirations_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventExpirations */
export type EventExpirations_Pk_Columns_Input = {
  eventId: Scalars['uuid'];
};

/** select columns of table "eventExpirations" */
export enum EventExpirations_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "eventExpirations" */
export type EventExpirations_Set_Input = {
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "eventExpirations" */
export type EventExpirations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventExpirations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventExpirations_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "eventExpirations" */
export enum EventExpirations_Update_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Timestamp = 'timestamp'
}

export type EventExpirations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventExpirations_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventExpirations_Bool_Exp;
};

/** columns and relationships of "eventLimitTimes" */
export type EventLimitTimes = {
  __typename?: 'eventLimitTimes';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  value: Scalars['bigint'];
};


/** columns and relationships of "eventLimitTimes" */
export type EventLimitTimes_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "eventLimitTimes" */
export type EventLimitTimes_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** aggregated selection of "eventLimitTimes" */
export type EventLimitTimes_Aggregate = {
  __typename?: 'eventLimitTimes_aggregate';
  aggregate?: Maybe<EventLimitTimes_Aggregate_Fields>;
  nodes: Array<EventLimitTimes>;
};

export type EventLimitTimes_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventLimitTimes_Aggregate_Bool_Exp_Count>;
};

export type EventLimitTimes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventLimitTimes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventLimitTimes" */
export type EventLimitTimes_Aggregate_Fields = {
  __typename?: 'eventLimitTimes_aggregate_fields';
  avg?: Maybe<EventLimitTimes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EventLimitTimes_Max_Fields>;
  min?: Maybe<EventLimitTimes_Min_Fields>;
  stddev?: Maybe<EventLimitTimes_Stddev_Fields>;
  stddev_pop?: Maybe<EventLimitTimes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventLimitTimes_Stddev_Samp_Fields>;
  sum?: Maybe<EventLimitTimes_Sum_Fields>;
  var_pop?: Maybe<EventLimitTimes_Var_Pop_Fields>;
  var_samp?: Maybe<EventLimitTimes_Var_Samp_Fields>;
  variance?: Maybe<EventLimitTimes_Variance_Fields>;
};


/** aggregate fields of "eventLimitTimes" */
export type EventLimitTimes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eventLimitTimes" */
export type EventLimitTimes_Aggregate_Order_By = {
  avg?: InputMaybe<EventLimitTimes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventLimitTimes_Max_Order_By>;
  min?: InputMaybe<EventLimitTimes_Min_Order_By>;
  stddev?: InputMaybe<EventLimitTimes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventLimitTimes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventLimitTimes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventLimitTimes_Sum_Order_By>;
  var_pop?: InputMaybe<EventLimitTimes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventLimitTimes_Var_Samp_Order_By>;
  variance?: InputMaybe<EventLimitTimes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventLimitTimes" */
export type EventLimitTimes_Arr_Rel_Insert_Input = {
  data: Array<EventLimitTimes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventLimitTimes_On_Conflict>;
};

/** aggregate avg on columns */
export type EventLimitTimes_Avg_Fields = {
  __typename?: 'eventLimitTimes_avg_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventLimitTimes". All fields are combined with a logical 'AND'. */
export type EventLimitTimes_Bool_Exp = {
  _and?: InputMaybe<Array<EventLimitTimes_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _not?: InputMaybe<EventLimitTimes_Bool_Exp>;
  _or?: InputMaybe<Array<EventLimitTimes_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventLimitTimes" */
export enum EventLimitTimes_Constraint {
  /** unique or primary key constraint on columns "eventId", "groupId" */
  EventLimitTimesGroupIdEventIdKey = 'eventLimitTimes_groupId_eventId_key',
  /** unique or primary key constraint on columns "eventId" */
  EventLimitTimesPkey = 'eventLimitTimes_pkey'
}

/** input type for incrementing numeric columns in table "eventLimitTimes" */
export type EventLimitTimes_Inc_Input = {
  value?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "eventLimitTimes" */
export type EventLimitTimes_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EventLimitTimes_Max_Fields = {
  __typename?: 'eventLimitTimes_max_fields';
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Max_Order_By = {
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventLimitTimes_Min_Fields = {
  __typename?: 'eventLimitTimes_min_fields';
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Min_Order_By = {
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventLimitTimes" */
export type EventLimitTimes_Mutation_Response = {
  __typename?: 'eventLimitTimes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventLimitTimes>;
};

/** input type for inserting object relation for remote table "eventLimitTimes" */
export type EventLimitTimes_Obj_Rel_Insert_Input = {
  data: EventLimitTimes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventLimitTimes_On_Conflict>;
};

/** on_conflict condition type for table "eventLimitTimes" */
export type EventLimitTimes_On_Conflict = {
  constraint: EventLimitTimes_Constraint;
  update_columns?: Array<EventLimitTimes_Update_Column>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};

/** Ordering options when selecting data from "eventLimitTimes". */
export type EventLimitTimes_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventLimitTimes */
export type EventLimitTimes_Pk_Columns_Input = {
  eventId: Scalars['uuid'];
};

/** select columns of table "eventLimitTimes" */
export enum EventLimitTimes_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eventLimitTimes" */
export type EventLimitTimes_Set_Input = {
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type EventLimitTimes_Stddev_Fields = {
  __typename?: 'eventLimitTimes_stddev_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EventLimitTimes_Stddev_Pop_Fields = {
  __typename?: 'eventLimitTimes_stddev_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EventLimitTimes_Stddev_Samp_Fields = {
  __typename?: 'eventLimitTimes_stddev_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventLimitTimes" */
export type EventLimitTimes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventLimitTimes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventLimitTimes_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventLimitTimes_Sum_Fields = {
  __typename?: 'eventLimitTimes_sum_fields';
  value?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** update columns of table "eventLimitTimes" */
export enum EventLimitTimes_Update_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Value = 'value'
}

export type EventLimitTimes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventLimitTimes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventLimitTimes_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventLimitTimes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EventLimitTimes_Var_Pop_Fields = {
  __typename?: 'eventLimitTimes_var_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EventLimitTimes_Var_Samp_Fields = {
  __typename?: 'eventLimitTimes_var_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EventLimitTimes_Variance_Fields = {
  __typename?: 'eventLimitTimes_variance_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "eventLimitTimes" */
export type EventLimitTimes_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventTagAssignments" */
export type EventTagAssignments = {
  __typename?: 'eventTagAssignments';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An object relationship */
  _eventTag?: Maybe<EventTags>;
  /** An array relationship */
  _eventTags: Array<EventTags>;
  /** An aggregate relationship */
  _eventTags_aggregate: EventTags_Aggregate;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId: Scalars['uuid'];
  /** An object relationship */
  eventTag?: Maybe<EventTags>;
  eventTagId: Scalars['uuid'];
  groupId: Scalars['uuid'];
};


/** columns and relationships of "eventTagAssignments" */
export type EventTagAssignments_EventTagsArgs = {
  distinct_on?: InputMaybe<Array<EventTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTags_Order_By>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


/** columns and relationships of "eventTagAssignments" */
export type EventTagAssignments_EventTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTags_Order_By>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


/** columns and relationships of "eventTagAssignments" */
export type EventTagAssignments_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "eventTagAssignments" */
export type EventTagAssignments_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** aggregated selection of "eventTagAssignments" */
export type EventTagAssignments_Aggregate = {
  __typename?: 'eventTagAssignments_aggregate';
  aggregate?: Maybe<EventTagAssignments_Aggregate_Fields>;
  nodes: Array<EventTagAssignments>;
};

export type EventTagAssignments_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventTagAssignments_Aggregate_Bool_Exp_Count>;
};

export type EventTagAssignments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventTagAssignments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventTagAssignments" */
export type EventTagAssignments_Aggregate_Fields = {
  __typename?: 'eventTagAssignments_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EventTagAssignments_Max_Fields>;
  min?: Maybe<EventTagAssignments_Min_Fields>;
};


/** aggregate fields of "eventTagAssignments" */
export type EventTagAssignments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eventTagAssignments" */
export type EventTagAssignments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventTagAssignments_Max_Order_By>;
  min?: InputMaybe<EventTagAssignments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eventTagAssignments" */
export type EventTagAssignments_Arr_Rel_Insert_Input = {
  data: Array<EventTagAssignments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventTagAssignments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eventTagAssignments". All fields are combined with a logical 'AND'. */
export type EventTagAssignments_Bool_Exp = {
  _and?: InputMaybe<Array<EventTagAssignments_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _eventTag?: InputMaybe<EventTags_Bool_Exp>;
  _eventTags?: InputMaybe<EventTags_Bool_Exp>;
  _eventTags_aggregate?: InputMaybe<EventTags_Aggregate_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _not?: InputMaybe<EventTagAssignments_Bool_Exp>;
  _or?: InputMaybe<Array<EventTagAssignments_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  eventTag?: InputMaybe<EventTags_Bool_Exp>;
  eventTagId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventTagAssignments" */
export enum EventTagAssignments_Constraint {
  /** unique or primary key constraint on columns "eventId", "eventTagId" */
  EventTagAssignmentsPkey = 'eventTagAssignments_pkey'
}

/** input type for inserting data into table "eventTagAssignments" */
export type EventTagAssignments_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _eventTag?: InputMaybe<EventTags_Obj_Rel_Insert_Input>;
  _eventTags?: InputMaybe<EventTags_Arr_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventTag?: InputMaybe<EventTags_Obj_Rel_Insert_Input>;
  eventTagId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventTagAssignments_Max_Fields = {
  __typename?: 'eventTagAssignments_max_fields';
  eventId?: Maybe<Scalars['uuid']>;
  eventTagId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "eventTagAssignments" */
export type EventTagAssignments_Max_Order_By = {
  eventId?: InputMaybe<Order_By>;
  eventTagId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventTagAssignments_Min_Fields = {
  __typename?: 'eventTagAssignments_min_fields';
  eventId?: Maybe<Scalars['uuid']>;
  eventTagId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "eventTagAssignments" */
export type EventTagAssignments_Min_Order_By = {
  eventId?: InputMaybe<Order_By>;
  eventTagId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventTagAssignments" */
export type EventTagAssignments_Mutation_Response = {
  __typename?: 'eventTagAssignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTagAssignments>;
};

/** on_conflict condition type for table "eventTagAssignments" */
export type EventTagAssignments_On_Conflict = {
  constraint: EventTagAssignments_Constraint;
  update_columns?: Array<EventTagAssignments_Update_Column>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};

/** Ordering options when selecting data from "eventTagAssignments". */
export type EventTagAssignments_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _eventTag?: InputMaybe<EventTags_Order_By>;
  _eventTags_aggregate?: InputMaybe<EventTags_Aggregate_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  eventTag?: InputMaybe<EventTags_Order_By>;
  eventTagId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventTagAssignments */
export type EventTagAssignments_Pk_Columns_Input = {
  eventId: Scalars['uuid'];
  eventTagId: Scalars['uuid'];
};

/** select columns of table "eventTagAssignments" */
export enum EventTagAssignments_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventTagId = 'eventTagId',
  /** column name */
  GroupId = 'groupId'
}

/** input type for updating data in table "eventTagAssignments" */
export type EventTagAssignments_Set_Input = {
  eventId?: InputMaybe<Scalars['uuid']>;
  eventTagId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "eventTagAssignments" */
export type EventTagAssignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventTagAssignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTagAssignments_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['uuid']>;
  eventTagId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "eventTagAssignments" */
export enum EventTagAssignments_Update_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventTagId = 'eventTagId',
  /** column name */
  GroupId = 'groupId'
}

export type EventTagAssignments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTagAssignments_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventTagAssignments_Bool_Exp;
};

/** columns and relationships of "eventTags" */
export type EventTags = {
  __typename?: 'eventTags';
  /** An array relationship */
  _eventTagAssignments: Array<EventTagAssignments>;
  /** An aggregate relationship */
  _eventTagAssignments_aggregate: EventTagAssignments_Aggregate;
  /** An array relationship */
  eventTagAssignments: Array<EventTagAssignments>;
  /** An aggregate relationship */
  eventTagAssignments_aggregate: EventTagAssignments_Aggregate;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "eventTags" */
export type EventTags_EventTagAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


/** columns and relationships of "eventTags" */
export type EventTags_EventTagAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


/** columns and relationships of "eventTags" */
export type EventTagsEventTagAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


/** columns and relationships of "eventTags" */
export type EventTagsEventTagAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};

/** aggregated selection of "eventTags" */
export type EventTags_Aggregate = {
  __typename?: 'eventTags_aggregate';
  aggregate?: Maybe<EventTags_Aggregate_Fields>;
  nodes: Array<EventTags>;
};

export type EventTags_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventTags_Aggregate_Bool_Exp_Count>;
};

export type EventTags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventTags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventTags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventTags" */
export type EventTags_Aggregate_Fields = {
  __typename?: 'eventTags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EventTags_Max_Fields>;
  min?: Maybe<EventTags_Min_Fields>;
};


/** aggregate fields of "eventTags" */
export type EventTags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventTags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eventTags" */
export type EventTags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventTags_Max_Order_By>;
  min?: InputMaybe<EventTags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eventTags" */
export type EventTags_Arr_Rel_Insert_Input = {
  data: Array<EventTags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventTags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eventTags". All fields are combined with a logical 'AND'. */
export type EventTags_Bool_Exp = {
  _and?: InputMaybe<Array<EventTags_Bool_Exp>>;
  _eventTagAssignments?: InputMaybe<EventTagAssignments_Bool_Exp>;
  _eventTagAssignments_aggregate?: InputMaybe<EventTagAssignments_Aggregate_Bool_Exp>;
  _not?: InputMaybe<EventTags_Bool_Exp>;
  _or?: InputMaybe<Array<EventTags_Bool_Exp>>;
  eventTagAssignments?: InputMaybe<EventTagAssignments_Bool_Exp>;
  eventTagAssignments_aggregate?: InputMaybe<EventTagAssignments_Aggregate_Bool_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventTags" */
export enum EventTags_Constraint {
  /** unique or primary key constraint on columns "id", "groupId" */
  EventTagsGroupIdIdKey = 'eventTags_groupId_id_key',
  /** unique or primary key constraint on columns "name", "groupId" */
  EventTagsGroupIdNameKey = 'eventTags_groupId_name_key',
  /** unique or primary key constraint on columns "id" */
  EventTagsPkey = 'eventTags_pkey'
}

/** input type for inserting data into table "eventTags" */
export type EventTags_Insert_Input = {
  _eventTagAssignments?: InputMaybe<EventTagAssignments_Arr_Rel_Insert_Input>;
  eventTagAssignments?: InputMaybe<EventTagAssignments_Arr_Rel_Insert_Input>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventTags_Max_Fields = {
  __typename?: 'eventTags_max_fields';
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "eventTags" */
export type EventTags_Max_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventTags_Min_Fields = {
  __typename?: 'eventTags_min_fields';
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "eventTags" */
export type EventTags_Min_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventTags" */
export type EventTags_Mutation_Response = {
  __typename?: 'eventTags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTags>;
};

/** input type for inserting object relation for remote table "eventTags" */
export type EventTags_Obj_Rel_Insert_Input = {
  data: EventTags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventTags_On_Conflict>;
};

/** on_conflict condition type for table "eventTags" */
export type EventTags_On_Conflict = {
  constraint: EventTags_Constraint;
  update_columns?: Array<EventTags_Update_Column>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};

/** Ordering options when selecting data from "eventTags". */
export type EventTags_Order_By = {
  _eventTagAssignments_aggregate?: InputMaybe<EventTagAssignments_Aggregate_Order_By>;
  eventTagAssignments_aggregate?: InputMaybe<EventTagAssignments_Aggregate_Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventTags */
export type EventTags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "eventTags" */
export enum EventTags_Select_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "eventTags" */
export type EventTags_Set_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "eventTags" */
export type EventTags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventTags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTags_Stream_Cursor_Value_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "eventTags" */
export enum EventTags_Update_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type EventTags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTags_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventTags_Bool_Exp;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  /** An array relationship */
  _eventAreaAssignments: Array<EventAreaAssignments>;
  /** An aggregate relationship */
  _eventAreaAssignments_aggregate: EventAreaAssignments_Aggregate;
  /** An object relationship */
  _eventBeginning?: Maybe<EventBeginnings>;
  /** An array relationship */
  _eventBeginnings: Array<EventBeginnings>;
  /** An aggregate relationship */
  _eventBeginnings_aggregate: EventBeginnings_Aggregate;
  /** An array relationship */
  _eventDiagnoses: Array<EventDiagnoses>;
  /** An aggregate relationship */
  _eventDiagnoses_aggregate: EventDiagnoses_Aggregate;
  /** An object relationship */
  _eventExpiration?: Maybe<EventExpirations>;
  /** An array relationship */
  _eventExpirations: Array<EventExpirations>;
  /** An aggregate relationship */
  _eventExpirations_aggregate: EventExpirations_Aggregate;
  /** An object relationship */
  _eventLimitTime?: Maybe<EventLimitTimes>;
  /** An array relationship */
  _eventLimitTimes: Array<EventLimitTimes>;
  /** An aggregate relationship */
  _eventLimitTimes_aggregate: EventLimitTimes_Aggregate;
  /** An array relationship */
  _eventTagAssignments: Array<EventTagAssignments>;
  /** An aggregate relationship */
  _eventTagAssignments_aggregate: EventTagAssignments_Aggregate;
  /** An array relationship */
  _examinations: Array<Examinations>;
  /** An aggregate relationship */
  _examinations_aggregate: Examinations_Aggregate;
  /** An array relationship */
  _guestExaminees: Array<GuestExaminees>;
  /** An aggregate relationship */
  _guestExaminees_aggregate: GuestExaminees_Aggregate;
  /** An array relationship */
  _inactiveGroupEvents: Array<InactiveGroupEvents>;
  /** An aggregate relationship */
  _inactiveGroupEvents_aggregate: InactiveGroupEvents_Aggregate;
  enableFileUpload: Scalars['Boolean'];
  /** An array relationship */
  eventAreaAssignments: Array<EventAreaAssignments>;
  /** An aggregate relationship */
  eventAreaAssignments_aggregate: EventAreaAssignments_Aggregate;
  /** An object relationship */
  eventBeginning?: Maybe<EventBeginnings>;
  /** An array relationship */
  eventDiagnoses: Array<EventDiagnoses>;
  /** An aggregate relationship */
  eventDiagnoses_aggregate: EventDiagnoses_Aggregate;
  /** An object relationship */
  eventExpiration?: Maybe<EventExpirations>;
  /** An object relationship */
  eventLimitTime?: Maybe<EventLimitTimes>;
  /** An array relationship */
  eventTagAssignments: Array<EventTagAssignments>;
  /** An aggregate relationship */
  eventTagAssignments_aggregate: EventTagAssignments_Aggregate;
  /** An array relationship */
  examinations: Array<Examinations>;
  /** An aggregate relationship */
  examinations_aggregate: Examinations_Aggregate;
  fileUploadDescription: Scalars['String'];
  fileUploadType: Scalars['String'];
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  /** An array relationship */
  guestExaminees: Array<GuestExaminees>;
  /** An aggregate relationship */
  guestExaminees_aggregate: GuestExaminees_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  inactiveGroupEvent?: Maybe<InactiveGroupEvents>;
  name: Scalars['String'];
  public: Scalars['Boolean'];
};


/** columns and relationships of "events" */
export type Events_EventAreaAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventAreaAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventBeginningsArgs = {
  distinct_on?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventBeginnings_Order_By>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventBeginnings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventBeginnings_Order_By>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventExpirationsArgs = {
  distinct_on?: InputMaybe<Array<EventExpirations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExpirations_Order_By>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventExpirations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventExpirations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExpirations_Order_By>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventLimitTimesArgs = {
  distinct_on?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventLimitTimes_Order_By>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventLimitTimes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventLimitTimes_Order_By>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventTagAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_EventTagAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_ExaminationsArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_Examinations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_GuestExamineesArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_GuestExaminees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_InactiveGroupEventsArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroupEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroupEvents_Order_By>>;
  where?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
};


/** columns and relationships of "events" */
export type Events_InactiveGroupEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroupEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroupEvents_Order_By>>;
  where?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventAreaAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventAreaAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventTagAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventTagAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsExaminationsArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsGuestExamineesArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsGuestExaminees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};

/** aggregated selection of "events" */
export type Events_Aggregate = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_Fields>;
  nodes: Array<Events>;
};

export type Events_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Events_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Events_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Events_Aggregate_Bool_Exp_Count>;
};

export type Events_Aggregate_Bool_Exp_Bool_And = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Events_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "events" */
export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Events_Max_Fields>;
  min?: Maybe<Events_Min_Fields>;
};


/** aggregate fields of "events" */
export type Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "events" */
export type Events_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Events_Max_Order_By>;
  min?: InputMaybe<Events_Min_Order_By>;
};

/** input type for inserting array relation for remote table "events" */
export type Events_Arr_Rel_Insert_Input = {
  data: Array<Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _eventAreaAssignments?: InputMaybe<EventAreaAssignments_Bool_Exp>;
  _eventAreaAssignments_aggregate?: InputMaybe<EventAreaAssignments_Aggregate_Bool_Exp>;
  _eventBeginning?: InputMaybe<EventBeginnings_Bool_Exp>;
  _eventBeginnings?: InputMaybe<EventBeginnings_Bool_Exp>;
  _eventBeginnings_aggregate?: InputMaybe<EventBeginnings_Aggregate_Bool_Exp>;
  _eventDiagnoses?: InputMaybe<EventDiagnoses_Bool_Exp>;
  _eventDiagnoses_aggregate?: InputMaybe<EventDiagnoses_Aggregate_Bool_Exp>;
  _eventExpiration?: InputMaybe<EventExpirations_Bool_Exp>;
  _eventExpirations?: InputMaybe<EventExpirations_Bool_Exp>;
  _eventExpirations_aggregate?: InputMaybe<EventExpirations_Aggregate_Bool_Exp>;
  _eventLimitTime?: InputMaybe<EventLimitTimes_Bool_Exp>;
  _eventLimitTimes?: InputMaybe<EventLimitTimes_Bool_Exp>;
  _eventLimitTimes_aggregate?: InputMaybe<EventLimitTimes_Aggregate_Bool_Exp>;
  _eventTagAssignments?: InputMaybe<EventTagAssignments_Bool_Exp>;
  _eventTagAssignments_aggregate?: InputMaybe<EventTagAssignments_Aggregate_Bool_Exp>;
  _examinations?: InputMaybe<Examinations_Bool_Exp>;
  _examinations_aggregate?: InputMaybe<Examinations_Aggregate_Bool_Exp>;
  _guestExaminees?: InputMaybe<GuestExaminees_Bool_Exp>;
  _guestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Bool_Exp>;
  _inactiveGroupEvents?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
  _inactiveGroupEvents_aggregate?: InputMaybe<InactiveGroupEvents_Aggregate_Bool_Exp>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  enableFileUpload?: InputMaybe<Boolean_Comparison_Exp>;
  eventAreaAssignments?: InputMaybe<EventAreaAssignments_Bool_Exp>;
  eventAreaAssignments_aggregate?: InputMaybe<EventAreaAssignments_Aggregate_Bool_Exp>;
  eventBeginning?: InputMaybe<EventBeginnings_Bool_Exp>;
  eventDiagnoses?: InputMaybe<EventDiagnoses_Bool_Exp>;
  eventDiagnoses_aggregate?: InputMaybe<EventDiagnoses_Aggregate_Bool_Exp>;
  eventExpiration?: InputMaybe<EventExpirations_Bool_Exp>;
  eventLimitTime?: InputMaybe<EventLimitTimes_Bool_Exp>;
  eventTagAssignments?: InputMaybe<EventTagAssignments_Bool_Exp>;
  eventTagAssignments_aggregate?: InputMaybe<EventTagAssignments_Aggregate_Bool_Exp>;
  examinations?: InputMaybe<Examinations_Bool_Exp>;
  examinations_aggregate?: InputMaybe<Examinations_Aggregate_Bool_Exp>;
  fileUploadDescription?: InputMaybe<String_Comparison_Exp>;
  fileUploadType?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  guestExaminees?: InputMaybe<GuestExaminees_Bool_Exp>;
  guestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inactiveGroupEvent?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "events" */
export enum Events_Constraint {
  /** unique or primary key constraint on columns "id", "groupId" */
  EventsGroupIdIdKey = 'events_groupId_id_key',
  /** unique or primary key constraint on columns "id" */
  EventsPkey = 'events_pkey'
}

/** input type for inserting data into table "events" */
export type Events_Insert_Input = {
  _eventAreaAssignments?: InputMaybe<EventAreaAssignments_Arr_Rel_Insert_Input>;
  _eventBeginning?: InputMaybe<EventBeginnings_Obj_Rel_Insert_Input>;
  _eventBeginnings?: InputMaybe<EventBeginnings_Arr_Rel_Insert_Input>;
  _eventDiagnoses?: InputMaybe<EventDiagnoses_Arr_Rel_Insert_Input>;
  _eventExpiration?: InputMaybe<EventExpirations_Obj_Rel_Insert_Input>;
  _eventExpirations?: InputMaybe<EventExpirations_Arr_Rel_Insert_Input>;
  _eventLimitTime?: InputMaybe<EventLimitTimes_Obj_Rel_Insert_Input>;
  _eventLimitTimes?: InputMaybe<EventLimitTimes_Arr_Rel_Insert_Input>;
  _eventTagAssignments?: InputMaybe<EventTagAssignments_Arr_Rel_Insert_Input>;
  _examinations?: InputMaybe<Examinations_Arr_Rel_Insert_Input>;
  _guestExaminees?: InputMaybe<GuestExaminees_Arr_Rel_Insert_Input>;
  _inactiveGroupEvents?: InputMaybe<InactiveGroupEvents_Arr_Rel_Insert_Input>;
  enableFileUpload?: InputMaybe<Scalars['Boolean']>;
  eventAreaAssignments?: InputMaybe<EventAreaAssignments_Arr_Rel_Insert_Input>;
  eventBeginning?: InputMaybe<EventBeginnings_Obj_Rel_Insert_Input>;
  eventDiagnoses?: InputMaybe<EventDiagnoses_Arr_Rel_Insert_Input>;
  eventExpiration?: InputMaybe<EventExpirations_Obj_Rel_Insert_Input>;
  eventLimitTime?: InputMaybe<EventLimitTimes_Obj_Rel_Insert_Input>;
  eventTagAssignments?: InputMaybe<EventTagAssignments_Arr_Rel_Insert_Input>;
  examinations?: InputMaybe<Examinations_Arr_Rel_Insert_Input>;
  fileUploadDescription?: InputMaybe<Scalars['String']>;
  fileUploadType?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  guestExaminees?: InputMaybe<GuestExaminees_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  inactiveGroupEvent?: InputMaybe<InactiveGroupEvents_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Events_Max_Fields = {
  __typename?: 'events_max_fields';
  fileUploadDescription?: Maybe<Scalars['String']>;
  fileUploadType?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "events" */
export type Events_Max_Order_By = {
  fileUploadDescription?: InputMaybe<Order_By>;
  fileUploadType?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Events_Min_Fields = {
  __typename?: 'events_min_fields';
  fileUploadDescription?: Maybe<Scalars['String']>;
  fileUploadType?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "events" */
export type Events_Min_Order_By = {
  fileUploadDescription?: InputMaybe<Order_By>;
  fileUploadType?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "events" */
export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** input type for inserting object relation for remote table "events" */
export type Events_Obj_Rel_Insert_Input = {
  data: Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** on_conflict condition type for table "events" */
export type Events_On_Conflict = {
  constraint: Events_Constraint;
  update_columns?: Array<Events_Update_Column>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  _eventAreaAssignments_aggregate?: InputMaybe<EventAreaAssignments_Aggregate_Order_By>;
  _eventBeginning?: InputMaybe<EventBeginnings_Order_By>;
  _eventBeginnings_aggregate?: InputMaybe<EventBeginnings_Aggregate_Order_By>;
  _eventDiagnoses_aggregate?: InputMaybe<EventDiagnoses_Aggregate_Order_By>;
  _eventExpiration?: InputMaybe<EventExpirations_Order_By>;
  _eventExpirations_aggregate?: InputMaybe<EventExpirations_Aggregate_Order_By>;
  _eventLimitTime?: InputMaybe<EventLimitTimes_Order_By>;
  _eventLimitTimes_aggregate?: InputMaybe<EventLimitTimes_Aggregate_Order_By>;
  _eventTagAssignments_aggregate?: InputMaybe<EventTagAssignments_Aggregate_Order_By>;
  _examinations_aggregate?: InputMaybe<Examinations_Aggregate_Order_By>;
  _guestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Order_By>;
  _inactiveGroupEvents_aggregate?: InputMaybe<InactiveGroupEvents_Aggregate_Order_By>;
  enableFileUpload?: InputMaybe<Order_By>;
  eventAreaAssignments_aggregate?: InputMaybe<EventAreaAssignments_Aggregate_Order_By>;
  eventBeginning?: InputMaybe<EventBeginnings_Order_By>;
  eventDiagnoses_aggregate?: InputMaybe<EventDiagnoses_Aggregate_Order_By>;
  eventExpiration?: InputMaybe<EventExpirations_Order_By>;
  eventLimitTime?: InputMaybe<EventLimitTimes_Order_By>;
  eventTagAssignments_aggregate?: InputMaybe<EventTagAssignments_Aggregate_Order_By>;
  examinations_aggregate?: InputMaybe<Examinations_Aggregate_Order_By>;
  fileUploadDescription?: InputMaybe<Order_By>;
  fileUploadType?: InputMaybe<Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  guestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  inactiveGroupEvent?: InputMaybe<InactiveGroupEvents_Order_By>;
  name?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
};

/** primary key columns input for table: events */
export type Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  EnableFileUpload = 'enableFileUpload',
  /** column name */
  FileUploadDescription = 'fileUploadDescription',
  /** column name */
  FileUploadType = 'fileUploadType',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Public = 'public'
}

/** select "events_aggregate_bool_exp_bool_and_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EnableFileUpload = 'enableFileUpload',
  /** column name */
  Public = 'public'
}

/** select "events_aggregate_bool_exp_bool_or_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EnableFileUpload = 'enableFileUpload',
  /** column name */
  Public = 'public'
}

/** input type for updating data in table "events" */
export type Events_Set_Input = {
  enableFileUpload?: InputMaybe<Scalars['Boolean']>;
  fileUploadDescription?: InputMaybe<Scalars['String']>;
  fileUploadType?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_Input = {
  enableFileUpload?: InputMaybe<Scalars['Boolean']>;
  fileUploadDescription?: InputMaybe<Scalars['String']>;
  fileUploadType?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "events" */
export enum Events_Update_Column {
  /** column name */
  EnableFileUpload = 'enableFileUpload',
  /** column name */
  FileUploadDescription = 'fileUploadDescription',
  /** column name */
  FileUploadType = 'fileUploadType',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Public = 'public'
}

export type Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Events_Bool_Exp;
};

/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnoses = {
  __typename?: 'examinationDiagnoses';
  /** An array relationship */
  _eventDiagnoses: Array<EventDiagnoses>;
  /** An aggregate relationship */
  _eventDiagnoses_aggregate: EventDiagnoses_Aggregate;
  /** An object relationship */
  _eventDiagnosis?: Maybe<EventDiagnoses>;
  /** An object relationship */
  _examination?: Maybe<Examinations>;
  /** An array relationship */
  _examinationDiagnosisAnswers: Array<ExaminationDiagnosisAnswers>;
  /** An aggregate relationship */
  _examinationDiagnosisAnswers_aggregate: ExaminationDiagnosisAnswers_Aggregate;
  /** An array relationship */
  _examinations: Array<Examinations>;
  /** An aggregate relationship */
  _examinations_aggregate: Examinations_Aggregate;
  diagnosisId: Scalars['uuid'];
  /** An object relationship */
  eventDiagnosis?: Maybe<EventDiagnoses>;
  eventId: Scalars['uuid'];
  /** An object relationship */
  examination?: Maybe<Examinations>;
  /** An array relationship */
  examinationDiagnosisAnswers: Array<ExaminationDiagnosisAnswers>;
  /** An aggregate relationship */
  examinationDiagnosisAnswers_aggregate: ExaminationDiagnosisAnswers_Aggregate;
  /** An array relationship */
  examinationDiagnosisScores: Array<ExaminationDiagnosisScores>;
  /** An aggregate relationship */
  examinationDiagnosisScores_aggregate: ExaminationDiagnosisScores_Aggregate;
  examinationId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  /** An object relationship */
  personalityDiagnosisResult?: Maybe<PersonalityDiagnosisResults>;
  /** An object relationship */
  resilienceDiagnosisResult?: Maybe<ResilienceDiagnosisResults>;
  /** An object relationship */
  stressDiagnosisResult?: Maybe<StressDiagnosisResults>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnoses_EventDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnoses_EventDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnoses_ExaminationDiagnosisAnswersArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnoses_ExaminationDiagnosisAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnoses_ExaminationsArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnoses_Examinations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnosesExaminationDiagnosisAnswersArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnosesExaminationDiagnosisAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnosesExaminationDiagnosisScoresArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisScores_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnoses" */
export type ExaminationDiagnosesExaminationDiagnosisScores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisScores_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
};

/** aggregated selection of "examinationDiagnoses" */
export type ExaminationDiagnoses_Aggregate = {
  __typename?: 'examinationDiagnoses_aggregate';
  aggregate?: Maybe<ExaminationDiagnoses_Aggregate_Fields>;
  nodes: Array<ExaminationDiagnoses>;
};

export type ExaminationDiagnoses_Aggregate_Bool_Exp = {
  count?: InputMaybe<ExaminationDiagnoses_Aggregate_Bool_Exp_Count>;
};

export type ExaminationDiagnoses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "examinationDiagnoses" */
export type ExaminationDiagnoses_Aggregate_Fields = {
  __typename?: 'examinationDiagnoses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ExaminationDiagnoses_Max_Fields>;
  min?: Maybe<ExaminationDiagnoses_Min_Fields>;
};


/** aggregate fields of "examinationDiagnoses" */
export type ExaminationDiagnoses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "examinationDiagnoses" */
export type ExaminationDiagnoses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ExaminationDiagnoses_Max_Order_By>;
  min?: InputMaybe<ExaminationDiagnoses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "examinationDiagnoses" */
export type ExaminationDiagnoses_Arr_Rel_Insert_Input = {
  data: Array<ExaminationDiagnoses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ExaminationDiagnoses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "examinationDiagnoses". All fields are combined with a logical 'AND'. */
export type ExaminationDiagnoses_Bool_Exp = {
  _and?: InputMaybe<Array<ExaminationDiagnoses_Bool_Exp>>;
  _eventDiagnoses?: InputMaybe<EventDiagnoses_Bool_Exp>;
  _eventDiagnoses_aggregate?: InputMaybe<EventDiagnoses_Aggregate_Bool_Exp>;
  _eventDiagnosis?: InputMaybe<EventDiagnoses_Bool_Exp>;
  _examination?: InputMaybe<Examinations_Bool_Exp>;
  _examinationDiagnosisAnswers?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
  _examinationDiagnosisAnswers_aggregate?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Bool_Exp>;
  _examinations?: InputMaybe<Examinations_Bool_Exp>;
  _examinations_aggregate?: InputMaybe<Examinations_Aggregate_Bool_Exp>;
  _not?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  _or?: InputMaybe<Array<ExaminationDiagnoses_Bool_Exp>>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  eventDiagnosis?: InputMaybe<EventDiagnoses_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  examination?: InputMaybe<Examinations_Bool_Exp>;
  examinationDiagnosisAnswers?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
  examinationDiagnosisAnswers_aggregate?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Bool_Exp>;
  examinationDiagnosisScores?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  examinationDiagnosisScores_aggregate?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp>;
  examinationId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  personalityDiagnosisResult?: InputMaybe<PersonalityDiagnosisResults_Bool_Exp>;
  resilienceDiagnosisResult?: InputMaybe<ResilienceDiagnosisResults_Bool_Exp>;
  stressDiagnosisResult?: InputMaybe<StressDiagnosisResults_Bool_Exp>;
};

/** unique or primary key constraints on table "examinationDiagnoses" */
export enum ExaminationDiagnoses_Constraint {
  /** unique or primary key constraint on columns "diagnosisId", "examinationId", "groupId" */
  ExaminationDiagnosesExaminationIdDiagnosisIdGroupIdKey = 'examinationDiagnoses_examinationId_diagnosisId_groupId_key',
  /** unique or primary key constraint on columns "diagnosisId", "examinationId" */
  ExaminationDiagnosesPkey = 'examinationDiagnoses_pkey'
}

/** input type for inserting data into table "examinationDiagnoses" */
export type ExaminationDiagnoses_Insert_Input = {
  _eventDiagnoses?: InputMaybe<EventDiagnoses_Arr_Rel_Insert_Input>;
  _eventDiagnosis?: InputMaybe<EventDiagnoses_Obj_Rel_Insert_Input>;
  _examination?: InputMaybe<Examinations_Obj_Rel_Insert_Input>;
  _examinationDiagnosisAnswers?: InputMaybe<ExaminationDiagnosisAnswers_Arr_Rel_Insert_Input>;
  _examinations?: InputMaybe<Examinations_Arr_Rel_Insert_Input>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  eventDiagnosis?: InputMaybe<EventDiagnoses_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']>;
  examination?: InputMaybe<Examinations_Obj_Rel_Insert_Input>;
  examinationDiagnosisAnswers?: InputMaybe<ExaminationDiagnosisAnswers_Arr_Rel_Insert_Input>;
  examinationDiagnosisScores?: InputMaybe<ExaminationDiagnosisScores_Arr_Rel_Insert_Input>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  personalityDiagnosisResult?: InputMaybe<PersonalityDiagnosisResults_Obj_Rel_Insert_Input>;
  resilienceDiagnosisResult?: InputMaybe<ResilienceDiagnosisResults_Obj_Rel_Insert_Input>;
  stressDiagnosisResult?: InputMaybe<StressDiagnosisResults_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ExaminationDiagnoses_Max_Fields = {
  __typename?: 'examinationDiagnoses_max_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  eventId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "examinationDiagnoses" */
export type ExaminationDiagnoses_Max_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ExaminationDiagnoses_Min_Fields = {
  __typename?: 'examinationDiagnoses_min_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  eventId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "examinationDiagnoses" */
export type ExaminationDiagnoses_Min_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "examinationDiagnoses" */
export type ExaminationDiagnoses_Mutation_Response = {
  __typename?: 'examinationDiagnoses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExaminationDiagnoses>;
};

/** input type for inserting object relation for remote table "examinationDiagnoses" */
export type ExaminationDiagnoses_Obj_Rel_Insert_Input = {
  data: ExaminationDiagnoses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ExaminationDiagnoses_On_Conflict>;
};

/** on_conflict condition type for table "examinationDiagnoses" */
export type ExaminationDiagnoses_On_Conflict = {
  constraint: ExaminationDiagnoses_Constraint;
  update_columns?: Array<ExaminationDiagnoses_Update_Column>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};

/** Ordering options when selecting data from "examinationDiagnoses". */
export type ExaminationDiagnoses_Order_By = {
  _eventDiagnoses_aggregate?: InputMaybe<EventDiagnoses_Aggregate_Order_By>;
  _eventDiagnosis?: InputMaybe<EventDiagnoses_Order_By>;
  _examination?: InputMaybe<Examinations_Order_By>;
  _examinationDiagnosisAnswers_aggregate?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Order_By>;
  _examinations_aggregate?: InputMaybe<Examinations_Aggregate_Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
  eventDiagnosis?: InputMaybe<EventDiagnoses_Order_By>;
  eventId?: InputMaybe<Order_By>;
  examination?: InputMaybe<Examinations_Order_By>;
  examinationDiagnosisAnswers_aggregate?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Order_By>;
  examinationDiagnosisScores_aggregate?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  personalityDiagnosisResult?: InputMaybe<PersonalityDiagnosisResults_Order_By>;
  resilienceDiagnosisResult?: InputMaybe<ResilienceDiagnosisResults_Order_By>;
  stressDiagnosisResult?: InputMaybe<StressDiagnosisResults_Order_By>;
};

/** primary key columns input for table: examinationDiagnoses */
export type ExaminationDiagnoses_Pk_Columns_Input = {
  diagnosisId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
};

/** select columns of table "examinationDiagnoses" */
export enum ExaminationDiagnoses_Select_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId'
}

/** input type for updating data in table "examinationDiagnoses" */
export type ExaminationDiagnoses_Set_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "examinationDiagnoses" */
export type ExaminationDiagnoses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ExaminationDiagnoses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ExaminationDiagnoses_Stream_Cursor_Value_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "examinationDiagnoses" */
export enum ExaminationDiagnoses_Update_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId'
}

export type ExaminationDiagnoses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExaminationDiagnoses_Set_Input>;
  /** filter the rows which have to be updated */
  where: ExaminationDiagnoses_Bool_Exp;
};

/** columns and relationships of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers = {
  __typename?: 'examinationDiagnosisAnswers';
  /** An array relationship */
  _examinationDiagnoses: Array<ExaminationDiagnoses>;
  /** An aggregate relationship */
  _examinationDiagnoses_aggregate: ExaminationDiagnoses_Aggregate;
  /** An object relationship */
  _examinationDiagnosis?: Maybe<ExaminationDiagnoses>;
  /** An array relationship */
  _questionChoices: Array<QuestionChoices>;
  /** An aggregate relationship */
  _questionChoices_aggregate: QuestionChoices_Aggregate;
  /** An array relationship */
  _questions: Array<Questions>;
  /** An aggregate relationship */
  _questions_aggregate: Questions_Aggregate;
  diagnosisId: Scalars['uuid'];
  /** An object relationship */
  examinationDiagnosis?: Maybe<ExaminationDiagnoses>;
  examinationId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  /** An object relationship */
  question?: Maybe<Questions>;
  /** An object relationship */
  questionChoice?: Maybe<QuestionChoices>;
  questionChoiceId: Scalars['uuid'];
  questionId: Scalars['uuid'];
};


/** columns and relationships of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_ExaminationDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_ExaminationDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_QuestionChoicesArgs = {
  distinct_on?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionChoices_Order_By>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_QuestionChoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionChoices_Order_By>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


/** columns and relationships of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};

/** aggregated selection of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Aggregate = {
  __typename?: 'examinationDiagnosisAnswers_aggregate';
  aggregate?: Maybe<ExaminationDiagnosisAnswers_Aggregate_Fields>;
  nodes: Array<ExaminationDiagnosisAnswers>;
};

export type ExaminationDiagnosisAnswers_Aggregate_Bool_Exp = {
  count?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Bool_Exp_Count>;
};

export type ExaminationDiagnosisAnswers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Aggregate_Fields = {
  __typename?: 'examinationDiagnosisAnswers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ExaminationDiagnosisAnswers_Max_Fields>;
  min?: Maybe<ExaminationDiagnosisAnswers_Min_Fields>;
};


/** aggregate fields of "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ExaminationDiagnosisAnswers_Max_Order_By>;
  min?: InputMaybe<ExaminationDiagnosisAnswers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Arr_Rel_Insert_Input = {
  data: Array<ExaminationDiagnosisAnswers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ExaminationDiagnosisAnswers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "examinationDiagnosisAnswers". All fields are combined with a logical 'AND'. */
export type ExaminationDiagnosisAnswers_Bool_Exp = {
  _and?: InputMaybe<Array<ExaminationDiagnosisAnswers_Bool_Exp>>;
  _examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  _examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Bool_Exp>;
  _examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  _not?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
  _or?: InputMaybe<Array<ExaminationDiagnosisAnswers_Bool_Exp>>;
  _questionChoices?: InputMaybe<QuestionChoices_Bool_Exp>;
  _questionChoices_aggregate?: InputMaybe<QuestionChoices_Aggregate_Bool_Exp>;
  _questions?: InputMaybe<Questions_Bool_Exp>;
  _questions_aggregate?: InputMaybe<Questions_Aggregate_Bool_Exp>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  examinationId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<Questions_Bool_Exp>;
  questionChoice?: InputMaybe<QuestionChoices_Bool_Exp>;
  questionChoiceId?: InputMaybe<Uuid_Comparison_Exp>;
  questionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "examinationDiagnosisAnswers" */
export enum ExaminationDiagnosisAnswers_Constraint {
  /** unique or primary key constraint on columns "questionId", "diagnosisId", "examinationId" */
  ExaminationDiagnosisAnswersPkey = 'examinationDiagnosisAnswers_pkey'
}

/** input type for inserting data into table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Insert_Input = {
  _examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Arr_Rel_Insert_Input>;
  _examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Obj_Rel_Insert_Input>;
  _questionChoices?: InputMaybe<QuestionChoices_Arr_Rel_Insert_Input>;
  _questions?: InputMaybe<Questions_Arr_Rel_Insert_Input>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Obj_Rel_Insert_Input>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Questions_Obj_Rel_Insert_Input>;
  questionChoice?: InputMaybe<QuestionChoices_Obj_Rel_Insert_Input>;
  questionChoiceId?: InputMaybe<Scalars['uuid']>;
  questionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ExaminationDiagnosisAnswers_Max_Fields = {
  __typename?: 'examinationDiagnosisAnswers_max_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  questionChoiceId?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Max_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  questionChoiceId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ExaminationDiagnosisAnswers_Min_Fields = {
  __typename?: 'examinationDiagnosisAnswers_min_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  questionChoiceId?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Min_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  questionChoiceId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Mutation_Response = {
  __typename?: 'examinationDiagnosisAnswers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExaminationDiagnosisAnswers>;
};

/** on_conflict condition type for table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_On_Conflict = {
  constraint: ExaminationDiagnosisAnswers_Constraint;
  update_columns?: Array<ExaminationDiagnosisAnswers_Update_Column>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};

/** Ordering options when selecting data from "examinationDiagnosisAnswers". */
export type ExaminationDiagnosisAnswers_Order_By = {
  _examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Order_By>;
  _examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Order_By>;
  _questionChoices_aggregate?: InputMaybe<QuestionChoices_Aggregate_Order_By>;
  _questions_aggregate?: InputMaybe<Questions_Aggregate_Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  question?: InputMaybe<Questions_Order_By>;
  questionChoice?: InputMaybe<QuestionChoices_Order_By>;
  questionChoiceId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: examinationDiagnosisAnswers */
export type ExaminationDiagnosisAnswers_Pk_Columns_Input = {
  diagnosisId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
  questionId: Scalars['uuid'];
};

/** select columns of table "examinationDiagnosisAnswers" */
export enum ExaminationDiagnosisAnswers_Select_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  QuestionChoiceId = 'questionChoiceId',
  /** column name */
  QuestionId = 'questionId'
}

/** input type for updating data in table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Set_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  questionChoiceId?: InputMaybe<Scalars['uuid']>;
  questionId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "examinationDiagnosisAnswers" */
export type ExaminationDiagnosisAnswers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ExaminationDiagnosisAnswers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ExaminationDiagnosisAnswers_Stream_Cursor_Value_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  questionChoiceId?: InputMaybe<Scalars['uuid']>;
  questionId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "examinationDiagnosisAnswers" */
export enum ExaminationDiagnosisAnswers_Update_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  QuestionChoiceId = 'questionChoiceId',
  /** column name */
  QuestionId = 'questionId'
}

export type ExaminationDiagnosisAnswers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExaminationDiagnosisAnswers_Set_Input>;
  /** filter the rows which have to be updated */
  where: ExaminationDiagnosisAnswers_Bool_Exp;
};

/** columns and relationships of "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores = {
  __typename?: 'examinationDiagnosisScores';
  diagnosisId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  examinationDiagnosis?: Maybe<ExaminationDiagnoses>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  scoreType?: Maybe<ScoreTypes>;
  scoreTypeCode?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Aggregate = {
  __typename?: 'examinationDiagnosisScores_aggregate';
  aggregate?: Maybe<ExaminationDiagnosisScores_Aggregate_Fields>;
  nodes: Array<ExaminationDiagnosisScores>;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp = {
  avg?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<ExaminationDiagnosisScores_Aggregate_Bool_Exp_Var_Samp>;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Avg = {
  arguments: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Corr = {
  arguments: ExaminationDiagnosisScores_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Corr_Arguments = {
  X: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ExaminationDiagnosisScores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: ExaminationDiagnosisScores_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Max = {
  arguments: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Min = {
  arguments: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Sum = {
  arguments: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ExaminationDiagnosisScores_Aggregate_Bool_Exp_Var_Samp = {
  arguments: ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Aggregate_Fields = {
  __typename?: 'examinationDiagnosisScores_aggregate_fields';
  avg?: Maybe<ExaminationDiagnosisScores_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ExaminationDiagnosisScores_Max_Fields>;
  min?: Maybe<ExaminationDiagnosisScores_Min_Fields>;
  stddev?: Maybe<ExaminationDiagnosisScores_Stddev_Fields>;
  stddev_pop?: Maybe<ExaminationDiagnosisScores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ExaminationDiagnosisScores_Stddev_Samp_Fields>;
  sum?: Maybe<ExaminationDiagnosisScores_Sum_Fields>;
  var_pop?: Maybe<ExaminationDiagnosisScores_Var_Pop_Fields>;
  var_samp?: Maybe<ExaminationDiagnosisScores_Var_Samp_Fields>;
  variance?: Maybe<ExaminationDiagnosisScores_Variance_Fields>;
};


/** aggregate fields of "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ExaminationDiagnosisScores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Aggregate_Order_By = {
  avg?: InputMaybe<ExaminationDiagnosisScores_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ExaminationDiagnosisScores_Max_Order_By>;
  min?: InputMaybe<ExaminationDiagnosisScores_Min_Order_By>;
  stddev?: InputMaybe<ExaminationDiagnosisScores_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ExaminationDiagnosisScores_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ExaminationDiagnosisScores_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ExaminationDiagnosisScores_Sum_Order_By>;
  var_pop?: InputMaybe<ExaminationDiagnosisScores_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ExaminationDiagnosisScores_Var_Samp_Order_By>;
  variance?: InputMaybe<ExaminationDiagnosisScores_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Arr_Rel_Insert_Input = {
  data: Array<ExaminationDiagnosisScores_Insert_Input>;
};

/** aggregate avg on columns */
export type ExaminationDiagnosisScores_Avg_Fields = {
  __typename?: 'examinationDiagnosisScores_avg_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "examinationDiagnosisScores". All fields are combined with a logical 'AND'. */
export type ExaminationDiagnosisScores_Bool_Exp = {
  _and?: InputMaybe<Array<ExaminationDiagnosisScores_Bool_Exp>>;
  _not?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
  _or?: InputMaybe<Array<ExaminationDiagnosisScores_Bool_Exp>>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  examinationId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  scoreType?: InputMaybe<ScoreTypes_Bool_Exp>;
  scoreTypeCode?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for inserting data into table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Insert_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Obj_Rel_Insert_Input>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  scoreType?: InputMaybe<ScoreTypes_Obj_Rel_Insert_Input>;
  scoreTypeCode?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type ExaminationDiagnosisScores_Max_Fields = {
  __typename?: 'examinationDiagnosisScores_max_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  scoreTypeCode?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Max_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  scoreTypeCode?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ExaminationDiagnosisScores_Min_Fields = {
  __typename?: 'examinationDiagnosisScores_min_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  scoreTypeCode?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Min_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  scoreTypeCode?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "examinationDiagnosisScores". */
export type ExaminationDiagnosisScores_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  scoreType?: InputMaybe<ScoreTypes_Order_By>;
  scoreTypeCode?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  ScoreTypeCode = 'scoreTypeCode',
  /** column name */
  Value = 'value'
}

/** select "examinationDiagnosisScores_aggregate_bool_exp_avg_arguments_columns" columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "examinationDiagnosisScores_aggregate_bool_exp_corr_arguments_columns" columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "examinationDiagnosisScores_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "examinationDiagnosisScores_aggregate_bool_exp_max_arguments_columns" columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "examinationDiagnosisScores_aggregate_bool_exp_min_arguments_columns" columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "examinationDiagnosisScores_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "examinationDiagnosisScores_aggregate_bool_exp_sum_arguments_columns" columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "examinationDiagnosisScores_aggregate_bool_exp_var_samp_arguments_columns" columns of table "examinationDiagnosisScores" */
export enum ExaminationDiagnosisScores_Select_Column_ExaminationDiagnosisScores_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type ExaminationDiagnosisScores_Stddev_Fields = {
  __typename?: 'examinationDiagnosisScores_stddev_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ExaminationDiagnosisScores_Stddev_Pop_Fields = {
  __typename?: 'examinationDiagnosisScores_stddev_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ExaminationDiagnosisScores_Stddev_Samp_Fields = {
  __typename?: 'examinationDiagnosisScores_stddev_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ExaminationDiagnosisScores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ExaminationDiagnosisScores_Stream_Cursor_Value_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  scoreTypeCode?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type ExaminationDiagnosisScores_Sum_Fields = {
  __typename?: 'examinationDiagnosisScores_sum_fields';
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type ExaminationDiagnosisScores_Var_Pop_Fields = {
  __typename?: 'examinationDiagnosisScores_var_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ExaminationDiagnosisScores_Var_Samp_Fields = {
  __typename?: 'examinationDiagnosisScores_var_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ExaminationDiagnosisScores_Variance_Fields = {
  __typename?: 'examinationDiagnosisScores_variance_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "examinationDiagnosisScores" */
export type ExaminationDiagnosisScores_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "examinations" */
export type Examinations = {
  __typename?: 'examinations';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An array relationship */
  _examinationDiagnoses: Array<ExaminationDiagnoses>;
  /** An aggregate relationship */
  _examinationDiagnoses_aggregate: ExaminationDiagnoses_Aggregate;
  /** An object relationship */
  _guestExamineeExamination?: Maybe<GuestExamineeExaminations>;
  /** An array relationship */
  _guestExamineeExaminations: Array<GuestExamineeExaminations>;
  /** An aggregate relationship */
  _guestExamineeExaminations_aggregate: GuestExamineeExaminations_Aggregate;
  age: Scalars['Int'];
  /** An object relationship */
  event?: Maybe<Events>;
  eventId: Scalars['uuid'];
  /** An array relationship */
  examinationDiagnoses: Array<ExaminationDiagnoses>;
  /** An aggregate relationship */
  examinationDiagnoses_aggregate: ExaminationDiagnoses_Aggregate;
  /** An object relationship */
  gender?: Maybe<Genders>;
  genderCode: Genders_Enum;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  /** An object relationship */
  guestExamineeExamination?: Maybe<GuestExamineeExaminations>;
  id: Scalars['uuid'];
  memo: Scalars['String'];
  telephone: Scalars['String'];
  timestamp: Scalars['timestamp'];
};


/** columns and relationships of "examinations" */
export type Examinations_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "examinations" */
export type Examinations_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "examinations" */
export type Examinations_ExaminationDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


/** columns and relationships of "examinations" */
export type Examinations_ExaminationDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


/** columns and relationships of "examinations" */
export type Examinations_GuestExamineeExaminationsArgs = {
  distinct_on?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExamineeExaminations_Order_By>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


/** columns and relationships of "examinations" */
export type Examinations_GuestExamineeExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExamineeExaminations_Order_By>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


/** columns and relationships of "examinations" */
export type ExaminationsExaminationDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


/** columns and relationships of "examinations" */
export type ExaminationsExaminationDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};

/** aggregated selection of "examinations" */
export type Examinations_Aggregate = {
  __typename?: 'examinations_aggregate';
  aggregate?: Maybe<Examinations_Aggregate_Fields>;
  nodes: Array<Examinations>;
};

export type Examinations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Examinations_Aggregate_Bool_Exp_Count>;
};

export type Examinations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Examinations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Examinations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "examinations" */
export type Examinations_Aggregate_Fields = {
  __typename?: 'examinations_aggregate_fields';
  avg?: Maybe<Examinations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Examinations_Max_Fields>;
  min?: Maybe<Examinations_Min_Fields>;
  stddev?: Maybe<Examinations_Stddev_Fields>;
  stddev_pop?: Maybe<Examinations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Examinations_Stddev_Samp_Fields>;
  sum?: Maybe<Examinations_Sum_Fields>;
  var_pop?: Maybe<Examinations_Var_Pop_Fields>;
  var_samp?: Maybe<Examinations_Var_Samp_Fields>;
  variance?: Maybe<Examinations_Variance_Fields>;
};


/** aggregate fields of "examinations" */
export type Examinations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Examinations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "examinations" */
export type Examinations_Aggregate_Order_By = {
  avg?: InputMaybe<Examinations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Examinations_Max_Order_By>;
  min?: InputMaybe<Examinations_Min_Order_By>;
  stddev?: InputMaybe<Examinations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Examinations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Examinations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Examinations_Sum_Order_By>;
  var_pop?: InputMaybe<Examinations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Examinations_Var_Samp_Order_By>;
  variance?: InputMaybe<Examinations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "examinations" */
export type Examinations_Arr_Rel_Insert_Input = {
  data: Array<Examinations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Examinations_On_Conflict>;
};

/** aggregate avg on columns */
export type Examinations_Avg_Fields = {
  __typename?: 'examinations_avg_fields';
  age?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "examinations" */
export type Examinations_Avg_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "examinations". All fields are combined with a logical 'AND'. */
export type Examinations_Bool_Exp = {
  _and?: InputMaybe<Array<Examinations_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  _examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Bool_Exp>;
  _guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
  _guestExamineeExaminations?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
  _guestExamineeExaminations_aggregate?: InputMaybe<GuestExamineeExaminations_Aggregate_Bool_Exp>;
  _not?: InputMaybe<Examinations_Bool_Exp>;
  _or?: InputMaybe<Array<Examinations_Bool_Exp>>;
  age?: InputMaybe<Int_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Bool_Exp>;
  gender?: InputMaybe<Genders_Bool_Exp>;
  genderCode?: InputMaybe<Genders_Enum_Comparison_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  memo?: InputMaybe<String_Comparison_Exp>;
  telephone?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "examinations" */
export enum Examinations_Constraint {
  /** unique or primary key constraint on columns "id", "groupId" */
  ExaminationsIdGroupIdKey = 'examinations_id_groupId_key',
  /** unique or primary key constraint on columns "id" */
  ExaminationsPkey = 'examinations_pkey'
}

/** input type for incrementing numeric columns in table "examinations" */
export type Examinations_Inc_Input = {
  age?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "examinations" */
export type Examinations_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  _examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Arr_Rel_Insert_Input>;
  _guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Obj_Rel_Insert_Input>;
  _guestExamineeExaminations?: InputMaybe<GuestExamineeExaminations_Arr_Rel_Insert_Input>;
  age?: InputMaybe<Scalars['Int']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']>;
  examinationDiagnoses?: InputMaybe<ExaminationDiagnoses_Arr_Rel_Insert_Input>;
  gender?: InputMaybe<Genders_Obj_Rel_Insert_Input>;
  genderCode?: InputMaybe<Genders_Enum>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  memo?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Examinations_Max_Fields = {
  __typename?: 'examinations_max_fields';
  age?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  memo?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "examinations" */
export type Examinations_Max_Order_By = {
  age?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  telephone?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Examinations_Min_Fields = {
  __typename?: 'examinations_min_fields';
  age?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  memo?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "examinations" */
export type Examinations_Min_Order_By = {
  age?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  telephone?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "examinations" */
export type Examinations_Mutation_Response = {
  __typename?: 'examinations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Examinations>;
};

/** input type for inserting object relation for remote table "examinations" */
export type Examinations_Obj_Rel_Insert_Input = {
  data: Examinations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Examinations_On_Conflict>;
};

/** on_conflict condition type for table "examinations" */
export type Examinations_On_Conflict = {
  constraint: Examinations_Constraint;
  update_columns?: Array<Examinations_Update_Column>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};

/** Ordering options when selecting data from "examinations". */
export type Examinations_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  _examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Order_By>;
  _guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Order_By>;
  _guestExamineeExaminations_aggregate?: InputMaybe<GuestExamineeExaminations_Aggregate_Order_By>;
  age?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  examinationDiagnoses_aggregate?: InputMaybe<ExaminationDiagnoses_Aggregate_Order_By>;
  gender?: InputMaybe<Genders_Order_By>;
  genderCode?: InputMaybe<Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Order_By>;
  id?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  telephone?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: examinations */
export type Examinations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "examinations" */
export enum Examinations_Select_Column {
  /** column name */
  Age = 'age',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GenderCode = 'genderCode',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Memo = 'memo',
  /** column name */
  Telephone = 'telephone',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "examinations" */
export type Examinations_Set_Input = {
  age?: InputMaybe<Scalars['Int']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  genderCode?: InputMaybe<Genders_Enum>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  memo?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Examinations_Stddev_Fields = {
  __typename?: 'examinations_stddev_fields';
  age?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "examinations" */
export type Examinations_Stddev_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Examinations_Stddev_Pop_Fields = {
  __typename?: 'examinations_stddev_pop_fields';
  age?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "examinations" */
export type Examinations_Stddev_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Examinations_Stddev_Samp_Fields = {
  __typename?: 'examinations_stddev_samp_fields';
  age?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "examinations" */
export type Examinations_Stddev_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "examinations" */
export type Examinations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Examinations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Examinations_Stream_Cursor_Value_Input = {
  age?: InputMaybe<Scalars['Int']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  genderCode?: InputMaybe<Genders_Enum>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  memo?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Examinations_Sum_Fields = {
  __typename?: 'examinations_sum_fields';
  age?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "examinations" */
export type Examinations_Sum_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** update columns of table "examinations" */
export enum Examinations_Update_Column {
  /** column name */
  Age = 'age',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GenderCode = 'genderCode',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Memo = 'memo',
  /** column name */
  Telephone = 'telephone',
  /** column name */
  Timestamp = 'timestamp'
}

export type Examinations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Examinations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Examinations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Examinations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Examinations_Var_Pop_Fields = {
  __typename?: 'examinations_var_pop_fields';
  age?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "examinations" */
export type Examinations_Var_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Examinations_Var_Samp_Fields = {
  __typename?: 'examinations_var_samp_fields';
  age?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "examinations" */
export type Examinations_Var_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Examinations_Variance_Fields = {
  __typename?: 'examinations_variance_fields';
  age?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "examinations" */
export type Examinations_Variance_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "genders" */
export type Genders = {
  __typename?: 'genders';
  code: Scalars['String'];
  /** An array relationship */
  examinations: Array<Examinations>;
  /** An aggregate relationship */
  examinations_aggregate: Examinations_Aggregate;
  /** An array relationship */
  translatedGenders: Array<TranslatedGenders>;
  /** An aggregate relationship */
  translatedGenders_aggregate: TranslatedGenders_Aggregate;
};


/** columns and relationships of "genders" */
export type GendersExaminationsArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "genders" */
export type GendersExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "genders" */
export type GendersTranslatedGendersArgs = {
  distinct_on?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TranslatedGenders_Order_By>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};


/** columns and relationships of "genders" */
export type GendersTranslatedGenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TranslatedGenders_Order_By>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};

/** aggregated selection of "genders" */
export type Genders_Aggregate = {
  __typename?: 'genders_aggregate';
  aggregate?: Maybe<Genders_Aggregate_Fields>;
  nodes: Array<Genders>;
};

/** aggregate fields of "genders" */
export type Genders_Aggregate_Fields = {
  __typename?: 'genders_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Genders_Max_Fields>;
  min?: Maybe<Genders_Min_Fields>;
};


/** aggregate fields of "genders" */
export type Genders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Genders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "genders". All fields are combined with a logical 'AND'. */
export type Genders_Bool_Exp = {
  _and?: InputMaybe<Array<Genders_Bool_Exp>>;
  _not?: InputMaybe<Genders_Bool_Exp>;
  _or?: InputMaybe<Array<Genders_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  examinations?: InputMaybe<Examinations_Bool_Exp>;
  examinations_aggregate?: InputMaybe<Examinations_Aggregate_Bool_Exp>;
  translatedGenders?: InputMaybe<TranslatedGenders_Bool_Exp>;
  translatedGenders_aggregate?: InputMaybe<TranslatedGenders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "genders" */
export enum Genders_Constraint {
  /** unique or primary key constraint on columns "code" */
  GendersPkey = 'genders_pkey'
}

export enum Genders_Enum {
  Another = 'another',
  Female = 'female',
  Male = 'male'
}

/** Boolean expression to compare columns of type "genders_enum". All fields are combined with logical 'AND'. */
export type Genders_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Genders_Enum>;
  _in?: InputMaybe<Array<Genders_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Genders_Enum>;
  _nin?: InputMaybe<Array<Genders_Enum>>;
};

/** input type for inserting data into table "genders" */
export type Genders_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  examinations?: InputMaybe<Examinations_Arr_Rel_Insert_Input>;
  translatedGenders?: InputMaybe<TranslatedGenders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Genders_Max_Fields = {
  __typename?: 'genders_max_fields';
  code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Genders_Min_Fields = {
  __typename?: 'genders_min_fields';
  code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "genders" */
export type Genders_Mutation_Response = {
  __typename?: 'genders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Genders>;
};

/** input type for inserting object relation for remote table "genders" */
export type Genders_Obj_Rel_Insert_Input = {
  data: Genders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Genders_On_Conflict>;
};

/** on_conflict condition type for table "genders" */
export type Genders_On_Conflict = {
  constraint: Genders_Constraint;
  update_columns?: Array<Genders_Update_Column>;
  where?: InputMaybe<Genders_Bool_Exp>;
};

/** Ordering options when selecting data from "genders". */
export type Genders_Order_By = {
  code?: InputMaybe<Order_By>;
  examinations_aggregate?: InputMaybe<Examinations_Aggregate_Order_By>;
  translatedGenders_aggregate?: InputMaybe<TranslatedGenders_Aggregate_Order_By>;
};

/** primary key columns input for table: genders */
export type Genders_Pk_Columns_Input = {
  code: Scalars['String'];
};

/** select columns of table "genders" */
export enum Genders_Select_Column {
  /** column name */
  Code = 'code'
}

/** input type for updating data in table "genders" */
export type Genders_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "genders" */
export type Genders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Genders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Genders_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
};

/** update columns of table "genders" */
export enum Genders_Update_Column {
  /** column name */
  Code = 'code'
}

export type Genders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Genders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Genders_Bool_Exp;
};

/** columns and relationships of "groupContents" */
export type GroupContents = {
  __typename?: 'groupContents';
  /** An array relationship */
  _groups: Array<Groups>;
  /** An aggregate relationship */
  _groups_aggregate: Groups_Aggregate;
  /** An object relationship */
  group?: Maybe<Groups>;
  id: Scalars['uuid'];
  imagePath: Scalars['String'];
};


/** columns and relationships of "groupContents" */
export type GroupContents_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


/** columns and relationships of "groupContents" */
export type GroupContents_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

/** aggregated selection of "groupContents" */
export type GroupContents_Aggregate = {
  __typename?: 'groupContents_aggregate';
  aggregate?: Maybe<GroupContents_Aggregate_Fields>;
  nodes: Array<GroupContents>;
};

export type GroupContents_Aggregate_Bool_Exp = {
  count?: InputMaybe<GroupContents_Aggregate_Bool_Exp_Count>;
};

export type GroupContents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<GroupContents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupContents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "groupContents" */
export type GroupContents_Aggregate_Fields = {
  __typename?: 'groupContents_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<GroupContents_Max_Fields>;
  min?: Maybe<GroupContents_Min_Fields>;
};


/** aggregate fields of "groupContents" */
export type GroupContents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GroupContents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "groupContents" */
export type GroupContents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<GroupContents_Max_Order_By>;
  min?: InputMaybe<GroupContents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "groupContents" */
export type GroupContents_Arr_Rel_Insert_Input = {
  data: Array<GroupContents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupContents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "groupContents". All fields are combined with a logical 'AND'. */
export type GroupContents_Bool_Exp = {
  _and?: InputMaybe<Array<GroupContents_Bool_Exp>>;
  _groups?: InputMaybe<Groups_Bool_Exp>;
  _groups_aggregate?: InputMaybe<Groups_Aggregate_Bool_Exp>;
  _not?: InputMaybe<GroupContents_Bool_Exp>;
  _or?: InputMaybe<Array<GroupContents_Bool_Exp>>;
  group?: InputMaybe<Groups_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imagePath?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "groupContents" */
export enum GroupContents_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupContentsPkey = 'groupContents_pkey'
}

/** input type for inserting data into table "groupContents" */
export type GroupContents_Insert_Input = {
  _groups?: InputMaybe<Groups_Arr_Rel_Insert_Input>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  imagePath?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GroupContents_Max_Fields = {
  __typename?: 'groupContents_max_fields';
  id?: Maybe<Scalars['uuid']>;
  imagePath?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "groupContents" */
export type GroupContents_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  imagePath?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type GroupContents_Min_Fields = {
  __typename?: 'groupContents_min_fields';
  id?: Maybe<Scalars['uuid']>;
  imagePath?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "groupContents" */
export type GroupContents_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  imagePath?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "groupContents" */
export type GroupContents_Mutation_Response = {
  __typename?: 'groupContents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupContents>;
};

/** input type for inserting object relation for remote table "groupContents" */
export type GroupContents_Obj_Rel_Insert_Input = {
  data: GroupContents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupContents_On_Conflict>;
};

/** on_conflict condition type for table "groupContents" */
export type GroupContents_On_Conflict = {
  constraint: GroupContents_Constraint;
  update_columns?: Array<GroupContents_Update_Column>;
  where?: InputMaybe<GroupContents_Bool_Exp>;
};

/** Ordering options when selecting data from "groupContents". */
export type GroupContents_Order_By = {
  _groups_aggregate?: InputMaybe<Groups_Aggregate_Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  id?: InputMaybe<Order_By>;
  imagePath?: InputMaybe<Order_By>;
};

/** primary key columns input for table: groupContents */
export type GroupContents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "groupContents" */
export enum GroupContents_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ImagePath = 'imagePath'
}

/** input type for updating data in table "groupContents" */
export type GroupContents_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  imagePath?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "groupContents" */
export type GroupContents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GroupContents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupContents_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  imagePath?: InputMaybe<Scalars['String']>;
};

/** update columns of table "groupContents" */
export enum GroupContents_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ImagePath = 'imagePath'
}

export type GroupContents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupContents_Set_Input>;
  /** filter the rows which have to be updated */
  where: GroupContents_Bool_Exp;
};

/** columns and relationships of "groupInvitations" */
export type GroupInvitations = {
  __typename?: 'groupInvitations';
  /** An array relationship */
  _memberships: Array<GroupInvitations>;
  /** An aggregate relationship */
  _memberships_aggregate: GroupInvitations_Aggregate;
  email: Scalars['String'];
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  /** An object relationship */
  membership?: Maybe<Memberships>;
  name: Scalars['String'];
  /** An array relationship */
  ownerships: Array<Ownerships>;
  /** An aggregate relationship */
  ownerships_aggregate: Ownerships_Aggregate;
  /** An object relationship */
  user?: Maybe<Users>;
  userId: Scalars['uuid'];
};


/** columns and relationships of "groupInvitations" */
export type GroupInvitations_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


/** columns and relationships of "groupInvitations" */
export type GroupInvitations_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


/** columns and relationships of "groupInvitations" */
export type GroupInvitationsOwnershipsArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


/** columns and relationships of "groupInvitations" */
export type GroupInvitationsOwnerships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};

/** aggregated selection of "groupInvitations" */
export type GroupInvitations_Aggregate = {
  __typename?: 'groupInvitations_aggregate';
  aggregate?: Maybe<GroupInvitations_Aggregate_Fields>;
  nodes: Array<GroupInvitations>;
};

export type GroupInvitations_Aggregate_Bool_Exp = {
  count?: InputMaybe<GroupInvitations_Aggregate_Bool_Exp_Count>;
};

export type GroupInvitations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupInvitations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "groupInvitations" */
export type GroupInvitations_Aggregate_Fields = {
  __typename?: 'groupInvitations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<GroupInvitations_Max_Fields>;
  min?: Maybe<GroupInvitations_Min_Fields>;
};


/** aggregate fields of "groupInvitations" */
export type GroupInvitations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "groupInvitations" */
export type GroupInvitations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<GroupInvitations_Max_Order_By>;
  min?: InputMaybe<GroupInvitations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "groupInvitations" */
export type GroupInvitations_Arr_Rel_Insert_Input = {
  data: Array<GroupInvitations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupInvitations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "groupInvitations". All fields are combined with a logical 'AND'. */
export type GroupInvitations_Bool_Exp = {
  _and?: InputMaybe<Array<GroupInvitations_Bool_Exp>>;
  _memberships?: InputMaybe<GroupInvitations_Bool_Exp>;
  _memberships_aggregate?: InputMaybe<GroupInvitations_Aggregate_Bool_Exp>;
  _not?: InputMaybe<GroupInvitations_Bool_Exp>;
  _or?: InputMaybe<Array<GroupInvitations_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  membership?: InputMaybe<Memberships_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ownerships?: InputMaybe<Ownerships_Bool_Exp>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "groupInvitations" */
export enum GroupInvitations_Constraint {
  /** unique or primary key constraint on columns "email" */
  GroupInvitationsEmailKey = 'groupInvitations_email_key',
  /** unique or primary key constraint on columns "userId", "groupId" */
  GroupInvitationsGroupIdUserIdUniqueness = 'groupInvitations_groupId_userId_uniqueness',
  /** unique or primary key constraint on columns "email", "groupId" */
  GroupInvitationsPkey = 'groupInvitations_pkey'
}

/** input type for inserting data into table "groupInvitations" */
export type GroupInvitations_Insert_Input = {
  _memberships?: InputMaybe<GroupInvitations_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  membership?: InputMaybe<Memberships_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  ownerships?: InputMaybe<Ownerships_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type GroupInvitations_Max_Fields = {
  __typename?: 'groupInvitations_max_fields';
  email?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "groupInvitations" */
export type GroupInvitations_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type GroupInvitations_Min_Fields = {
  __typename?: 'groupInvitations_min_fields';
  email?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "groupInvitations" */
export type GroupInvitations_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "groupInvitations" */
export type GroupInvitations_Mutation_Response = {
  __typename?: 'groupInvitations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupInvitations>;
};

/** input type for inserting object relation for remote table "groupInvitations" */
export type GroupInvitations_Obj_Rel_Insert_Input = {
  data: GroupInvitations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupInvitations_On_Conflict>;
};

/** on_conflict condition type for table "groupInvitations" */
export type GroupInvitations_On_Conflict = {
  constraint: GroupInvitations_Constraint;
  update_columns?: Array<GroupInvitations_Update_Column>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};

/** Ordering options when selecting data from "groupInvitations". */
export type GroupInvitations_Order_By = {
  _memberships_aggregate?: InputMaybe<GroupInvitations_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  membership?: InputMaybe<Memberships_Order_By>;
  name?: InputMaybe<Order_By>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: groupInvitations */
export type GroupInvitations_Pk_Columns_Input = {
  email: Scalars['String'];
  groupId: Scalars['uuid'];
};

/** select columns of table "groupInvitations" */
export enum GroupInvitations_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "groupInvitations" */
export type GroupInvitations_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "groupInvitations" */
export type GroupInvitations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GroupInvitations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupInvitations_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "groupInvitations" */
export enum GroupInvitations_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'userId'
}

export type GroupInvitations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupInvitations_Set_Input>;
  /** filter the rows which have to be updated */
  where: GroupInvitations_Bool_Exp;
};

/** columns and relationships of "groups" */
export type Groups = {
  __typename?: 'groups';
  /** An array relationship */
  _groupContents: Array<GroupContents>;
  /** An aggregate relationship */
  _groupContents_aggregate: GroupContents_Aggregate;
  /** An array relationship */
  _inactiveGroups: Array<InactiveGroups>;
  /** An aggregate relationship */
  _inactiveGroups_aggregate: InactiveGroups_Aggregate;
  /** An array relationship */
  eventAreas: Array<EventAreas>;
  /** An aggregate relationship */
  eventAreas_aggregate: EventAreas_Aggregate;
  /** An array relationship */
  eventBeginnings: Array<EventBeginnings>;
  /** An aggregate relationship */
  eventBeginnings_aggregate: EventBeginnings_Aggregate;
  /** An array relationship */
  eventExpirations: Array<EventExpirations>;
  /** An aggregate relationship */
  eventExpirations_aggregate: EventExpirations_Aggregate;
  /** An array relationship */
  eventLimitTimes: Array<EventLimitTimes>;
  /** An aggregate relationship */
  eventLimitTimes_aggregate: EventLimitTimes_Aggregate;
  /** An array relationship */
  eventTags: Array<EventTags>;
  /** An aggregate relationship */
  eventTags_aggregate: EventTags_Aggregate;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** An array relationship */
  examinations: Array<Examinations>;
  /** An aggregate relationship */
  examinations_aggregate: Examinations_Aggregate;
  /** An object relationship */
  groupContent?: Maybe<GroupContents>;
  /** An array relationship */
  groupInvitations: Array<GroupInvitations>;
  /** An aggregate relationship */
  groupInvitations_aggregate: GroupInvitations_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  inactiveGroup?: Maybe<InactiveGroups>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: Memberships_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  ownerships: Array<Ownerships>;
  /** An aggregate relationship */
  ownerships_aggregate: Ownerships_Aggregate;
};


/** columns and relationships of "groups" */
export type Groups_GroupContentsArgs = {
  distinct_on?: InputMaybe<Array<GroupContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupContents_Order_By>>;
  where?: InputMaybe<GroupContents_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type Groups_GroupContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupContents_Order_By>>;
  where?: InputMaybe<GroupContents_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type Groups_InactiveGroupsArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroups_Order_By>>;
  where?: InputMaybe<InactiveGroups_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type Groups_InactiveGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroups_Order_By>>;
  where?: InputMaybe<InactiveGroups_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventAreasArgs = {
  distinct_on?: InputMaybe<Array<EventAreas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreas_Order_By>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreas_Order_By>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventBeginningsArgs = {
  distinct_on?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventBeginnings_Order_By>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventBeginnings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventBeginnings_Order_By>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventExpirationsArgs = {
  distinct_on?: InputMaybe<Array<EventExpirations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExpirations_Order_By>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventExpirations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventExpirations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExpirations_Order_By>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventLimitTimesArgs = {
  distinct_on?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventLimitTimes_Order_By>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventLimitTimes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventLimitTimes_Order_By>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventTagsArgs = {
  distinct_on?: InputMaybe<Array<EventTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTags_Order_By>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTags_Order_By>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsExaminationsArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsGroupInvitationsArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsGroupInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsOwnershipsArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsOwnerships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};

/** aggregated selection of "groups" */
export type Groups_Aggregate = {
  __typename?: 'groups_aggregate';
  aggregate?: Maybe<Groups_Aggregate_Fields>;
  nodes: Array<Groups>;
};

export type Groups_Aggregate_Bool_Exp = {
  count?: InputMaybe<Groups_Aggregate_Bool_Exp_Count>;
};

export type Groups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Groups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "groups" */
export type Groups_Aggregate_Fields = {
  __typename?: 'groups_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Groups_Max_Fields>;
  min?: Maybe<Groups_Min_Fields>;
};


/** aggregate fields of "groups" */
export type Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "groups" */
export type Groups_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Groups_Max_Order_By>;
  min?: InputMaybe<Groups_Min_Order_By>;
};

/** input type for inserting array relation for remote table "groups" */
export type Groups_Arr_Rel_Insert_Input = {
  data: Array<Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** Boolean expression to filter rows from the table "groups". All fields are combined with a logical 'AND'. */
export type Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Groups_Bool_Exp>>;
  _groupContents?: InputMaybe<GroupContents_Bool_Exp>;
  _groupContents_aggregate?: InputMaybe<GroupContents_Aggregate_Bool_Exp>;
  _inactiveGroups?: InputMaybe<InactiveGroups_Bool_Exp>;
  _inactiveGroups_aggregate?: InputMaybe<InactiveGroups_Aggregate_Bool_Exp>;
  _not?: InputMaybe<Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Groups_Bool_Exp>>;
  eventAreas?: InputMaybe<EventAreas_Bool_Exp>;
  eventAreas_aggregate?: InputMaybe<EventAreas_Aggregate_Bool_Exp>;
  eventBeginnings?: InputMaybe<EventBeginnings_Bool_Exp>;
  eventBeginnings_aggregate?: InputMaybe<EventBeginnings_Aggregate_Bool_Exp>;
  eventExpirations?: InputMaybe<EventExpirations_Bool_Exp>;
  eventExpirations_aggregate?: InputMaybe<EventExpirations_Aggregate_Bool_Exp>;
  eventLimitTimes?: InputMaybe<EventLimitTimes_Bool_Exp>;
  eventLimitTimes_aggregate?: InputMaybe<EventLimitTimes_Aggregate_Bool_Exp>;
  eventTags?: InputMaybe<EventTags_Bool_Exp>;
  eventTags_aggregate?: InputMaybe<EventTags_Aggregate_Bool_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  examinations?: InputMaybe<Examinations_Bool_Exp>;
  examinations_aggregate?: InputMaybe<Examinations_Aggregate_Bool_Exp>;
  groupContent?: InputMaybe<GroupContents_Bool_Exp>;
  groupInvitations?: InputMaybe<GroupInvitations_Bool_Exp>;
  groupInvitations_aggregate?: InputMaybe<GroupInvitations_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inactiveGroup?: InputMaybe<InactiveGroups_Bool_Exp>;
  memberships?: InputMaybe<Memberships_Bool_Exp>;
  memberships_aggregate?: InputMaybe<Memberships_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ownerships?: InputMaybe<Ownerships_Bool_Exp>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "groups" */
export enum Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupsPkey = 'groups_pkey'
}

/** input type for inserting data into table "groups" */
export type Groups_Insert_Input = {
  _groupContents?: InputMaybe<GroupContents_Arr_Rel_Insert_Input>;
  _inactiveGroups?: InputMaybe<InactiveGroups_Arr_Rel_Insert_Input>;
  eventAreas?: InputMaybe<EventAreas_Arr_Rel_Insert_Input>;
  eventBeginnings?: InputMaybe<EventBeginnings_Arr_Rel_Insert_Input>;
  eventExpirations?: InputMaybe<EventExpirations_Arr_Rel_Insert_Input>;
  eventLimitTimes?: InputMaybe<EventLimitTimes_Arr_Rel_Insert_Input>;
  eventTags?: InputMaybe<EventTags_Arr_Rel_Insert_Input>;
  events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  examinations?: InputMaybe<Examinations_Arr_Rel_Insert_Input>;
  groupContent?: InputMaybe<GroupContents_Obj_Rel_Insert_Input>;
  groupInvitations?: InputMaybe<GroupInvitations_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  inactiveGroup?: InputMaybe<InactiveGroups_Obj_Rel_Insert_Input>;
  memberships?: InputMaybe<Memberships_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  ownerships?: InputMaybe<Ownerships_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Groups_Max_Fields = {
  __typename?: 'groups_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "groups" */
export type Groups_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Groups_Min_Fields = {
  __typename?: 'groups_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "groups" */
export type Groups_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "groups" */
export type Groups_Mutation_Response = {
  __typename?: 'groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Groups>;
};

/** input type for inserting object relation for remote table "groups" */
export type Groups_Obj_Rel_Insert_Input = {
  data: Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** on_conflict condition type for table "groups" */
export type Groups_On_Conflict = {
  constraint: Groups_Constraint;
  update_columns?: Array<Groups_Update_Column>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "groups". */
export type Groups_Order_By = {
  _groupContents_aggregate?: InputMaybe<GroupContents_Aggregate_Order_By>;
  _inactiveGroups_aggregate?: InputMaybe<InactiveGroups_Aggregate_Order_By>;
  eventAreas_aggregate?: InputMaybe<EventAreas_Aggregate_Order_By>;
  eventBeginnings_aggregate?: InputMaybe<EventBeginnings_Aggregate_Order_By>;
  eventExpirations_aggregate?: InputMaybe<EventExpirations_Aggregate_Order_By>;
  eventLimitTimes_aggregate?: InputMaybe<EventLimitTimes_Aggregate_Order_By>;
  eventTags_aggregate?: InputMaybe<EventTags_Aggregate_Order_By>;
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  examinations_aggregate?: InputMaybe<Examinations_Aggregate_Order_By>;
  groupContent?: InputMaybe<GroupContents_Order_By>;
  groupInvitations_aggregate?: InputMaybe<GroupInvitations_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  inactiveGroup?: InputMaybe<InactiveGroups_Order_By>;
  memberships_aggregate?: InputMaybe<Memberships_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Order_By>;
};

/** primary key columns input for table: groups */
export type Groups_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "groups" */
export enum Groups_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "groups" */
export type Groups_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "groups" */
export type Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Groups_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "groups" */
export enum Groups_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Groups_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Groups_Bool_Exp;
};

/** columns and relationships of "guestExamineeExaminations" */
export type GuestExamineeExaminations = {
  __typename?: 'guestExamineeExaminations';
  /** An object relationship */
  _examination?: Maybe<Examinations>;
  /** An array relationship */
  _examinations: Array<Examinations>;
  /** An aggregate relationship */
  _examinations_aggregate: Examinations_Aggregate;
  /** An object relationship */
  _guestExaminee?: Maybe<GuestExaminees>;
  /** An array relationship */
  _guestExaminees: Array<GuestExaminees>;
  /** An aggregate relationship */
  _guestExaminees_aggregate: GuestExaminees_Aggregate;
  /** An object relationship */
  examination?: Maybe<Examinations>;
  examinationId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  /** An object relationship */
  guestExaminee?: Maybe<GuestExaminees>;
  guestExamineeId: Scalars['uuid'];
};


/** columns and relationships of "guestExamineeExaminations" */
export type GuestExamineeExaminations_ExaminationsArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "guestExamineeExaminations" */
export type GuestExamineeExaminations_Examinations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


/** columns and relationships of "guestExamineeExaminations" */
export type GuestExamineeExaminations_GuestExamineesArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "guestExamineeExaminations" */
export type GuestExamineeExaminations_GuestExaminees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};

/** aggregated selection of "guestExamineeExaminations" */
export type GuestExamineeExaminations_Aggregate = {
  __typename?: 'guestExamineeExaminations_aggregate';
  aggregate?: Maybe<GuestExamineeExaminations_Aggregate_Fields>;
  nodes: Array<GuestExamineeExaminations>;
};

export type GuestExamineeExaminations_Aggregate_Bool_Exp = {
  count?: InputMaybe<GuestExamineeExaminations_Aggregate_Bool_Exp_Count>;
};

export type GuestExamineeExaminations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "guestExamineeExaminations" */
export type GuestExamineeExaminations_Aggregate_Fields = {
  __typename?: 'guestExamineeExaminations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<GuestExamineeExaminations_Max_Fields>;
  min?: Maybe<GuestExamineeExaminations_Min_Fields>;
};


/** aggregate fields of "guestExamineeExaminations" */
export type GuestExamineeExaminations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<GuestExamineeExaminations_Max_Order_By>;
  min?: InputMaybe<GuestExamineeExaminations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Arr_Rel_Insert_Input = {
  data: Array<GuestExamineeExaminations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<GuestExamineeExaminations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "guestExamineeExaminations". All fields are combined with a logical 'AND'. */
export type GuestExamineeExaminations_Bool_Exp = {
  _and?: InputMaybe<Array<GuestExamineeExaminations_Bool_Exp>>;
  _examination?: InputMaybe<Examinations_Bool_Exp>;
  _examinations?: InputMaybe<Examinations_Bool_Exp>;
  _examinations_aggregate?: InputMaybe<Examinations_Aggregate_Bool_Exp>;
  _guestExaminee?: InputMaybe<GuestExaminees_Bool_Exp>;
  _guestExaminees?: InputMaybe<GuestExaminees_Bool_Exp>;
  _guestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Bool_Exp>;
  _not?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
  _or?: InputMaybe<Array<GuestExamineeExaminations_Bool_Exp>>;
  examination?: InputMaybe<Examinations_Bool_Exp>;
  examinationId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  guestExaminee?: InputMaybe<GuestExaminees_Bool_Exp>;
  guestExamineeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "guestExamineeExaminations" */
export enum GuestExamineeExaminations_Constraint {
  /** unique or primary key constraint on columns "examinationId", "groupId" */
  GuestExamineeExaminationsExaminationIdGroupIdKey = 'guestExamineeExaminations_examinationId_groupId_key',
  /** unique or primary key constraint on columns "guestExamineeId", "groupId" */
  GuestExamineeExaminationsGuestExamineeIdGroupIdKey = 'guestExamineeExaminations_guestExamineeId_groupId_key',
  /** unique or primary key constraint on columns "guestExamineeId" */
  GuestExamineeExaminationsPkey = 'guestExamineeExaminations_pkey'
}

/** input type for inserting data into table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Insert_Input = {
  _examination?: InputMaybe<Examinations_Obj_Rel_Insert_Input>;
  _examinations?: InputMaybe<Examinations_Arr_Rel_Insert_Input>;
  _guestExaminee?: InputMaybe<GuestExaminees_Obj_Rel_Insert_Input>;
  _guestExaminees?: InputMaybe<GuestExaminees_Arr_Rel_Insert_Input>;
  examination?: InputMaybe<Examinations_Obj_Rel_Insert_Input>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  guestExaminee?: InputMaybe<GuestExaminees_Obj_Rel_Insert_Input>;
  guestExamineeId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type GuestExamineeExaminations_Max_Fields = {
  __typename?: 'guestExamineeExaminations_max_fields';
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  guestExamineeId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Max_Order_By = {
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  guestExamineeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type GuestExamineeExaminations_Min_Fields = {
  __typename?: 'guestExamineeExaminations_min_fields';
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  guestExamineeId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Min_Order_By = {
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  guestExamineeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Mutation_Response = {
  __typename?: 'guestExamineeExaminations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GuestExamineeExaminations>;
};

/** input type for inserting object relation for remote table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Obj_Rel_Insert_Input = {
  data: GuestExamineeExaminations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<GuestExamineeExaminations_On_Conflict>;
};

/** on_conflict condition type for table "guestExamineeExaminations" */
export type GuestExamineeExaminations_On_Conflict = {
  constraint: GuestExamineeExaminations_Constraint;
  update_columns?: Array<GuestExamineeExaminations_Update_Column>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};

/** Ordering options when selecting data from "guestExamineeExaminations". */
export type GuestExamineeExaminations_Order_By = {
  _examination?: InputMaybe<Examinations_Order_By>;
  _examinations_aggregate?: InputMaybe<Examinations_Aggregate_Order_By>;
  _guestExaminee?: InputMaybe<GuestExaminees_Order_By>;
  _guestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Order_By>;
  examination?: InputMaybe<Examinations_Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  guestExaminee?: InputMaybe<GuestExaminees_Order_By>;
  guestExamineeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: guestExamineeExaminations */
export type GuestExamineeExaminations_Pk_Columns_Input = {
  guestExamineeId: Scalars['uuid'];
};

/** select columns of table "guestExamineeExaminations" */
export enum GuestExamineeExaminations_Select_Column {
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GuestExamineeId = 'guestExamineeId'
}

/** input type for updating data in table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Set_Input = {
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  guestExamineeId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "guestExamineeExaminations" */
export type GuestExamineeExaminations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GuestExamineeExaminations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GuestExamineeExaminations_Stream_Cursor_Value_Input = {
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  guestExamineeId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "guestExamineeExaminations" */
export enum GuestExamineeExaminations_Update_Column {
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GuestExamineeId = 'guestExamineeId'
}

export type GuestExamineeExaminations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GuestExamineeExaminations_Set_Input>;
  /** filter the rows which have to be updated */
  where: GuestExamineeExaminations_Bool_Exp;
};

/** columns and relationships of "guestExaminees" */
export type GuestExaminees = {
  __typename?: 'guestExaminees';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An object relationship */
  _guestExamineeExamination?: Maybe<GuestExamineeExaminations>;
  /** An array relationship */
  _guestExamineeExaminations: Array<GuestExamineeExaminations>;
  /** An aggregate relationship */
  _guestExamineeExaminations_aggregate: GuestExamineeExaminations_Aggregate;
  email: Scalars['String'];
  /** An array relationship */
  emailGuestExaminees: Array<GuestExaminees>;
  /** An aggregate relationship */
  emailGuestExaminees_aggregate: GuestExaminees_Aggregate;
  /** An object relationship */
  event: Events;
  /** An array relationship */
  eventGuestExaminees: Array<GuestExaminees>;
  /** An aggregate relationship */
  eventGuestExaminees_aggregate: GuestExaminees_Aggregate;
  eventId: Scalars['uuid'];
  /** An array relationship */
  groupGuestExaminees: Array<GuestExaminees>;
  /** An aggregate relationship */
  groupGuestExaminees_aggregate: GuestExaminees_Aggregate;
  groupId: Scalars['uuid'];
  /** An object relationship */
  guestExamineeExamination?: Maybe<GuestExamineeExaminations>;
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "guestExaminees" */
export type GuestExaminees_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExaminees_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExaminees_GuestExamineeExaminationsArgs = {
  distinct_on?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExamineeExaminations_Order_By>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExaminees_GuestExamineeExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExamineeExaminations_Order_By>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExamineesEmailGuestExamineesArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExamineesEmailGuestExaminees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExamineesEventGuestExamineesArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExamineesEventGuestExaminees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExamineesGroupGuestExamineesArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


/** columns and relationships of "guestExaminees" */
export type GuestExamineesGroupGuestExaminees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};

/** aggregated selection of "guestExaminees" */
export type GuestExaminees_Aggregate = {
  __typename?: 'guestExaminees_aggregate';
  aggregate?: Maybe<GuestExaminees_Aggregate_Fields>;
  nodes: Array<GuestExaminees>;
};

export type GuestExaminees_Aggregate_Bool_Exp = {
  count?: InputMaybe<GuestExaminees_Aggregate_Bool_Exp_Count>;
};

export type GuestExaminees_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GuestExaminees_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "guestExaminees" */
export type GuestExaminees_Aggregate_Fields = {
  __typename?: 'guestExaminees_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<GuestExaminees_Max_Fields>;
  min?: Maybe<GuestExaminees_Min_Fields>;
};


/** aggregate fields of "guestExaminees" */
export type GuestExaminees_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guestExaminees" */
export type GuestExaminees_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<GuestExaminees_Max_Order_By>;
  min?: InputMaybe<GuestExaminees_Min_Order_By>;
};

/** input type for inserting array relation for remote table "guestExaminees" */
export type GuestExaminees_Arr_Rel_Insert_Input = {
  data: Array<GuestExaminees_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<GuestExaminees_On_Conflict>;
};

/** Boolean expression to filter rows from the table "guestExaminees". All fields are combined with a logical 'AND'. */
export type GuestExaminees_Bool_Exp = {
  _and?: InputMaybe<Array<GuestExaminees_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
  _guestExamineeExaminations?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
  _guestExamineeExaminations_aggregate?: InputMaybe<GuestExamineeExaminations_Aggregate_Bool_Exp>;
  _not?: InputMaybe<GuestExaminees_Bool_Exp>;
  _or?: InputMaybe<Array<GuestExaminees_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  emailGuestExaminees?: InputMaybe<GuestExaminees_Bool_Exp>;
  emailGuestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Bool_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventGuestExaminees?: InputMaybe<GuestExaminees_Bool_Exp>;
  eventGuestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  groupGuestExaminees?: InputMaybe<GuestExaminees_Bool_Exp>;
  groupGuestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "guestExaminees" */
export enum GuestExaminees_Constraint {
  /** unique or primary key constraint on columns "id", "groupId" */
  GuestExamineesGroupIdIdKey = 'guestExaminees_groupId_id_key',
  /** unique or primary key constraint on columns "id" */
  GuestExamineesPkey = 'guestExaminees_pkey'
}

/** input type for inserting data into table "guestExaminees" */
export type GuestExaminees_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  _guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Obj_Rel_Insert_Input>;
  _guestExamineeExaminations?: InputMaybe<GuestExamineeExaminations_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  emailGuestExaminees?: InputMaybe<GuestExaminees_Arr_Rel_Insert_Input>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventGuestExaminees?: InputMaybe<GuestExaminees_Arr_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupGuestExaminees?: InputMaybe<GuestExaminees_Arr_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GuestExaminees_Max_Fields = {
  __typename?: 'guestExaminees_max_fields';
  email?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "guestExaminees" */
export type GuestExaminees_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type GuestExaminees_Min_Fields = {
  __typename?: 'guestExaminees_min_fields';
  email?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "guestExaminees" */
export type GuestExaminees_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "guestExaminees" */
export type GuestExaminees_Mutation_Response = {
  __typename?: 'guestExaminees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GuestExaminees>;
};

/** input type for inserting object relation for remote table "guestExaminees" */
export type GuestExaminees_Obj_Rel_Insert_Input = {
  data: GuestExaminees_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<GuestExaminees_On_Conflict>;
};

/** on_conflict condition type for table "guestExaminees" */
export type GuestExaminees_On_Conflict = {
  constraint: GuestExaminees_Constraint;
  update_columns?: Array<GuestExaminees_Update_Column>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};

/** Ordering options when selecting data from "guestExaminees". */
export type GuestExaminees_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  _guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Order_By>;
  _guestExamineeExaminations_aggregate?: InputMaybe<GuestExamineeExaminations_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  emailGuestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventGuestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Order_By>;
  eventId?: InputMaybe<Order_By>;
  groupGuestExaminees_aggregate?: InputMaybe<GuestExaminees_Aggregate_Order_By>;
  groupId?: InputMaybe<Order_By>;
  guestExamineeExamination?: InputMaybe<GuestExamineeExaminations_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: guestExaminees */
export type GuestExaminees_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "guestExaminees" */
export enum GuestExaminees_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "guestExaminees" */
export type GuestExaminees_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "guestExaminees" */
export type GuestExaminees_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GuestExaminees_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GuestExaminees_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "guestExaminees" */
export enum GuestExaminees_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type GuestExaminees_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GuestExaminees_Set_Input>;
  /** filter the rows which have to be updated */
  where: GuestExaminees_Bool_Exp;
};

/** columns and relationships of "inactiveGroupEvents" */
export type InactiveGroupEvents = {
  __typename?: 'inactiveGroupEvents';
  /** An object relationship */
  _event?: Maybe<Events>;
  /** An array relationship */
  _events: Array<Events>;
  /** An aggregate relationship */
  _events_aggregate: Events_Aggregate;
  /** An object relationship */
  event?: Maybe<Events>;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
};


/** columns and relationships of "inactiveGroupEvents" */
export type InactiveGroupEvents_EventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "inactiveGroupEvents" */
export type InactiveGroupEvents_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** aggregated selection of "inactiveGroupEvents" */
export type InactiveGroupEvents_Aggregate = {
  __typename?: 'inactiveGroupEvents_aggregate';
  aggregate?: Maybe<InactiveGroupEvents_Aggregate_Fields>;
  nodes: Array<InactiveGroupEvents>;
};

export type InactiveGroupEvents_Aggregate_Bool_Exp = {
  count?: InputMaybe<InactiveGroupEvents_Aggregate_Bool_Exp_Count>;
};

export type InactiveGroupEvents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<InactiveGroupEvents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "inactiveGroupEvents" */
export type InactiveGroupEvents_Aggregate_Fields = {
  __typename?: 'inactiveGroupEvents_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<InactiveGroupEvents_Max_Fields>;
  min?: Maybe<InactiveGroupEvents_Min_Fields>;
};


/** aggregate fields of "inactiveGroupEvents" */
export type InactiveGroupEvents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<InactiveGroupEvents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "inactiveGroupEvents" */
export type InactiveGroupEvents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<InactiveGroupEvents_Max_Order_By>;
  min?: InputMaybe<InactiveGroupEvents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "inactiveGroupEvents" */
export type InactiveGroupEvents_Arr_Rel_Insert_Input = {
  data: Array<InactiveGroupEvents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<InactiveGroupEvents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "inactiveGroupEvents". All fields are combined with a logical 'AND'. */
export type InactiveGroupEvents_Bool_Exp = {
  _and?: InputMaybe<Array<InactiveGroupEvents_Bool_Exp>>;
  _event?: InputMaybe<Events_Bool_Exp>;
  _events?: InputMaybe<Events_Bool_Exp>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  _not?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
  _or?: InputMaybe<Array<InactiveGroupEvents_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "inactiveGroupEvents" */
export enum InactiveGroupEvents_Constraint {
  /** unique or primary key constraint on columns "id" */
  InactiveGroupEventsPkey = 'inactiveGroupEvents_pkey'
}

/** input type for inserting data into table "inactiveGroupEvents" */
export type InactiveGroupEvents_Insert_Input = {
  _event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  _events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type InactiveGroupEvents_Max_Fields = {
  __typename?: 'inactiveGroupEvents_max_fields';
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "inactiveGroupEvents" */
export type InactiveGroupEvents_Max_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type InactiveGroupEvents_Min_Fields = {
  __typename?: 'inactiveGroupEvents_min_fields';
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "inactiveGroupEvents" */
export type InactiveGroupEvents_Min_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "inactiveGroupEvents" */
export type InactiveGroupEvents_Mutation_Response = {
  __typename?: 'inactiveGroupEvents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InactiveGroupEvents>;
};

/** input type for inserting object relation for remote table "inactiveGroupEvents" */
export type InactiveGroupEvents_Obj_Rel_Insert_Input = {
  data: InactiveGroupEvents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<InactiveGroupEvents_On_Conflict>;
};

/** on_conflict condition type for table "inactiveGroupEvents" */
export type InactiveGroupEvents_On_Conflict = {
  constraint: InactiveGroupEvents_Constraint;
  update_columns?: Array<InactiveGroupEvents_Update_Column>;
  where?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
};

/** Ordering options when selecting data from "inactiveGroupEvents". */
export type InactiveGroupEvents_Order_By = {
  _event?: InputMaybe<Events_Order_By>;
  _events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  event?: InputMaybe<Events_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: inactiveGroupEvents */
export type InactiveGroupEvents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "inactiveGroupEvents" */
export enum InactiveGroupEvents_Select_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "inactiveGroupEvents" */
export type InactiveGroupEvents_Set_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "inactiveGroupEvents" */
export type InactiveGroupEvents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: InactiveGroupEvents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InactiveGroupEvents_Stream_Cursor_Value_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "inactiveGroupEvents" */
export enum InactiveGroupEvents_Update_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id'
}

export type InactiveGroupEvents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InactiveGroupEvents_Set_Input>;
  /** filter the rows which have to be updated */
  where: InactiveGroupEvents_Bool_Exp;
};

/** columns and relationships of "inactiveGroups" */
export type InactiveGroups = {
  __typename?: 'inactiveGroups';
  /** An array relationship */
  _groups: Array<Groups>;
  /** An aggregate relationship */
  _groups_aggregate: Groups_Aggregate;
  /** An object relationship */
  group?: Maybe<Groups>;
  id: Scalars['uuid'];
};


/** columns and relationships of "inactiveGroups" */
export type InactiveGroups_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


/** columns and relationships of "inactiveGroups" */
export type InactiveGroups_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

/** aggregated selection of "inactiveGroups" */
export type InactiveGroups_Aggregate = {
  __typename?: 'inactiveGroups_aggregate';
  aggregate?: Maybe<InactiveGroups_Aggregate_Fields>;
  nodes: Array<InactiveGroups>;
};

export type InactiveGroups_Aggregate_Bool_Exp = {
  count?: InputMaybe<InactiveGroups_Aggregate_Bool_Exp_Count>;
};

export type InactiveGroups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<InactiveGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InactiveGroups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "inactiveGroups" */
export type InactiveGroups_Aggregate_Fields = {
  __typename?: 'inactiveGroups_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<InactiveGroups_Max_Fields>;
  min?: Maybe<InactiveGroups_Min_Fields>;
};


/** aggregate fields of "inactiveGroups" */
export type InactiveGroups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<InactiveGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "inactiveGroups" */
export type InactiveGroups_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<InactiveGroups_Max_Order_By>;
  min?: InputMaybe<InactiveGroups_Min_Order_By>;
};

/** input type for inserting array relation for remote table "inactiveGroups" */
export type InactiveGroups_Arr_Rel_Insert_Input = {
  data: Array<InactiveGroups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<InactiveGroups_On_Conflict>;
};

/** Boolean expression to filter rows from the table "inactiveGroups". All fields are combined with a logical 'AND'. */
export type InactiveGroups_Bool_Exp = {
  _and?: InputMaybe<Array<InactiveGroups_Bool_Exp>>;
  _groups?: InputMaybe<Groups_Bool_Exp>;
  _groups_aggregate?: InputMaybe<Groups_Aggregate_Bool_Exp>;
  _not?: InputMaybe<InactiveGroups_Bool_Exp>;
  _or?: InputMaybe<Array<InactiveGroups_Bool_Exp>>;
  group?: InputMaybe<Groups_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "inactiveGroups" */
export enum InactiveGroups_Constraint {
  /** unique or primary key constraint on columns "id" */
  InactiveGroupsPkey = 'inactiveGroups_pkey'
}

/** input type for inserting data into table "inactiveGroups" */
export type InactiveGroups_Insert_Input = {
  _groups?: InputMaybe<Groups_Arr_Rel_Insert_Input>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type InactiveGroups_Max_Fields = {
  __typename?: 'inactiveGroups_max_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "inactiveGroups" */
export type InactiveGroups_Max_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type InactiveGroups_Min_Fields = {
  __typename?: 'inactiveGroups_min_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "inactiveGroups" */
export type InactiveGroups_Min_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "inactiveGroups" */
export type InactiveGroups_Mutation_Response = {
  __typename?: 'inactiveGroups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InactiveGroups>;
};

/** input type for inserting object relation for remote table "inactiveGroups" */
export type InactiveGroups_Obj_Rel_Insert_Input = {
  data: InactiveGroups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<InactiveGroups_On_Conflict>;
};

/** on_conflict condition type for table "inactiveGroups" */
export type InactiveGroups_On_Conflict = {
  constraint: InactiveGroups_Constraint;
  update_columns?: Array<InactiveGroups_Update_Column>;
  where?: InputMaybe<InactiveGroups_Bool_Exp>;
};

/** Ordering options when selecting data from "inactiveGroups". */
export type InactiveGroups_Order_By = {
  _groups_aggregate?: InputMaybe<Groups_Aggregate_Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: inactiveGroups */
export type InactiveGroups_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "inactiveGroups" */
export enum InactiveGroups_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "inactiveGroups" */
export type InactiveGroups_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "inactiveGroups" */
export type InactiveGroups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: InactiveGroups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InactiveGroups_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "inactiveGroups" */
export enum InactiveGroups_Update_Column {
  /** column name */
  Id = 'id'
}

export type InactiveGroups_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InactiveGroups_Set_Input>;
  /** filter the rows which have to be updated */
  where: InactiveGroups_Bool_Exp;
};

/** columns and relationships of "languages" */
export type Languages = {
  __typename?: 'languages';
  code: Scalars['String'];
  /** An array relationship */
  translatedGenders: Array<TranslatedGenders>;
  /** An aggregate relationship */
  translatedGenders_aggregate: TranslatedGenders_Aggregate;
};


/** columns and relationships of "languages" */
export type LanguagesTranslatedGendersArgs = {
  distinct_on?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TranslatedGenders_Order_By>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};


/** columns and relationships of "languages" */
export type LanguagesTranslatedGenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TranslatedGenders_Order_By>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};

/** aggregated selection of "languages" */
export type Languages_Aggregate = {
  __typename?: 'languages_aggregate';
  aggregate?: Maybe<Languages_Aggregate_Fields>;
  nodes: Array<Languages>;
};

/** aggregate fields of "languages" */
export type Languages_Aggregate_Fields = {
  __typename?: 'languages_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Languages_Max_Fields>;
  min?: Maybe<Languages_Min_Fields>;
};


/** aggregate fields of "languages" */
export type Languages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Languages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "languages". All fields are combined with a logical 'AND'. */
export type Languages_Bool_Exp = {
  _and?: InputMaybe<Array<Languages_Bool_Exp>>;
  _not?: InputMaybe<Languages_Bool_Exp>;
  _or?: InputMaybe<Array<Languages_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  translatedGenders?: InputMaybe<TranslatedGenders_Bool_Exp>;
  translatedGenders_aggregate?: InputMaybe<TranslatedGenders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "languages" */
export enum Languages_Constraint {
  /** unique or primary key constraint on columns "code" */
  LanguagesPkey = 'languages_pkey'
}

export enum Languages_Enum {
  Ja = 'ja'
}

/** Boolean expression to compare columns of type "languages_enum". All fields are combined with logical 'AND'. */
export type Languages_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Languages_Enum>;
  _in?: InputMaybe<Array<Languages_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Languages_Enum>;
  _nin?: InputMaybe<Array<Languages_Enum>>;
};

/** input type for inserting data into table "languages" */
export type Languages_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  translatedGenders?: InputMaybe<TranslatedGenders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Languages_Max_Fields = {
  __typename?: 'languages_max_fields';
  code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Languages_Min_Fields = {
  __typename?: 'languages_min_fields';
  code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "languages" */
export type Languages_Mutation_Response = {
  __typename?: 'languages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Languages>;
};

/** input type for inserting object relation for remote table "languages" */
export type Languages_Obj_Rel_Insert_Input = {
  data: Languages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};

/** on_conflict condition type for table "languages" */
export type Languages_On_Conflict = {
  constraint: Languages_Constraint;
  update_columns?: Array<Languages_Update_Column>;
  where?: InputMaybe<Languages_Bool_Exp>;
};

/** Ordering options when selecting data from "languages". */
export type Languages_Order_By = {
  code?: InputMaybe<Order_By>;
  translatedGenders_aggregate?: InputMaybe<TranslatedGenders_Aggregate_Order_By>;
};

/** primary key columns input for table: languages */
export type Languages_Pk_Columns_Input = {
  code: Scalars['String'];
};

/** select columns of table "languages" */
export enum Languages_Select_Column {
  /** column name */
  Code = 'code'
}

/** input type for updating data in table "languages" */
export type Languages_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "languages" */
export type Languages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Languages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Languages_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
};

/** update columns of table "languages" */
export enum Languages_Update_Column {
  /** column name */
  Code = 'code'
}

export type Languages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Languages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Languages_Bool_Exp;
};

/** columns and relationships of "memberships" */
export type Memberships = {
  __typename?: 'memberships';
  /** An array relationship */
  _groupInvitations: Array<GroupInvitations>;
  /** An aggregate relationship */
  _groupInvitations_aggregate: GroupInvitations_Aggregate;
  /** An array relationship */
  _ownerships: Array<Ownerships>;
  /** An aggregate relationship */
  _ownerships_aggregate: Ownerships_Aggregate;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  /** An object relationship */
  groupInvitation?: Maybe<GroupInvitations>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: Memberships_Aggregate;
  /** An object relationship */
  ownership?: Maybe<Ownerships>;
  /** An array relationship */
  ownerships: Array<Ownerships>;
  /** An aggregate relationship */
  ownerships_aggregate: Ownerships_Aggregate;
  /** An object relationship */
  user?: Maybe<Users>;
  userId: Scalars['uuid'];
};


/** columns and relationships of "memberships" */
export type Memberships_GroupInvitationsArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


/** columns and relationships of "memberships" */
export type Memberships_GroupInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


/** columns and relationships of "memberships" */
export type Memberships_OwnershipsArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


/** columns and relationships of "memberships" */
export type Memberships_Ownerships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


/** columns and relationships of "memberships" */
export type MembershipsMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "memberships" */
export type MembershipsMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "memberships" */
export type MembershipsOwnershipsArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


/** columns and relationships of "memberships" */
export type MembershipsOwnerships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};

/** aggregated selection of "memberships" */
export type Memberships_Aggregate = {
  __typename?: 'memberships_aggregate';
  aggregate?: Maybe<Memberships_Aggregate_Fields>;
  nodes: Array<Memberships>;
};

export type Memberships_Aggregate_Bool_Exp = {
  count?: InputMaybe<Memberships_Aggregate_Bool_Exp_Count>;
};

export type Memberships_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Memberships_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Memberships_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "memberships" */
export type Memberships_Aggregate_Fields = {
  __typename?: 'memberships_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Memberships_Max_Fields>;
  min?: Maybe<Memberships_Min_Fields>;
};


/** aggregate fields of "memberships" */
export type Memberships_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Memberships_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "memberships" */
export type Memberships_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Memberships_Max_Order_By>;
  min?: InputMaybe<Memberships_Min_Order_By>;
};

/** input type for inserting array relation for remote table "memberships" */
export type Memberships_Arr_Rel_Insert_Input = {
  data: Array<Memberships_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Memberships_On_Conflict>;
};

/** Boolean expression to filter rows from the table "memberships". All fields are combined with a logical 'AND'. */
export type Memberships_Bool_Exp = {
  _and?: InputMaybe<Array<Memberships_Bool_Exp>>;
  _groupInvitations?: InputMaybe<GroupInvitations_Bool_Exp>;
  _groupInvitations_aggregate?: InputMaybe<GroupInvitations_Aggregate_Bool_Exp>;
  _not?: InputMaybe<Memberships_Bool_Exp>;
  _or?: InputMaybe<Array<Memberships_Bool_Exp>>;
  _ownerships?: InputMaybe<Ownerships_Bool_Exp>;
  _ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Bool_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  groupInvitation?: InputMaybe<GroupInvitations_Bool_Exp>;
  memberships?: InputMaybe<Memberships_Bool_Exp>;
  memberships_aggregate?: InputMaybe<Memberships_Aggregate_Bool_Exp>;
  ownership?: InputMaybe<Ownerships_Bool_Exp>;
  ownerships?: InputMaybe<Ownerships_Bool_Exp>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "memberships" */
export enum Memberships_Constraint {
  /** unique or primary key constraint on columns "userId", "groupId" */
  MembershipsPkey = 'memberships_pkey',
  /** unique or primary key constraint on columns "userId" */
  MembershipsUserIdKey = 'memberships_userId_key'
}

/** input type for inserting data into table "memberships" */
export type Memberships_Insert_Input = {
  _groupInvitations?: InputMaybe<GroupInvitations_Arr_Rel_Insert_Input>;
  _ownerships?: InputMaybe<Ownerships_Arr_Rel_Insert_Input>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupInvitation?: InputMaybe<GroupInvitations_Obj_Rel_Insert_Input>;
  memberships?: InputMaybe<Memberships_Arr_Rel_Insert_Input>;
  ownership?: InputMaybe<Ownerships_Obj_Rel_Insert_Input>;
  ownerships?: InputMaybe<Ownerships_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Memberships_Max_Fields = {
  __typename?: 'memberships_max_fields';
  groupId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "memberships" */
export type Memberships_Max_Order_By = {
  groupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Memberships_Min_Fields = {
  __typename?: 'memberships_min_fields';
  groupId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "memberships" */
export type Memberships_Min_Order_By = {
  groupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "memberships" */
export type Memberships_Mutation_Response = {
  __typename?: 'memberships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Memberships>;
};

/** input type for inserting object relation for remote table "memberships" */
export type Memberships_Obj_Rel_Insert_Input = {
  data: Memberships_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Memberships_On_Conflict>;
};

/** on_conflict condition type for table "memberships" */
export type Memberships_On_Conflict = {
  constraint: Memberships_Constraint;
  update_columns?: Array<Memberships_Update_Column>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};

/** Ordering options when selecting data from "memberships". */
export type Memberships_Order_By = {
  _groupInvitations_aggregate?: InputMaybe<GroupInvitations_Aggregate_Order_By>;
  _ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  groupInvitation?: InputMaybe<GroupInvitations_Order_By>;
  memberships_aggregate?: InputMaybe<Memberships_Aggregate_Order_By>;
  ownership?: InputMaybe<Ownerships_Order_By>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: memberships */
export type Memberships_Pk_Columns_Input = {
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

/** select columns of table "memberships" */
export enum Memberships_Select_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "memberships" */
export type Memberships_Set_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "memberships" */
export type Memberships_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Memberships_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Memberships_Stream_Cursor_Value_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "memberships" */
export enum Memberships_Update_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  UserId = 'userId'
}

export type Memberships_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Memberships_Set_Input>;
  /** filter the rows which have to be updated */
  where: Memberships_Bool_Exp;
};

/** columns and relationships of "monthlyExaminationCounts" */
export type MonthlyExaminationCounts = {
  __typename?: 'monthlyExaminationCounts';
  count?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "monthlyExaminationCounts" */
export type MonthlyExaminationCounts_Aggregate = {
  __typename?: 'monthlyExaminationCounts_aggregate';
  aggregate?: Maybe<MonthlyExaminationCounts_Aggregate_Fields>;
  nodes: Array<MonthlyExaminationCounts>;
};

/** aggregate fields of "monthlyExaminationCounts" */
export type MonthlyExaminationCounts_Aggregate_Fields = {
  __typename?: 'monthlyExaminationCounts_aggregate_fields';
  avg?: Maybe<MonthlyExaminationCounts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MonthlyExaminationCounts_Max_Fields>;
  min?: Maybe<MonthlyExaminationCounts_Min_Fields>;
  stddev?: Maybe<MonthlyExaminationCounts_Stddev_Fields>;
  stddev_pop?: Maybe<MonthlyExaminationCounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MonthlyExaminationCounts_Stddev_Samp_Fields>;
  sum?: Maybe<MonthlyExaminationCounts_Sum_Fields>;
  var_pop?: Maybe<MonthlyExaminationCounts_Var_Pop_Fields>;
  var_samp?: Maybe<MonthlyExaminationCounts_Var_Samp_Fields>;
  variance?: Maybe<MonthlyExaminationCounts_Variance_Fields>;
};


/** aggregate fields of "monthlyExaminationCounts" */
export type MonthlyExaminationCounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MonthlyExaminationCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MonthlyExaminationCounts_Avg_Fields = {
  __typename?: 'monthlyExaminationCounts_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "monthlyExaminationCounts". All fields are combined with a logical 'AND'. */
export type MonthlyExaminationCounts_Bool_Exp = {
  _and?: InputMaybe<Array<MonthlyExaminationCounts_Bool_Exp>>;
  _not?: InputMaybe<MonthlyExaminationCounts_Bool_Exp>;
  _or?: InputMaybe<Array<MonthlyExaminationCounts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  month?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** aggregate max on columns */
export type MonthlyExaminationCounts_Max_Fields = {
  __typename?: 'monthlyExaminationCounts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type MonthlyExaminationCounts_Min_Fields = {
  __typename?: 'monthlyExaminationCounts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['timestamp']>;
};

/** Ordering options when selecting data from "monthlyExaminationCounts". */
export type MonthlyExaminationCounts_Order_By = {
  count?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
};

/** select columns of table "monthlyExaminationCounts" */
export enum MonthlyExaminationCounts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Month = 'month'
}

/** aggregate stddev on columns */
export type MonthlyExaminationCounts_Stddev_Fields = {
  __typename?: 'monthlyExaminationCounts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MonthlyExaminationCounts_Stddev_Pop_Fields = {
  __typename?: 'monthlyExaminationCounts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MonthlyExaminationCounts_Stddev_Samp_Fields = {
  __typename?: 'monthlyExaminationCounts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "monthlyExaminationCounts" */
export type MonthlyExaminationCounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MonthlyExaminationCounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MonthlyExaminationCounts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  month?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type MonthlyExaminationCounts_Sum_Fields = {
  __typename?: 'monthlyExaminationCounts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type MonthlyExaminationCounts_Var_Pop_Fields = {
  __typename?: 'monthlyExaminationCounts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MonthlyExaminationCounts_Var_Samp_Fields = {
  __typename?: 'monthlyExaminationCounts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MonthlyExaminationCounts_Variance_Fields = {
  __typename?: 'monthlyExaminationCounts_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** InsertGuestExamineeMails */
  InsertGuestExamineeMails?: Maybe<InsertGuestExamineeMailsOutput>;
  /** InsertGuestExamineesDerived */
  InsertGuestExamineesDerived?: Maybe<InsertGuestExamineesDerivedOutput>;
  InsertMembershipsOneDerived?: Maybe<InsertMembershipsOneDerivedOutput>;
  InsertStaffsOneDerived?: Maybe<InsertStaffsOneDerivedOutput>;
  /** delete data from the table: "diagnoses" */
  delete_diagnoses?: Maybe<Diagnoses_Mutation_Response>;
  /** delete single row from the table: "diagnoses" */
  delete_diagnoses_by_pk?: Maybe<Diagnoses>;
  /** delete data from the table: "diagnosisTypes" */
  delete_diagnosisTypes?: Maybe<DiagnosisTypes_Mutation_Response>;
  /** delete single row from the table: "diagnosisTypes" */
  delete_diagnosisTypes_by_pk?: Maybe<DiagnosisTypes>;
  /** delete data from the table: "eventAreaAssignments" */
  delete_eventAreaAssignments?: Maybe<EventAreaAssignments_Mutation_Response>;
  /** delete single row from the table: "eventAreaAssignments" */
  delete_eventAreaAssignments_by_pk?: Maybe<EventAreaAssignments>;
  /** delete data from the table: "eventAreas" */
  delete_eventAreas?: Maybe<EventAreas_Mutation_Response>;
  /** delete single row from the table: "eventAreas" */
  delete_eventAreas_by_pk?: Maybe<EventAreas>;
  /** delete data from the table: "eventBeginnings" */
  delete_eventBeginnings?: Maybe<EventBeginnings_Mutation_Response>;
  /** delete single row from the table: "eventBeginnings" */
  delete_eventBeginnings_by_pk?: Maybe<EventBeginnings>;
  /** delete data from the table: "eventDiagnoses" */
  delete_eventDiagnoses?: Maybe<EventDiagnoses_Mutation_Response>;
  /** delete single row from the table: "eventDiagnoses" */
  delete_eventDiagnoses_by_pk?: Maybe<EventDiagnoses>;
  /** delete data from the table: "eventExpirations" */
  delete_eventExpirations?: Maybe<EventExpirations_Mutation_Response>;
  /** delete single row from the table: "eventExpirations" */
  delete_eventExpirations_by_pk?: Maybe<EventExpirations>;
  /** delete data from the table: "eventLimitTimes" */
  delete_eventLimitTimes?: Maybe<EventLimitTimes_Mutation_Response>;
  /** delete single row from the table: "eventLimitTimes" */
  delete_eventLimitTimes_by_pk?: Maybe<EventLimitTimes>;
  /** delete data from the table: "eventTagAssignments" */
  delete_eventTagAssignments?: Maybe<EventTagAssignments_Mutation_Response>;
  /** delete single row from the table: "eventTagAssignments" */
  delete_eventTagAssignments_by_pk?: Maybe<EventTagAssignments>;
  /** delete data from the table: "eventTags" */
  delete_eventTags?: Maybe<EventTags_Mutation_Response>;
  /** delete single row from the table: "eventTags" */
  delete_eventTags_by_pk?: Maybe<EventTags>;
  /** delete data from the table: "events" */
  delete_events?: Maybe<Events_Mutation_Response>;
  /** delete single row from the table: "events" */
  delete_events_by_pk?: Maybe<Events>;
  /** delete data from the table: "examinationDiagnoses" */
  delete_examinationDiagnoses?: Maybe<ExaminationDiagnoses_Mutation_Response>;
  /** delete single row from the table: "examinationDiagnoses" */
  delete_examinationDiagnoses_by_pk?: Maybe<ExaminationDiagnoses>;
  /** delete data from the table: "examinationDiagnosisAnswers" */
  delete_examinationDiagnosisAnswers?: Maybe<ExaminationDiagnosisAnswers_Mutation_Response>;
  /** delete single row from the table: "examinationDiagnosisAnswers" */
  delete_examinationDiagnosisAnswers_by_pk?: Maybe<ExaminationDiagnosisAnswers>;
  /** delete data from the table: "examinations" */
  delete_examinations?: Maybe<Examinations_Mutation_Response>;
  /** delete single row from the table: "examinations" */
  delete_examinations_by_pk?: Maybe<Examinations>;
  /** delete data from the table: "genders" */
  delete_genders?: Maybe<Genders_Mutation_Response>;
  /** delete single row from the table: "genders" */
  delete_genders_by_pk?: Maybe<Genders>;
  /** delete data from the table: "groupContents" */
  delete_groupContents?: Maybe<GroupContents_Mutation_Response>;
  /** delete single row from the table: "groupContents" */
  delete_groupContents_by_pk?: Maybe<GroupContents>;
  /** delete data from the table: "groupInvitations" */
  delete_groupInvitations?: Maybe<GroupInvitations_Mutation_Response>;
  /** delete single row from the table: "groupInvitations" */
  delete_groupInvitations_by_pk?: Maybe<GroupInvitations>;
  /** delete data from the table: "groups" */
  delete_groups?: Maybe<Groups_Mutation_Response>;
  /** delete single row from the table: "groups" */
  delete_groups_by_pk?: Maybe<Groups>;
  /** delete data from the table: "guestExamineeExaminations" */
  delete_guestExamineeExaminations?: Maybe<GuestExamineeExaminations_Mutation_Response>;
  /** delete single row from the table: "guestExamineeExaminations" */
  delete_guestExamineeExaminations_by_pk?: Maybe<GuestExamineeExaminations>;
  /** delete data from the table: "guestExaminees" */
  delete_guestExaminees?: Maybe<GuestExaminees_Mutation_Response>;
  /** delete single row from the table: "guestExaminees" */
  delete_guestExaminees_by_pk?: Maybe<GuestExaminees>;
  /** delete data from the table: "inactiveGroupEvents" */
  delete_inactiveGroupEvents?: Maybe<InactiveGroupEvents_Mutation_Response>;
  /** delete single row from the table: "inactiveGroupEvents" */
  delete_inactiveGroupEvents_by_pk?: Maybe<InactiveGroupEvents>;
  /** delete data from the table: "inactiveGroups" */
  delete_inactiveGroups?: Maybe<InactiveGroups_Mutation_Response>;
  /** delete single row from the table: "inactiveGroups" */
  delete_inactiveGroups_by_pk?: Maybe<InactiveGroups>;
  /** delete data from the table: "languages" */
  delete_languages?: Maybe<Languages_Mutation_Response>;
  /** delete single row from the table: "languages" */
  delete_languages_by_pk?: Maybe<Languages>;
  /** delete data from the table: "memberships" */
  delete_memberships?: Maybe<Memberships_Mutation_Response>;
  /** delete single row from the table: "memberships" */
  delete_memberships_by_pk?: Maybe<Memberships>;
  /** delete data from the table: "ownerships" */
  delete_ownerships?: Maybe<Ownerships_Mutation_Response>;
  /** delete single row from the table: "ownerships" */
  delete_ownerships_by_pk?: Maybe<Ownerships>;
  /** delete data from the table: "questionChoices" */
  delete_questionChoices?: Maybe<QuestionChoices_Mutation_Response>;
  /** delete single row from the table: "questionChoices" */
  delete_questionChoices_by_pk?: Maybe<QuestionChoices>;
  /** delete data from the table: "questionScores" */
  delete_questionScores?: Maybe<QuestionScores_Mutation_Response>;
  /** delete single row from the table: "questionScores" */
  delete_questionScores_by_pk?: Maybe<QuestionScores>;
  /** delete data from the table: "questions" */
  delete_questions?: Maybe<Questions_Mutation_Response>;
  /** delete single row from the table: "questions" */
  delete_questions_by_pk?: Maybe<Questions>;
  /** delete data from the table: "scoreTypes" */
  delete_scoreTypes?: Maybe<ScoreTypes_Mutation_Response>;
  /** delete single row from the table: "scoreTypes" */
  delete_scoreTypes_by_pk?: Maybe<ScoreTypes>;
  /** delete data from the table: "staffInvitations" */
  delete_staffInvitations?: Maybe<StaffInvitations_Mutation_Response>;
  /** delete single row from the table: "staffInvitations" */
  delete_staffInvitations_by_pk?: Maybe<StaffInvitations>;
  /** delete data from the table: "staffs" */
  delete_staffs?: Maybe<Staffs_Mutation_Response>;
  /** delete single row from the table: "staffs" */
  delete_staffs_by_pk?: Maybe<Staffs>;
  /** delete data from the table: "translatedGenders" */
  delete_translatedGenders?: Maybe<TranslatedGenders_Mutation_Response>;
  /** delete single row from the table: "translatedGenders" */
  delete_translatedGenders_by_pk?: Maybe<TranslatedGenders>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "diagnoses" */
  insert_diagnoses?: Maybe<Diagnoses_Mutation_Response>;
  /** insert a single row into the table: "diagnoses" */
  insert_diagnoses_one?: Maybe<Diagnoses>;
  /** insert data into the table: "diagnosisTypes" */
  insert_diagnosisTypes?: Maybe<DiagnosisTypes_Mutation_Response>;
  /** insert a single row into the table: "diagnosisTypes" */
  insert_diagnosisTypes_one?: Maybe<DiagnosisTypes>;
  /** insert data into the table: "eventAreaAssignments" */
  insert_eventAreaAssignments?: Maybe<EventAreaAssignments_Mutation_Response>;
  /** insert a single row into the table: "eventAreaAssignments" */
  insert_eventAreaAssignments_one?: Maybe<EventAreaAssignments>;
  /** insert data into the table: "eventAreas" */
  insert_eventAreas?: Maybe<EventAreas_Mutation_Response>;
  /** insert a single row into the table: "eventAreas" */
  insert_eventAreas_one?: Maybe<EventAreas>;
  /** insert data into the table: "eventBeginnings" */
  insert_eventBeginnings?: Maybe<EventBeginnings_Mutation_Response>;
  /** insert a single row into the table: "eventBeginnings" */
  insert_eventBeginnings_one?: Maybe<EventBeginnings>;
  /** insert data into the table: "eventDiagnoses" */
  insert_eventDiagnoses?: Maybe<EventDiagnoses_Mutation_Response>;
  /** insert a single row into the table: "eventDiagnoses" */
  insert_eventDiagnoses_one?: Maybe<EventDiagnoses>;
  /** insert data into the table: "eventExpirations" */
  insert_eventExpirations?: Maybe<EventExpirations_Mutation_Response>;
  /** insert a single row into the table: "eventExpirations" */
  insert_eventExpirations_one?: Maybe<EventExpirations>;
  /** insert data into the table: "eventLimitTimes" */
  insert_eventLimitTimes?: Maybe<EventLimitTimes_Mutation_Response>;
  /** insert a single row into the table: "eventLimitTimes" */
  insert_eventLimitTimes_one?: Maybe<EventLimitTimes>;
  /** insert data into the table: "eventTagAssignments" */
  insert_eventTagAssignments?: Maybe<EventTagAssignments_Mutation_Response>;
  /** insert a single row into the table: "eventTagAssignments" */
  insert_eventTagAssignments_one?: Maybe<EventTagAssignments>;
  /** insert data into the table: "eventTags" */
  insert_eventTags?: Maybe<EventTags_Mutation_Response>;
  /** insert a single row into the table: "eventTags" */
  insert_eventTags_one?: Maybe<EventTags>;
  /** insert data into the table: "events" */
  insert_events?: Maybe<Events_Mutation_Response>;
  /** insert a single row into the table: "events" */
  insert_events_one?: Maybe<Events>;
  /** insert data into the table: "examinationDiagnoses" */
  insert_examinationDiagnoses?: Maybe<ExaminationDiagnoses_Mutation_Response>;
  /** insert a single row into the table: "examinationDiagnoses" */
  insert_examinationDiagnoses_one?: Maybe<ExaminationDiagnoses>;
  /** insert data into the table: "examinationDiagnosisAnswers" */
  insert_examinationDiagnosisAnswers?: Maybe<ExaminationDiagnosisAnswers_Mutation_Response>;
  /** insert a single row into the table: "examinationDiagnosisAnswers" */
  insert_examinationDiagnosisAnswers_one?: Maybe<ExaminationDiagnosisAnswers>;
  /** insert data into the table: "examinations" */
  insert_examinations?: Maybe<Examinations_Mutation_Response>;
  /** insert a single row into the table: "examinations" */
  insert_examinations_one?: Maybe<Examinations>;
  /** insert data into the table: "genders" */
  insert_genders?: Maybe<Genders_Mutation_Response>;
  /** insert a single row into the table: "genders" */
  insert_genders_one?: Maybe<Genders>;
  /** insert data into the table: "groupContents" */
  insert_groupContents?: Maybe<GroupContents_Mutation_Response>;
  /** insert a single row into the table: "groupContents" */
  insert_groupContents_one?: Maybe<GroupContents>;
  /** insert data into the table: "groupInvitations" */
  insert_groupInvitations?: Maybe<GroupInvitations_Mutation_Response>;
  /** insert a single row into the table: "groupInvitations" */
  insert_groupInvitations_one?: Maybe<GroupInvitations>;
  /** insert data into the table: "groups" */
  insert_groups?: Maybe<Groups_Mutation_Response>;
  /** insert a single row into the table: "groups" */
  insert_groups_one?: Maybe<Groups>;
  /** insert data into the table: "guestExamineeExaminations" */
  insert_guestExamineeExaminations?: Maybe<GuestExamineeExaminations_Mutation_Response>;
  /** insert a single row into the table: "guestExamineeExaminations" */
  insert_guestExamineeExaminations_one?: Maybe<GuestExamineeExaminations>;
  /** insert data into the table: "guestExaminees" */
  insert_guestExaminees?: Maybe<GuestExaminees_Mutation_Response>;
  /** insert a single row into the table: "guestExaminees" */
  insert_guestExaminees_one?: Maybe<GuestExaminees>;
  /** insert data into the table: "inactiveGroupEvents" */
  insert_inactiveGroupEvents?: Maybe<InactiveGroupEvents_Mutation_Response>;
  /** insert a single row into the table: "inactiveGroupEvents" */
  insert_inactiveGroupEvents_one?: Maybe<InactiveGroupEvents>;
  /** insert data into the table: "inactiveGroups" */
  insert_inactiveGroups?: Maybe<InactiveGroups_Mutation_Response>;
  /** insert a single row into the table: "inactiveGroups" */
  insert_inactiveGroups_one?: Maybe<InactiveGroups>;
  /** insert data into the table: "languages" */
  insert_languages?: Maybe<Languages_Mutation_Response>;
  /** insert a single row into the table: "languages" */
  insert_languages_one?: Maybe<Languages>;
  /** insert data into the table: "memberships" */
  insert_memberships?: Maybe<Memberships_Mutation_Response>;
  /** insert a single row into the table: "memberships" */
  insert_memberships_one?: Maybe<Memberships>;
  /** insert data into the table: "ownerships" */
  insert_ownerships?: Maybe<Ownerships_Mutation_Response>;
  /** insert a single row into the table: "ownerships" */
  insert_ownerships_one?: Maybe<Ownerships>;
  /** insert data into the table: "questionChoices" */
  insert_questionChoices?: Maybe<QuestionChoices_Mutation_Response>;
  /** insert a single row into the table: "questionChoices" */
  insert_questionChoices_one?: Maybe<QuestionChoices>;
  /** insert data into the table: "questionScores" */
  insert_questionScores?: Maybe<QuestionScores_Mutation_Response>;
  /** insert a single row into the table: "questionScores" */
  insert_questionScores_one?: Maybe<QuestionScores>;
  /** insert data into the table: "questions" */
  insert_questions?: Maybe<Questions_Mutation_Response>;
  /** insert a single row into the table: "questions" */
  insert_questions_one?: Maybe<Questions>;
  /** insert data into the table: "scoreTypes" */
  insert_scoreTypes?: Maybe<ScoreTypes_Mutation_Response>;
  /** insert a single row into the table: "scoreTypes" */
  insert_scoreTypes_one?: Maybe<ScoreTypes>;
  /** insert data into the table: "staffInvitations" */
  insert_staffInvitations?: Maybe<StaffInvitations_Mutation_Response>;
  /** insert a single row into the table: "staffInvitations" */
  insert_staffInvitations_one?: Maybe<StaffInvitations>;
  /** insert data into the table: "staffs" */
  insert_staffs?: Maybe<Staffs_Mutation_Response>;
  /** insert a single row into the table: "staffs" */
  insert_staffs_one?: Maybe<Staffs>;
  /** insert data into the table: "translatedGenders" */
  insert_translatedGenders?: Maybe<TranslatedGenders_Mutation_Response>;
  /** insert a single row into the table: "translatedGenders" */
  insert_translatedGenders_one?: Maybe<TranslatedGenders>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** update data of the table: "diagnoses" */
  update_diagnoses?: Maybe<Diagnoses_Mutation_Response>;
  /** update single row of the table: "diagnoses" */
  update_diagnoses_by_pk?: Maybe<Diagnoses>;
  /** update multiples rows of table: "diagnoses" */
  update_diagnoses_many?: Maybe<Array<Maybe<Diagnoses_Mutation_Response>>>;
  /** update data of the table: "diagnosisTypes" */
  update_diagnosisTypes?: Maybe<DiagnosisTypes_Mutation_Response>;
  /** update single row of the table: "diagnosisTypes" */
  update_diagnosisTypes_by_pk?: Maybe<DiagnosisTypes>;
  /** update multiples rows of table: "diagnosisTypes" */
  update_diagnosisTypes_many?: Maybe<Array<Maybe<DiagnosisTypes_Mutation_Response>>>;
  /** update data of the table: "eventAreaAssignments" */
  update_eventAreaAssignments?: Maybe<EventAreaAssignments_Mutation_Response>;
  /** update single row of the table: "eventAreaAssignments" */
  update_eventAreaAssignments_by_pk?: Maybe<EventAreaAssignments>;
  /** update multiples rows of table: "eventAreaAssignments" */
  update_eventAreaAssignments_many?: Maybe<Array<Maybe<EventAreaAssignments_Mutation_Response>>>;
  /** update data of the table: "eventAreas" */
  update_eventAreas?: Maybe<EventAreas_Mutation_Response>;
  /** update single row of the table: "eventAreas" */
  update_eventAreas_by_pk?: Maybe<EventAreas>;
  /** update multiples rows of table: "eventAreas" */
  update_eventAreas_many?: Maybe<Array<Maybe<EventAreas_Mutation_Response>>>;
  /** update data of the table: "eventBeginnings" */
  update_eventBeginnings?: Maybe<EventBeginnings_Mutation_Response>;
  /** update single row of the table: "eventBeginnings" */
  update_eventBeginnings_by_pk?: Maybe<EventBeginnings>;
  /** update multiples rows of table: "eventBeginnings" */
  update_eventBeginnings_many?: Maybe<Array<Maybe<EventBeginnings_Mutation_Response>>>;
  /** update data of the table: "eventDiagnoses" */
  update_eventDiagnoses?: Maybe<EventDiagnoses_Mutation_Response>;
  /** update single row of the table: "eventDiagnoses" */
  update_eventDiagnoses_by_pk?: Maybe<EventDiagnoses>;
  /** update multiples rows of table: "eventDiagnoses" */
  update_eventDiagnoses_many?: Maybe<Array<Maybe<EventDiagnoses_Mutation_Response>>>;
  /** update data of the table: "eventExpirations" */
  update_eventExpirations?: Maybe<EventExpirations_Mutation_Response>;
  /** update single row of the table: "eventExpirations" */
  update_eventExpirations_by_pk?: Maybe<EventExpirations>;
  /** update multiples rows of table: "eventExpirations" */
  update_eventExpirations_many?: Maybe<Array<Maybe<EventExpirations_Mutation_Response>>>;
  /** update data of the table: "eventLimitTimes" */
  update_eventLimitTimes?: Maybe<EventLimitTimes_Mutation_Response>;
  /** update single row of the table: "eventLimitTimes" */
  update_eventLimitTimes_by_pk?: Maybe<EventLimitTimes>;
  /** update multiples rows of table: "eventLimitTimes" */
  update_eventLimitTimes_many?: Maybe<Array<Maybe<EventLimitTimes_Mutation_Response>>>;
  /** update data of the table: "eventTagAssignments" */
  update_eventTagAssignments?: Maybe<EventTagAssignments_Mutation_Response>;
  /** update single row of the table: "eventTagAssignments" */
  update_eventTagAssignments_by_pk?: Maybe<EventTagAssignments>;
  /** update multiples rows of table: "eventTagAssignments" */
  update_eventTagAssignments_many?: Maybe<Array<Maybe<EventTagAssignments_Mutation_Response>>>;
  /** update data of the table: "eventTags" */
  update_eventTags?: Maybe<EventTags_Mutation_Response>;
  /** update single row of the table: "eventTags" */
  update_eventTags_by_pk?: Maybe<EventTags>;
  /** update multiples rows of table: "eventTags" */
  update_eventTags_many?: Maybe<Array<Maybe<EventTags_Mutation_Response>>>;
  /** update data of the table: "events" */
  update_events?: Maybe<Events_Mutation_Response>;
  /** update single row of the table: "events" */
  update_events_by_pk?: Maybe<Events>;
  /** update multiples rows of table: "events" */
  update_events_many?: Maybe<Array<Maybe<Events_Mutation_Response>>>;
  /** update data of the table: "examinationDiagnoses" */
  update_examinationDiagnoses?: Maybe<ExaminationDiagnoses_Mutation_Response>;
  /** update single row of the table: "examinationDiagnoses" */
  update_examinationDiagnoses_by_pk?: Maybe<ExaminationDiagnoses>;
  /** update multiples rows of table: "examinationDiagnoses" */
  update_examinationDiagnoses_many?: Maybe<Array<Maybe<ExaminationDiagnoses_Mutation_Response>>>;
  /** update data of the table: "examinationDiagnosisAnswers" */
  update_examinationDiagnosisAnswers?: Maybe<ExaminationDiagnosisAnswers_Mutation_Response>;
  /** update single row of the table: "examinationDiagnosisAnswers" */
  update_examinationDiagnosisAnswers_by_pk?: Maybe<ExaminationDiagnosisAnswers>;
  /** update multiples rows of table: "examinationDiagnosisAnswers" */
  update_examinationDiagnosisAnswers_many?: Maybe<Array<Maybe<ExaminationDiagnosisAnswers_Mutation_Response>>>;
  /** update data of the table: "examinations" */
  update_examinations?: Maybe<Examinations_Mutation_Response>;
  /** update single row of the table: "examinations" */
  update_examinations_by_pk?: Maybe<Examinations>;
  /** update multiples rows of table: "examinations" */
  update_examinations_many?: Maybe<Array<Maybe<Examinations_Mutation_Response>>>;
  /** update data of the table: "genders" */
  update_genders?: Maybe<Genders_Mutation_Response>;
  /** update single row of the table: "genders" */
  update_genders_by_pk?: Maybe<Genders>;
  /** update multiples rows of table: "genders" */
  update_genders_many?: Maybe<Array<Maybe<Genders_Mutation_Response>>>;
  /** update data of the table: "groupContents" */
  update_groupContents?: Maybe<GroupContents_Mutation_Response>;
  /** update single row of the table: "groupContents" */
  update_groupContents_by_pk?: Maybe<GroupContents>;
  /** update multiples rows of table: "groupContents" */
  update_groupContents_many?: Maybe<Array<Maybe<GroupContents_Mutation_Response>>>;
  /** update data of the table: "groupInvitations" */
  update_groupInvitations?: Maybe<GroupInvitations_Mutation_Response>;
  /** update single row of the table: "groupInvitations" */
  update_groupInvitations_by_pk?: Maybe<GroupInvitations>;
  /** update multiples rows of table: "groupInvitations" */
  update_groupInvitations_many?: Maybe<Array<Maybe<GroupInvitations_Mutation_Response>>>;
  /** update data of the table: "groups" */
  update_groups?: Maybe<Groups_Mutation_Response>;
  /** update single row of the table: "groups" */
  update_groups_by_pk?: Maybe<Groups>;
  /** update multiples rows of table: "groups" */
  update_groups_many?: Maybe<Array<Maybe<Groups_Mutation_Response>>>;
  /** update data of the table: "guestExamineeExaminations" */
  update_guestExamineeExaminations?: Maybe<GuestExamineeExaminations_Mutation_Response>;
  /** update single row of the table: "guestExamineeExaminations" */
  update_guestExamineeExaminations_by_pk?: Maybe<GuestExamineeExaminations>;
  /** update multiples rows of table: "guestExamineeExaminations" */
  update_guestExamineeExaminations_many?: Maybe<Array<Maybe<GuestExamineeExaminations_Mutation_Response>>>;
  /** update data of the table: "guestExaminees" */
  update_guestExaminees?: Maybe<GuestExaminees_Mutation_Response>;
  /** update single row of the table: "guestExaminees" */
  update_guestExaminees_by_pk?: Maybe<GuestExaminees>;
  /** update multiples rows of table: "guestExaminees" */
  update_guestExaminees_many?: Maybe<Array<Maybe<GuestExaminees_Mutation_Response>>>;
  /** update data of the table: "inactiveGroupEvents" */
  update_inactiveGroupEvents?: Maybe<InactiveGroupEvents_Mutation_Response>;
  /** update single row of the table: "inactiveGroupEvents" */
  update_inactiveGroupEvents_by_pk?: Maybe<InactiveGroupEvents>;
  /** update multiples rows of table: "inactiveGroupEvents" */
  update_inactiveGroupEvents_many?: Maybe<Array<Maybe<InactiveGroupEvents_Mutation_Response>>>;
  /** update data of the table: "inactiveGroups" */
  update_inactiveGroups?: Maybe<InactiveGroups_Mutation_Response>;
  /** update single row of the table: "inactiveGroups" */
  update_inactiveGroups_by_pk?: Maybe<InactiveGroups>;
  /** update multiples rows of table: "inactiveGroups" */
  update_inactiveGroups_many?: Maybe<Array<Maybe<InactiveGroups_Mutation_Response>>>;
  /** update data of the table: "languages" */
  update_languages?: Maybe<Languages_Mutation_Response>;
  /** update single row of the table: "languages" */
  update_languages_by_pk?: Maybe<Languages>;
  /** update multiples rows of table: "languages" */
  update_languages_many?: Maybe<Array<Maybe<Languages_Mutation_Response>>>;
  /** update data of the table: "memberships" */
  update_memberships?: Maybe<Memberships_Mutation_Response>;
  /** update single row of the table: "memberships" */
  update_memberships_by_pk?: Maybe<Memberships>;
  /** update multiples rows of table: "memberships" */
  update_memberships_many?: Maybe<Array<Maybe<Memberships_Mutation_Response>>>;
  /** update data of the table: "ownerships" */
  update_ownerships?: Maybe<Ownerships_Mutation_Response>;
  /** update single row of the table: "ownerships" */
  update_ownerships_by_pk?: Maybe<Ownerships>;
  /** update multiples rows of table: "ownerships" */
  update_ownerships_many?: Maybe<Array<Maybe<Ownerships_Mutation_Response>>>;
  /** update data of the table: "questionChoices" */
  update_questionChoices?: Maybe<QuestionChoices_Mutation_Response>;
  /** update single row of the table: "questionChoices" */
  update_questionChoices_by_pk?: Maybe<QuestionChoices>;
  /** update multiples rows of table: "questionChoices" */
  update_questionChoices_many?: Maybe<Array<Maybe<QuestionChoices_Mutation_Response>>>;
  /** update data of the table: "questionScores" */
  update_questionScores?: Maybe<QuestionScores_Mutation_Response>;
  /** update single row of the table: "questionScores" */
  update_questionScores_by_pk?: Maybe<QuestionScores>;
  /** update multiples rows of table: "questionScores" */
  update_questionScores_many?: Maybe<Array<Maybe<QuestionScores_Mutation_Response>>>;
  /** update data of the table: "questions" */
  update_questions?: Maybe<Questions_Mutation_Response>;
  /** update single row of the table: "questions" */
  update_questions_by_pk?: Maybe<Questions>;
  /** update multiples rows of table: "questions" */
  update_questions_many?: Maybe<Array<Maybe<Questions_Mutation_Response>>>;
  /** update data of the table: "scoreTypes" */
  update_scoreTypes?: Maybe<ScoreTypes_Mutation_Response>;
  /** update single row of the table: "scoreTypes" */
  update_scoreTypes_by_pk?: Maybe<ScoreTypes>;
  /** update multiples rows of table: "scoreTypes" */
  update_scoreTypes_many?: Maybe<Array<Maybe<ScoreTypes_Mutation_Response>>>;
  /** update data of the table: "staffInvitations" */
  update_staffInvitations?: Maybe<StaffInvitations_Mutation_Response>;
  /** update single row of the table: "staffInvitations" */
  update_staffInvitations_by_pk?: Maybe<StaffInvitations>;
  /** update multiples rows of table: "staffInvitations" */
  update_staffInvitations_many?: Maybe<Array<Maybe<StaffInvitations_Mutation_Response>>>;
  /** update data of the table: "staffs" */
  update_staffs?: Maybe<Staffs_Mutation_Response>;
  /** update single row of the table: "staffs" */
  update_staffs_by_pk?: Maybe<Staffs>;
  /** update multiples rows of table: "staffs" */
  update_staffs_many?: Maybe<Array<Maybe<Staffs_Mutation_Response>>>;
  /** update data of the table: "translatedGenders" */
  update_translatedGenders?: Maybe<TranslatedGenders_Mutation_Response>;
  /** update single row of the table: "translatedGenders" */
  update_translatedGenders_by_pk?: Maybe<TranslatedGenders>;
  /** update multiples rows of table: "translatedGenders" */
  update_translatedGenders_many?: Maybe<Array<Maybe<TranslatedGenders_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootInsertGuestExamineeMailsArgs = {
  guestExamineeIds: Array<Scalars['uuid']>;
};


/** mutation root */
export type Mutation_RootInsertGuestExamineesDerivedArgs = {
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  guestExaminees: Array<InsertGuestExaineesDerivedInput>;
};


/** mutation root */
export type Mutation_RootInsertMembershipsOneDerivedArgs = {
  email: Scalars['String'];
  groupId: Scalars['uuid'];
  isOwner: Scalars['Boolean'];
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsertStaffsOneDerivedArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_DiagnosesArgs = {
  where: Diagnoses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Diagnoses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DiagnosisTypesArgs = {
  where: DiagnosisTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_DiagnosisTypes_By_PkArgs = {
  code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_EventAreaAssignmentsArgs = {
  where: EventAreaAssignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventAreaAssignments_By_PkArgs = {
  eventAreaId: Scalars['uuid'];
  eventId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventAreasArgs = {
  where: EventAreas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventAreas_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventBeginningsArgs = {
  where: EventBeginnings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventBeginnings_By_PkArgs = {
  eventId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventDiagnosesArgs = {
  where: EventDiagnoses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventDiagnoses_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  eventId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventExpirationsArgs = {
  where: EventExpirations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventExpirations_By_PkArgs = {
  eventId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventLimitTimesArgs = {
  where: EventLimitTimes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventLimitTimes_By_PkArgs = {
  eventId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventTagAssignmentsArgs = {
  where: EventTagAssignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventTagAssignments_By_PkArgs = {
  eventId: Scalars['uuid'];
  eventTagId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventTagsArgs = {
  where: EventTags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventTags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventsArgs = {
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ExaminationDiagnosesArgs = {
  where: ExaminationDiagnoses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ExaminationDiagnoses_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ExaminationDiagnosisAnswersArgs = {
  where: ExaminationDiagnosisAnswers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ExaminationDiagnosisAnswers_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
  questionId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ExaminationsArgs = {
  where: Examinations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Examinations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GendersArgs = {
  where: Genders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Genders_By_PkArgs = {
  code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_GroupContentsArgs = {
  where: GroupContents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GroupContents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GroupInvitationsArgs = {
  where: GroupInvitations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GroupInvitations_By_PkArgs = {
  email: Scalars['String'];
  groupId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GroupsArgs = {
  where: Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Groups_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GuestExamineeExaminationsArgs = {
  where: GuestExamineeExaminations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GuestExamineeExaminations_By_PkArgs = {
  guestExamineeId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GuestExamineesArgs = {
  where: GuestExaminees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GuestExaminees_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InactiveGroupEventsArgs = {
  where: InactiveGroupEvents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_InactiveGroupEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InactiveGroupsArgs = {
  where: InactiveGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_InactiveGroups_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LanguagesArgs = {
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Languages_By_PkArgs = {
  code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_MembershipsArgs = {
  where: Memberships_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Memberships_By_PkArgs = {
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OwnershipsArgs = {
  where: Ownerships_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ownerships_By_PkArgs = {
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionChoicesArgs = {
  where: QuestionChoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_QuestionChoices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionScoresArgs = {
  where: QuestionScores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_QuestionScores_By_PkArgs = {
  questionChoiceId: Scalars['uuid'];
  scoreTypeCode: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionsArgs = {
  where: Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ScoreTypesArgs = {
  where: ScoreTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ScoreTypes_By_PkArgs = {
  code: Scalars['String'];
  diagnosisId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_StaffInvitationsArgs = {
  where: StaffInvitations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StaffInvitations_By_PkArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_StaffsArgs = {
  where: Staffs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staffs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TranslatedGendersArgs = {
  where: TranslatedGenders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TranslatedGenders_By_PkArgs = {
  genderCode: Genders_Enum;
  languageCode: Languages_Enum;
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_DiagnosesArgs = {
  objects: Array<Diagnoses_Insert_Input>;
  on_conflict?: InputMaybe<Diagnoses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Diagnoses_OneArgs = {
  object: Diagnoses_Insert_Input;
  on_conflict?: InputMaybe<Diagnoses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DiagnosisTypesArgs = {
  objects: Array<DiagnosisTypes_Insert_Input>;
  on_conflict?: InputMaybe<DiagnosisTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DiagnosisTypes_OneArgs = {
  object: DiagnosisTypes_Insert_Input;
  on_conflict?: InputMaybe<DiagnosisTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAreaAssignmentsArgs = {
  objects: Array<EventAreaAssignments_Insert_Input>;
  on_conflict?: InputMaybe<EventAreaAssignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAreaAssignments_OneArgs = {
  object: EventAreaAssignments_Insert_Input;
  on_conflict?: InputMaybe<EventAreaAssignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAreasArgs = {
  objects: Array<EventAreas_Insert_Input>;
  on_conflict?: InputMaybe<EventAreas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAreas_OneArgs = {
  object: EventAreas_Insert_Input;
  on_conflict?: InputMaybe<EventAreas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventBeginningsArgs = {
  objects: Array<EventBeginnings_Insert_Input>;
  on_conflict?: InputMaybe<EventBeginnings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventBeginnings_OneArgs = {
  object: EventBeginnings_Insert_Input;
  on_conflict?: InputMaybe<EventBeginnings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventDiagnosesArgs = {
  objects: Array<EventDiagnoses_Insert_Input>;
  on_conflict?: InputMaybe<EventDiagnoses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventDiagnoses_OneArgs = {
  object: EventDiagnoses_Insert_Input;
  on_conflict?: InputMaybe<EventDiagnoses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventExpirationsArgs = {
  objects: Array<EventExpirations_Insert_Input>;
  on_conflict?: InputMaybe<EventExpirations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventExpirations_OneArgs = {
  object: EventExpirations_Insert_Input;
  on_conflict?: InputMaybe<EventExpirations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventLimitTimesArgs = {
  objects: Array<EventLimitTimes_Insert_Input>;
  on_conflict?: InputMaybe<EventLimitTimes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventLimitTimes_OneArgs = {
  object: EventLimitTimes_Insert_Input;
  on_conflict?: InputMaybe<EventLimitTimes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventTagAssignmentsArgs = {
  objects: Array<EventTagAssignments_Insert_Input>;
  on_conflict?: InputMaybe<EventTagAssignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventTagAssignments_OneArgs = {
  object: EventTagAssignments_Insert_Input;
  on_conflict?: InputMaybe<EventTagAssignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventTagsArgs = {
  objects: Array<EventTags_Insert_Input>;
  on_conflict?: InputMaybe<EventTags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventTags_OneArgs = {
  object: EventTags_Insert_Input;
  on_conflict?: InputMaybe<EventTags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventsArgs = {
  objects: Array<Events_Insert_Input>;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Events_OneArgs = {
  object: Events_Insert_Input;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExaminationDiagnosesArgs = {
  objects: Array<ExaminationDiagnoses_Insert_Input>;
  on_conflict?: InputMaybe<ExaminationDiagnoses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExaminationDiagnoses_OneArgs = {
  object: ExaminationDiagnoses_Insert_Input;
  on_conflict?: InputMaybe<ExaminationDiagnoses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExaminationDiagnosisAnswersArgs = {
  objects: Array<ExaminationDiagnosisAnswers_Insert_Input>;
  on_conflict?: InputMaybe<ExaminationDiagnosisAnswers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExaminationDiagnosisAnswers_OneArgs = {
  object: ExaminationDiagnosisAnswers_Insert_Input;
  on_conflict?: InputMaybe<ExaminationDiagnosisAnswers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExaminationsArgs = {
  objects: Array<Examinations_Insert_Input>;
  on_conflict?: InputMaybe<Examinations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Examinations_OneArgs = {
  object: Examinations_Insert_Input;
  on_conflict?: InputMaybe<Examinations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GendersArgs = {
  objects: Array<Genders_Insert_Input>;
  on_conflict?: InputMaybe<Genders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Genders_OneArgs = {
  object: Genders_Insert_Input;
  on_conflict?: InputMaybe<Genders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GroupContentsArgs = {
  objects: Array<GroupContents_Insert_Input>;
  on_conflict?: InputMaybe<GroupContents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GroupContents_OneArgs = {
  object: GroupContents_Insert_Input;
  on_conflict?: InputMaybe<GroupContents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GroupInvitationsArgs = {
  objects: Array<GroupInvitations_Insert_Input>;
  on_conflict?: InputMaybe<GroupInvitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GroupInvitations_OneArgs = {
  object: GroupInvitations_Insert_Input;
  on_conflict?: InputMaybe<GroupInvitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GroupsArgs = {
  objects: Array<Groups_Insert_Input>;
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Groups_OneArgs = {
  object: Groups_Insert_Input;
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GuestExamineeExaminationsArgs = {
  objects: Array<GuestExamineeExaminations_Insert_Input>;
  on_conflict?: InputMaybe<GuestExamineeExaminations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GuestExamineeExaminations_OneArgs = {
  object: GuestExamineeExaminations_Insert_Input;
  on_conflict?: InputMaybe<GuestExamineeExaminations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GuestExamineesArgs = {
  objects: Array<GuestExaminees_Insert_Input>;
  on_conflict?: InputMaybe<GuestExaminees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GuestExaminees_OneArgs = {
  object: GuestExaminees_Insert_Input;
  on_conflict?: InputMaybe<GuestExaminees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InactiveGroupEventsArgs = {
  objects: Array<InactiveGroupEvents_Insert_Input>;
  on_conflict?: InputMaybe<InactiveGroupEvents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InactiveGroupEvents_OneArgs = {
  object: InactiveGroupEvents_Insert_Input;
  on_conflict?: InputMaybe<InactiveGroupEvents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InactiveGroupsArgs = {
  objects: Array<InactiveGroups_Insert_Input>;
  on_conflict?: InputMaybe<InactiveGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InactiveGroups_OneArgs = {
  object: InactiveGroups_Insert_Input;
  on_conflict?: InputMaybe<InactiveGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LanguagesArgs = {
  objects: Array<Languages_Insert_Input>;
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Languages_OneArgs = {
  object: Languages_Insert_Input;
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MembershipsArgs = {
  objects: Array<Memberships_Insert_Input>;
  on_conflict?: InputMaybe<Memberships_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Memberships_OneArgs = {
  object: Memberships_Insert_Input;
  on_conflict?: InputMaybe<Memberships_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OwnershipsArgs = {
  objects: Array<Ownerships_Insert_Input>;
  on_conflict?: InputMaybe<Ownerships_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ownerships_OneArgs = {
  object: Ownerships_Insert_Input;
  on_conflict?: InputMaybe<Ownerships_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionChoicesArgs = {
  objects: Array<QuestionChoices_Insert_Input>;
  on_conflict?: InputMaybe<QuestionChoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionChoices_OneArgs = {
  object: QuestionChoices_Insert_Input;
  on_conflict?: InputMaybe<QuestionChoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionScoresArgs = {
  objects: Array<QuestionScores_Insert_Input>;
  on_conflict?: InputMaybe<QuestionScores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionScores_OneArgs = {
  object: QuestionScores_Insert_Input;
  on_conflict?: InputMaybe<QuestionScores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionsArgs = {
  objects: Array<Questions_Insert_Input>;
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questions_OneArgs = {
  object: Questions_Insert_Input;
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScoreTypesArgs = {
  objects: Array<ScoreTypes_Insert_Input>;
  on_conflict?: InputMaybe<ScoreTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScoreTypes_OneArgs = {
  object: ScoreTypes_Insert_Input;
  on_conflict?: InputMaybe<ScoreTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StaffInvitationsArgs = {
  objects: Array<StaffInvitations_Insert_Input>;
  on_conflict?: InputMaybe<StaffInvitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StaffInvitations_OneArgs = {
  object: StaffInvitations_Insert_Input;
  on_conflict?: InputMaybe<StaffInvitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StaffsArgs = {
  objects: Array<Staffs_Insert_Input>;
  on_conflict?: InputMaybe<Staffs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staffs_OneArgs = {
  object: Staffs_Insert_Input;
  on_conflict?: InputMaybe<Staffs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TranslatedGendersArgs = {
  objects: Array<TranslatedGenders_Insert_Input>;
  on_conflict?: InputMaybe<TranslatedGenders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TranslatedGenders_OneArgs = {
  object: TranslatedGenders_Insert_Input;
  on_conflict?: InputMaybe<TranslatedGenders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_DiagnosesArgs = {
  _set?: InputMaybe<Diagnoses_Set_Input>;
  where: Diagnoses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Diagnoses_By_PkArgs = {
  _set?: InputMaybe<Diagnoses_Set_Input>;
  pk_columns: Diagnoses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Diagnoses_ManyArgs = {
  updates: Array<Diagnoses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DiagnosisTypesArgs = {
  _set?: InputMaybe<DiagnosisTypes_Set_Input>;
  where: DiagnosisTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_DiagnosisTypes_By_PkArgs = {
  _set?: InputMaybe<DiagnosisTypes_Set_Input>;
  pk_columns: DiagnosisTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DiagnosisTypes_ManyArgs = {
  updates: Array<DiagnosisTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventAreaAssignmentsArgs = {
  _set?: InputMaybe<EventAreaAssignments_Set_Input>;
  where: EventAreaAssignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventAreaAssignments_By_PkArgs = {
  _set?: InputMaybe<EventAreaAssignments_Set_Input>;
  pk_columns: EventAreaAssignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventAreaAssignments_ManyArgs = {
  updates: Array<EventAreaAssignments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventAreasArgs = {
  _set?: InputMaybe<EventAreas_Set_Input>;
  where: EventAreas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventAreas_By_PkArgs = {
  _set?: InputMaybe<EventAreas_Set_Input>;
  pk_columns: EventAreas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventAreas_ManyArgs = {
  updates: Array<EventAreas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventBeginningsArgs = {
  _set?: InputMaybe<EventBeginnings_Set_Input>;
  where: EventBeginnings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventBeginnings_By_PkArgs = {
  _set?: InputMaybe<EventBeginnings_Set_Input>;
  pk_columns: EventBeginnings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventBeginnings_ManyArgs = {
  updates: Array<EventBeginnings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventDiagnosesArgs = {
  _set?: InputMaybe<EventDiagnoses_Set_Input>;
  where: EventDiagnoses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventDiagnoses_By_PkArgs = {
  _set?: InputMaybe<EventDiagnoses_Set_Input>;
  pk_columns: EventDiagnoses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventDiagnoses_ManyArgs = {
  updates: Array<EventDiagnoses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventExpirationsArgs = {
  _set?: InputMaybe<EventExpirations_Set_Input>;
  where: EventExpirations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventExpirations_By_PkArgs = {
  _set?: InputMaybe<EventExpirations_Set_Input>;
  pk_columns: EventExpirations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventExpirations_ManyArgs = {
  updates: Array<EventExpirations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventLimitTimesArgs = {
  _inc?: InputMaybe<EventLimitTimes_Inc_Input>;
  _set?: InputMaybe<EventLimitTimes_Set_Input>;
  where: EventLimitTimes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventLimitTimes_By_PkArgs = {
  _inc?: InputMaybe<EventLimitTimes_Inc_Input>;
  _set?: InputMaybe<EventLimitTimes_Set_Input>;
  pk_columns: EventLimitTimes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventLimitTimes_ManyArgs = {
  updates: Array<EventLimitTimes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventTagAssignmentsArgs = {
  _set?: InputMaybe<EventTagAssignments_Set_Input>;
  where: EventTagAssignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventTagAssignments_By_PkArgs = {
  _set?: InputMaybe<EventTagAssignments_Set_Input>;
  pk_columns: EventTagAssignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventTagAssignments_ManyArgs = {
  updates: Array<EventTagAssignments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventTagsArgs = {
  _set?: InputMaybe<EventTags_Set_Input>;
  where: EventTags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventTags_By_PkArgs = {
  _set?: InputMaybe<EventTags_Set_Input>;
  pk_columns: EventTags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventTags_ManyArgs = {
  updates: Array<EventTags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventsArgs = {
  _set?: InputMaybe<Events_Set_Input>;
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Events_By_PkArgs = {
  _set?: InputMaybe<Events_Set_Input>;
  pk_columns: Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Events_ManyArgs = {
  updates: Array<Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExaminationDiagnosesArgs = {
  _set?: InputMaybe<ExaminationDiagnoses_Set_Input>;
  where: ExaminationDiagnoses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ExaminationDiagnoses_By_PkArgs = {
  _set?: InputMaybe<ExaminationDiagnoses_Set_Input>;
  pk_columns: ExaminationDiagnoses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ExaminationDiagnoses_ManyArgs = {
  updates: Array<ExaminationDiagnoses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExaminationDiagnosisAnswersArgs = {
  _set?: InputMaybe<ExaminationDiagnosisAnswers_Set_Input>;
  where: ExaminationDiagnosisAnswers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ExaminationDiagnosisAnswers_By_PkArgs = {
  _set?: InputMaybe<ExaminationDiagnosisAnswers_Set_Input>;
  pk_columns: ExaminationDiagnosisAnswers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ExaminationDiagnosisAnswers_ManyArgs = {
  updates: Array<ExaminationDiagnosisAnswers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExaminationsArgs = {
  _inc?: InputMaybe<Examinations_Inc_Input>;
  _set?: InputMaybe<Examinations_Set_Input>;
  where: Examinations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Examinations_By_PkArgs = {
  _inc?: InputMaybe<Examinations_Inc_Input>;
  _set?: InputMaybe<Examinations_Set_Input>;
  pk_columns: Examinations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Examinations_ManyArgs = {
  updates: Array<Examinations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GendersArgs = {
  _set?: InputMaybe<Genders_Set_Input>;
  where: Genders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Genders_By_PkArgs = {
  _set?: InputMaybe<Genders_Set_Input>;
  pk_columns: Genders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Genders_ManyArgs = {
  updates: Array<Genders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GroupContentsArgs = {
  _set?: InputMaybe<GroupContents_Set_Input>;
  where: GroupContents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GroupContents_By_PkArgs = {
  _set?: InputMaybe<GroupContents_Set_Input>;
  pk_columns: GroupContents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GroupContents_ManyArgs = {
  updates: Array<GroupContents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GroupInvitationsArgs = {
  _set?: InputMaybe<GroupInvitations_Set_Input>;
  where: GroupInvitations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GroupInvitations_By_PkArgs = {
  _set?: InputMaybe<GroupInvitations_Set_Input>;
  pk_columns: GroupInvitations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GroupInvitations_ManyArgs = {
  updates: Array<GroupInvitations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GroupsArgs = {
  _set?: InputMaybe<Groups_Set_Input>;
  where: Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Groups_By_PkArgs = {
  _set?: InputMaybe<Groups_Set_Input>;
  pk_columns: Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Groups_ManyArgs = {
  updates: Array<Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GuestExamineeExaminationsArgs = {
  _set?: InputMaybe<GuestExamineeExaminations_Set_Input>;
  where: GuestExamineeExaminations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GuestExamineeExaminations_By_PkArgs = {
  _set?: InputMaybe<GuestExamineeExaminations_Set_Input>;
  pk_columns: GuestExamineeExaminations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GuestExamineeExaminations_ManyArgs = {
  updates: Array<GuestExamineeExaminations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GuestExamineesArgs = {
  _set?: InputMaybe<GuestExaminees_Set_Input>;
  where: GuestExaminees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GuestExaminees_By_PkArgs = {
  _set?: InputMaybe<GuestExaminees_Set_Input>;
  pk_columns: GuestExaminees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GuestExaminees_ManyArgs = {
  updates: Array<GuestExaminees_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InactiveGroupEventsArgs = {
  _set?: InputMaybe<InactiveGroupEvents_Set_Input>;
  where: InactiveGroupEvents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_InactiveGroupEvents_By_PkArgs = {
  _set?: InputMaybe<InactiveGroupEvents_Set_Input>;
  pk_columns: InactiveGroupEvents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_InactiveGroupEvents_ManyArgs = {
  updates: Array<InactiveGroupEvents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InactiveGroupsArgs = {
  _set?: InputMaybe<InactiveGroups_Set_Input>;
  where: InactiveGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_InactiveGroups_By_PkArgs = {
  _set?: InputMaybe<InactiveGroups_Set_Input>;
  pk_columns: InactiveGroups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_InactiveGroups_ManyArgs = {
  updates: Array<InactiveGroups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LanguagesArgs = {
  _set?: InputMaybe<Languages_Set_Input>;
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_By_PkArgs = {
  _set?: InputMaybe<Languages_Set_Input>;
  pk_columns: Languages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_ManyArgs = {
  updates: Array<Languages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MembershipsArgs = {
  _set?: InputMaybe<Memberships_Set_Input>;
  where: Memberships_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Memberships_By_PkArgs = {
  _set?: InputMaybe<Memberships_Set_Input>;
  pk_columns: Memberships_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Memberships_ManyArgs = {
  updates: Array<Memberships_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OwnershipsArgs = {
  _set?: InputMaybe<Ownerships_Set_Input>;
  where: Ownerships_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ownerships_By_PkArgs = {
  _set?: InputMaybe<Ownerships_Set_Input>;
  pk_columns: Ownerships_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ownerships_ManyArgs = {
  updates: Array<Ownerships_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionChoicesArgs = {
  _set?: InputMaybe<QuestionChoices_Set_Input>;
  where: QuestionChoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionChoices_By_PkArgs = {
  _set?: InputMaybe<QuestionChoices_Set_Input>;
  pk_columns: QuestionChoices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionChoices_ManyArgs = {
  updates: Array<QuestionChoices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionScoresArgs = {
  _inc?: InputMaybe<QuestionScores_Inc_Input>;
  _set?: InputMaybe<QuestionScores_Set_Input>;
  where: QuestionScores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionScores_By_PkArgs = {
  _inc?: InputMaybe<QuestionScores_Inc_Input>;
  _set?: InputMaybe<QuestionScores_Set_Input>;
  pk_columns: QuestionScores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionScores_ManyArgs = {
  updates: Array<QuestionScores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionsArgs = {
  _set?: InputMaybe<Questions_Set_Input>;
  where: Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questions_By_PkArgs = {
  _set?: InputMaybe<Questions_Set_Input>;
  pk_columns: Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questions_ManyArgs = {
  updates: Array<Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScoreTypesArgs = {
  _set?: InputMaybe<ScoreTypes_Set_Input>;
  where: ScoreTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ScoreTypes_By_PkArgs = {
  _set?: InputMaybe<ScoreTypes_Set_Input>;
  pk_columns: ScoreTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ScoreTypes_ManyArgs = {
  updates: Array<ScoreTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StaffInvitationsArgs = {
  _set?: InputMaybe<StaffInvitations_Set_Input>;
  where: StaffInvitations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_StaffInvitations_By_PkArgs = {
  _set?: InputMaybe<StaffInvitations_Set_Input>;
  pk_columns: StaffInvitations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StaffInvitations_ManyArgs = {
  updates: Array<StaffInvitations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StaffsArgs = {
  _set?: InputMaybe<Staffs_Set_Input>;
  where: Staffs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staffs_By_PkArgs = {
  _set?: InputMaybe<Staffs_Set_Input>;
  pk_columns: Staffs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staffs_ManyArgs = {
  updates: Array<Staffs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TranslatedGendersArgs = {
  _set?: InputMaybe<TranslatedGenders_Set_Input>;
  where: TranslatedGenders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TranslatedGenders_By_PkArgs = {
  _set?: InputMaybe<TranslatedGenders_Set_Input>;
  pk_columns: TranslatedGenders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TranslatedGenders_ManyArgs = {
  updates: Array<TranslatedGenders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "ownerships" */
export type Ownerships = {
  __typename?: 'ownerships';
  /** An array relationship */
  _memberships: Array<Memberships>;
  /** An aggregate relationship */
  _memberships_aggregate: Memberships_Aggregate;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId: Scalars['uuid'];
  /** An object relationship */
  membership?: Maybe<Memberships>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: Memberships_Aggregate;
  /** An array relationship */
  ownerships: Array<Ownerships>;
  /** An aggregate relationship */
  ownerships_aggregate: Ownerships_Aggregate;
  /** An object relationship */
  user?: Maybe<Users>;
  userId: Scalars['uuid'];
};


/** columns and relationships of "ownerships" */
export type Ownerships_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "ownerships" */
export type Ownerships_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "ownerships" */
export type OwnershipsMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "ownerships" */
export type OwnershipsMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "ownerships" */
export type OwnershipsOwnershipsArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


/** columns and relationships of "ownerships" */
export type OwnershipsOwnerships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};

/** aggregated selection of "ownerships" */
export type Ownerships_Aggregate = {
  __typename?: 'ownerships_aggregate';
  aggregate?: Maybe<Ownerships_Aggregate_Fields>;
  nodes: Array<Ownerships>;
};

export type Ownerships_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ownerships_Aggregate_Bool_Exp_Count>;
};

export type Ownerships_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ownerships_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ownerships_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ownerships" */
export type Ownerships_Aggregate_Fields = {
  __typename?: 'ownerships_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ownerships_Max_Fields>;
  min?: Maybe<Ownerships_Min_Fields>;
};


/** aggregate fields of "ownerships" */
export type Ownerships_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ownerships_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ownerships" */
export type Ownerships_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ownerships_Max_Order_By>;
  min?: InputMaybe<Ownerships_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ownerships" */
export type Ownerships_Arr_Rel_Insert_Input = {
  data: Array<Ownerships_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ownerships_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ownerships". All fields are combined with a logical 'AND'. */
export type Ownerships_Bool_Exp = {
  _and?: InputMaybe<Array<Ownerships_Bool_Exp>>;
  _memberships?: InputMaybe<Memberships_Bool_Exp>;
  _memberships_aggregate?: InputMaybe<Memberships_Aggregate_Bool_Exp>;
  _not?: InputMaybe<Ownerships_Bool_Exp>;
  _or?: InputMaybe<Array<Ownerships_Bool_Exp>>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  membership?: InputMaybe<Memberships_Bool_Exp>;
  memberships?: InputMaybe<Memberships_Bool_Exp>;
  memberships_aggregate?: InputMaybe<Memberships_Aggregate_Bool_Exp>;
  ownerships?: InputMaybe<Ownerships_Bool_Exp>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ownerships" */
export enum Ownerships_Constraint {
  /** unique or primary key constraint on columns "userId", "groupId" */
  OwnershipsPkey = 'ownerships_pkey'
}

/** input type for inserting data into table "ownerships" */
export type Ownerships_Insert_Input = {
  _memberships?: InputMaybe<Memberships_Arr_Rel_Insert_Input>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  membership?: InputMaybe<Memberships_Obj_Rel_Insert_Input>;
  memberships?: InputMaybe<Memberships_Arr_Rel_Insert_Input>;
  ownerships?: InputMaybe<Ownerships_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Ownerships_Max_Fields = {
  __typename?: 'ownerships_max_fields';
  groupId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ownerships" */
export type Ownerships_Max_Order_By = {
  groupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ownerships_Min_Fields = {
  __typename?: 'ownerships_min_fields';
  groupId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ownerships" */
export type Ownerships_Min_Order_By = {
  groupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ownerships" */
export type Ownerships_Mutation_Response = {
  __typename?: 'ownerships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ownerships>;
};

/** input type for inserting object relation for remote table "ownerships" */
export type Ownerships_Obj_Rel_Insert_Input = {
  data: Ownerships_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ownerships_On_Conflict>;
};

/** on_conflict condition type for table "ownerships" */
export type Ownerships_On_Conflict = {
  constraint: Ownerships_Constraint;
  update_columns?: Array<Ownerships_Update_Column>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};

/** Ordering options when selecting data from "ownerships". */
export type Ownerships_Order_By = {
  _memberships_aggregate?: InputMaybe<Memberships_Aggregate_Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  membership?: InputMaybe<Memberships_Order_By>;
  memberships_aggregate?: InputMaybe<Memberships_Aggregate_Order_By>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ownerships */
export type Ownerships_Pk_Columns_Input = {
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

/** select columns of table "ownerships" */
export enum Ownerships_Select_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "ownerships" */
export type Ownerships_Set_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ownerships" */
export type Ownerships_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ownerships_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ownerships_Stream_Cursor_Value_Input = {
  groupId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ownerships" */
export enum Ownerships_Update_Column {
  /** column name */
  GroupId = 'groupId',
  /** column name */
  UserId = 'userId'
}

export type Ownerships_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ownerships_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ownerships_Bool_Exp;
};

/** columns and relationships of "personalityDiagnosisResultCountsRecords" */
export type PersonalityDiagnosisResultCountsRecords = {
  __typename?: 'personalityDiagnosisResultCountsRecords';
  basicCode?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "personalityDiagnosisResultCountsRecords" */
export type PersonalityDiagnosisResultCountsRecords_Aggregate = {
  __typename?: 'personalityDiagnosisResultCountsRecords_aggregate';
  aggregate?: Maybe<PersonalityDiagnosisResultCountsRecords_Aggregate_Fields>;
  nodes: Array<PersonalityDiagnosisResultCountsRecords>;
};

/** aggregate fields of "personalityDiagnosisResultCountsRecords" */
export type PersonalityDiagnosisResultCountsRecords_Aggregate_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_aggregate_fields';
  avg?: Maybe<PersonalityDiagnosisResultCountsRecords_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PersonalityDiagnosisResultCountsRecords_Max_Fields>;
  min?: Maybe<PersonalityDiagnosisResultCountsRecords_Min_Fields>;
  stddev?: Maybe<PersonalityDiagnosisResultCountsRecords_Stddev_Fields>;
  stddev_pop?: Maybe<PersonalityDiagnosisResultCountsRecords_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PersonalityDiagnosisResultCountsRecords_Stddev_Samp_Fields>;
  sum?: Maybe<PersonalityDiagnosisResultCountsRecords_Sum_Fields>;
  var_pop?: Maybe<PersonalityDiagnosisResultCountsRecords_Var_Pop_Fields>;
  var_samp?: Maybe<PersonalityDiagnosisResultCountsRecords_Var_Samp_Fields>;
  variance?: Maybe<PersonalityDiagnosisResultCountsRecords_Variance_Fields>;
};


/** aggregate fields of "personalityDiagnosisResultCountsRecords" */
export type PersonalityDiagnosisResultCountsRecords_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PersonalityDiagnosisResultCountsRecords_Avg_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "personalityDiagnosisResultCountsRecords". All fields are combined with a logical 'AND'. */
export type PersonalityDiagnosisResultCountsRecords_Bool_Exp = {
  _and?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Bool_Exp>>;
  _not?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
  _or?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Bool_Exp>>;
  basicCode?: InputMaybe<String_Comparison_Exp>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type PersonalityDiagnosisResultCountsRecords_Max_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_max_fields';
  basicCode?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PersonalityDiagnosisResultCountsRecords_Min_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_min_fields';
  basicCode?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "personalityDiagnosisResultCountsRecords". */
export type PersonalityDiagnosisResultCountsRecords_Order_By = {
  basicCode?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** select columns of table "personalityDiagnosisResultCountsRecords" */
export enum PersonalityDiagnosisResultCountsRecords_Select_Column {
  /** column name */
  BasicCode = 'basicCode',
  /** column name */
  Count = 'count',
  /** column name */
  GroupId = 'groupId'
}

/** aggregate stddev on columns */
export type PersonalityDiagnosisResultCountsRecords_Stddev_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PersonalityDiagnosisResultCountsRecords_Stddev_Pop_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PersonalityDiagnosisResultCountsRecords_Stddev_Samp_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "personalityDiagnosisResultCountsRecords" */
export type PersonalityDiagnosisResultCountsRecords_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PersonalityDiagnosisResultCountsRecords_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PersonalityDiagnosisResultCountsRecords_Stream_Cursor_Value_Input = {
  basicCode?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PersonalityDiagnosisResultCountsRecords_Sum_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type PersonalityDiagnosisResultCountsRecords_Var_Pop_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PersonalityDiagnosisResultCountsRecords_Var_Samp_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PersonalityDiagnosisResultCountsRecords_Variance_Fields = {
  __typename?: 'personalityDiagnosisResultCountsRecords_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "personalityDiagnosisResults" */
export type PersonalityDiagnosisResults = {
  __typename?: 'personalityDiagnosisResults';
  A?: Maybe<Scalars['float8']>;
  Att?: Maybe<Scalars['float8']>;
  C?: Maybe<Scalars['float8']>;
  E?: Maybe<Scalars['float8']>;
  F?: Maybe<Scalars['float8']>;
  N?: Maybe<Scalars['float8']>;
  O?: Maybe<Scalars['float8']>;
  basicCode?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  examinationDiagnosis?: Maybe<ExaminationDiagnoses>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "personalityDiagnosisResults" */
export type PersonalityDiagnosisResults_Aggregate = {
  __typename?: 'personalityDiagnosisResults_aggregate';
  aggregate?: Maybe<PersonalityDiagnosisResults_Aggregate_Fields>;
  nodes: Array<PersonalityDiagnosisResults>;
};

/** aggregate fields of "personalityDiagnosisResults" */
export type PersonalityDiagnosisResults_Aggregate_Fields = {
  __typename?: 'personalityDiagnosisResults_aggregate_fields';
  avg?: Maybe<PersonalityDiagnosisResults_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PersonalityDiagnosisResults_Max_Fields>;
  min?: Maybe<PersonalityDiagnosisResults_Min_Fields>;
  stddev?: Maybe<PersonalityDiagnosisResults_Stddev_Fields>;
  stddev_pop?: Maybe<PersonalityDiagnosisResults_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PersonalityDiagnosisResults_Stddev_Samp_Fields>;
  sum?: Maybe<PersonalityDiagnosisResults_Sum_Fields>;
  var_pop?: Maybe<PersonalityDiagnosisResults_Var_Pop_Fields>;
  var_samp?: Maybe<PersonalityDiagnosisResults_Var_Samp_Fields>;
  variance?: Maybe<PersonalityDiagnosisResults_Variance_Fields>;
};


/** aggregate fields of "personalityDiagnosisResults" */
export type PersonalityDiagnosisResults_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PersonalityDiagnosisResults_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PersonalityDiagnosisResults_Avg_Fields = {
  __typename?: 'personalityDiagnosisResults_avg_fields';
  A?: Maybe<Scalars['Float']>;
  Att?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  E?: Maybe<Scalars['Float']>;
  F?: Maybe<Scalars['Float']>;
  N?: Maybe<Scalars['Float']>;
  O?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "personalityDiagnosisResults". All fields are combined with a logical 'AND'. */
export type PersonalityDiagnosisResults_Bool_Exp = {
  A?: InputMaybe<Float8_Comparison_Exp>;
  Att?: InputMaybe<Float8_Comparison_Exp>;
  C?: InputMaybe<Float8_Comparison_Exp>;
  E?: InputMaybe<Float8_Comparison_Exp>;
  F?: InputMaybe<Float8_Comparison_Exp>;
  N?: InputMaybe<Float8_Comparison_Exp>;
  O?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<PersonalityDiagnosisResults_Bool_Exp>>;
  _not?: InputMaybe<PersonalityDiagnosisResults_Bool_Exp>;
  _or?: InputMaybe<Array<PersonalityDiagnosisResults_Bool_Exp>>;
  basicCode?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  examinationId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "personalityDiagnosisResults" */
export type PersonalityDiagnosisResults_Insert_Input = {
  A?: InputMaybe<Scalars['float8']>;
  Att?: InputMaybe<Scalars['float8']>;
  C?: InputMaybe<Scalars['float8']>;
  E?: InputMaybe<Scalars['float8']>;
  F?: InputMaybe<Scalars['float8']>;
  N?: InputMaybe<Scalars['float8']>;
  O?: InputMaybe<Scalars['float8']>;
  basicCode?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Obj_Rel_Insert_Input>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PersonalityDiagnosisResults_Max_Fields = {
  __typename?: 'personalityDiagnosisResults_max_fields';
  A?: Maybe<Scalars['float8']>;
  Att?: Maybe<Scalars['float8']>;
  C?: Maybe<Scalars['float8']>;
  E?: Maybe<Scalars['float8']>;
  F?: Maybe<Scalars['float8']>;
  N?: Maybe<Scalars['float8']>;
  O?: Maybe<Scalars['float8']>;
  basicCode?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PersonalityDiagnosisResults_Min_Fields = {
  __typename?: 'personalityDiagnosisResults_min_fields';
  A?: Maybe<Scalars['float8']>;
  Att?: Maybe<Scalars['float8']>;
  C?: Maybe<Scalars['float8']>;
  E?: Maybe<Scalars['float8']>;
  F?: Maybe<Scalars['float8']>;
  N?: Maybe<Scalars['float8']>;
  O?: Maybe<Scalars['float8']>;
  basicCode?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
};

/** input type for inserting object relation for remote table "personalityDiagnosisResults" */
export type PersonalityDiagnosisResults_Obj_Rel_Insert_Input = {
  data: PersonalityDiagnosisResults_Insert_Input;
};

/** Ordering options when selecting data from "personalityDiagnosisResults". */
export type PersonalityDiagnosisResults_Order_By = {
  A?: InputMaybe<Order_By>;
  Att?: InputMaybe<Order_By>;
  C?: InputMaybe<Order_By>;
  E?: InputMaybe<Order_By>;
  F?: InputMaybe<Order_By>;
  N?: InputMaybe<Order_By>;
  O?: InputMaybe<Order_By>;
  basicCode?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
};

/** select columns of table "personalityDiagnosisResults" */
export enum PersonalityDiagnosisResults_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  Att = 'Att',
  /** column name */
  C = 'C',
  /** column name */
  E = 'E',
  /** column name */
  F = 'F',
  /** column name */
  N = 'N',
  /** column name */
  O = 'O',
  /** column name */
  BasicCode = 'basicCode',
  /** column name */
  Code = 'code',
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId'
}

/** aggregate stddev on columns */
export type PersonalityDiagnosisResults_Stddev_Fields = {
  __typename?: 'personalityDiagnosisResults_stddev_fields';
  A?: Maybe<Scalars['Float']>;
  Att?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  E?: Maybe<Scalars['Float']>;
  F?: Maybe<Scalars['Float']>;
  N?: Maybe<Scalars['Float']>;
  O?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PersonalityDiagnosisResults_Stddev_Pop_Fields = {
  __typename?: 'personalityDiagnosisResults_stddev_pop_fields';
  A?: Maybe<Scalars['Float']>;
  Att?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  E?: Maybe<Scalars['Float']>;
  F?: Maybe<Scalars['Float']>;
  N?: Maybe<Scalars['Float']>;
  O?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PersonalityDiagnosisResults_Stddev_Samp_Fields = {
  __typename?: 'personalityDiagnosisResults_stddev_samp_fields';
  A?: Maybe<Scalars['Float']>;
  Att?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  E?: Maybe<Scalars['Float']>;
  F?: Maybe<Scalars['Float']>;
  N?: Maybe<Scalars['Float']>;
  O?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "personalityDiagnosisResults" */
export type PersonalityDiagnosisResults_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PersonalityDiagnosisResults_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PersonalityDiagnosisResults_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['float8']>;
  Att?: InputMaybe<Scalars['float8']>;
  C?: InputMaybe<Scalars['float8']>;
  E?: InputMaybe<Scalars['float8']>;
  F?: InputMaybe<Scalars['float8']>;
  N?: InputMaybe<Scalars['float8']>;
  O?: InputMaybe<Scalars['float8']>;
  basicCode?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PersonalityDiagnosisResults_Sum_Fields = {
  __typename?: 'personalityDiagnosisResults_sum_fields';
  A?: Maybe<Scalars['float8']>;
  Att?: Maybe<Scalars['float8']>;
  C?: Maybe<Scalars['float8']>;
  E?: Maybe<Scalars['float8']>;
  F?: Maybe<Scalars['float8']>;
  N?: Maybe<Scalars['float8']>;
  O?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type PersonalityDiagnosisResults_Var_Pop_Fields = {
  __typename?: 'personalityDiagnosisResults_var_pop_fields';
  A?: Maybe<Scalars['Float']>;
  Att?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  E?: Maybe<Scalars['Float']>;
  F?: Maybe<Scalars['Float']>;
  N?: Maybe<Scalars['Float']>;
  O?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PersonalityDiagnosisResults_Var_Samp_Fields = {
  __typename?: 'personalityDiagnosisResults_var_samp_fields';
  A?: Maybe<Scalars['Float']>;
  Att?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  E?: Maybe<Scalars['Float']>;
  F?: Maybe<Scalars['Float']>;
  N?: Maybe<Scalars['Float']>;
  O?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PersonalityDiagnosisResults_Variance_Fields = {
  __typename?: 'personalityDiagnosisResults_variance_fields';
  A?: Maybe<Scalars['Float']>;
  Att?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  E?: Maybe<Scalars['Float']>;
  F?: Maybe<Scalars['Float']>;
  N?: Maybe<Scalars['Float']>;
  O?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** An array relationship */
  diagnoses: Array<Diagnoses>;
  /** An aggregate relationship */
  diagnoses_aggregate: Diagnoses_Aggregate;
  /** fetch data from the table: "diagnoses" using primary key columns */
  diagnoses_by_pk?: Maybe<Diagnoses>;
  /** fetch data from the table: "diagnosisTypes" */
  diagnosisTypes: Array<DiagnosisTypes>;
  /** fetch aggregated fields from the table: "diagnosisTypes" */
  diagnosisTypes_aggregate: DiagnosisTypes_Aggregate;
  /** fetch data from the table: "diagnosisTypes" using primary key columns */
  diagnosisTypes_by_pk?: Maybe<DiagnosisTypes>;
  /** An array relationship */
  eventAreaAssignments: Array<EventAreaAssignments>;
  /** An aggregate relationship */
  eventAreaAssignments_aggregate: EventAreaAssignments_Aggregate;
  /** fetch data from the table: "eventAreaAssignments" using primary key columns */
  eventAreaAssignments_by_pk?: Maybe<EventAreaAssignments>;
  /** An array relationship */
  eventAreas: Array<EventAreas>;
  /** An aggregate relationship */
  eventAreas_aggregate: EventAreas_Aggregate;
  /** fetch data from the table: "eventAreas" using primary key columns */
  eventAreas_by_pk?: Maybe<EventAreas>;
  /** An array relationship */
  eventBeginnings: Array<EventBeginnings>;
  /** An aggregate relationship */
  eventBeginnings_aggregate: EventBeginnings_Aggregate;
  /** fetch data from the table: "eventBeginnings" using primary key columns */
  eventBeginnings_by_pk?: Maybe<EventBeginnings>;
  /** An array relationship */
  eventDiagnoses: Array<EventDiagnoses>;
  /** An aggregate relationship */
  eventDiagnoses_aggregate: EventDiagnoses_Aggregate;
  /** fetch data from the table: "eventDiagnoses" using primary key columns */
  eventDiagnoses_by_pk?: Maybe<EventDiagnoses>;
  /** fetch data from the table: "eventExaminationCounts" */
  eventExaminationCounts: Array<EventExaminationCounts>;
  /** fetch aggregated fields from the table: "eventExaminationCounts" */
  eventExaminationCounts_aggregate: EventExaminationCounts_Aggregate;
  /** An array relationship */
  eventExpirations: Array<EventExpirations>;
  /** An aggregate relationship */
  eventExpirations_aggregate: EventExpirations_Aggregate;
  /** fetch data from the table: "eventExpirations" using primary key columns */
  eventExpirations_by_pk?: Maybe<EventExpirations>;
  /** An array relationship */
  eventLimitTimes: Array<EventLimitTimes>;
  /** An aggregate relationship */
  eventLimitTimes_aggregate: EventLimitTimes_Aggregate;
  /** fetch data from the table: "eventLimitTimes" using primary key columns */
  eventLimitTimes_by_pk?: Maybe<EventLimitTimes>;
  /** An array relationship */
  eventTagAssignments: Array<EventTagAssignments>;
  /** An aggregate relationship */
  eventTagAssignments_aggregate: EventTagAssignments_Aggregate;
  /** fetch data from the table: "eventTagAssignments" using primary key columns */
  eventTagAssignments_by_pk?: Maybe<EventTagAssignments>;
  /** An array relationship */
  eventTags: Array<EventTags>;
  /** An aggregate relationship */
  eventTags_aggregate: EventTags_Aggregate;
  /** fetch data from the table: "eventTags" using primary key columns */
  eventTags_by_pk?: Maybe<EventTags>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** An array relationship */
  examinationDiagnoses: Array<ExaminationDiagnoses>;
  /** An aggregate relationship */
  examinationDiagnoses_aggregate: ExaminationDiagnoses_Aggregate;
  /** fetch data from the table: "examinationDiagnoses" using primary key columns */
  examinationDiagnoses_by_pk?: Maybe<ExaminationDiagnoses>;
  /** An array relationship */
  examinationDiagnosisAnswers: Array<ExaminationDiagnosisAnswers>;
  /** An aggregate relationship */
  examinationDiagnosisAnswers_aggregate: ExaminationDiagnosisAnswers_Aggregate;
  /** fetch data from the table: "examinationDiagnosisAnswers" using primary key columns */
  examinationDiagnosisAnswers_by_pk?: Maybe<ExaminationDiagnosisAnswers>;
  /** An array relationship */
  examinationDiagnosisScores: Array<ExaminationDiagnosisScores>;
  /** An aggregate relationship */
  examinationDiagnosisScores_aggregate: ExaminationDiagnosisScores_Aggregate;
  /** An array relationship */
  examinations: Array<Examinations>;
  /** An aggregate relationship */
  examinations_aggregate: Examinations_Aggregate;
  /** fetch data from the table: "examinations" using primary key columns */
  examinations_by_pk?: Maybe<Examinations>;
  /** fetch data from the table: "genders" */
  genders: Array<Genders>;
  /** fetch aggregated fields from the table: "genders" */
  genders_aggregate: Genders_Aggregate;
  /** fetch data from the table: "genders" using primary key columns */
  genders_by_pk?: Maybe<Genders>;
  /** fetch data from the table: "groupContents" */
  groupContents: Array<GroupContents>;
  /** fetch aggregated fields from the table: "groupContents" */
  groupContents_aggregate: GroupContents_Aggregate;
  /** fetch data from the table: "groupContents" using primary key columns */
  groupContents_by_pk?: Maybe<GroupContents>;
  /** An array relationship */
  groupInvitations: Array<GroupInvitations>;
  /** An aggregate relationship */
  groupInvitations_aggregate: GroupInvitations_Aggregate;
  /** fetch data from the table: "groupInvitations" using primary key columns */
  groupInvitations_by_pk?: Maybe<GroupInvitations>;
  /** fetch data from the table: "groups" */
  groups: Array<Groups>;
  /** fetch aggregated fields from the table: "groups" */
  groups_aggregate: Groups_Aggregate;
  /** fetch data from the table: "groups" using primary key columns */
  groups_by_pk?: Maybe<Groups>;
  /** fetch data from the table: "guestExamineeExaminations" */
  guestExamineeExaminations: Array<GuestExamineeExaminations>;
  /** fetch aggregated fields from the table: "guestExamineeExaminations" */
  guestExamineeExaminations_aggregate: GuestExamineeExaminations_Aggregate;
  /** fetch data from the table: "guestExamineeExaminations" using primary key columns */
  guestExamineeExaminations_by_pk?: Maybe<GuestExamineeExaminations>;
  /** An array relationship */
  guestExaminees: Array<GuestExaminees>;
  /** An aggregate relationship */
  guestExaminees_aggregate: GuestExaminees_Aggregate;
  /** fetch data from the table: "guestExaminees" using primary key columns */
  guestExaminees_by_pk?: Maybe<GuestExaminees>;
  /** fetch data from the table: "inactiveGroupEvents" */
  inactiveGroupEvents: Array<InactiveGroupEvents>;
  /** fetch aggregated fields from the table: "inactiveGroupEvents" */
  inactiveGroupEvents_aggregate: InactiveGroupEvents_Aggregate;
  /** fetch data from the table: "inactiveGroupEvents" using primary key columns */
  inactiveGroupEvents_by_pk?: Maybe<InactiveGroupEvents>;
  /** fetch data from the table: "inactiveGroups" */
  inactiveGroups: Array<InactiveGroups>;
  /** fetch aggregated fields from the table: "inactiveGroups" */
  inactiveGroups_aggregate: InactiveGroups_Aggregate;
  /** fetch data from the table: "inactiveGroups" using primary key columns */
  inactiveGroups_by_pk?: Maybe<InactiveGroups>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk?: Maybe<Languages>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: Memberships_Aggregate;
  /** fetch data from the table: "memberships" using primary key columns */
  memberships_by_pk?: Maybe<Memberships>;
  /** fetch data from the table: "monthlyExaminationCounts" */
  monthlyExaminationCounts: Array<MonthlyExaminationCounts>;
  /** fetch aggregated fields from the table: "monthlyExaminationCounts" */
  monthlyExaminationCounts_aggregate: MonthlyExaminationCounts_Aggregate;
  /** An array relationship */
  ownerships: Array<Ownerships>;
  /** An aggregate relationship */
  ownerships_aggregate: Ownerships_Aggregate;
  /** fetch data from the table: "ownerships" using primary key columns */
  ownerships_by_pk?: Maybe<Ownerships>;
  /** execute function "personalityDiagnosisResultCounts" which returns "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCounts: Array<PersonalityDiagnosisResultCountsRecords>;
  /** fetch data from the table: "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCountsRecords: Array<PersonalityDiagnosisResultCountsRecords>;
  /** fetch aggregated fields from the table: "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCountsRecords_aggregate: PersonalityDiagnosisResultCountsRecords_Aggregate;
  /** execute function "personalityDiagnosisResultCounts" and query aggregates on result of table type "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCounts_aggregate: PersonalityDiagnosisResultCountsRecords_Aggregate;
  /** fetch data from the table: "personalityDiagnosisResults" */
  personalityDiagnosisResults: Array<PersonalityDiagnosisResults>;
  /** fetch aggregated fields from the table: "personalityDiagnosisResults" */
  personalityDiagnosisResults_aggregate: PersonalityDiagnosisResults_Aggregate;
  /** An array relationship */
  questionChoices: Array<QuestionChoices>;
  /** An aggregate relationship */
  questionChoices_aggregate: QuestionChoices_Aggregate;
  /** fetch data from the table: "questionChoices" using primary key columns */
  questionChoices_by_pk?: Maybe<QuestionChoices>;
  /** An array relationship */
  questionScores: Array<QuestionScores>;
  /** An aggregate relationship */
  questionScores_aggregate: QuestionScores_Aggregate;
  /** fetch data from the table: "questionScores" using primary key columns */
  questionScores_by_pk?: Maybe<QuestionScores>;
  /** An array relationship */
  questions: Array<Questions>;
  /** An aggregate relationship */
  questions_aggregate: Questions_Aggregate;
  /** fetch data from the table: "questions" using primary key columns */
  questions_by_pk?: Maybe<Questions>;
  /** fetch data from the table: "resilienceDiagnosisResults" */
  resilienceDiagnosisResults: Array<ResilienceDiagnosisResults>;
  /** fetch aggregated fields from the table: "resilienceDiagnosisResults" */
  resilienceDiagnosisResults_aggregate: ResilienceDiagnosisResults_Aggregate;
  /** An array relationship */
  scoreTypes: Array<ScoreTypes>;
  /** An aggregate relationship */
  scoreTypes_aggregate: ScoreTypes_Aggregate;
  /** fetch data from the table: "scoreTypes" using primary key columns */
  scoreTypes_by_pk?: Maybe<ScoreTypes>;
  /** fetch data from the table: "staffInvitations" */
  staffInvitations: Array<StaffInvitations>;
  /** fetch aggregated fields from the table: "staffInvitations" */
  staffInvitations_aggregate: StaffInvitations_Aggregate;
  /** fetch data from the table: "staffInvitations" using primary key columns */
  staffInvitations_by_pk?: Maybe<StaffInvitations>;
  /** fetch data from the table: "staffs" */
  staffs: Array<Staffs>;
  /** fetch aggregated fields from the table: "staffs" */
  staffs_aggregate: Staffs_Aggregate;
  /** fetch data from the table: "staffs" using primary key columns */
  staffs_by_pk?: Maybe<Staffs>;
  /** fetch data from the table: "stressDiagnosisResults" */
  stressDiagnosisResults: Array<StressDiagnosisResults>;
  /** fetch aggregated fields from the table: "stressDiagnosisResults" */
  stressDiagnosisResults_aggregate: StressDiagnosisResults_Aggregate;
  /** An array relationship */
  translatedGenders: Array<TranslatedGenders>;
  /** An aggregate relationship */
  translatedGenders_aggregate: TranslatedGenders_Aggregate;
  /** fetch data from the table: "translatedGenders" using primary key columns */
  translatedGenders_by_pk?: Maybe<TranslatedGenders>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<Diagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnoses_Order_By>>;
  where?: InputMaybe<Diagnoses_Bool_Exp>;
};


export type Query_RootDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Diagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnoses_Order_By>>;
  where?: InputMaybe<Diagnoses_Bool_Exp>;
};


export type Query_RootDiagnoses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDiagnosisTypesArgs = {
  distinct_on?: InputMaybe<Array<DiagnosisTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DiagnosisTypes_Order_By>>;
  where?: InputMaybe<DiagnosisTypes_Bool_Exp>;
};


export type Query_RootDiagnosisTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DiagnosisTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DiagnosisTypes_Order_By>>;
  where?: InputMaybe<DiagnosisTypes_Bool_Exp>;
};


export type Query_RootDiagnosisTypes_By_PkArgs = {
  code: Scalars['String'];
};


export type Query_RootEventAreaAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


export type Query_RootEventAreaAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


export type Query_RootEventAreaAssignments_By_PkArgs = {
  eventAreaId: Scalars['uuid'];
  eventId: Scalars['uuid'];
};


export type Query_RootEventAreasArgs = {
  distinct_on?: InputMaybe<Array<EventAreas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreas_Order_By>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


export type Query_RootEventAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreas_Order_By>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


export type Query_RootEventAreas_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventBeginningsArgs = {
  distinct_on?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventBeginnings_Order_By>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


export type Query_RootEventBeginnings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventBeginnings_Order_By>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


export type Query_RootEventBeginnings_By_PkArgs = {
  eventId: Scalars['uuid'];
};


export type Query_RootEventDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


export type Query_RootEventDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


export type Query_RootEventDiagnoses_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  eventId: Scalars['uuid'];
};


export type Query_RootEventExaminationCountsArgs = {
  distinct_on?: InputMaybe<Array<EventExaminationCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExaminationCounts_Order_By>>;
  where?: InputMaybe<EventExaminationCounts_Bool_Exp>;
};


export type Query_RootEventExaminationCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventExaminationCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExaminationCounts_Order_By>>;
  where?: InputMaybe<EventExaminationCounts_Bool_Exp>;
};


export type Query_RootEventExpirationsArgs = {
  distinct_on?: InputMaybe<Array<EventExpirations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExpirations_Order_By>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


export type Query_RootEventExpirations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventExpirations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExpirations_Order_By>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


export type Query_RootEventExpirations_By_PkArgs = {
  eventId: Scalars['uuid'];
};


export type Query_RootEventLimitTimesArgs = {
  distinct_on?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventLimitTimes_Order_By>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


export type Query_RootEventLimitTimes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventLimitTimes_Order_By>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


export type Query_RootEventLimitTimes_By_PkArgs = {
  eventId: Scalars['uuid'];
};


export type Query_RootEventTagAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


export type Query_RootEventTagAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


export type Query_RootEventTagAssignments_By_PkArgs = {
  eventId: Scalars['uuid'];
  eventTagId: Scalars['uuid'];
};


export type Query_RootEventTagsArgs = {
  distinct_on?: InputMaybe<Array<EventTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTags_Order_By>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


export type Query_RootEventTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTags_Order_By>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


export type Query_RootEventTags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootExaminationDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


export type Query_RootExaminationDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


export type Query_RootExaminationDiagnoses_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
};


export type Query_RootExaminationDiagnosisAnswersArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


export type Query_RootExaminationDiagnosisAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


export type Query_RootExaminationDiagnosisAnswers_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
  questionId: Scalars['uuid'];
};


export type Query_RootExaminationDiagnosisScoresArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisScores_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
};


export type Query_RootExaminationDiagnosisScores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisScores_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
};


export type Query_RootExaminationsArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


export type Query_RootExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


export type Query_RootExaminations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGendersArgs = {
  distinct_on?: InputMaybe<Array<Genders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Genders_Order_By>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Query_RootGenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Genders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Genders_Order_By>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Query_RootGenders_By_PkArgs = {
  code: Scalars['String'];
};


export type Query_RootGroupContentsArgs = {
  distinct_on?: InputMaybe<Array<GroupContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupContents_Order_By>>;
  where?: InputMaybe<GroupContents_Bool_Exp>;
};


export type Query_RootGroupContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupContents_Order_By>>;
  where?: InputMaybe<GroupContents_Bool_Exp>;
};


export type Query_RootGroupContents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupInvitationsArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


export type Query_RootGroupInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


export type Query_RootGroupInvitations_By_PkArgs = {
  email: Scalars['String'];
  groupId: Scalars['uuid'];
};


export type Query_RootGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Query_RootGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Query_RootGroups_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGuestExamineeExaminationsArgs = {
  distinct_on?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExamineeExaminations_Order_By>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


export type Query_RootGuestExamineeExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExamineeExaminations_Order_By>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


export type Query_RootGuestExamineeExaminations_By_PkArgs = {
  guestExamineeId: Scalars['uuid'];
};


export type Query_RootGuestExamineesArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


export type Query_RootGuestExaminees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


export type Query_RootGuestExaminees_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootInactiveGroupEventsArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroupEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroupEvents_Order_By>>;
  where?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
};


export type Query_RootInactiveGroupEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroupEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroupEvents_Order_By>>;
  where?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
};


export type Query_RootInactiveGroupEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootInactiveGroupsArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroups_Order_By>>;
  where?: InputMaybe<InactiveGroups_Bool_Exp>;
};


export type Query_RootInactiveGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroups_Order_By>>;
  where?: InputMaybe<InactiveGroups_Bool_Exp>;
};


export type Query_RootInactiveGroups_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLanguagesArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_By_PkArgs = {
  code: Scalars['String'];
};


export type Query_RootMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


export type Query_RootMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


export type Query_RootMemberships_By_PkArgs = {
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
};


export type Query_RootMonthlyExaminationCountsArgs = {
  distinct_on?: InputMaybe<Array<MonthlyExaminationCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonthlyExaminationCounts_Order_By>>;
  where?: InputMaybe<MonthlyExaminationCounts_Bool_Exp>;
};


export type Query_RootMonthlyExaminationCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonthlyExaminationCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonthlyExaminationCounts_Order_By>>;
  where?: InputMaybe<MonthlyExaminationCounts_Bool_Exp>;
};


export type Query_RootOwnershipsArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


export type Query_RootOwnerships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


export type Query_RootOwnerships_By_PkArgs = {
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
};


export type Query_RootPersonalityDiagnosisResultCountsArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Query_RootPersonalityDiagnosisResultCountsRecordsArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Query_RootPersonalityDiagnosisResultCountsRecords_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Query_RootPersonalityDiagnosisResultCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Query_RootPersonalityDiagnosisResultsArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResults_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResults_Bool_Exp>;
};


export type Query_RootPersonalityDiagnosisResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResults_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResults_Bool_Exp>;
};


export type Query_RootQuestionChoicesArgs = {
  distinct_on?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionChoices_Order_By>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};


export type Query_RootQuestionChoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionChoices_Order_By>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};


export type Query_RootQuestionChoices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootQuestionScoresArgs = {
  distinct_on?: InputMaybe<Array<QuestionScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionScores_Order_By>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};


export type Query_RootQuestionScores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<QuestionScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionScores_Order_By>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};


export type Query_RootQuestionScores_By_PkArgs = {
  questionChoiceId: Scalars['uuid'];
  scoreTypeCode: Scalars['String'];
};


export type Query_RootQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Query_RootQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Query_RootQuestions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootResilienceDiagnosisResultsArgs = {
  distinct_on?: InputMaybe<Array<ResilienceDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResilienceDiagnosisResults_Order_By>>;
  where?: InputMaybe<ResilienceDiagnosisResults_Bool_Exp>;
};


export type Query_RootResilienceDiagnosisResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ResilienceDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResilienceDiagnosisResults_Order_By>>;
  where?: InputMaybe<ResilienceDiagnosisResults_Bool_Exp>;
};


export type Query_RootScoreTypesArgs = {
  distinct_on?: InputMaybe<Array<ScoreTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScoreTypes_Order_By>>;
  where?: InputMaybe<ScoreTypes_Bool_Exp>;
};


export type Query_RootScoreTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ScoreTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScoreTypes_Order_By>>;
  where?: InputMaybe<ScoreTypes_Bool_Exp>;
};


export type Query_RootScoreTypes_By_PkArgs = {
  code: Scalars['String'];
  diagnosisId: Scalars['uuid'];
};


export type Query_RootStaffInvitationsArgs = {
  distinct_on?: InputMaybe<Array<StaffInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaffInvitations_Order_By>>;
  where?: InputMaybe<StaffInvitations_Bool_Exp>;
};


export type Query_RootStaffInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StaffInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaffInvitations_Order_By>>;
  where?: InputMaybe<StaffInvitations_Bool_Exp>;
};


export type Query_RootStaffInvitations_By_PkArgs = {
  email: Scalars['String'];
};


export type Query_RootStaffsArgs = {
  distinct_on?: InputMaybe<Array<Staffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Staffs_Order_By>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};


export type Query_RootStaffs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Staffs_Order_By>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};


export type Query_RootStaffs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootStressDiagnosisResultsArgs = {
  distinct_on?: InputMaybe<Array<StressDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StressDiagnosisResults_Order_By>>;
  where?: InputMaybe<StressDiagnosisResults_Bool_Exp>;
};


export type Query_RootStressDiagnosisResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StressDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StressDiagnosisResults_Order_By>>;
  where?: InputMaybe<StressDiagnosisResults_Bool_Exp>;
};


export type Query_RootTranslatedGendersArgs = {
  distinct_on?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TranslatedGenders_Order_By>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};


export type Query_RootTranslatedGenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TranslatedGenders_Order_By>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};


export type Query_RootTranslatedGenders_By_PkArgs = {
  genderCode: Genders_Enum;
  languageCode: Languages_Enum;
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "questionChoices" */
export type QuestionChoices = {
  __typename?: 'questionChoices';
  /** An array relationship */
  examinationDiagnosisAnswers: Array<ExaminationDiagnosisAnswers>;
  /** An aggregate relationship */
  examinationDiagnosisAnswers_aggregate: ExaminationDiagnosisAnswers_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  question?: Maybe<Questions>;
  questionId: Scalars['uuid'];
  /** An array relationship */
  questionScores: Array<QuestionScores>;
  /** An aggregate relationship */
  questionScores_aggregate: QuestionScores_Aggregate;
  text: Scalars['String'];
};


/** columns and relationships of "questionChoices" */
export type QuestionChoicesExaminationDiagnosisAnswersArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


/** columns and relationships of "questionChoices" */
export type QuestionChoicesExaminationDiagnosisAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


/** columns and relationships of "questionChoices" */
export type QuestionChoicesQuestionScoresArgs = {
  distinct_on?: InputMaybe<Array<QuestionScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionScores_Order_By>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};


/** columns and relationships of "questionChoices" */
export type QuestionChoicesQuestionScores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<QuestionScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionScores_Order_By>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};

/** aggregated selection of "questionChoices" */
export type QuestionChoices_Aggregate = {
  __typename?: 'questionChoices_aggregate';
  aggregate?: Maybe<QuestionChoices_Aggregate_Fields>;
  nodes: Array<QuestionChoices>;
};

export type QuestionChoices_Aggregate_Bool_Exp = {
  count?: InputMaybe<QuestionChoices_Aggregate_Bool_Exp_Count>;
};

export type QuestionChoices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionChoices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questionChoices" */
export type QuestionChoices_Aggregate_Fields = {
  __typename?: 'questionChoices_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<QuestionChoices_Max_Fields>;
  min?: Maybe<QuestionChoices_Min_Fields>;
};


/** aggregate fields of "questionChoices" */
export type QuestionChoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "questionChoices" */
export type QuestionChoices_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<QuestionChoices_Max_Order_By>;
  min?: InputMaybe<QuestionChoices_Min_Order_By>;
};

/** input type for inserting array relation for remote table "questionChoices" */
export type QuestionChoices_Arr_Rel_Insert_Input = {
  data: Array<QuestionChoices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<QuestionChoices_On_Conflict>;
};

/** Boolean expression to filter rows from the table "questionChoices". All fields are combined with a logical 'AND'. */
export type QuestionChoices_Bool_Exp = {
  _and?: InputMaybe<Array<QuestionChoices_Bool_Exp>>;
  _not?: InputMaybe<QuestionChoices_Bool_Exp>;
  _or?: InputMaybe<Array<QuestionChoices_Bool_Exp>>;
  examinationDiagnosisAnswers?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
  examinationDiagnosisAnswers_aggregate?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<Questions_Bool_Exp>;
  questionId?: InputMaybe<Uuid_Comparison_Exp>;
  questionScores?: InputMaybe<QuestionScores_Bool_Exp>;
  questionScores_aggregate?: InputMaybe<QuestionScores_Aggregate_Bool_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionChoices" */
export enum QuestionChoices_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionChoicesPkey = 'questionChoices_pkey'
}

/** input type for inserting data into table "questionChoices" */
export type QuestionChoices_Insert_Input = {
  examinationDiagnosisAnswers?: InputMaybe<ExaminationDiagnosisAnswers_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Questions_Obj_Rel_Insert_Input>;
  questionId?: InputMaybe<Scalars['uuid']>;
  questionScores?: InputMaybe<QuestionScores_Arr_Rel_Insert_Input>;
  text?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type QuestionChoices_Max_Fields = {
  __typename?: 'questionChoices_max_fields';
  id?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "questionChoices" */
export type QuestionChoices_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type QuestionChoices_Min_Fields = {
  __typename?: 'questionChoices_min_fields';
  id?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "questionChoices" */
export type QuestionChoices_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionChoices" */
export type QuestionChoices_Mutation_Response = {
  __typename?: 'questionChoices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QuestionChoices>;
};

/** input type for inserting object relation for remote table "questionChoices" */
export type QuestionChoices_Obj_Rel_Insert_Input = {
  data: QuestionChoices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<QuestionChoices_On_Conflict>;
};

/** on_conflict condition type for table "questionChoices" */
export type QuestionChoices_On_Conflict = {
  constraint: QuestionChoices_Constraint;
  update_columns?: Array<QuestionChoices_Update_Column>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};

/** Ordering options when selecting data from "questionChoices". */
export type QuestionChoices_Order_By = {
  examinationDiagnosisAnswers_aggregate?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Questions_Order_By>;
  questionId?: InputMaybe<Order_By>;
  questionScores_aggregate?: InputMaybe<QuestionScores_Aggregate_Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionChoices */
export type QuestionChoices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "questionChoices" */
export enum QuestionChoices_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "questionChoices" */
export type QuestionChoices_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  questionId?: InputMaybe<Scalars['uuid']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "questionChoices" */
export type QuestionChoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: QuestionChoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type QuestionChoices_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  questionId?: InputMaybe<Scalars['uuid']>;
  text?: InputMaybe<Scalars['String']>;
};

/** update columns of table "questionChoices" */
export enum QuestionChoices_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  Text = 'text'
}

export type QuestionChoices_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuestionChoices_Set_Input>;
  /** filter the rows which have to be updated */
  where: QuestionChoices_Bool_Exp;
};

/** columns and relationships of "questionScores" */
export type QuestionScores = {
  __typename?: 'questionScores';
  diagnosisId: Scalars['uuid'];
  /** An object relationship */
  questionChoice?: Maybe<QuestionChoices>;
  questionChoiceId: Scalars['uuid'];
  /** An object relationship */
  scoreType?: Maybe<ScoreTypes>;
  scoreTypeCode: Scalars['String'];
  value: Scalars['float8'];
};

/** aggregated selection of "questionScores" */
export type QuestionScores_Aggregate = {
  __typename?: 'questionScores_aggregate';
  aggregate?: Maybe<QuestionScores_Aggregate_Fields>;
  nodes: Array<QuestionScores>;
};

export type QuestionScores_Aggregate_Bool_Exp = {
  avg?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<QuestionScores_Aggregate_Bool_Exp_Var_Samp>;
};

export type QuestionScores_Aggregate_Bool_Exp_Avg = {
  arguments: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type QuestionScores_Aggregate_Bool_Exp_Corr = {
  arguments: QuestionScores_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type QuestionScores_Aggregate_Bool_Exp_Corr_Arguments = {
  X: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type QuestionScores_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<QuestionScores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type QuestionScores_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: QuestionScores_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type QuestionScores_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type QuestionScores_Aggregate_Bool_Exp_Max = {
  arguments: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type QuestionScores_Aggregate_Bool_Exp_Min = {
  arguments: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type QuestionScores_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type QuestionScores_Aggregate_Bool_Exp_Sum = {
  arguments: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type QuestionScores_Aggregate_Bool_Exp_Var_Samp = {
  arguments: QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuestionScores_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "questionScores" */
export type QuestionScores_Aggregate_Fields = {
  __typename?: 'questionScores_aggregate_fields';
  avg?: Maybe<QuestionScores_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<QuestionScores_Max_Fields>;
  min?: Maybe<QuestionScores_Min_Fields>;
  stddev?: Maybe<QuestionScores_Stddev_Fields>;
  stddev_pop?: Maybe<QuestionScores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<QuestionScores_Stddev_Samp_Fields>;
  sum?: Maybe<QuestionScores_Sum_Fields>;
  var_pop?: Maybe<QuestionScores_Var_Pop_Fields>;
  var_samp?: Maybe<QuestionScores_Var_Samp_Fields>;
  variance?: Maybe<QuestionScores_Variance_Fields>;
};


/** aggregate fields of "questionScores" */
export type QuestionScores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<QuestionScores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "questionScores" */
export type QuestionScores_Aggregate_Order_By = {
  avg?: InputMaybe<QuestionScores_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<QuestionScores_Max_Order_By>;
  min?: InputMaybe<QuestionScores_Min_Order_By>;
  stddev?: InputMaybe<QuestionScores_Stddev_Order_By>;
  stddev_pop?: InputMaybe<QuestionScores_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<QuestionScores_Stddev_Samp_Order_By>;
  sum?: InputMaybe<QuestionScores_Sum_Order_By>;
  var_pop?: InputMaybe<QuestionScores_Var_Pop_Order_By>;
  var_samp?: InputMaybe<QuestionScores_Var_Samp_Order_By>;
  variance?: InputMaybe<QuestionScores_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionScores" */
export type QuestionScores_Arr_Rel_Insert_Input = {
  data: Array<QuestionScores_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<QuestionScores_On_Conflict>;
};

/** aggregate avg on columns */
export type QuestionScores_Avg_Fields = {
  __typename?: 'questionScores_avg_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "questionScores" */
export type QuestionScores_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionScores". All fields are combined with a logical 'AND'. */
export type QuestionScores_Bool_Exp = {
  _and?: InputMaybe<Array<QuestionScores_Bool_Exp>>;
  _not?: InputMaybe<QuestionScores_Bool_Exp>;
  _or?: InputMaybe<Array<QuestionScores_Bool_Exp>>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  questionChoice?: InputMaybe<QuestionChoices_Bool_Exp>;
  questionChoiceId?: InputMaybe<Uuid_Comparison_Exp>;
  scoreType?: InputMaybe<ScoreTypes_Bool_Exp>;
  scoreTypeCode?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionScores" */
export enum QuestionScores_Constraint {
  /** unique or primary key constraint on columns "scoreTypeCode", "questionChoiceId" */
  QuestionScoresPkey = 'questionScores_pkey'
}

/** input type for incrementing numeric columns in table "questionScores" */
export type QuestionScores_Inc_Input = {
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "questionScores" */
export type QuestionScores_Insert_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  questionChoice?: InputMaybe<QuestionChoices_Obj_Rel_Insert_Input>;
  questionChoiceId?: InputMaybe<Scalars['uuid']>;
  scoreType?: InputMaybe<ScoreTypes_Obj_Rel_Insert_Input>;
  scoreTypeCode?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type QuestionScores_Max_Fields = {
  __typename?: 'questionScores_max_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  questionChoiceId?: Maybe<Scalars['uuid']>;
  scoreTypeCode?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "questionScores" */
export type QuestionScores_Max_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  questionChoiceId?: InputMaybe<Order_By>;
  scoreTypeCode?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type QuestionScores_Min_Fields = {
  __typename?: 'questionScores_min_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  questionChoiceId?: Maybe<Scalars['uuid']>;
  scoreTypeCode?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "questionScores" */
export type QuestionScores_Min_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  questionChoiceId?: InputMaybe<Order_By>;
  scoreTypeCode?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionScores" */
export type QuestionScores_Mutation_Response = {
  __typename?: 'questionScores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QuestionScores>;
};

/** on_conflict condition type for table "questionScores" */
export type QuestionScores_On_Conflict = {
  constraint: QuestionScores_Constraint;
  update_columns?: Array<QuestionScores_Update_Column>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};

/** Ordering options when selecting data from "questionScores". */
export type QuestionScores_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  questionChoice?: InputMaybe<QuestionChoices_Order_By>;
  questionChoiceId?: InputMaybe<Order_By>;
  scoreType?: InputMaybe<ScoreTypes_Order_By>;
  scoreTypeCode?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionScores */
export type QuestionScores_Pk_Columns_Input = {
  questionChoiceId: Scalars['uuid'];
  scoreTypeCode: Scalars['String'];
};

/** select columns of table "questionScores" */
export enum QuestionScores_Select_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  QuestionChoiceId = 'questionChoiceId',
  /** column name */
  ScoreTypeCode = 'scoreTypeCode',
  /** column name */
  Value = 'value'
}

/** select "questionScores_aggregate_bool_exp_avg_arguments_columns" columns of table "questionScores" */
export enum QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "questionScores_aggregate_bool_exp_corr_arguments_columns" columns of table "questionScores" */
export enum QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "questionScores_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "questionScores" */
export enum QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "questionScores_aggregate_bool_exp_max_arguments_columns" columns of table "questionScores" */
export enum QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "questionScores_aggregate_bool_exp_min_arguments_columns" columns of table "questionScores" */
export enum QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "questionScores_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "questionScores" */
export enum QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "questionScores_aggregate_bool_exp_sum_arguments_columns" columns of table "questionScores" */
export enum QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "questionScores_aggregate_bool_exp_var_samp_arguments_columns" columns of table "questionScores" */
export enum QuestionScores_Select_Column_QuestionScores_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "questionScores" */
export type QuestionScores_Set_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  questionChoiceId?: InputMaybe<Scalars['uuid']>;
  scoreTypeCode?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type QuestionScores_Stddev_Fields = {
  __typename?: 'questionScores_stddev_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "questionScores" */
export type QuestionScores_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type QuestionScores_Stddev_Pop_Fields = {
  __typename?: 'questionScores_stddev_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "questionScores" */
export type QuestionScores_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type QuestionScores_Stddev_Samp_Fields = {
  __typename?: 'questionScores_stddev_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "questionScores" */
export type QuestionScores_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionScores" */
export type QuestionScores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: QuestionScores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type QuestionScores_Stream_Cursor_Value_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  questionChoiceId?: InputMaybe<Scalars['uuid']>;
  scoreTypeCode?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type QuestionScores_Sum_Fields = {
  __typename?: 'questionScores_sum_fields';
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "questionScores" */
export type QuestionScores_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** update columns of table "questionScores" */
export enum QuestionScores_Update_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  QuestionChoiceId = 'questionChoiceId',
  /** column name */
  ScoreTypeCode = 'scoreTypeCode',
  /** column name */
  Value = 'value'
}

export type QuestionScores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<QuestionScores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuestionScores_Set_Input>;
  /** filter the rows which have to be updated */
  where: QuestionScores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type QuestionScores_Var_Pop_Fields = {
  __typename?: 'questionScores_var_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "questionScores" */
export type QuestionScores_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type QuestionScores_Var_Samp_Fields = {
  __typename?: 'questionScores_var_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "questionScores" */
export type QuestionScores_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type QuestionScores_Variance_Fields = {
  __typename?: 'questionScores_variance_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "questionScores" */
export type QuestionScores_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "questions" */
export type Questions = {
  __typename?: 'questions';
  /** An object relationship */
  diagnosis?: Maybe<Diagnoses>;
  diagnosisId: Scalars['uuid'];
  /** An array relationship */
  examinationDiagnosisAnswers: Array<ExaminationDiagnosisAnswers>;
  /** An aggregate relationship */
  examinationDiagnosisAnswers_aggregate: ExaminationDiagnosisAnswers_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  questionChoices: Array<QuestionChoices>;
  /** An aggregate relationship */
  questionChoices_aggregate: QuestionChoices_Aggregate;
  text: Scalars['String'];
};


/** columns and relationships of "questions" */
export type QuestionsExaminationDiagnosisAnswersArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsExaminationDiagnosisAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsQuestionChoicesArgs = {
  distinct_on?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionChoices_Order_By>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsQuestionChoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionChoices_Order_By>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};

/** aggregated selection of "questions" */
export type Questions_Aggregate = {
  __typename?: 'questions_aggregate';
  aggregate?: Maybe<Questions_Aggregate_Fields>;
  nodes: Array<Questions>;
};

export type Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Questions_Aggregate_Bool_Exp_Count>;
};

export type Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questions" */
export type Questions_Aggregate_Fields = {
  __typename?: 'questions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Questions_Max_Fields>;
  min?: Maybe<Questions_Min_Fields>;
};


/** aggregate fields of "questions" */
export type Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "questions" */
export type Questions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questions_Max_Order_By>;
  min?: InputMaybe<Questions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "questions" */
export type Questions_Arr_Rel_Insert_Input = {
  data: Array<Questions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "questions". All fields are combined with a logical 'AND'. */
export type Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Questions_Bool_Exp>>;
  _not?: InputMaybe<Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Questions_Bool_Exp>>;
  diagnosis?: InputMaybe<Diagnoses_Bool_Exp>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  examinationDiagnosisAnswers?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
  examinationDiagnosisAnswers_aggregate?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  questionChoices?: InputMaybe<QuestionChoices_Bool_Exp>;
  questionChoices_aggregate?: InputMaybe<QuestionChoices_Aggregate_Bool_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "questions" */
export enum Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionsPkey = 'questions_pkey'
}

/** input type for inserting data into table "questions" */
export type Questions_Insert_Input = {
  diagnosis?: InputMaybe<Diagnoses_Obj_Rel_Insert_Input>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationDiagnosisAnswers?: InputMaybe<ExaminationDiagnosisAnswers_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  questionChoices?: InputMaybe<QuestionChoices_Arr_Rel_Insert_Input>;
  text?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Questions_Max_Fields = {
  __typename?: 'questions_max_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "questions" */
export type Questions_Max_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questions_Min_Fields = {
  __typename?: 'questions_min_fields';
  diagnosisId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "questions" */
export type Questions_Min_Order_By = {
  diagnosisId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questions" */
export type Questions_Mutation_Response = {
  __typename?: 'questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Questions>;
};

/** input type for inserting object relation for remote table "questions" */
export type Questions_Obj_Rel_Insert_Input = {
  data: Questions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};

/** on_conflict condition type for table "questions" */
export type Questions_On_Conflict = {
  constraint: Questions_Constraint;
  update_columns?: Array<Questions_Update_Column>;
  where?: InputMaybe<Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "questions". */
export type Questions_Order_By = {
  diagnosis?: InputMaybe<Diagnoses_Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
  examinationDiagnosisAnswers_aggregate?: InputMaybe<ExaminationDiagnosisAnswers_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  questionChoices_aggregate?: InputMaybe<QuestionChoices_Aggregate_Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questions */
export type Questions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "questions" */
export enum Questions_Select_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  Id = 'id',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "questions" */
export type Questions_Set_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "questions" */
export type Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questions_Stream_Cursor_Value_Input = {
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  text?: InputMaybe<Scalars['String']>;
};

/** update columns of table "questions" */
export enum Questions_Update_Column {
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  Id = 'id',
  /** column name */
  Text = 'text'
}

export type Questions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questions_Bool_Exp;
};

/** columns and relationships of "resilienceDiagnosisResults" */
export type ResilienceDiagnosisResults = {
  __typename?: 'resilienceDiagnosisResults';
  H1?: Maybe<Scalars['float8']>;
  H2?: Maybe<Scalars['float8']>;
  H3?: Maybe<Scalars['float8']>;
  H4?: Maybe<Scalars['float8']>;
  S1?: Maybe<Scalars['float8']>;
  S2?: Maybe<Scalars['float8']>;
  S3?: Maybe<Scalars['float8']>;
  S4?: Maybe<Scalars['float8']>;
  behavior?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  examinationDiagnosis?: Maybe<ExaminationDiagnoses>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  proactiveness?: Maybe<Scalars['float8']>;
  thoughtfulness?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "resilienceDiagnosisResults" */
export type ResilienceDiagnosisResults_Aggregate = {
  __typename?: 'resilienceDiagnosisResults_aggregate';
  aggregate?: Maybe<ResilienceDiagnosisResults_Aggregate_Fields>;
  nodes: Array<ResilienceDiagnosisResults>;
};

/** aggregate fields of "resilienceDiagnosisResults" */
export type ResilienceDiagnosisResults_Aggregate_Fields = {
  __typename?: 'resilienceDiagnosisResults_aggregate_fields';
  avg?: Maybe<ResilienceDiagnosisResults_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ResilienceDiagnosisResults_Max_Fields>;
  min?: Maybe<ResilienceDiagnosisResults_Min_Fields>;
  stddev?: Maybe<ResilienceDiagnosisResults_Stddev_Fields>;
  stddev_pop?: Maybe<ResilienceDiagnosisResults_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ResilienceDiagnosisResults_Stddev_Samp_Fields>;
  sum?: Maybe<ResilienceDiagnosisResults_Sum_Fields>;
  var_pop?: Maybe<ResilienceDiagnosisResults_Var_Pop_Fields>;
  var_samp?: Maybe<ResilienceDiagnosisResults_Var_Samp_Fields>;
  variance?: Maybe<ResilienceDiagnosisResults_Variance_Fields>;
};


/** aggregate fields of "resilienceDiagnosisResults" */
export type ResilienceDiagnosisResults_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ResilienceDiagnosisResults_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ResilienceDiagnosisResults_Avg_Fields = {
  __typename?: 'resilienceDiagnosisResults_avg_fields';
  H1?: Maybe<Scalars['Float']>;
  H2?: Maybe<Scalars['Float']>;
  H3?: Maybe<Scalars['Float']>;
  H4?: Maybe<Scalars['Float']>;
  S1?: Maybe<Scalars['Float']>;
  S2?: Maybe<Scalars['Float']>;
  S3?: Maybe<Scalars['Float']>;
  S4?: Maybe<Scalars['Float']>;
  proactiveness?: Maybe<Scalars['Float']>;
  thoughtfulness?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "resilienceDiagnosisResults". All fields are combined with a logical 'AND'. */
export type ResilienceDiagnosisResults_Bool_Exp = {
  H1?: InputMaybe<Float8_Comparison_Exp>;
  H2?: InputMaybe<Float8_Comparison_Exp>;
  H3?: InputMaybe<Float8_Comparison_Exp>;
  H4?: InputMaybe<Float8_Comparison_Exp>;
  S1?: InputMaybe<Float8_Comparison_Exp>;
  S2?: InputMaybe<Float8_Comparison_Exp>;
  S3?: InputMaybe<Float8_Comparison_Exp>;
  S4?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<ResilienceDiagnosisResults_Bool_Exp>>;
  _not?: InputMaybe<ResilienceDiagnosisResults_Bool_Exp>;
  _or?: InputMaybe<Array<ResilienceDiagnosisResults_Bool_Exp>>;
  behavior?: InputMaybe<String_Comparison_Exp>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  examinationId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  proactiveness?: InputMaybe<Float8_Comparison_Exp>;
  thoughtfulness?: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for inserting data into table "resilienceDiagnosisResults" */
export type ResilienceDiagnosisResults_Insert_Input = {
  H1?: InputMaybe<Scalars['float8']>;
  H2?: InputMaybe<Scalars['float8']>;
  H3?: InputMaybe<Scalars['float8']>;
  H4?: InputMaybe<Scalars['float8']>;
  S1?: InputMaybe<Scalars['float8']>;
  S2?: InputMaybe<Scalars['float8']>;
  S3?: InputMaybe<Scalars['float8']>;
  S4?: InputMaybe<Scalars['float8']>;
  behavior?: InputMaybe<Scalars['String']>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Obj_Rel_Insert_Input>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  proactiveness?: InputMaybe<Scalars['float8']>;
  thoughtfulness?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type ResilienceDiagnosisResults_Max_Fields = {
  __typename?: 'resilienceDiagnosisResults_max_fields';
  H1?: Maybe<Scalars['float8']>;
  H2?: Maybe<Scalars['float8']>;
  H3?: Maybe<Scalars['float8']>;
  H4?: Maybe<Scalars['float8']>;
  S1?: Maybe<Scalars['float8']>;
  S2?: Maybe<Scalars['float8']>;
  S3?: Maybe<Scalars['float8']>;
  S4?: Maybe<Scalars['float8']>;
  behavior?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  proactiveness?: Maybe<Scalars['float8']>;
  thoughtfulness?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type ResilienceDiagnosisResults_Min_Fields = {
  __typename?: 'resilienceDiagnosisResults_min_fields';
  H1?: Maybe<Scalars['float8']>;
  H2?: Maybe<Scalars['float8']>;
  H3?: Maybe<Scalars['float8']>;
  H4?: Maybe<Scalars['float8']>;
  S1?: Maybe<Scalars['float8']>;
  S2?: Maybe<Scalars['float8']>;
  S3?: Maybe<Scalars['float8']>;
  S4?: Maybe<Scalars['float8']>;
  behavior?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  proactiveness?: Maybe<Scalars['float8']>;
  thoughtfulness?: Maybe<Scalars['float8']>;
};

/** input type for inserting object relation for remote table "resilienceDiagnosisResults" */
export type ResilienceDiagnosisResults_Obj_Rel_Insert_Input = {
  data: ResilienceDiagnosisResults_Insert_Input;
};

/** Ordering options when selecting data from "resilienceDiagnosisResults". */
export type ResilienceDiagnosisResults_Order_By = {
  H1?: InputMaybe<Order_By>;
  H2?: InputMaybe<Order_By>;
  H3?: InputMaybe<Order_By>;
  H4?: InputMaybe<Order_By>;
  S1?: InputMaybe<Order_By>;
  S2?: InputMaybe<Order_By>;
  S3?: InputMaybe<Order_By>;
  S4?: InputMaybe<Order_By>;
  behavior?: InputMaybe<Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  proactiveness?: InputMaybe<Order_By>;
  thoughtfulness?: InputMaybe<Order_By>;
};

/** select columns of table "resilienceDiagnosisResults" */
export enum ResilienceDiagnosisResults_Select_Column {
  /** column name */
  H1 = 'H1',
  /** column name */
  H2 = 'H2',
  /** column name */
  H3 = 'H3',
  /** column name */
  H4 = 'H4',
  /** column name */
  S1 = 'S1',
  /** column name */
  S2 = 'S2',
  /** column name */
  S3 = 'S3',
  /** column name */
  S4 = 'S4',
  /** column name */
  Behavior = 'behavior',
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Proactiveness = 'proactiveness',
  /** column name */
  Thoughtfulness = 'thoughtfulness'
}

/** aggregate stddev on columns */
export type ResilienceDiagnosisResults_Stddev_Fields = {
  __typename?: 'resilienceDiagnosisResults_stddev_fields';
  H1?: Maybe<Scalars['Float']>;
  H2?: Maybe<Scalars['Float']>;
  H3?: Maybe<Scalars['Float']>;
  H4?: Maybe<Scalars['Float']>;
  S1?: Maybe<Scalars['Float']>;
  S2?: Maybe<Scalars['Float']>;
  S3?: Maybe<Scalars['Float']>;
  S4?: Maybe<Scalars['Float']>;
  proactiveness?: Maybe<Scalars['Float']>;
  thoughtfulness?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ResilienceDiagnosisResults_Stddev_Pop_Fields = {
  __typename?: 'resilienceDiagnosisResults_stddev_pop_fields';
  H1?: Maybe<Scalars['Float']>;
  H2?: Maybe<Scalars['Float']>;
  H3?: Maybe<Scalars['Float']>;
  H4?: Maybe<Scalars['Float']>;
  S1?: Maybe<Scalars['Float']>;
  S2?: Maybe<Scalars['Float']>;
  S3?: Maybe<Scalars['Float']>;
  S4?: Maybe<Scalars['Float']>;
  proactiveness?: Maybe<Scalars['Float']>;
  thoughtfulness?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ResilienceDiagnosisResults_Stddev_Samp_Fields = {
  __typename?: 'resilienceDiagnosisResults_stddev_samp_fields';
  H1?: Maybe<Scalars['Float']>;
  H2?: Maybe<Scalars['Float']>;
  H3?: Maybe<Scalars['Float']>;
  H4?: Maybe<Scalars['Float']>;
  S1?: Maybe<Scalars['Float']>;
  S2?: Maybe<Scalars['Float']>;
  S3?: Maybe<Scalars['Float']>;
  S4?: Maybe<Scalars['Float']>;
  proactiveness?: Maybe<Scalars['Float']>;
  thoughtfulness?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "resilienceDiagnosisResults" */
export type ResilienceDiagnosisResults_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ResilienceDiagnosisResults_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ResilienceDiagnosisResults_Stream_Cursor_Value_Input = {
  H1?: InputMaybe<Scalars['float8']>;
  H2?: InputMaybe<Scalars['float8']>;
  H3?: InputMaybe<Scalars['float8']>;
  H4?: InputMaybe<Scalars['float8']>;
  S1?: InputMaybe<Scalars['float8']>;
  S2?: InputMaybe<Scalars['float8']>;
  S3?: InputMaybe<Scalars['float8']>;
  S4?: InputMaybe<Scalars['float8']>;
  behavior?: InputMaybe<Scalars['String']>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  proactiveness?: InputMaybe<Scalars['float8']>;
  thoughtfulness?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type ResilienceDiagnosisResults_Sum_Fields = {
  __typename?: 'resilienceDiagnosisResults_sum_fields';
  H1?: Maybe<Scalars['float8']>;
  H2?: Maybe<Scalars['float8']>;
  H3?: Maybe<Scalars['float8']>;
  H4?: Maybe<Scalars['float8']>;
  S1?: Maybe<Scalars['float8']>;
  S2?: Maybe<Scalars['float8']>;
  S3?: Maybe<Scalars['float8']>;
  S4?: Maybe<Scalars['float8']>;
  proactiveness?: Maybe<Scalars['float8']>;
  thoughtfulness?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type ResilienceDiagnosisResults_Var_Pop_Fields = {
  __typename?: 'resilienceDiagnosisResults_var_pop_fields';
  H1?: Maybe<Scalars['Float']>;
  H2?: Maybe<Scalars['Float']>;
  H3?: Maybe<Scalars['Float']>;
  H4?: Maybe<Scalars['Float']>;
  S1?: Maybe<Scalars['Float']>;
  S2?: Maybe<Scalars['Float']>;
  S3?: Maybe<Scalars['Float']>;
  S4?: Maybe<Scalars['Float']>;
  proactiveness?: Maybe<Scalars['Float']>;
  thoughtfulness?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ResilienceDiagnosisResults_Var_Samp_Fields = {
  __typename?: 'resilienceDiagnosisResults_var_samp_fields';
  H1?: Maybe<Scalars['Float']>;
  H2?: Maybe<Scalars['Float']>;
  H3?: Maybe<Scalars['Float']>;
  H4?: Maybe<Scalars['Float']>;
  S1?: Maybe<Scalars['Float']>;
  S2?: Maybe<Scalars['Float']>;
  S3?: Maybe<Scalars['Float']>;
  S4?: Maybe<Scalars['Float']>;
  proactiveness?: Maybe<Scalars['Float']>;
  thoughtfulness?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ResilienceDiagnosisResults_Variance_Fields = {
  __typename?: 'resilienceDiagnosisResults_variance_fields';
  H1?: Maybe<Scalars['Float']>;
  H2?: Maybe<Scalars['Float']>;
  H3?: Maybe<Scalars['Float']>;
  H4?: Maybe<Scalars['Float']>;
  S1?: Maybe<Scalars['Float']>;
  S2?: Maybe<Scalars['Float']>;
  S3?: Maybe<Scalars['Float']>;
  S4?: Maybe<Scalars['Float']>;
  proactiveness?: Maybe<Scalars['Float']>;
  thoughtfulness?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "scoreTypes" */
export type ScoreTypes = {
  __typename?: 'scoreTypes';
  code: Scalars['String'];
  /** An object relationship */
  diagnosis?: Maybe<Diagnoses>;
  diagnosisId: Scalars['uuid'];
  /** An array relationship */
  questionScores: Array<QuestionScores>;
  /** An aggregate relationship */
  questionScores_aggregate: QuestionScores_Aggregate;
};


/** columns and relationships of "scoreTypes" */
export type ScoreTypesQuestionScoresArgs = {
  distinct_on?: InputMaybe<Array<QuestionScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionScores_Order_By>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};


/** columns and relationships of "scoreTypes" */
export type ScoreTypesQuestionScores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<QuestionScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionScores_Order_By>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};

/** aggregated selection of "scoreTypes" */
export type ScoreTypes_Aggregate = {
  __typename?: 'scoreTypes_aggregate';
  aggregate?: Maybe<ScoreTypes_Aggregate_Fields>;
  nodes: Array<ScoreTypes>;
};

export type ScoreTypes_Aggregate_Bool_Exp = {
  count?: InputMaybe<ScoreTypes_Aggregate_Bool_Exp_Count>;
};

export type ScoreTypes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ScoreTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScoreTypes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scoreTypes" */
export type ScoreTypes_Aggregate_Fields = {
  __typename?: 'scoreTypes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ScoreTypes_Max_Fields>;
  min?: Maybe<ScoreTypes_Min_Fields>;
};


/** aggregate fields of "scoreTypes" */
export type ScoreTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ScoreTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scoreTypes" */
export type ScoreTypes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ScoreTypes_Max_Order_By>;
  min?: InputMaybe<ScoreTypes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "scoreTypes" */
export type ScoreTypes_Arr_Rel_Insert_Input = {
  data: Array<ScoreTypes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ScoreTypes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "scoreTypes". All fields are combined with a logical 'AND'. */
export type ScoreTypes_Bool_Exp = {
  _and?: InputMaybe<Array<ScoreTypes_Bool_Exp>>;
  _not?: InputMaybe<ScoreTypes_Bool_Exp>;
  _or?: InputMaybe<Array<ScoreTypes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  diagnosis?: InputMaybe<Diagnoses_Bool_Exp>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  questionScores?: InputMaybe<QuestionScores_Bool_Exp>;
  questionScores_aggregate?: InputMaybe<QuestionScores_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "scoreTypes" */
export enum ScoreTypes_Constraint {
  /** unique or primary key constraint on columns "code", "diagnosisId" */
  ScoreTypesPkey = 'scoreTypes_pkey'
}

/** input type for inserting data into table "scoreTypes" */
export type ScoreTypes_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  diagnosis?: InputMaybe<Diagnoses_Obj_Rel_Insert_Input>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  questionScores?: InputMaybe<QuestionScores_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ScoreTypes_Max_Fields = {
  __typename?: 'scoreTypes_max_fields';
  code?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "scoreTypes" */
export type ScoreTypes_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ScoreTypes_Min_Fields = {
  __typename?: 'scoreTypes_min_fields';
  code?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "scoreTypes" */
export type ScoreTypes_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scoreTypes" */
export type ScoreTypes_Mutation_Response = {
  __typename?: 'scoreTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScoreTypes>;
};

/** input type for inserting object relation for remote table "scoreTypes" */
export type ScoreTypes_Obj_Rel_Insert_Input = {
  data: ScoreTypes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ScoreTypes_On_Conflict>;
};

/** on_conflict condition type for table "scoreTypes" */
export type ScoreTypes_On_Conflict = {
  constraint: ScoreTypes_Constraint;
  update_columns?: Array<ScoreTypes_Update_Column>;
  where?: InputMaybe<ScoreTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "scoreTypes". */
export type ScoreTypes_Order_By = {
  code?: InputMaybe<Order_By>;
  diagnosis?: InputMaybe<Diagnoses_Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
  questionScores_aggregate?: InputMaybe<QuestionScores_Aggregate_Order_By>;
};

/** primary key columns input for table: scoreTypes */
export type ScoreTypes_Pk_Columns_Input = {
  code: Scalars['String'];
  diagnosisId: Scalars['uuid'];
};

/** select columns of table "scoreTypes" */
export enum ScoreTypes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  DiagnosisId = 'diagnosisId'
}

/** input type for updating data in table "scoreTypes" */
export type ScoreTypes_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "scoreTypes" */
export type ScoreTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ScoreTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ScoreTypes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "scoreTypes" */
export enum ScoreTypes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  DiagnosisId = 'diagnosisId'
}

export type ScoreTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScoreTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: ScoreTypes_Bool_Exp;
};

/** columns and relationships of "staffInvitations" */
export type StaffInvitations = {
  __typename?: 'staffInvitations';
  /** An array relationship */
  _staffs: Array<Staffs>;
  /** An aggregate relationship */
  _staffs_aggregate: Staffs_Aggregate;
  email: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  staff?: Maybe<Staffs>;
};


/** columns and relationships of "staffInvitations" */
export type StaffInvitations_StaffsArgs = {
  distinct_on?: InputMaybe<Array<Staffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Staffs_Order_By>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};


/** columns and relationships of "staffInvitations" */
export type StaffInvitations_Staffs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Staffs_Order_By>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};

/** aggregated selection of "staffInvitations" */
export type StaffInvitations_Aggregate = {
  __typename?: 'staffInvitations_aggregate';
  aggregate?: Maybe<StaffInvitations_Aggregate_Fields>;
  nodes: Array<StaffInvitations>;
};

export type StaffInvitations_Aggregate_Bool_Exp = {
  count?: InputMaybe<StaffInvitations_Aggregate_Bool_Exp_Count>;
};

export type StaffInvitations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<StaffInvitations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<StaffInvitations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "staffInvitations" */
export type StaffInvitations_Aggregate_Fields = {
  __typename?: 'staffInvitations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<StaffInvitations_Max_Fields>;
  min?: Maybe<StaffInvitations_Min_Fields>;
};


/** aggregate fields of "staffInvitations" */
export type StaffInvitations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StaffInvitations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "staffInvitations" */
export type StaffInvitations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<StaffInvitations_Max_Order_By>;
  min?: InputMaybe<StaffInvitations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "staffInvitations" */
export type StaffInvitations_Arr_Rel_Insert_Input = {
  data: Array<StaffInvitations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<StaffInvitations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "staffInvitations". All fields are combined with a logical 'AND'. */
export type StaffInvitations_Bool_Exp = {
  _and?: InputMaybe<Array<StaffInvitations_Bool_Exp>>;
  _not?: InputMaybe<StaffInvitations_Bool_Exp>;
  _or?: InputMaybe<Array<StaffInvitations_Bool_Exp>>;
  _staffs?: InputMaybe<Staffs_Bool_Exp>;
  _staffs_aggregate?: InputMaybe<Staffs_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  staff?: InputMaybe<Staffs_Bool_Exp>;
};

/** unique or primary key constraints on table "staffInvitations" */
export enum StaffInvitations_Constraint {
  /** unique or primary key constraint on columns "id" */
  StaffInvitationsIdUniqueness = 'staffInvitations_id_uniqueness',
  /** unique or primary key constraint on columns "email" */
  StaffInvitationsPkey = 'staffInvitations_pkey'
}

/** input type for inserting data into table "staffInvitations" */
export type StaffInvitations_Insert_Input = {
  _staffs?: InputMaybe<Staffs_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  staff?: InputMaybe<Staffs_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type StaffInvitations_Max_Fields = {
  __typename?: 'staffInvitations_max_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "staffInvitations" */
export type StaffInvitations_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type StaffInvitations_Min_Fields = {
  __typename?: 'staffInvitations_min_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "staffInvitations" */
export type StaffInvitations_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "staffInvitations" */
export type StaffInvitations_Mutation_Response = {
  __typename?: 'staffInvitations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<StaffInvitations>;
};

/** input type for inserting object relation for remote table "staffInvitations" */
export type StaffInvitations_Obj_Rel_Insert_Input = {
  data: StaffInvitations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StaffInvitations_On_Conflict>;
};

/** on_conflict condition type for table "staffInvitations" */
export type StaffInvitations_On_Conflict = {
  constraint: StaffInvitations_Constraint;
  update_columns?: Array<StaffInvitations_Update_Column>;
  where?: InputMaybe<StaffInvitations_Bool_Exp>;
};

/** Ordering options when selecting data from "staffInvitations". */
export type StaffInvitations_Order_By = {
  _staffs_aggregate?: InputMaybe<Staffs_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  staff?: InputMaybe<Staffs_Order_By>;
};

/** primary key columns input for table: staffInvitations */
export type StaffInvitations_Pk_Columns_Input = {
  email: Scalars['String'];
};

/** select columns of table "staffInvitations" */
export enum StaffInvitations_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "staffInvitations" */
export type StaffInvitations_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "staffInvitations" */
export type StaffInvitations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StaffInvitations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StaffInvitations_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "staffInvitations" */
export enum StaffInvitations_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type StaffInvitations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StaffInvitations_Set_Input>;
  /** filter the rows which have to be updated */
  where: StaffInvitations_Bool_Exp;
};

/** columns and relationships of "staffs" */
export type Staffs = {
  __typename?: 'staffs';
  /** An array relationship */
  _staffInvitations: Array<StaffInvitations>;
  /** An aggregate relationship */
  _staffInvitations_aggregate: StaffInvitations_Aggregate;
  /** An array relationship */
  _users: Array<Users>;
  /** An aggregate relationship */
  _users_aggregate: Users_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  staffInvitation?: Maybe<StaffInvitations>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "staffs" */
export type Staffs_StaffInvitationsArgs = {
  distinct_on?: InputMaybe<Array<StaffInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaffInvitations_Order_By>>;
  where?: InputMaybe<StaffInvitations_Bool_Exp>;
};


/** columns and relationships of "staffs" */
export type Staffs_StaffInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StaffInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaffInvitations_Order_By>>;
  where?: InputMaybe<StaffInvitations_Bool_Exp>;
};


/** columns and relationships of "staffs" */
export type Staffs_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "staffs" */
export type Staffs_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "staffs" */
export type Staffs_Aggregate = {
  __typename?: 'staffs_aggregate';
  aggregate?: Maybe<Staffs_Aggregate_Fields>;
  nodes: Array<Staffs>;
};

export type Staffs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Staffs_Aggregate_Bool_Exp_Count>;
};

export type Staffs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Staffs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Staffs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "staffs" */
export type Staffs_Aggregate_Fields = {
  __typename?: 'staffs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Staffs_Max_Fields>;
  min?: Maybe<Staffs_Min_Fields>;
};


/** aggregate fields of "staffs" */
export type Staffs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staffs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "staffs" */
export type Staffs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Staffs_Max_Order_By>;
  min?: InputMaybe<Staffs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "staffs" */
export type Staffs_Arr_Rel_Insert_Input = {
  data: Array<Staffs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Staffs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "staffs". All fields are combined with a logical 'AND'. */
export type Staffs_Bool_Exp = {
  _and?: InputMaybe<Array<Staffs_Bool_Exp>>;
  _not?: InputMaybe<Staffs_Bool_Exp>;
  _or?: InputMaybe<Array<Staffs_Bool_Exp>>;
  _staffInvitations?: InputMaybe<StaffInvitations_Bool_Exp>;
  _staffInvitations_aggregate?: InputMaybe<StaffInvitations_Aggregate_Bool_Exp>;
  _users?: InputMaybe<Users_Bool_Exp>;
  _users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  staffInvitation?: InputMaybe<StaffInvitations_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "staffs" */
export enum Staffs_Constraint {
  /** unique or primary key constraint on columns "id" */
  StaffsPkey = 'staffs_pkey'
}

/** input type for inserting data into table "staffs" */
export type Staffs_Insert_Input = {
  _staffInvitations?: InputMaybe<StaffInvitations_Arr_Rel_Insert_Input>;
  _users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  staffInvitation?: InputMaybe<StaffInvitations_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Staffs_Max_Fields = {
  __typename?: 'staffs_max_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "staffs" */
export type Staffs_Max_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Staffs_Min_Fields = {
  __typename?: 'staffs_min_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "staffs" */
export type Staffs_Min_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "staffs" */
export type Staffs_Mutation_Response = {
  __typename?: 'staffs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Staffs>;
};

/** input type for inserting object relation for remote table "staffs" */
export type Staffs_Obj_Rel_Insert_Input = {
  data: Staffs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Staffs_On_Conflict>;
};

/** on_conflict condition type for table "staffs" */
export type Staffs_On_Conflict = {
  constraint: Staffs_Constraint;
  update_columns?: Array<Staffs_Update_Column>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};

/** Ordering options when selecting data from "staffs". */
export type Staffs_Order_By = {
  _staffInvitations_aggregate?: InputMaybe<StaffInvitations_Aggregate_Order_By>;
  _users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  staffInvitation?: InputMaybe<StaffInvitations_Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: staffs */
export type Staffs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "staffs" */
export enum Staffs_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "staffs" */
export type Staffs_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "staffs" */
export type Staffs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staffs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staffs_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "staffs" */
export enum Staffs_Update_Column {
  /** column name */
  Id = 'id'
}

export type Staffs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staffs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staffs_Bool_Exp;
};

/** columns and relationships of "stressDiagnosisResults" */
export type StressDiagnosisResults = {
  __typename?: 'stressDiagnosisResults';
  A?: Maybe<Scalars['float8']>;
  B?: Maybe<Scalars['float8']>;
  C?: Maybe<Scalars['float8']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  examinationDiagnosis?: Maybe<ExaminationDiagnoses>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  resilience?: Maybe<Scalars['float8']>;
  resilienceGrade?: Maybe<Scalars['String']>;
};

/** aggregated selection of "stressDiagnosisResults" */
export type StressDiagnosisResults_Aggregate = {
  __typename?: 'stressDiagnosisResults_aggregate';
  aggregate?: Maybe<StressDiagnosisResults_Aggregate_Fields>;
  nodes: Array<StressDiagnosisResults>;
};

/** aggregate fields of "stressDiagnosisResults" */
export type StressDiagnosisResults_Aggregate_Fields = {
  __typename?: 'stressDiagnosisResults_aggregate_fields';
  avg?: Maybe<StressDiagnosisResults_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<StressDiagnosisResults_Max_Fields>;
  min?: Maybe<StressDiagnosisResults_Min_Fields>;
  stddev?: Maybe<StressDiagnosisResults_Stddev_Fields>;
  stddev_pop?: Maybe<StressDiagnosisResults_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StressDiagnosisResults_Stddev_Samp_Fields>;
  sum?: Maybe<StressDiagnosisResults_Sum_Fields>;
  var_pop?: Maybe<StressDiagnosisResults_Var_Pop_Fields>;
  var_samp?: Maybe<StressDiagnosisResults_Var_Samp_Fields>;
  variance?: Maybe<StressDiagnosisResults_Variance_Fields>;
};


/** aggregate fields of "stressDiagnosisResults" */
export type StressDiagnosisResults_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StressDiagnosisResults_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type StressDiagnosisResults_Avg_Fields = {
  __typename?: 'stressDiagnosisResults_avg_fields';
  A?: Maybe<Scalars['Float']>;
  B?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  resilience?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stressDiagnosisResults". All fields are combined with a logical 'AND'. */
export type StressDiagnosisResults_Bool_Exp = {
  A?: InputMaybe<Float8_Comparison_Exp>;
  B?: InputMaybe<Float8_Comparison_Exp>;
  C?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<StressDiagnosisResults_Bool_Exp>>;
  _not?: InputMaybe<StressDiagnosisResults_Bool_Exp>;
  _or?: InputMaybe<Array<StressDiagnosisResults_Bool_Exp>>;
  diagnosisId?: InputMaybe<Uuid_Comparison_Exp>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
  examinationId?: InputMaybe<Uuid_Comparison_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  resilience?: InputMaybe<Float8_Comparison_Exp>;
  resilienceGrade?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "stressDiagnosisResults" */
export type StressDiagnosisResults_Insert_Input = {
  A?: InputMaybe<Scalars['float8']>;
  B?: InputMaybe<Scalars['float8']>;
  C?: InputMaybe<Scalars['float8']>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Obj_Rel_Insert_Input>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  resilience?: InputMaybe<Scalars['float8']>;
  resilienceGrade?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type StressDiagnosisResults_Max_Fields = {
  __typename?: 'stressDiagnosisResults_max_fields';
  A?: Maybe<Scalars['float8']>;
  B?: Maybe<Scalars['float8']>;
  C?: Maybe<Scalars['float8']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  resilience?: Maybe<Scalars['float8']>;
  resilienceGrade?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type StressDiagnosisResults_Min_Fields = {
  __typename?: 'stressDiagnosisResults_min_fields';
  A?: Maybe<Scalars['float8']>;
  B?: Maybe<Scalars['float8']>;
  C?: Maybe<Scalars['float8']>;
  diagnosisId?: Maybe<Scalars['uuid']>;
  examinationId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  resilience?: Maybe<Scalars['float8']>;
  resilienceGrade?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "stressDiagnosisResults" */
export type StressDiagnosisResults_Obj_Rel_Insert_Input = {
  data: StressDiagnosisResults_Insert_Input;
};

/** Ordering options when selecting data from "stressDiagnosisResults". */
export type StressDiagnosisResults_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
  C?: InputMaybe<Order_By>;
  diagnosisId?: InputMaybe<Order_By>;
  examinationDiagnosis?: InputMaybe<ExaminationDiagnoses_Order_By>;
  examinationId?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  resilience?: InputMaybe<Order_By>;
  resilienceGrade?: InputMaybe<Order_By>;
};

/** select columns of table "stressDiagnosisResults" */
export enum StressDiagnosisResults_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B',
  /** column name */
  C = 'C',
  /** column name */
  DiagnosisId = 'diagnosisId',
  /** column name */
  ExaminationId = 'examinationId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Resilience = 'resilience',
  /** column name */
  ResilienceGrade = 'resilienceGrade'
}

/** aggregate stddev on columns */
export type StressDiagnosisResults_Stddev_Fields = {
  __typename?: 'stressDiagnosisResults_stddev_fields';
  A?: Maybe<Scalars['Float']>;
  B?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  resilience?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type StressDiagnosisResults_Stddev_Pop_Fields = {
  __typename?: 'stressDiagnosisResults_stddev_pop_fields';
  A?: Maybe<Scalars['Float']>;
  B?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  resilience?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type StressDiagnosisResults_Stddev_Samp_Fields = {
  __typename?: 'stressDiagnosisResults_stddev_samp_fields';
  A?: Maybe<Scalars['Float']>;
  B?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  resilience?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stressDiagnosisResults" */
export type StressDiagnosisResults_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StressDiagnosisResults_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StressDiagnosisResults_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['float8']>;
  B?: InputMaybe<Scalars['float8']>;
  C?: InputMaybe<Scalars['float8']>;
  diagnosisId?: InputMaybe<Scalars['uuid']>;
  examinationId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  resilience?: InputMaybe<Scalars['float8']>;
  resilienceGrade?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type StressDiagnosisResults_Sum_Fields = {
  __typename?: 'stressDiagnosisResults_sum_fields';
  A?: Maybe<Scalars['float8']>;
  B?: Maybe<Scalars['float8']>;
  C?: Maybe<Scalars['float8']>;
  resilience?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type StressDiagnosisResults_Var_Pop_Fields = {
  __typename?: 'stressDiagnosisResults_var_pop_fields';
  A?: Maybe<Scalars['Float']>;
  B?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  resilience?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type StressDiagnosisResults_Var_Samp_Fields = {
  __typename?: 'stressDiagnosisResults_var_samp_fields';
  A?: Maybe<Scalars['Float']>;
  B?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  resilience?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type StressDiagnosisResults_Variance_Fields = {
  __typename?: 'stressDiagnosisResults_variance_fields';
  A?: Maybe<Scalars['Float']>;
  B?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  resilience?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  diagnoses: Array<Diagnoses>;
  /** An aggregate relationship */
  diagnoses_aggregate: Diagnoses_Aggregate;
  /** fetch data from the table: "diagnoses" using primary key columns */
  diagnoses_by_pk?: Maybe<Diagnoses>;
  /** fetch data from the table in a streaming manner: "diagnoses" */
  diagnoses_stream: Array<Diagnoses>;
  /** fetch data from the table: "diagnosisTypes" */
  diagnosisTypes: Array<DiagnosisTypes>;
  /** fetch aggregated fields from the table: "diagnosisTypes" */
  diagnosisTypes_aggregate: DiagnosisTypes_Aggregate;
  /** fetch data from the table: "diagnosisTypes" using primary key columns */
  diagnosisTypes_by_pk?: Maybe<DiagnosisTypes>;
  /** fetch data from the table in a streaming manner: "diagnosisTypes" */
  diagnosisTypes_stream: Array<DiagnosisTypes>;
  /** An array relationship */
  eventAreaAssignments: Array<EventAreaAssignments>;
  /** An aggregate relationship */
  eventAreaAssignments_aggregate: EventAreaAssignments_Aggregate;
  /** fetch data from the table: "eventAreaAssignments" using primary key columns */
  eventAreaAssignments_by_pk?: Maybe<EventAreaAssignments>;
  /** fetch data from the table in a streaming manner: "eventAreaAssignments" */
  eventAreaAssignments_stream: Array<EventAreaAssignments>;
  /** An array relationship */
  eventAreas: Array<EventAreas>;
  /** An aggregate relationship */
  eventAreas_aggregate: EventAreas_Aggregate;
  /** fetch data from the table: "eventAreas" using primary key columns */
  eventAreas_by_pk?: Maybe<EventAreas>;
  /** fetch data from the table in a streaming manner: "eventAreas" */
  eventAreas_stream: Array<EventAreas>;
  /** An array relationship */
  eventBeginnings: Array<EventBeginnings>;
  /** An aggregate relationship */
  eventBeginnings_aggregate: EventBeginnings_Aggregate;
  /** fetch data from the table: "eventBeginnings" using primary key columns */
  eventBeginnings_by_pk?: Maybe<EventBeginnings>;
  /** fetch data from the table in a streaming manner: "eventBeginnings" */
  eventBeginnings_stream: Array<EventBeginnings>;
  /** An array relationship */
  eventDiagnoses: Array<EventDiagnoses>;
  /** An aggregate relationship */
  eventDiagnoses_aggregate: EventDiagnoses_Aggregate;
  /** fetch data from the table: "eventDiagnoses" using primary key columns */
  eventDiagnoses_by_pk?: Maybe<EventDiagnoses>;
  /** fetch data from the table in a streaming manner: "eventDiagnoses" */
  eventDiagnoses_stream: Array<EventDiagnoses>;
  /** fetch data from the table: "eventExaminationCounts" */
  eventExaminationCounts: Array<EventExaminationCounts>;
  /** fetch aggregated fields from the table: "eventExaminationCounts" */
  eventExaminationCounts_aggregate: EventExaminationCounts_Aggregate;
  /** fetch data from the table in a streaming manner: "eventExaminationCounts" */
  eventExaminationCounts_stream: Array<EventExaminationCounts>;
  /** An array relationship */
  eventExpirations: Array<EventExpirations>;
  /** An aggregate relationship */
  eventExpirations_aggregate: EventExpirations_Aggregate;
  /** fetch data from the table: "eventExpirations" using primary key columns */
  eventExpirations_by_pk?: Maybe<EventExpirations>;
  /** fetch data from the table in a streaming manner: "eventExpirations" */
  eventExpirations_stream: Array<EventExpirations>;
  /** An array relationship */
  eventLimitTimes: Array<EventLimitTimes>;
  /** An aggregate relationship */
  eventLimitTimes_aggregate: EventLimitTimes_Aggregate;
  /** fetch data from the table: "eventLimitTimes" using primary key columns */
  eventLimitTimes_by_pk?: Maybe<EventLimitTimes>;
  /** fetch data from the table in a streaming manner: "eventLimitTimes" */
  eventLimitTimes_stream: Array<EventLimitTimes>;
  /** An array relationship */
  eventTagAssignments: Array<EventTagAssignments>;
  /** An aggregate relationship */
  eventTagAssignments_aggregate: EventTagAssignments_Aggregate;
  /** fetch data from the table: "eventTagAssignments" using primary key columns */
  eventTagAssignments_by_pk?: Maybe<EventTagAssignments>;
  /** fetch data from the table in a streaming manner: "eventTagAssignments" */
  eventTagAssignments_stream: Array<EventTagAssignments>;
  /** An array relationship */
  eventTags: Array<EventTags>;
  /** An aggregate relationship */
  eventTags_aggregate: EventTags_Aggregate;
  /** fetch data from the table: "eventTags" using primary key columns */
  eventTags_by_pk?: Maybe<EventTags>;
  /** fetch data from the table in a streaming manner: "eventTags" */
  eventTags_stream: Array<EventTags>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table in a streaming manner: "events" */
  events_stream: Array<Events>;
  /** An array relationship */
  examinationDiagnoses: Array<ExaminationDiagnoses>;
  /** An aggregate relationship */
  examinationDiagnoses_aggregate: ExaminationDiagnoses_Aggregate;
  /** fetch data from the table: "examinationDiagnoses" using primary key columns */
  examinationDiagnoses_by_pk?: Maybe<ExaminationDiagnoses>;
  /** fetch data from the table in a streaming manner: "examinationDiagnoses" */
  examinationDiagnoses_stream: Array<ExaminationDiagnoses>;
  /** An array relationship */
  examinationDiagnosisAnswers: Array<ExaminationDiagnosisAnswers>;
  /** An aggregate relationship */
  examinationDiagnosisAnswers_aggregate: ExaminationDiagnosisAnswers_Aggregate;
  /** fetch data from the table: "examinationDiagnosisAnswers" using primary key columns */
  examinationDiagnosisAnswers_by_pk?: Maybe<ExaminationDiagnosisAnswers>;
  /** fetch data from the table in a streaming manner: "examinationDiagnosisAnswers" */
  examinationDiagnosisAnswers_stream: Array<ExaminationDiagnosisAnswers>;
  /** An array relationship */
  examinationDiagnosisScores: Array<ExaminationDiagnosisScores>;
  /** An aggregate relationship */
  examinationDiagnosisScores_aggregate: ExaminationDiagnosisScores_Aggregate;
  /** fetch data from the table in a streaming manner: "examinationDiagnosisScores" */
  examinationDiagnosisScores_stream: Array<ExaminationDiagnosisScores>;
  /** An array relationship */
  examinations: Array<Examinations>;
  /** An aggregate relationship */
  examinations_aggregate: Examinations_Aggregate;
  /** fetch data from the table: "examinations" using primary key columns */
  examinations_by_pk?: Maybe<Examinations>;
  /** fetch data from the table in a streaming manner: "examinations" */
  examinations_stream: Array<Examinations>;
  /** fetch data from the table: "genders" */
  genders: Array<Genders>;
  /** fetch aggregated fields from the table: "genders" */
  genders_aggregate: Genders_Aggregate;
  /** fetch data from the table: "genders" using primary key columns */
  genders_by_pk?: Maybe<Genders>;
  /** fetch data from the table in a streaming manner: "genders" */
  genders_stream: Array<Genders>;
  /** fetch data from the table: "groupContents" */
  groupContents: Array<GroupContents>;
  /** fetch aggregated fields from the table: "groupContents" */
  groupContents_aggregate: GroupContents_Aggregate;
  /** fetch data from the table: "groupContents" using primary key columns */
  groupContents_by_pk?: Maybe<GroupContents>;
  /** fetch data from the table in a streaming manner: "groupContents" */
  groupContents_stream: Array<GroupContents>;
  /** An array relationship */
  groupInvitations: Array<GroupInvitations>;
  /** An aggregate relationship */
  groupInvitations_aggregate: GroupInvitations_Aggregate;
  /** fetch data from the table: "groupInvitations" using primary key columns */
  groupInvitations_by_pk?: Maybe<GroupInvitations>;
  /** fetch data from the table in a streaming manner: "groupInvitations" */
  groupInvitations_stream: Array<GroupInvitations>;
  /** fetch data from the table: "groups" */
  groups: Array<Groups>;
  /** fetch aggregated fields from the table: "groups" */
  groups_aggregate: Groups_Aggregate;
  /** fetch data from the table: "groups" using primary key columns */
  groups_by_pk?: Maybe<Groups>;
  /** fetch data from the table in a streaming manner: "groups" */
  groups_stream: Array<Groups>;
  /** fetch data from the table: "guestExamineeExaminations" */
  guestExamineeExaminations: Array<GuestExamineeExaminations>;
  /** fetch aggregated fields from the table: "guestExamineeExaminations" */
  guestExamineeExaminations_aggregate: GuestExamineeExaminations_Aggregate;
  /** fetch data from the table: "guestExamineeExaminations" using primary key columns */
  guestExamineeExaminations_by_pk?: Maybe<GuestExamineeExaminations>;
  /** fetch data from the table in a streaming manner: "guestExamineeExaminations" */
  guestExamineeExaminations_stream: Array<GuestExamineeExaminations>;
  /** An array relationship */
  guestExaminees: Array<GuestExaminees>;
  /** An aggregate relationship */
  guestExaminees_aggregate: GuestExaminees_Aggregate;
  /** fetch data from the table: "guestExaminees" using primary key columns */
  guestExaminees_by_pk?: Maybe<GuestExaminees>;
  /** fetch data from the table in a streaming manner: "guestExaminees" */
  guestExaminees_stream: Array<GuestExaminees>;
  /** fetch data from the table: "inactiveGroupEvents" */
  inactiveGroupEvents: Array<InactiveGroupEvents>;
  /** fetch aggregated fields from the table: "inactiveGroupEvents" */
  inactiveGroupEvents_aggregate: InactiveGroupEvents_Aggregate;
  /** fetch data from the table: "inactiveGroupEvents" using primary key columns */
  inactiveGroupEvents_by_pk?: Maybe<InactiveGroupEvents>;
  /** fetch data from the table in a streaming manner: "inactiveGroupEvents" */
  inactiveGroupEvents_stream: Array<InactiveGroupEvents>;
  /** fetch data from the table: "inactiveGroups" */
  inactiveGroups: Array<InactiveGroups>;
  /** fetch aggregated fields from the table: "inactiveGroups" */
  inactiveGroups_aggregate: InactiveGroups_Aggregate;
  /** fetch data from the table: "inactiveGroups" using primary key columns */
  inactiveGroups_by_pk?: Maybe<InactiveGroups>;
  /** fetch data from the table in a streaming manner: "inactiveGroups" */
  inactiveGroups_stream: Array<InactiveGroups>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk?: Maybe<Languages>;
  /** fetch data from the table in a streaming manner: "languages" */
  languages_stream: Array<Languages>;
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: Memberships_Aggregate;
  /** fetch data from the table: "memberships" using primary key columns */
  memberships_by_pk?: Maybe<Memberships>;
  /** fetch data from the table in a streaming manner: "memberships" */
  memberships_stream: Array<Memberships>;
  /** fetch data from the table: "monthlyExaminationCounts" */
  monthlyExaminationCounts: Array<MonthlyExaminationCounts>;
  /** fetch aggregated fields from the table: "monthlyExaminationCounts" */
  monthlyExaminationCounts_aggregate: MonthlyExaminationCounts_Aggregate;
  /** fetch data from the table in a streaming manner: "monthlyExaminationCounts" */
  monthlyExaminationCounts_stream: Array<MonthlyExaminationCounts>;
  /** An array relationship */
  ownerships: Array<Ownerships>;
  /** An aggregate relationship */
  ownerships_aggregate: Ownerships_Aggregate;
  /** fetch data from the table: "ownerships" using primary key columns */
  ownerships_by_pk?: Maybe<Ownerships>;
  /** fetch data from the table in a streaming manner: "ownerships" */
  ownerships_stream: Array<Ownerships>;
  /** execute function "personalityDiagnosisResultCounts" which returns "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCounts: Array<PersonalityDiagnosisResultCountsRecords>;
  /** fetch data from the table: "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCountsRecords: Array<PersonalityDiagnosisResultCountsRecords>;
  /** fetch aggregated fields from the table: "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCountsRecords_aggregate: PersonalityDiagnosisResultCountsRecords_Aggregate;
  /** fetch data from the table in a streaming manner: "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCountsRecords_stream: Array<PersonalityDiagnosisResultCountsRecords>;
  /** execute function "personalityDiagnosisResultCounts" and query aggregates on result of table type "personalityDiagnosisResultCountsRecords" */
  personalityDiagnosisResultCounts_aggregate: PersonalityDiagnosisResultCountsRecords_Aggregate;
  /** fetch data from the table: "personalityDiagnosisResults" */
  personalityDiagnosisResults: Array<PersonalityDiagnosisResults>;
  /** fetch aggregated fields from the table: "personalityDiagnosisResults" */
  personalityDiagnosisResults_aggregate: PersonalityDiagnosisResults_Aggregate;
  /** fetch data from the table in a streaming manner: "personalityDiagnosisResults" */
  personalityDiagnosisResults_stream: Array<PersonalityDiagnosisResults>;
  /** An array relationship */
  questionChoices: Array<QuestionChoices>;
  /** An aggregate relationship */
  questionChoices_aggregate: QuestionChoices_Aggregate;
  /** fetch data from the table: "questionChoices" using primary key columns */
  questionChoices_by_pk?: Maybe<QuestionChoices>;
  /** fetch data from the table in a streaming manner: "questionChoices" */
  questionChoices_stream: Array<QuestionChoices>;
  /** An array relationship */
  questionScores: Array<QuestionScores>;
  /** An aggregate relationship */
  questionScores_aggregate: QuestionScores_Aggregate;
  /** fetch data from the table: "questionScores" using primary key columns */
  questionScores_by_pk?: Maybe<QuestionScores>;
  /** fetch data from the table in a streaming manner: "questionScores" */
  questionScores_stream: Array<QuestionScores>;
  /** An array relationship */
  questions: Array<Questions>;
  /** An aggregate relationship */
  questions_aggregate: Questions_Aggregate;
  /** fetch data from the table: "questions" using primary key columns */
  questions_by_pk?: Maybe<Questions>;
  /** fetch data from the table in a streaming manner: "questions" */
  questions_stream: Array<Questions>;
  /** fetch data from the table: "resilienceDiagnosisResults" */
  resilienceDiagnosisResults: Array<ResilienceDiagnosisResults>;
  /** fetch aggregated fields from the table: "resilienceDiagnosisResults" */
  resilienceDiagnosisResults_aggregate: ResilienceDiagnosisResults_Aggregate;
  /** fetch data from the table in a streaming manner: "resilienceDiagnosisResults" */
  resilienceDiagnosisResults_stream: Array<ResilienceDiagnosisResults>;
  /** An array relationship */
  scoreTypes: Array<ScoreTypes>;
  /** An aggregate relationship */
  scoreTypes_aggregate: ScoreTypes_Aggregate;
  /** fetch data from the table: "scoreTypes" using primary key columns */
  scoreTypes_by_pk?: Maybe<ScoreTypes>;
  /** fetch data from the table in a streaming manner: "scoreTypes" */
  scoreTypes_stream: Array<ScoreTypes>;
  /** fetch data from the table: "staffInvitations" */
  staffInvitations: Array<StaffInvitations>;
  /** fetch aggregated fields from the table: "staffInvitations" */
  staffInvitations_aggregate: StaffInvitations_Aggregate;
  /** fetch data from the table: "staffInvitations" using primary key columns */
  staffInvitations_by_pk?: Maybe<StaffInvitations>;
  /** fetch data from the table in a streaming manner: "staffInvitations" */
  staffInvitations_stream: Array<StaffInvitations>;
  /** fetch data from the table: "staffs" */
  staffs: Array<Staffs>;
  /** fetch aggregated fields from the table: "staffs" */
  staffs_aggregate: Staffs_Aggregate;
  /** fetch data from the table: "staffs" using primary key columns */
  staffs_by_pk?: Maybe<Staffs>;
  /** fetch data from the table in a streaming manner: "staffs" */
  staffs_stream: Array<Staffs>;
  /** fetch data from the table: "stressDiagnosisResults" */
  stressDiagnosisResults: Array<StressDiagnosisResults>;
  /** fetch aggregated fields from the table: "stressDiagnosisResults" */
  stressDiagnosisResults_aggregate: StressDiagnosisResults_Aggregate;
  /** fetch data from the table in a streaming manner: "stressDiagnosisResults" */
  stressDiagnosisResults_stream: Array<StressDiagnosisResults>;
  /** An array relationship */
  translatedGenders: Array<TranslatedGenders>;
  /** An aggregate relationship */
  translatedGenders_aggregate: TranslatedGenders_Aggregate;
  /** fetch data from the table: "translatedGenders" using primary key columns */
  translatedGenders_by_pk?: Maybe<TranslatedGenders>;
  /** fetch data from the table in a streaming manner: "translatedGenders" */
  translatedGenders_stream: Array<TranslatedGenders>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<Diagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnoses_Order_By>>;
  where?: InputMaybe<Diagnoses_Bool_Exp>;
};


export type Subscription_RootDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Diagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnoses_Order_By>>;
  where?: InputMaybe<Diagnoses_Bool_Exp>;
};


export type Subscription_RootDiagnoses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDiagnoses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Diagnoses_Stream_Cursor_Input>>;
  where?: InputMaybe<Diagnoses_Bool_Exp>;
};


export type Subscription_RootDiagnosisTypesArgs = {
  distinct_on?: InputMaybe<Array<DiagnosisTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DiagnosisTypes_Order_By>>;
  where?: InputMaybe<DiagnosisTypes_Bool_Exp>;
};


export type Subscription_RootDiagnosisTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DiagnosisTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DiagnosisTypes_Order_By>>;
  where?: InputMaybe<DiagnosisTypes_Bool_Exp>;
};


export type Subscription_RootDiagnosisTypes_By_PkArgs = {
  code: Scalars['String'];
};


export type Subscription_RootDiagnosisTypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DiagnosisTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<DiagnosisTypes_Bool_Exp>;
};


export type Subscription_RootEventAreaAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


export type Subscription_RootEventAreaAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreaAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreaAssignments_Order_By>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


export type Subscription_RootEventAreaAssignments_By_PkArgs = {
  eventAreaId: Scalars['uuid'];
  eventId: Scalars['uuid'];
};


export type Subscription_RootEventAreaAssignments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventAreaAssignments_Stream_Cursor_Input>>;
  where?: InputMaybe<EventAreaAssignments_Bool_Exp>;
};


export type Subscription_RootEventAreasArgs = {
  distinct_on?: InputMaybe<Array<EventAreas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreas_Order_By>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


export type Subscription_RootEventAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAreas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventAreas_Order_By>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


export type Subscription_RootEventAreas_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventAreas_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventAreas_Stream_Cursor_Input>>;
  where?: InputMaybe<EventAreas_Bool_Exp>;
};


export type Subscription_RootEventBeginningsArgs = {
  distinct_on?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventBeginnings_Order_By>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


export type Subscription_RootEventBeginnings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventBeginnings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventBeginnings_Order_By>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


export type Subscription_RootEventBeginnings_By_PkArgs = {
  eventId: Scalars['uuid'];
};


export type Subscription_RootEventBeginnings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventBeginnings_Stream_Cursor_Input>>;
  where?: InputMaybe<EventBeginnings_Bool_Exp>;
};


export type Subscription_RootEventDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


export type Subscription_RootEventDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventDiagnoses_Order_By>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


export type Subscription_RootEventDiagnoses_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  eventId: Scalars['uuid'];
};


export type Subscription_RootEventDiagnoses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventDiagnoses_Stream_Cursor_Input>>;
  where?: InputMaybe<EventDiagnoses_Bool_Exp>;
};


export type Subscription_RootEventExaminationCountsArgs = {
  distinct_on?: InputMaybe<Array<EventExaminationCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExaminationCounts_Order_By>>;
  where?: InputMaybe<EventExaminationCounts_Bool_Exp>;
};


export type Subscription_RootEventExaminationCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventExaminationCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExaminationCounts_Order_By>>;
  where?: InputMaybe<EventExaminationCounts_Bool_Exp>;
};


export type Subscription_RootEventExaminationCounts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventExaminationCounts_Stream_Cursor_Input>>;
  where?: InputMaybe<EventExaminationCounts_Bool_Exp>;
};


export type Subscription_RootEventExpirationsArgs = {
  distinct_on?: InputMaybe<Array<EventExpirations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExpirations_Order_By>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


export type Subscription_RootEventExpirations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventExpirations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventExpirations_Order_By>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


export type Subscription_RootEventExpirations_By_PkArgs = {
  eventId: Scalars['uuid'];
};


export type Subscription_RootEventExpirations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventExpirations_Stream_Cursor_Input>>;
  where?: InputMaybe<EventExpirations_Bool_Exp>;
};


export type Subscription_RootEventLimitTimesArgs = {
  distinct_on?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventLimitTimes_Order_By>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


export type Subscription_RootEventLimitTimes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventLimitTimes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventLimitTimes_Order_By>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


export type Subscription_RootEventLimitTimes_By_PkArgs = {
  eventId: Scalars['uuid'];
};


export type Subscription_RootEventLimitTimes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventLimitTimes_Stream_Cursor_Input>>;
  where?: InputMaybe<EventLimitTimes_Bool_Exp>;
};


export type Subscription_RootEventTagAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


export type Subscription_RootEventTagAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTagAssignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTagAssignments_Order_By>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


export type Subscription_RootEventTagAssignments_By_PkArgs = {
  eventId: Scalars['uuid'];
  eventTagId: Scalars['uuid'];
};


export type Subscription_RootEventTagAssignments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventTagAssignments_Stream_Cursor_Input>>;
  where?: InputMaybe<EventTagAssignments_Bool_Exp>;
};


export type Subscription_RootEventTagsArgs = {
  distinct_on?: InputMaybe<Array<EventTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTags_Order_By>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


export type Subscription_RootEventTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventTags_Order_By>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


export type Subscription_RootEventTags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventTags_Stream_Cursor_Input>>;
  where?: InputMaybe<EventTags_Bool_Exp>;
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnosesArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnoses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnoses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnoses_Order_By>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnoses_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
};


export type Subscription_RootExaminationDiagnoses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExaminationDiagnoses_Stream_Cursor_Input>>;
  where?: InputMaybe<ExaminationDiagnoses_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnosisAnswersArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnosisAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisAnswers_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnosisAnswers_By_PkArgs = {
  diagnosisId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
  questionId: Scalars['uuid'];
};


export type Subscription_RootExaminationDiagnosisAnswers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExaminationDiagnosisAnswers_Stream_Cursor_Input>>;
  where?: InputMaybe<ExaminationDiagnosisAnswers_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnosisScoresArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisScores_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnosisScores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ExaminationDiagnosisScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExaminationDiagnosisScores_Order_By>>;
  where?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
};


export type Subscription_RootExaminationDiagnosisScores_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExaminationDiagnosisScores_Stream_Cursor_Input>>;
  where?: InputMaybe<ExaminationDiagnosisScores_Bool_Exp>;
};


export type Subscription_RootExaminationsArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


export type Subscription_RootExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Examinations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Examinations_Order_By>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


export type Subscription_RootExaminations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootExaminations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Examinations_Stream_Cursor_Input>>;
  where?: InputMaybe<Examinations_Bool_Exp>;
};


export type Subscription_RootGendersArgs = {
  distinct_on?: InputMaybe<Array<Genders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Genders_Order_By>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Subscription_RootGenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Genders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Genders_Order_By>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Subscription_RootGenders_By_PkArgs = {
  code: Scalars['String'];
};


export type Subscription_RootGenders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Genders_Stream_Cursor_Input>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Subscription_RootGroupContentsArgs = {
  distinct_on?: InputMaybe<Array<GroupContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupContents_Order_By>>;
  where?: InputMaybe<GroupContents_Bool_Exp>;
};


export type Subscription_RootGroupContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupContents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupContents_Order_By>>;
  where?: InputMaybe<GroupContents_Bool_Exp>;
};


export type Subscription_RootGroupContents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupContents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GroupContents_Stream_Cursor_Input>>;
  where?: InputMaybe<GroupContents_Bool_Exp>;
};


export type Subscription_RootGroupInvitationsArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


export type Subscription_RootGroupInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


export type Subscription_RootGroupInvitations_By_PkArgs = {
  email: Scalars['String'];
  groupId: Scalars['uuid'];
};


export type Subscription_RootGroupInvitations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GroupInvitations_Stream_Cursor_Input>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


export type Subscription_RootGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootGroups_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootGuestExamineeExaminationsArgs = {
  distinct_on?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExamineeExaminations_Order_By>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


export type Subscription_RootGuestExamineeExaminations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExamineeExaminations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExamineeExaminations_Order_By>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


export type Subscription_RootGuestExamineeExaminations_By_PkArgs = {
  guestExamineeId: Scalars['uuid'];
};


export type Subscription_RootGuestExamineeExaminations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GuestExamineeExaminations_Stream_Cursor_Input>>;
  where?: InputMaybe<GuestExamineeExaminations_Bool_Exp>;
};


export type Subscription_RootGuestExamineesArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


export type Subscription_RootGuestExaminees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GuestExaminees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GuestExaminees_Order_By>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


export type Subscription_RootGuestExaminees_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGuestExaminees_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GuestExaminees_Stream_Cursor_Input>>;
  where?: InputMaybe<GuestExaminees_Bool_Exp>;
};


export type Subscription_RootInactiveGroupEventsArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroupEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroupEvents_Order_By>>;
  where?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
};


export type Subscription_RootInactiveGroupEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroupEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroupEvents_Order_By>>;
  where?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
};


export type Subscription_RootInactiveGroupEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInactiveGroupEvents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InactiveGroupEvents_Stream_Cursor_Input>>;
  where?: InputMaybe<InactiveGroupEvents_Bool_Exp>;
};


export type Subscription_RootInactiveGroupsArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroups_Order_By>>;
  where?: InputMaybe<InactiveGroups_Bool_Exp>;
};


export type Subscription_RootInactiveGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InactiveGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InactiveGroups_Order_By>>;
  where?: InputMaybe<InactiveGroups_Bool_Exp>;
};


export type Subscription_RootInactiveGroups_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInactiveGroups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InactiveGroups_Stream_Cursor_Input>>;
  where?: InputMaybe<InactiveGroups_Bool_Exp>;
};


export type Subscription_RootLanguagesArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_By_PkArgs = {
  code: Scalars['String'];
};


export type Subscription_RootLanguages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Languages_Stream_Cursor_Input>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


export type Subscription_RootMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


export type Subscription_RootMemberships_By_PkArgs = {
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
};


export type Subscription_RootMemberships_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Memberships_Stream_Cursor_Input>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


export type Subscription_RootMonthlyExaminationCountsArgs = {
  distinct_on?: InputMaybe<Array<MonthlyExaminationCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonthlyExaminationCounts_Order_By>>;
  where?: InputMaybe<MonthlyExaminationCounts_Bool_Exp>;
};


export type Subscription_RootMonthlyExaminationCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonthlyExaminationCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonthlyExaminationCounts_Order_By>>;
  where?: InputMaybe<MonthlyExaminationCounts_Bool_Exp>;
};


export type Subscription_RootMonthlyExaminationCounts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MonthlyExaminationCounts_Stream_Cursor_Input>>;
  where?: InputMaybe<MonthlyExaminationCounts_Bool_Exp>;
};


export type Subscription_RootOwnershipsArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


export type Subscription_RootOwnerships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


export type Subscription_RootOwnerships_By_PkArgs = {
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
};


export type Subscription_RootOwnerships_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ownerships_Stream_Cursor_Input>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


export type Subscription_RootPersonalityDiagnosisResultCountsArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Subscription_RootPersonalityDiagnosisResultCountsRecordsArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Subscription_RootPersonalityDiagnosisResultCountsRecords_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Subscription_RootPersonalityDiagnosisResultCountsRecords_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PersonalityDiagnosisResultCountsRecords_Stream_Cursor_Input>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Subscription_RootPersonalityDiagnosisResultCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResultCountsRecords_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResultCountsRecords_Bool_Exp>;
};


export type Subscription_RootPersonalityDiagnosisResultsArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResults_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootPersonalityDiagnosisResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PersonalityDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PersonalityDiagnosisResults_Order_By>>;
  where?: InputMaybe<PersonalityDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootPersonalityDiagnosisResults_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PersonalityDiagnosisResults_Stream_Cursor_Input>>;
  where?: InputMaybe<PersonalityDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootQuestionChoicesArgs = {
  distinct_on?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionChoices_Order_By>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};


export type Subscription_RootQuestionChoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<QuestionChoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionChoices_Order_By>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};


export type Subscription_RootQuestionChoices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootQuestionChoices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<QuestionChoices_Stream_Cursor_Input>>;
  where?: InputMaybe<QuestionChoices_Bool_Exp>;
};


export type Subscription_RootQuestionScoresArgs = {
  distinct_on?: InputMaybe<Array<QuestionScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionScores_Order_By>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};


export type Subscription_RootQuestionScores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<QuestionScores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuestionScores_Order_By>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};


export type Subscription_RootQuestionScores_By_PkArgs = {
  questionChoiceId: Scalars['uuid'];
  scoreTypeCode: Scalars['String'];
};


export type Subscription_RootQuestionScores_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<QuestionScores_Stream_Cursor_Input>>;
  where?: InputMaybe<QuestionScores_Bool_Exp>;
};


export type Subscription_RootQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Subscription_RootQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Subscription_RootQuestions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootQuestions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Subscription_RootResilienceDiagnosisResultsArgs = {
  distinct_on?: InputMaybe<Array<ResilienceDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResilienceDiagnosisResults_Order_By>>;
  where?: InputMaybe<ResilienceDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootResilienceDiagnosisResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ResilienceDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResilienceDiagnosisResults_Order_By>>;
  where?: InputMaybe<ResilienceDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootResilienceDiagnosisResults_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ResilienceDiagnosisResults_Stream_Cursor_Input>>;
  where?: InputMaybe<ResilienceDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootScoreTypesArgs = {
  distinct_on?: InputMaybe<Array<ScoreTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScoreTypes_Order_By>>;
  where?: InputMaybe<ScoreTypes_Bool_Exp>;
};


export type Subscription_RootScoreTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ScoreTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScoreTypes_Order_By>>;
  where?: InputMaybe<ScoreTypes_Bool_Exp>;
};


export type Subscription_RootScoreTypes_By_PkArgs = {
  code: Scalars['String'];
  diagnosisId: Scalars['uuid'];
};


export type Subscription_RootScoreTypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ScoreTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<ScoreTypes_Bool_Exp>;
};


export type Subscription_RootStaffInvitationsArgs = {
  distinct_on?: InputMaybe<Array<StaffInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaffInvitations_Order_By>>;
  where?: InputMaybe<StaffInvitations_Bool_Exp>;
};


export type Subscription_RootStaffInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StaffInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaffInvitations_Order_By>>;
  where?: InputMaybe<StaffInvitations_Bool_Exp>;
};


export type Subscription_RootStaffInvitations_By_PkArgs = {
  email: Scalars['String'];
};


export type Subscription_RootStaffInvitations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StaffInvitations_Stream_Cursor_Input>>;
  where?: InputMaybe<StaffInvitations_Bool_Exp>;
};


export type Subscription_RootStaffsArgs = {
  distinct_on?: InputMaybe<Array<Staffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Staffs_Order_By>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};


export type Subscription_RootStaffs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Staffs_Order_By>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};


export type Subscription_RootStaffs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootStaffs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Staffs_Stream_Cursor_Input>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};


export type Subscription_RootStressDiagnosisResultsArgs = {
  distinct_on?: InputMaybe<Array<StressDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StressDiagnosisResults_Order_By>>;
  where?: InputMaybe<StressDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootStressDiagnosisResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StressDiagnosisResults_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StressDiagnosisResults_Order_By>>;
  where?: InputMaybe<StressDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootStressDiagnosisResults_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StressDiagnosisResults_Stream_Cursor_Input>>;
  where?: InputMaybe<StressDiagnosisResults_Bool_Exp>;
};


export type Subscription_RootTranslatedGendersArgs = {
  distinct_on?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TranslatedGenders_Order_By>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};


export type Subscription_RootTranslatedGenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TranslatedGenders_Order_By>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};


export type Subscription_RootTranslatedGenders_By_PkArgs = {
  genderCode: Genders_Enum;
  languageCode: Languages_Enum;
};


export type Subscription_RootTranslatedGenders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TranslatedGenders_Stream_Cursor_Input>>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** columns and relationships of "translatedGenders" */
export type TranslatedGenders = {
  __typename?: 'translatedGenders';
  /** An object relationship */
  gender?: Maybe<Genders>;
  genderCode: Genders_Enum;
  /** An object relationship */
  language?: Maybe<Languages>;
  languageCode: Languages_Enum;
  text: Scalars['String'];
};

/** aggregated selection of "translatedGenders" */
export type TranslatedGenders_Aggregate = {
  __typename?: 'translatedGenders_aggregate';
  aggregate?: Maybe<TranslatedGenders_Aggregate_Fields>;
  nodes: Array<TranslatedGenders>;
};

export type TranslatedGenders_Aggregate_Bool_Exp = {
  count?: InputMaybe<TranslatedGenders_Aggregate_Bool_Exp_Count>;
};

export type TranslatedGenders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TranslatedGenders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "translatedGenders" */
export type TranslatedGenders_Aggregate_Fields = {
  __typename?: 'translatedGenders_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TranslatedGenders_Max_Fields>;
  min?: Maybe<TranslatedGenders_Min_Fields>;
};


/** aggregate fields of "translatedGenders" */
export type TranslatedGenders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TranslatedGenders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "translatedGenders" */
export type TranslatedGenders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TranslatedGenders_Max_Order_By>;
  min?: InputMaybe<TranslatedGenders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "translatedGenders" */
export type TranslatedGenders_Arr_Rel_Insert_Input = {
  data: Array<TranslatedGenders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TranslatedGenders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "translatedGenders". All fields are combined with a logical 'AND'. */
export type TranslatedGenders_Bool_Exp = {
  _and?: InputMaybe<Array<TranslatedGenders_Bool_Exp>>;
  _not?: InputMaybe<TranslatedGenders_Bool_Exp>;
  _or?: InputMaybe<Array<TranslatedGenders_Bool_Exp>>;
  gender?: InputMaybe<Genders_Bool_Exp>;
  genderCode?: InputMaybe<Genders_Enum_Comparison_Exp>;
  language?: InputMaybe<Languages_Bool_Exp>;
  languageCode?: InputMaybe<Languages_Enum_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "translatedGenders" */
export enum TranslatedGenders_Constraint {
  /** unique or primary key constraint on columns "languageCode", "genderCode" */
  TranslatedGendersPkey = 'translatedGenders_pkey'
}

/** input type for inserting data into table "translatedGenders" */
export type TranslatedGenders_Insert_Input = {
  gender?: InputMaybe<Genders_Obj_Rel_Insert_Input>;
  genderCode?: InputMaybe<Genders_Enum>;
  language?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  languageCode?: InputMaybe<Languages_Enum>;
  text?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TranslatedGenders_Max_Fields = {
  __typename?: 'translatedGenders_max_fields';
  text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "translatedGenders" */
export type TranslatedGenders_Max_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TranslatedGenders_Min_Fields = {
  __typename?: 'translatedGenders_min_fields';
  text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "translatedGenders" */
export type TranslatedGenders_Min_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "translatedGenders" */
export type TranslatedGenders_Mutation_Response = {
  __typename?: 'translatedGenders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TranslatedGenders>;
};

/** on_conflict condition type for table "translatedGenders" */
export type TranslatedGenders_On_Conflict = {
  constraint: TranslatedGenders_Constraint;
  update_columns?: Array<TranslatedGenders_Update_Column>;
  where?: InputMaybe<TranslatedGenders_Bool_Exp>;
};

/** Ordering options when selecting data from "translatedGenders". */
export type TranslatedGenders_Order_By = {
  gender?: InputMaybe<Genders_Order_By>;
  genderCode?: InputMaybe<Order_By>;
  language?: InputMaybe<Languages_Order_By>;
  languageCode?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: translatedGenders */
export type TranslatedGenders_Pk_Columns_Input = {
  genderCode: Genders_Enum;
  languageCode: Languages_Enum;
};

/** select columns of table "translatedGenders" */
export enum TranslatedGenders_Select_Column {
  /** column name */
  GenderCode = 'genderCode',
  /** column name */
  LanguageCode = 'languageCode',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "translatedGenders" */
export type TranslatedGenders_Set_Input = {
  genderCode?: InputMaybe<Genders_Enum>;
  languageCode?: InputMaybe<Languages_Enum>;
  text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "translatedGenders" */
export type TranslatedGenders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TranslatedGenders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TranslatedGenders_Stream_Cursor_Value_Input = {
  genderCode?: InputMaybe<Genders_Enum>;
  languageCode?: InputMaybe<Languages_Enum>;
  text?: InputMaybe<Scalars['String']>;
};

/** update columns of table "translatedGenders" */
export enum TranslatedGenders_Update_Column {
  /** column name */
  GenderCode = 'genderCode',
  /** column name */
  LanguageCode = 'languageCode',
  /** column name */
  Text = 'text'
}

export type TranslatedGenders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TranslatedGenders_Set_Input>;
  /** filter the rows which have to be updated */
  where: TranslatedGenders_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An array relationship */
  _staffs: Array<Staffs>;
  /** An aggregate relationship */
  _staffs_aggregate: Staffs_Aggregate;
  email: Scalars['String'];
  /** An array relationship */
  groupInvitations: Array<GroupInvitations>;
  /** An aggregate relationship */
  groupInvitations_aggregate: GroupInvitations_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  memberships: Array<Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: Memberships_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  ownerships: Array<Ownerships>;
  /** An aggregate relationship */
  ownerships_aggregate: Ownerships_Aggregate;
  /** An object relationship */
  staff?: Maybe<Staffs>;
  uid: Scalars['String'];
};


/** columns and relationships of "users" */
export type Users_StaffsArgs = {
  distinct_on?: InputMaybe<Array<Staffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Staffs_Order_By>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type Users_Staffs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Staffs_Order_By>>;
  where?: InputMaybe<Staffs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroupInvitationsArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroupInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GroupInvitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GroupInvitations_Order_By>>;
  where?: InputMaybe<GroupInvitations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Memberships_Order_By>>;
  where?: InputMaybe<Memberships_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOwnershipsArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOwnerships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownerships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownerships_Order_By>>;
  where?: InputMaybe<Ownerships_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  _staffs?: InputMaybe<Staffs_Bool_Exp>;
  _staffs_aggregate?: InputMaybe<Staffs_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  groupInvitations?: InputMaybe<GroupInvitations_Bool_Exp>;
  groupInvitations_aggregate?: InputMaybe<GroupInvitations_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  memberships?: InputMaybe<Memberships_Bool_Exp>;
  memberships_aggregate?: InputMaybe<Memberships_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ownerships?: InputMaybe<Ownerships_Bool_Exp>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Bool_Exp>;
  staff?: InputMaybe<Staffs_Bool_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailUniqueness = 'users_email_uniqueness',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint on columns "uid" */
  UsersUidUniqueness = 'users_uid_uniqueness'
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  _staffs?: InputMaybe<Staffs_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  groupInvitations?: InputMaybe<GroupInvitations_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  memberships?: InputMaybe<Memberships_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  ownerships?: InputMaybe<Ownerships_Arr_Rel_Insert_Input>;
  staff?: InputMaybe<Staffs_Obj_Rel_Insert_Input>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  _staffs_aggregate?: InputMaybe<Staffs_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  groupInvitations_aggregate?: InputMaybe<GroupInvitations_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  memberships_aggregate?: InputMaybe<Memberships_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  ownerships_aggregate?: InputMaybe<Ownerships_Aggregate_Order_By>;
  staff?: InputMaybe<Staffs_Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Uid = 'uid'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Uid = 'uid'
}

export type Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type DeleteClientUserMutationVariables = Exact<{
  userId: Scalars['uuid'];
  groupId: Scalars['uuid'];
}>;


export type DeleteClientUserMutation = { __typename?: 'mutation_root', delete_memberships_by_pk?: { __typename?: 'memberships', userId: UuidString, groupId: UuidString } | null };

export type InsertClientUserMutationVariables = Exact<{
  groupId: Scalars['uuid'];
  email: Scalars['String'];
  name: Scalars['String'];
  isOwner: Scalars['Boolean'];
}>;


export type InsertClientUserMutation = { __typename?: 'mutation_root', InsertMembershipsOneDerived?: { __typename?: 'InsertMembershipsOneDerivedOutput', groupId: UuidString, userId: UuidString } | null };

export type DeleteStaffMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteStaffMutation = { __typename?: 'mutation_root', delete_staffs_by_pk?: { __typename?: 'staffs', id: UuidString } | null };

export type InsertStaffMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
}>;


export type InsertStaffMutation = { __typename?: 'mutation_root', InsertStaffsOneDerived?: { __typename?: 'InsertStaffsOneDerivedOutput', id: UuidString, staffInvitation?: { __typename?: 'staffInvitations', email: string, name: string } | null } | null };

export type InsertClientMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type InsertClientMutation = { __typename?: 'mutation_root', insert_groups_one?: { __typename?: 'groups', id: UuidString, name: string } | null };

export type FetchClientListQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchClientListQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'groups', id: UuidString, name: string, memberships_aggregate: { __typename?: 'memberships_aggregate', aggregate?: { __typename?: 'memberships_aggregate_fields', count: number } | null }, inactiveGroup?: { __typename?: 'inactiveGroups', id: UuidString } | null }> };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteEventMutation = { __typename?: 'mutation_root', delete_events_by_pk?: { __typename?: 'events', id: UuidString } | null };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  enableFileUpload: Scalars['Boolean'];
  fileUploadDescription: Scalars['String'];
  fileUploadType: Scalars['String'];
  areaObjects: Array<EventAreaAssignments_Insert_Input> | EventAreaAssignments_Insert_Input;
  tagObjects: Array<EventTagAssignments_Insert_Input> | EventTagAssignments_Insert_Input;
}>;


export type UpdateEventMutation = { __typename?: 'mutation_root', update_events_by_pk?: { __typename?: 'events', name: string, enableFileUpload: boolean, fileUploadDescription: string, fileUploadType: string } | null, insert_eventAreaAssignments?: { __typename?: 'eventAreaAssignments_mutation_response', affected_rows: number } | null, insert_eventTagAssignments?: { __typename?: 'eventTagAssignments_mutation_response', affected_rows: number } | null };

export type InsertEventBeginningMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  timestamp: Scalars['timestamp'];
}>;


export type InsertEventBeginningMutation = { __typename?: 'mutation_root', insert_eventBeginnings_one?: { __typename?: 'eventBeginnings', eventId: UuidString, groupId: UuidString, timestamp: TimestampString } | null };

export type DeleteEventBeginningMutationVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type DeleteEventBeginningMutation = { __typename?: 'mutation_root', delete_eventBeginnings_by_pk?: { __typename?: 'eventBeginnings', eventId: UuidString, groupId: UuidString, timestamp: TimestampString } | null };

export type InsertEventExpirationMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  timestamp: Scalars['timestamp'];
}>;


export type InsertEventExpirationMutation = { __typename?: 'mutation_root', insert_eventExpirations_one?: { __typename?: 'eventExpirations', eventId: UuidString, groupId: UuidString, timestamp: TimestampString } | null };

export type DeleteEventExpirationMutationVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type DeleteEventExpirationMutation = { __typename?: 'mutation_root', delete_eventExpirations_by_pk?: { __typename?: 'eventExpirations', eventId: UuidString, groupId: UuidString, timestamp: TimestampString } | null };

export type InsertEventLimitTimeMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  value: Scalars['bigint'];
}>;


export type InsertEventLimitTimeMutation = { __typename?: 'mutation_root', insert_eventLimitTimes_one?: { __typename?: 'eventLimitTimes', eventId: UuidString, groupId: UuidString, value: number } | null };

export type DeleteEventLimitTimeMutationVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type DeleteEventLimitTimeMutation = { __typename?: 'mutation_root', delete_eventLimitTimes_by_pk?: { __typename?: 'eventLimitTimes', eventId: UuidString, groupId: UuidString, value: number } | null };

export type InsertInactiveGroupEventMutationVariables = Exact<{
  id: Scalars['uuid'];
  groupId: Scalars['uuid'];
}>;


export type InsertInactiveGroupEventMutation = { __typename?: 'mutation_root', insert_inactiveGroupEvents_one?: { __typename?: 'inactiveGroupEvents', id: UuidString, groupId: UuidString } | null };

export type DeleteInactiveGroupEventMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteInactiveGroupEventMutation = { __typename?: 'mutation_root', delete_inactiveGroupEvents_by_pk?: { __typename?: 'inactiveGroupEvents', id: UuidString, groupId: UuidString } | null };

export type InsertEventMutationVariables = Exact<{
  object: Events_Insert_Input;
}>;


export type InsertEventMutation = { __typename?: 'mutation_root', insert_events_one?: { __typename?: 'events', id: UuidString, name: string, eventTagAssignments: Array<{ __typename?: 'eventTagAssignments', eventTag?: { __typename?: 'eventTags', name: string } | null }>, eventAreaAssignments: Array<{ __typename?: 'eventAreaAssignments', eventArea?: { __typename?: 'eventAreas', name: string } | null }> } | null };

export type DeleteExaminationMutationVariables = Exact<{
  guestExamineeId: Scalars['uuid'];
  examinationId: Scalars['uuid'];
}>;


export type DeleteExaminationMutation = { __typename?: 'mutation_root', delete_guestExaminees_by_pk?: { __typename?: 'guestExaminees', id: UuidString } | null, delete_examinations_by_pk?: { __typename?: 'examinations', id: UuidString } | null };

export type FetchDiagnoseListQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDiagnoseListQuery = { __typename?: 'query_root', diagnoses: Array<{ __typename?: 'diagnoses', id: UuidString, name: string, questions_aggregate: { __typename?: 'questions_aggregate', aggregate?: { __typename?: 'questions_aggregate_fields', count: number } | null } }> };

export type FetchStaffListQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchStaffListQuery = { __typename?: 'query_root', staffs: Array<{ __typename?: 'staffs', id: UuidString, staffInvitation?: { __typename?: 'staffInvitations', email: string, name: string } | null, user?: { __typename?: 'users', email: string, name: string } | null }> };

export type InsertGuestExamineesMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  guestExaminees: Array<InsertGuestExaineesDerivedInput> | InsertGuestExaineesDerivedInput;
}>;


export type InsertGuestExamineesMutation = { __typename?: 'mutation_root', InsertGuestExamineesDerived?: { __typename?: 'InsertGuestExamineesDerivedOutput', guestExamineeIds: Array<UuidString> } | null };

export type UpdateGuestExamineeMutationVariables = Exact<{
  id: Scalars['uuid'];
  email: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateGuestExamineeMutation = { __typename?: 'mutation_root', guestExmaminee?: { __typename?: 'guestExaminees', email: string, name: string } | null };

export type InsertGuestExamineeMailsMutationVariables = Exact<{
  guestExamineeIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type InsertGuestExamineeMailsMutation = { __typename?: 'mutation_root', mails?: { __typename?: 'InsertGuestExamineeMailsOutput', guestExamineeIds: Array<UuidString> } | null };

export type InsertGuestExamineeMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  guestExaminees: Array<InsertGuestExaineesDerivedInput> | InsertGuestExaineesDerivedInput;
}>;


export type InsertGuestExamineeMutation = { __typename?: 'mutation_root', InsertGuestExamineesDerived?: { __typename?: 'InsertGuestExamineesDerivedOutput', guestExamineeIds: Array<UuidString> } | null };

export type FetchGuestEventByIdQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  guestExamineeIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type FetchGuestEventByIdQuery = { __typename?: 'query_root', event?: { __typename?: 'events', id: UuidString, groupId: UuidString, name: string, enableFileUpload: boolean, fileUploadDescription: string, fileUploadType: string, public: boolean, group: { __typename?: 'groups', name: string, groupContent?: { __typename?: 'groupContents', imagePath: string } | null }, eventDiagnoses: Array<{ __typename?: 'eventDiagnoses', diagnosis: { __typename?: 'diagnoses', name: string, questions: Array<{ __typename?: 'questions', text: string, id: UuidString, diagnosisId: UuidString, diagnosis?: { __typename?: 'diagnoses', name: string } | null, questionChoices: Array<{ __typename?: 'questionChoices', text: string, id: UuidString }> }> } }>, guestExaminees: Array<{ __typename?: 'guestExaminees', id: UuidString }> } | null };

export type FetchGroupEventListQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['uuid']>;
}>;


export type FetchGroupEventListQuery = { __typename?: 'query_root', diagnoses: Array<{ __typename?: 'diagnoses', id: UuidString, name: string }>, events: Array<{ __typename?: 'events', id: UuidString, name: string, groupId: UuidString, group: { __typename?: 'groups', name: string }, eventTagAssignments: Array<{ __typename?: 'eventTagAssignments', eventTag?: { __typename?: 'eventTags', name: string } | null }>, inactiveGroupEvent?: { __typename?: 'inactiveGroupEvents', id: UuidString } | null, guestExaminees_aggregate: { __typename?: 'guestExaminees_aggregate', aggregate?: { __typename?: 'guestExaminees_aggregate_fields', count: number } | null }, eventDiagnoses: Array<{ __typename?: 'eventDiagnoses', diagnosis: { __typename?: 'diagnoses', name: string } }> }> };

export type GroupExamineesQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where: GuestExaminees_Bool_Exp;
}>;


export type GroupExamineesQuery = { __typename?: 'query_root', guestExaminees: { __typename?: 'guestExaminees_aggregate', aggregate?: { __typename?: 'guestExaminees_aggregate_fields', count: number } | null, nodes: Array<{ __typename?: 'guestExaminees', email: string, guestExaminees_aggregate: { __typename?: 'guestExaminees_aggregate', aggregate?: { __typename?: 'guestExaminees_aggregate_fields', count: number } | null }, guestExaminees: Array<{ __typename?: 'guestExaminees', name: string, guestExamineeExamination?: { __typename?: 'guestExamineeExaminations', examination?: { __typename?: 'examinations', timestamp: TimestampString, id: UuidString } | null } | null }> }> }, guestExaminees_aggregate: { __typename?: 'guestExaminees_aggregate', aggregate?: { __typename?: 'guestExaminees_aggregate_fields', count: number } | null } };

export type FetchClientQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type FetchClientQuery = { __typename?: 'query_root', group?: { __typename?: 'groups', id: UuidString, name: string, groupContent?: { __typename?: 'groupContents', imagePath: string } | null, inactiveGroup?: { __typename?: 'inactiveGroups', id: UuidString } | null, memberships: Array<{ __typename?: 'memberships', groupId: UuidString, userId: UuidString, groupInvitation?: { __typename?: 'groupInvitations', name: string, email: string } | null, user?: { __typename?: 'users', name: string, email: string } | null }> } | null };

export type FetchEventQueryVariables = Exact<{
  id: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  examinationsWhere: Examinations_Bool_Exp;
}>;


export type FetchEventQuery = { __typename?: 'query_root', event?: { __typename?: 'events', id: UuidString, name: string, enableFileUpload: boolean, fileUploadDescription: string, fileUploadType: string, public: boolean, group: { __typename?: 'groups', id: UuidString, name: string }, eventTagAssignments: Array<{ __typename?: 'eventTagAssignments', eventTag?: { __typename?: 'eventTags', name: string } | null }>, eventAreaAssignments: Array<{ __typename?: 'eventAreaAssignments', eventArea?: { __typename?: 'eventAreas', name: string } | null }>, eventBeginning?: { __typename?: 'eventBeginnings', timestamp: TimestampString } | null, eventExpiration?: { __typename?: 'eventExpirations', timestamp: TimestampString } | null, eventLimitTime?: { __typename?: 'eventLimitTimes', value: number } | null, inactiveGroupEvent?: { __typename?: 'inactiveGroupEvents', id: UuidString } | null, eventDiagnoses: Array<{ __typename?: 'eventDiagnoses', diagnosis: { __typename?: 'diagnoses', id: UuidString, name: string } }>, examinations: Array<{ __typename?: 'examinations', id: UuidString, timestamp: TimestampString, guestExamineeExamination?: { __typename?: 'guestExamineeExaminations', guestExaminee?: { __typename?: 'guestExaminees', email: string, name: string } | null } | null, examinationDiagnoses: Array<{ __typename?: 'examinationDiagnoses', diagnosisId: UuidString, personalityDiagnosisResult?: { __typename?: 'personalityDiagnosisResults', A?: number | null, Att?: number | null, C?: number | null, E?: number | null, F?: number | null, N?: number | null, O?: number | null, basicCode?: string | null, code?: string | null } | null, resilienceDiagnosisResult?: { __typename?: 'resilienceDiagnosisResults', proactiveness?: number | null, thoughtfulness?: number | null } | null, stressDiagnosisResult?: { __typename?: 'stressDiagnosisResults', A?: number | null, B?: number | null, C?: number | null } | null }> }>, guestExaminees: Array<{ __typename?: 'guestExaminees', id: UuidString, email: string, name: string }>, examinations_aggregate: { __typename?: 'examinations_aggregate', aggregate?: { __typename?: 'examinations_aggregate_fields', count: number } | null } } | null };

export type FetchEventListQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchEventListQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'groups', id: UuidString, name: string }>, diagnoses: Array<{ __typename?: 'diagnoses', id: UuidString, name: string }>, events: Array<{ __typename?: 'events', id: UuidString, groupId: UuidString, name: string, group: { __typename?: 'groups', name: string }, eventTagAssignments: Array<{ __typename?: 'eventTagAssignments', eventTag?: { __typename?: 'eventTags', name: string } | null }>, inactiveGroupEvent?: { __typename?: 'inactiveGroupEvents', id: UuidString } | null, guestExaminees_aggregate: { __typename?: 'guestExaminees_aggregate', aggregate?: { __typename?: 'guestExaminees_aggregate_fields', count: number } | null }, eventDiagnoses: Array<{ __typename?: 'eventDiagnoses', diagnosis: { __typename?: 'diagnoses', name: string } }> }> };

export type FetchExaminationByIdQueryVariables = Exact<{
  examinationId: Scalars['uuid'];
}>;


export type FetchExaminationByIdQuery = { __typename?: 'query_root', examination?: { __typename?: 'examinations', id: UuidString, eventId: UuidString, groupId: UuidString, timestamp: TimestampString, event?: { __typename?: 'events', name: string, enableFileUpload: boolean, group: { __typename?: 'groups', name: string } } | null, guestExamineeExamination?: { __typename?: 'guestExamineeExaminations', guestExaminee?: { __typename?: 'guestExaminees', name: string, email: string } | null } | null, gender?: { __typename?: 'genders', translatedGenders: Array<{ __typename?: 'translatedGenders', text: string, languageCode: Languages_Enum }> } | null, examinationDiagnoses: Array<{ __typename?: 'examinationDiagnoses', diagnosisId: UuidString, eventDiagnosis?: { __typename?: 'eventDiagnoses', diagnosis: { __typename?: 'diagnoses', name: string } } | null, examinationDiagnosisAnswers: Array<{ __typename?: 'examinationDiagnosisAnswers', questionChoiceId: UuidString, question?: { __typename?: 'questions', text: string, questionChoices: Array<{ __typename?: 'questionChoices', text: string, id: UuidString, questionScores: Array<{ __typename?: 'questionScores', scoreTypeCode: string, value: number }> }> } | null }>, personalityDiagnosisResult?: { __typename?: 'personalityDiagnosisResults', A?: number | null, Att?: number | null, C?: number | null, E?: number | null, F?: number | null, N?: number | null, O?: number | null, basicCode?: string | null, code?: string | null } | null, resilienceDiagnosisResult?: { __typename?: 'resilienceDiagnosisResults', thoughtfulness?: number | null, proactiveness?: number | null, behavior?: string | null, S4?: number | null, S3?: number | null, S2?: number | null, S1?: number | null, H4?: number | null, H3?: number | null, H2?: number | null, H1?: number | null } | null, stressDiagnosisResult?: { __typename?: 'stressDiagnosisResults', A?: number | null, B?: number | null, C?: number | null, resilience?: number | null, resilienceGrade?: string | null } | null }> } | null };

export type FetchExaminationsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type FetchExaminationsQuery = { __typename?: 'query_root', examinations: Array<{ __typename?: 'examinations', id: UuidString, timestamp: TimestampString, guestExamineeExamination?: { __typename?: 'guestExamineeExaminations', guestExaminee?: { __typename?: 'guestExaminees', id: UuidString, name: string, email: string } | null } | null, group?: { __typename?: 'groups', name: string } | null, event?: { __typename?: 'events', name: string, eventDiagnoses: Array<{ __typename?: 'eventDiagnoses', diagnosis: { __typename?: 'diagnoses', name: string } }> } | null }> };

export type ExamineesQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where: GuestExaminees_Bool_Exp;
}>;


export type ExamineesQuery = { __typename?: 'query_root', guestExaminees: { __typename?: 'guestExaminees_aggregate', nodes: Array<{ __typename?: 'guestExaminees', email: string, guestExaminees_aggregate: { __typename?: 'guestExaminees_aggregate', aggregate?: { __typename?: 'guestExaminees_aggregate_fields', count: number } | null }, guestExaminees: Array<{ __typename?: 'guestExaminees', name: string, guestExamineeExamination?: { __typename?: 'guestExamineeExaminations', examination?: { __typename?: 'examinations', timestamp: TimestampString, id: UuidString } | null } | null }> }> }, guestExaminees_aggregate: { __typename?: 'guestExaminees_aggregate', aggregate?: { __typename?: 'guestExaminees_aggregate_fields', count: number } | null } };

export type StaffDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffDashboardQuery = { __typename?: 'query_root', groups_aggregate: { __typename?: 'groups_aggregate', aggregate?: { __typename?: 'groups_aggregate_fields', count: number } | null }, memberships_aggregate: { __typename?: 'memberships_aggregate', aggregate?: { __typename?: 'memberships_aggregate_fields', count: number } | null }, diagnoses_aggregate: { __typename?: 'diagnoses_aggregate', aggregate?: { __typename?: 'diagnoses_aggregate_fields', count: number } | null } };

export type UserDashboardQueryVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type UserDashboardQuery = { __typename?: 'query_root', personalityDiagnosisResultCounts: Array<{ __typename?: 'personalityDiagnosisResultCountsRecords', groupId?: UuidString | null, count?: number | null, basicCode?: string | null }>, monthlyExaminationCounts: Array<{ __typename?: 'monthlyExaminationCounts', month?: TimestampString | null, groupId?: UuidString | null, count?: number | null }>, group?: { __typename?: 'groups', events: Array<{ __typename?: 'events', name: string, examinations_aggregate: { __typename?: 'examinations_aggregate', aggregate?: { __typename?: 'examinations_aggregate_fields', count: number } | null } }>, examinations: Array<{ __typename?: 'examinations', id: UuidString, timestamp: TimestampString, event?: { __typename?: 'events', name: string } | null, guestExamineeExamination?: { __typename?: 'guestExamineeExaminations', guestExaminee?: { __typename?: 'guestExaminees', name: string, email: string } | null } | null }> } | null };

export type InsertGroupContentMutationVariables = Exact<{
  id: Scalars['uuid'];
  imagePath: Scalars['String'];
}>;


export type InsertGroupContentMutation = { __typename?: 'mutation_root', insert_groupContents_one?: { __typename?: 'groupContents', imagePath: string } | null };

export type InsertInactiveGroupMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type InsertInactiveGroupMutation = { __typename?: 'mutation_root', insert_inactiveGroups_one?: { __typename?: 'inactiveGroups', id: UuidString } | null };

export type DeleteInactiveGroupMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteInactiveGroupMutation = { __typename?: 'mutation_root', delete_inactiveGroups_by_pk?: { __typename?: 'inactiveGroups', id: UuidString } | null };

export type InsertExaminationMutationVariables = Exact<{
  guestExaminees: Array<GuestExaminees_Insert_Input> | GuestExaminees_Insert_Input;
  examinations: Array<Examinations_Insert_Input> | Examinations_Insert_Input;
}>;


export type InsertExaminationMutation = { __typename?: 'mutation_root', insert_guestExaminees?: { __typename?: 'guestExaminees_mutation_response', affected_rows: number } | null, insert_examinations?: { __typename?: 'examinations_mutation_response', affected_rows: number } | null };

export type FetchDiagnoseQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type FetchDiagnoseQuery = { __typename?: 'query_root', diagnose?: { __typename?: 'diagnoses', id: UuidString, name: string, questions: Array<{ __typename?: 'questions', id: UuidString, text: string, questionChoices: Array<{ __typename?: 'questionChoices', text: string, questionScores: Array<{ __typename?: 'questionScores', scoreTypeCode: string, value: number }> }> }> } | null };

export type FetchUserByPkQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type FetchUserByPkQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: UuidString, uid: string, email: string, name: string, memberships: Array<{ __typename?: 'memberships', groupId: UuidString }> } | null };

export type FetchMembershipsByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type FetchMembershipsByUserIdQuery = { __typename?: 'query_root', memberships: Array<{ __typename?: 'memberships', groupId: UuidString }> };

import { IntrospectionQuery } from 'graphql';
export default {
  "__schema": {
    "queryType": {
      "name": "query_root"
    },
    "mutationType": {
      "name": "mutation_root"
    },
    "subscriptionType": {
      "name": "subscription_root"
    },
    "types": [
      {
        "kind": "OBJECT",
        "name": "InsertGuestExamineeMailsOutput",
        "fields": [
          {
            "name": "guestExamineeIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InsertGuestExamineesDerivedOutput",
        "fields": [
          {
            "name": "guestExamineeIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InsertMembershipsOneDerivedOutput",
        "fields": [
          {
            "name": "User",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "groupInvitation",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ownership",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InsertStaffsOneDerivedOutput",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "staffInvitation",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnoses",
        "fields": [
          {
            "name": "diagnosisType",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "diagnosisTypeCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "eventDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questions_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questions_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "scoreTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "scoreTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "scoreTypes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "scoreTypes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnoses_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnoses_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnoses_max_fields",
        "fields": [
          {
            "name": "diagnosisTypeCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnoses_min_fields",
        "fields": [
          {
            "name": "diagnosisTypeCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnoses_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnosisTypes",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "diagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "diagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnosisTypes_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnosisTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnosisTypes_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnosisTypes_max_fields",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnosisTypes_min_fields",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "diagnosisTypes_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnosisTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreaAssignments",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_eventArea",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_eventAreas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreas",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventAreas_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreas_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventArea",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventAreaId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "events",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreaAssignments_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreaAssignments_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreaAssignments_max_fields",
        "fields": [
          {
            "name": "eventAreaId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreaAssignments_min_fields",
        "fields": [
          {
            "name": "eventAreaId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreaAssignments_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreas",
        "fields": [
          {
            "name": "_eventAreaAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventAreaAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreaAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreaAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreas_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreas",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreas_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreas_max_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreas_min_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventAreas_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreas",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventBeginnings",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "event",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventBeginnings_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventBeginnings",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventBeginnings_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventBeginnings_max_fields",
        "fields": [
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventBeginnings_min_fields",
        "fields": [
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventBeginnings_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventBeginnings",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventDiagnoses",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinationDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinationDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnosis",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "diagnoses",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "event",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "examinationDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventDiagnoses_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventDiagnoses_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventDiagnoses_max_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventDiagnoses_min_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventDiagnoses_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExaminationCounts",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "eventExaminationCounts_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_avg_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_max_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_min_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_stddev_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_stddev_pop_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_stddev_samp_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_sum_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_var_pop_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_var_samp_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExaminationCounts_variance_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExpirations",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "event",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExpirations_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExpirations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExpirations_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExpirations_max_fields",
        "fields": [
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExpirations_min_fields",
        "fields": [
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventExpirations_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExpirations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "event",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventLimitTimes",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_avg_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_max_fields",
        "fields": [
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_min_fields",
        "fields": [
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventLimitTimes",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_stddev_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_stddev_pop_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_stddev_samp_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_sum_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_var_pop_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_var_samp_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventLimitTimes_variance_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTagAssignments",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_eventTag",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_eventTags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTags",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventTags_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTags_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "eventTag",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventTagId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTagAssignments_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTagAssignments_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTagAssignments_max_fields",
        "fields": [
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventTagId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTagAssignments_min_fields",
        "fields": [
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventTagId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTagAssignments_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTags",
        "fields": [
          {
            "name": "_eventTagAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventTagAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTagAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTagAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTags_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTags",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTags_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTags_max_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTags_min_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "eventTags_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTags",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "events",
        "fields": [
          {
            "name": "_eventAreaAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventAreaAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreaAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventBeginning",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_eventBeginnings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventBeginnings",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventBeginnings_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventBeginnings_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventExpiration",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_eventExpirations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExpirations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventExpirations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventExpirations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventLimitTime",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_eventLimitTimes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventLimitTimes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventLimitTimes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventLimitTimes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventTagAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventTagAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTagAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_guestExaminees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_guestExaminees_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_inactiveGroupEvents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroupEvents",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_inactiveGroupEvents_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "inactiveGroupEvents_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "enableFileUpload",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "eventAreaAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreaAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventBeginning",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpiration",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventLimitTime",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventTagAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTagAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "fileUploadDescription",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "fileUploadType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "group",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groups",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "guestExaminees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExaminees_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "inactiveGroupEvent",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "public",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "events_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "events_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "events_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "events_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "events_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "events_max_fields",
        "fields": [
          {
            "name": "fileUploadDescription",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "fileUploadType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "events_min_fields",
        "fields": [
          {
            "name": "fileUploadDescription",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "fileUploadType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "events_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnoses",
        "fields": [
          {
            "name": "_eventDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_eventDiagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_examination",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_examinationDiagnosisAnswers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinationDiagnosisAnswers_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisAnswers_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "eventDiagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "examination",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "examinationDiagnosisAnswers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisAnswers_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisScores",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisScores_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisScores_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "personalityDiagnosisResult",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "resilienceDiagnosisResult",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stressDiagnosisResult",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnoses_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnoses_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnoses_max_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnoses_min_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnoses_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisAnswers",
        "fields": [
          {
            "name": "_examinationDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinationDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinationDiagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_questionChoices",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionChoices",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_questionChoices_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionChoices_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_questions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_questions_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questions_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "examinationDiagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "question",
            "type": {
              "kind": "OBJECT",
              "name": "questions",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "questionChoice",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "questionChoiceId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisAnswers_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisAnswers_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisAnswers_max_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionChoiceId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisAnswers_min_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionChoiceId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisAnswers_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationDiagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "scoreType",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "scoreTypeCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisScores_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_avg_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_max_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "scoreTypeCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_min_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "scoreTypeCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_stddev_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_stddev_pop_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_stddev_samp_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_sum_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_var_pop_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_var_samp_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinationDiagnosisScores_variance_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinationDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinationDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_guestExamineeExamination",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_guestExamineeExaminations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExamineeExaminations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_guestExamineeExaminations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExamineeExaminations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "age",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "examinationDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "gender",
            "type": {
              "kind": "OBJECT",
              "name": "genders",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "genderCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "guestExamineeExamination",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "memo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "telephone",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_avg_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_max_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "memo",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "telephone",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_min_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "memo",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "telephone",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_stddev_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_stddev_pop_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_stddev_samp_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_sum_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_var_pop_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_var_samp_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "examinations_variance_fields",
        "fields": [
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "genders",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "examinations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "translatedGenders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "translatedGenders_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "genders_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "genders_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "genders",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "genders_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "genders_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "genders_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "genders_max_fields",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "genders_min_fields",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "genders_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "genders",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupContents",
        "fields": [
          {
            "name": "_groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_groups_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groups_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "imagePath",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupContents_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupContents",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupContents_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupContents_max_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "imagePath",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupContents_min_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "imagePath",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupContents_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupContents",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupInvitations",
        "fields": [
          {
            "name": "_memberships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_memberships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "membership",
            "type": {
              "kind": "OBJECT",
              "name": "memberships",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ownerships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupInvitations_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupInvitations_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupInvitations_max_fields",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupInvitations_min_fields",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groupInvitations_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groups",
        "fields": [
          {
            "name": "_groupContents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupContents",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_groupContents_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupContents_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_inactiveGroups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_inactiveGroups_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "inactiveGroups_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreas",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreas_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreas_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventBeginnings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventBeginnings",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventBeginnings_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventBeginnings_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpirations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExpirations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpirations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventExpirations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventLimitTimes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventLimitTimes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTags",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTags_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTags_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupContent",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupInvitations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "inactiveGroup",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "memberships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "memberships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ownerships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groups_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "groups_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groups_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "groups_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "groups_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groups_max_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groups_min_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "groups_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExamineeExaminations",
        "fields": [
          {
            "name": "_examination",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_examinations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_examinations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_guestExaminee",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_guestExaminees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_guestExaminees_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examination",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "guestExaminee",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "guestExamineeId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExamineeExaminations_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExamineeExaminations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExamineeExaminations_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExamineeExaminations_max_fields",
        "fields": [
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "guestExamineeId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExamineeExaminations_min_fields",
        "fields": [
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "guestExamineeId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExamineeExaminations_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExamineeExaminations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExaminees",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_guestExamineeExamination",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_guestExamineeExaminations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExamineeExaminations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_guestExamineeExaminations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExamineeExaminations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "emailGuestExaminees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "emailGuestExaminees_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "event",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventGuestExaminees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventGuestExaminees_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "groupGuestExaminees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupGuestExaminees_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "guestExamineeExamination",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExaminees_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExaminees_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExaminees_max_fields",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExaminees_min_fields",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "guestExaminees_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroupEvents",
        "fields": [
          {
            "name": "_event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "_events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "event",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroupEvents_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroupEvents",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroupEvents_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroupEvents_max_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroupEvents_min_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroupEvents_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroupEvents",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroups",
        "fields": [
          {
            "name": "_groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_groups_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groups_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroups_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroups",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroups_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroups_max_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroups_min_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "inactiveGroups_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroups",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "languages",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "translatedGenders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "translatedGenders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "translatedGenders_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "languages_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "languages_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "languages",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "languages_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "languages_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "languages_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "languages_max_fields",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "languages_min_fields",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "languages_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "languages",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "memberships",
        "fields": [
          {
            "name": "_groupInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_groupInvitations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_ownerships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_ownerships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "groupInvitation",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "memberships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "memberships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownership",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ownerships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "memberships_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "memberships_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "memberships_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "memberships_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "memberships_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "memberships_max_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "memberships_min_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "memberships_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "month",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "monthlyExaminationCounts",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "monthlyExaminationCounts_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_avg_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_max_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "month",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_min_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "month",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_stddev_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_stddev_pop_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_stddev_samp_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_sum_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_var_pop_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_var_samp_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "monthlyExaminationCounts_variance_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "mutation_root",
        "fields": [
          {
            "name": "InsertGuestExamineeMails",
            "type": {
              "kind": "OBJECT",
              "name": "InsertGuestExamineeMailsOutput",
              "ofType": null
            },
            "args": [
              {
                "name": "guestExamineeIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "InsertGuestExamineesDerived",
            "type": {
              "kind": "OBJECT",
              "name": "InsertGuestExamineesDerivedOutput",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "guestExaminees",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "InsertMembershipsOneDerived",
            "type": {
              "kind": "OBJECT",
              "name": "InsertMembershipsOneDerivedOutput",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "isOwner",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "InsertStaffsOneDerived",
            "type": {
              "kind": "OBJECT",
              "name": "InsertStaffsOneDerivedOutput",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_diagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_diagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_diagnosisTypes",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_diagnosisTypes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventAreaAssignments",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventAreaAssignments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "eventAreaId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventAreas",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventAreas_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventBeginnings",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventBeginnings_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventDiagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventDiagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventExpirations",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventExpirations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventLimitTimes",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventLimitTimes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventTagAssignments",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventTagAssignments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventTagId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventTags",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_eventTags_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_events",
            "type": {
              "kind": "OBJECT",
              "name": "events_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_events_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_examinationDiagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_examinationDiagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "examinationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_examinationDiagnosisAnswers",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_examinationDiagnosisAnswers_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "examinationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "questionId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_examinations",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_examinations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_genders",
            "type": {
              "kind": "OBJECT",
              "name": "genders_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_genders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "genders",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_groupContents",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_groupContents_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_groupInvitations",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_groupInvitations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_groups",
            "type": {
              "kind": "OBJECT",
              "name": "groups_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_groups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_guestExamineeExaminations",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_guestExamineeExaminations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": [
              {
                "name": "guestExamineeId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_guestExaminees",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_guestExaminees_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_inactiveGroupEvents",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_inactiveGroupEvents_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_inactiveGroups",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_inactiveGroups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_languages",
            "type": {
              "kind": "OBJECT",
              "name": "languages_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_languages_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "languages",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_memberships",
            "type": {
              "kind": "OBJECT",
              "name": "memberships_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_memberships_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "memberships",
              "ofType": null
            },
            "args": [
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_ownerships",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_ownerships_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships",
              "ofType": null
            },
            "args": [
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_questionChoices",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_questionChoices_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_questionScores",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_questionScores_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores",
              "ofType": null
            },
            "args": [
              {
                "name": "questionChoiceId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "scoreTypeCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_questions",
            "type": {
              "kind": "OBJECT",
              "name": "questions_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_questions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_scoreTypes",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_scoreTypes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_staffInvitations",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_staffInvitations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_staffs",
            "type": {
              "kind": "OBJECT",
              "name": "staffs_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_staffs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "staffs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_translatedGenders",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_translatedGenders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders",
              "ofType": null
            },
            "args": [
              {
                "name": "genderCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "languageCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_users",
            "type": {
              "kind": "OBJECT",
              "name": "users_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "delete_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "insert_diagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_diagnoses_one",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_diagnosisTypes",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_diagnosisTypes_one",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventAreaAssignments",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventAreaAssignments_one",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventAreas",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventAreas_one",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventBeginnings",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventBeginnings_one",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventDiagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventDiagnoses_one",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventExpirations",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventExpirations_one",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventLimitTimes",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventLimitTimes_one",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventTagAssignments",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventTagAssignments_one",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventTags",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_eventTags_one",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_events",
            "type": {
              "kind": "OBJECT",
              "name": "events_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_events_one",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_examinationDiagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_examinationDiagnoses_one",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_examinationDiagnosisAnswers",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_examinationDiagnosisAnswers_one",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_examinations",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_examinations_one",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_genders",
            "type": {
              "kind": "OBJECT",
              "name": "genders_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_genders_one",
            "type": {
              "kind": "OBJECT",
              "name": "genders",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_groupContents",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_groupContents_one",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_groupInvitations",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_groupInvitations_one",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_groups",
            "type": {
              "kind": "OBJECT",
              "name": "groups_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_groups_one",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_guestExamineeExaminations",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_guestExamineeExaminations_one",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_guestExaminees",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_guestExaminees_one",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_inactiveGroupEvents",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_inactiveGroupEvents_one",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_inactiveGroups",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_inactiveGroups_one",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_languages",
            "type": {
              "kind": "OBJECT",
              "name": "languages_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_languages_one",
            "type": {
              "kind": "OBJECT",
              "name": "languages",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_memberships",
            "type": {
              "kind": "OBJECT",
              "name": "memberships_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_memberships_one",
            "type": {
              "kind": "OBJECT",
              "name": "memberships",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_ownerships",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_ownerships_one",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_questionChoices",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_questionChoices_one",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_questionScores",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_questionScores_one",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_questions",
            "type": {
              "kind": "OBJECT",
              "name": "questions_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_questions_one",
            "type": {
              "kind": "OBJECT",
              "name": "questions",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_scoreTypes",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_scoreTypes_one",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_staffInvitations",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_staffInvitations_one",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_staffs",
            "type": {
              "kind": "OBJECT",
              "name": "staffs_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_staffs_one",
            "type": {
              "kind": "OBJECT",
              "name": "staffs",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_translatedGenders",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_translatedGenders_one",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_users",
            "type": {
              "kind": "OBJECT",
              "name": "users_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "objects",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "insert_users_one",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": [
              {
                "name": "object",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "on_conflict",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "update_diagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_diagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_diagnoses_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "diagnoses_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_diagnosisTypes",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_diagnosisTypes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_diagnosisTypes_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "diagnosisTypes_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventAreaAssignments",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventAreaAssignments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventAreaAssignments_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreaAssignments_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventAreas",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventAreas_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventAreas_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreas_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventBeginnings",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventBeginnings_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventBeginnings_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventBeginnings_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventDiagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventDiagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventDiagnoses_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventDiagnoses_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventExpirations",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventExpirations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventExpirations_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventExpirations_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventLimitTimes",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_inc",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventLimitTimes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes",
              "ofType": null
            },
            "args": [
              {
                "name": "_inc",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventLimitTimes_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventLimitTimes_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventTagAssignments",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventTagAssignments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventTagAssignments_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTagAssignments_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventTags",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventTags_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_eventTags_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTags_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_events",
            "type": {
              "kind": "OBJECT",
              "name": "events_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_events_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_events_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinationDiagnoses",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinationDiagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinationDiagnoses_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnoses_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinationDiagnosisAnswers",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinationDiagnosisAnswers_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinationDiagnosisAnswers_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisAnswers_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinations",
            "type": {
              "kind": "OBJECT",
              "name": "examinations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_inc",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": [
              {
                "name": "_inc",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_examinations_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_genders",
            "type": {
              "kind": "OBJECT",
              "name": "genders_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_genders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "genders",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_genders_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "genders_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_groupContents",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_groupContents_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_groupContents_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupContents_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_groupInvitations",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_groupInvitations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_groupInvitations_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupInvitations_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_groups",
            "type": {
              "kind": "OBJECT",
              "name": "groups_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_groups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_groups_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "groups_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_guestExamineeExaminations",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_guestExamineeExaminations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_guestExamineeExaminations_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExamineeExaminations_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_guestExaminees",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_guestExaminees_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_guestExaminees_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_inactiveGroupEvents",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_inactiveGroupEvents_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_inactiveGroupEvents_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "inactiveGroupEvents_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_inactiveGroups",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_inactiveGroups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_inactiveGroups_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "inactiveGroups_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_languages",
            "type": {
              "kind": "OBJECT",
              "name": "languages_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_languages_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "languages",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_languages_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "languages_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_memberships",
            "type": {
              "kind": "OBJECT",
              "name": "memberships_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_memberships_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "memberships",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_memberships_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "memberships_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_ownerships",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_ownerships_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_ownerships_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_questionChoices",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_questionChoices_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_questionChoices_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionChoices_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_questionScores",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_inc",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_questionScores_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores",
              "ofType": null
            },
            "args": [
              {
                "name": "_inc",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_questionScores_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionScores_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_questions",
            "type": {
              "kind": "OBJECT",
              "name": "questions_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_questions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questions",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_questions_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "questions_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_scoreTypes",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_scoreTypes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_scoreTypes_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "scoreTypes_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_staffInvitations",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_staffInvitations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_staffInvitations_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffInvitations_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_staffs",
            "type": {
              "kind": "OBJECT",
              "name": "staffs_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_staffs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "staffs",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_staffs_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffs_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_translatedGenders",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_translatedGenders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_translatedGenders_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "translatedGenders_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "update_users",
            "type": {
              "kind": "OBJECT",
              "name": "users_mutation_response",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": [
              {
                "name": "_set",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pk_columns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "update_users_many",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "users_mutation_response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ownerships",
        "fields": [
          {
            "name": "_memberships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_memberships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "memberships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "group",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "membership",
            "type": {
              "kind": "OBJECT",
              "name": "memberships",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "memberships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "memberships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ownerships_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ownerships_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ownerships_max_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ownerships_min_fields",
        "fields": [
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ownerships_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords",
        "fields": [
          {
            "name": "basicCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResultCountsRecords",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResultCountsRecords_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_avg_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_max_fields",
        "fields": [
          {
            "name": "basicCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_min_fields",
        "fields": [
          {
            "name": "basicCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_stddev_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_stddev_pop_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_stddev_samp_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_sum_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_var_pop_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_var_samp_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResultCountsRecords_variance_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "basicCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationDiagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "personalityDiagnosisResults_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_avg_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_max_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "basicCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_min_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "basicCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_stddev_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_stddev_pop_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_stddev_samp_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_sum_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_var_pop_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_var_samp_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "personalityDiagnosisResults_variance_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "Att",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "E",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "F",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "N",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "O",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "query_root",
        "fields": [
          {
            "name": "diagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "diagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "diagnosisTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnosisTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnosisTypes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "diagnosisTypes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnosisTypes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreaAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "eventAreaId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventAreas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreas",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreas_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreas_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreas_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventBeginnings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventBeginnings",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventBeginnings_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventBeginnings_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventBeginnings_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventExaminationCounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExaminationCounts",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExaminationCounts_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventExaminationCounts_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpirations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExpirations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpirations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventExpirations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpirations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventLimitTimes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventLimitTimes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTagAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventTagId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventTags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTags",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTags_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTags_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTags_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "examinationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisAnswers_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "examinationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "questionId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisScores",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisScores_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisScores_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "genders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "genders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "genders_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "genders_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "genders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "genders",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "groupContents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupContents",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupContents_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupContents_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupContents_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "groupInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupInvitations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupInvitations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groups_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groups_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "guestExamineeExaminations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExamineeExaminations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExamineeExaminations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExamineeExaminations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExamineeExaminations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": [
              {
                "name": "guestExamineeId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "guestExaminees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExaminees_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExaminees_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "inactiveGroupEvents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroupEvents",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroupEvents_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "inactiveGroupEvents_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroupEvents_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "inactiveGroups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroups_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "inactiveGroups_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "languages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "languages",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "languages_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "languages_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "languages_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "languages",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "memberships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "memberships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "memberships",
              "ofType": null
            },
            "args": [
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "monthlyExaminationCounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "monthlyExaminationCounts",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "monthlyExaminationCounts_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "monthlyExaminationCounts_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships",
              "ofType": null
            },
            "args": [
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResultCountsRecords",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCountsRecords",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResultCountsRecords",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCountsRecords_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "personalityDiagnosisResultCountsRecords_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCounts_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "personalityDiagnosisResultCountsRecords_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResults_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "personalityDiagnosisResults_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionChoices",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionChoices",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionChoices_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionChoices_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionChoices_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "questionScores",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionScores_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionScores_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionScores_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores",
              "ofType": null
            },
            "args": [
              {
                "name": "questionChoiceId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "scoreTypeCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "questions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questions_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questions_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "resilienceDiagnosisResults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "resilienceDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "resilienceDiagnosisResults_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "resilienceDiagnosisResults_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "scoreTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "scoreTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "scoreTypes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "scoreTypes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "scoreTypes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "staffInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffInvitations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffInvitations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "staffs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffs_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffs_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "staffs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "stressDiagnosisResults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "stressDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "stressDiagnosisResults_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "stressDiagnosisResults_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "translatedGenders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "translatedGenders_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders",
              "ofType": null
            },
            "args": [
              {
                "name": "genderCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "languageCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionChoices",
        "fields": [
          {
            "name": "examinationDiagnosisAnswers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisAnswers_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "question",
            "type": {
              "kind": "OBJECT",
              "name": "questions",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "questionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questionScores",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionScores_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionScores_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "text",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionChoices_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionChoices",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionChoices_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionChoices_max_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionChoices_min_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionChoices_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionChoices",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questionChoice",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "questionChoiceId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "scoreType",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "scoreTypeCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_avg_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_max_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionChoiceId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "scoreTypeCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_min_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionChoiceId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "scoreTypeCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_stddev_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_stddev_pop_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_stddev_samp_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_sum_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_var_pop_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_var_samp_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questionScores_variance_fields",
        "fields": [
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questions",
        "fields": [
          {
            "name": "diagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "examinationDiagnosisAnswers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisAnswers_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questionChoices",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionChoices",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionChoices_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionChoices_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "text",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questions_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "questions_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questions",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questions_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "questions_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "questions_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questions_max_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questions_min_fields",
        "fields": [
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "questions_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questions",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "behavior",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationDiagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "resilienceDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "resilienceDiagnosisResults_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_avg_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_max_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "behavior",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_min_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "behavior",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_stddev_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_stddev_pop_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_stddev_samp_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_sum_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_var_pop_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_var_samp_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "resilienceDiagnosisResults_variance_fields",
        "fields": [
          {
            "name": "H1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "H4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "S4",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "proactiveness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "thoughtfulness",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "scoreTypes",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "diagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questionScores",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionScores_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionScores_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "scoreTypes_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "scoreTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "scoreTypes_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "scoreTypes_max_fields",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "scoreTypes_min_fields",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "scoreTypes_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "scoreTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffInvitations",
        "fields": [
          {
            "name": "_staffs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_staffs_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffs_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "staff",
            "type": {
              "kind": "OBJECT",
              "name": "staffs",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffInvitations_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffInvitations_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffInvitations_max_fields",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffInvitations_min_fields",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffInvitations_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffs",
        "fields": [
          {
            "name": "_staffInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_staffInvitations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_users_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "staffInvitation",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffs_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "staffs_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffs",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffs_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "staffs_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "staffs_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffs_max_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffs_min_fields",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "staffs_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffs",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationDiagnosis",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilienceGrade",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "stressDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "stressDiagnosisResults_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_avg_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_max_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilienceGrade",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_min_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "diagnosisId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "examinationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "groupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilienceGrade",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_stddev_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_stddev_pop_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_stddev_samp_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_sum_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_var_pop_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_var_samp_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "stressDiagnosisResults_variance_fields",
        "fields": [
          {
            "name": "A",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "B",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "C",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resilience",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "subscription_root",
        "fields": [
          {
            "name": "diagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "diagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "diagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "diagnoses_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnosisTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnosisTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnosisTypes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "diagnosisTypes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "diagnosisTypes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "diagnosisTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "diagnosisTypes_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "diagnosisTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreaAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreaAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "eventAreaId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventAreaAssignments_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreaAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreas",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreas_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventAreas_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventAreas_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventAreas",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventAreas_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventAreas",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventBeginnings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventBeginnings",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventBeginnings_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventBeginnings_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventBeginnings_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventBeginnings",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventBeginnings_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventBeginnings",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventDiagnoses_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExaminationCounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExaminationCounts",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExaminationCounts_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventExaminationCounts_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExaminationCounts_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExaminationCounts",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpirations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExpirations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpirations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventExpirations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventExpirations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventExpirations",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventExpirations_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventExpirations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventLimitTimes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventLimitTimes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventLimitTimes",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventLimitTimes_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventLimitTimes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTagAssignments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventTagAssignments",
              "ofType": null
            },
            "args": [
              {
                "name": "eventId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "eventTagId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventTagAssignments_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTagAssignments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTags",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTags_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "eventTags_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "eventTags_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "eventTags",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "eventTags_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "eventTags",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "events_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "events_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnoses_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnoses",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "examinationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "examinationDiagnoses_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnoses",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisAnswers_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinationDiagnosisAnswers",
              "ofType": null
            },
            "args": [
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "examinationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "questionId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisAnswers_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisAnswers",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisScores",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisScores_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinationDiagnosisScores_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinationDiagnosisScores_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinationDiagnosisScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "examinations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "examinations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "examinations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "examinations_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "examinations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "genders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "genders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "genders_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "genders_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "genders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "genders",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "genders_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "genders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupContents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupContents",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupContents_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupContents_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupContents_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groupContents",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "groupContents_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupContents",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupInvitations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupInvitations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groupInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "groupInvitations_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groups_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groups_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "groups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "groups_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExamineeExaminations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExamineeExaminations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExamineeExaminations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExamineeExaminations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExamineeExaminations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "guestExamineeExaminations",
              "ofType": null
            },
            "args": [
              {
                "name": "guestExamineeId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "guestExamineeExaminations_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExamineeExaminations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExaminees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExaminees_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "guestExaminees_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "guestExaminees_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "guestExaminees",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "guestExaminees_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "guestExaminees",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroupEvents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroupEvents",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroupEvents_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "inactiveGroupEvents_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroupEvents_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroupEvents",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "inactiveGroupEvents_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroupEvents",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroups_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "inactiveGroups_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "inactiveGroups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "inactiveGroups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "inactiveGroups_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "inactiveGroups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "languages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "languages",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "languages_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "languages_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "languages_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "languages",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "languages_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "languages",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "memberships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "memberships",
              "ofType": null
            },
            "args": [
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "memberships_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "monthlyExaminationCounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "monthlyExaminationCounts",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "monthlyExaminationCounts_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "monthlyExaminationCounts_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "monthlyExaminationCounts_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "monthlyExaminationCounts",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "ownerships",
              "ofType": null
            },
            "args": [
              {
                "name": "groupId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "ownerships_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResultCountsRecords",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCountsRecords",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResultCountsRecords",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCountsRecords_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "personalityDiagnosisResultCountsRecords_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCountsRecords_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResultCountsRecords",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResultCounts_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "personalityDiagnosisResultCountsRecords_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResults_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "personalityDiagnosisResults_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "personalityDiagnosisResults_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "personalityDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionChoices",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionChoices",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionChoices_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionChoices_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionChoices_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questionChoices",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "questionChoices_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionChoices",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionScores",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionScores_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questionScores_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questionScores_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questionScores",
              "ofType": null
            },
            "args": [
              {
                "name": "questionChoiceId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "scoreTypeCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "questionScores_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questionScores",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questions_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "questions_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "questions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "questions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "questions_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "questions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "resilienceDiagnosisResults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "resilienceDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "resilienceDiagnosisResults_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "resilienceDiagnosisResults_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "resilienceDiagnosisResults_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "resilienceDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "scoreTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "scoreTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "scoreTypes_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "scoreTypes_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "scoreTypes_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "scoreTypes",
              "ofType": null
            },
            "args": [
              {
                "name": "code",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "diagnosisId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "scoreTypes_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "scoreTypes",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffInvitations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffInvitations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "staffInvitations",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "staffInvitations_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffs_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffs_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staffs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "staffs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "staffs_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "stressDiagnosisResults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "stressDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "stressDiagnosisResults_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "stressDiagnosisResults_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "stressDiagnosisResults_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "stressDiagnosisResults",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "translatedGenders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "translatedGenders_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "translatedGenders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders",
              "ofType": null
            },
            "args": [
              {
                "name": "genderCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "languageCode",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "translatedGenders_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "translatedGenders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "users_stream",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "batch_size",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "cursor",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "translatedGenders",
        "fields": [
          {
            "name": "gender",
            "type": {
              "kind": "OBJECT",
              "name": "genders",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "genderCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "language",
            "type": {
              "kind": "OBJECT",
              "name": "languages",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "languageCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "translatedGenders_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "translatedGenders",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "translatedGenders_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "translatedGenders_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "translatedGenders_max_fields",
        "fields": [
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "translatedGenders_min_fields",
        "fields": [
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "translatedGenders_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "translatedGenders",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "users",
        "fields": [
          {
            "name": "_staffs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "staffs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "_staffs_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "staffs_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "groupInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "groupInvitations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "groupInvitations_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "groupInvitations_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "memberships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "memberships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "memberships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "memberships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ownerships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ownerships",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ownerships_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ownerships_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "staff",
            "type": {
              "kind": "OBJECT",
              "name": "staffs",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "uid",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "users_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "users_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "users",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "users_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "users_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "users_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "users_max_fields",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "uid",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "users_min_fields",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "uid",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "users_mutation_response",
        "fields": [
          {
            "name": "affected_rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "returning",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "users",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "Any"
      }
    ],
    "directives": []
  }
} as unknown as IntrospectionQuery;

export const DeleteClientUserDocument = gql`
    mutation DeleteClientUser($userId: uuid!, $groupId: uuid!) {
  delete_memberships_by_pk(userId: $userId, groupId: $groupId) {
    userId
    groupId
  }
}
    `;

export function useDeleteClientUserMutation() {
  return Urql.useMutation<DeleteClientUserMutation, DeleteClientUserMutationVariables>(DeleteClientUserDocument);
};
export const InsertClientUserDocument = gql`
    mutation InsertClientUser($groupId: uuid!, $email: String!, $name: String!, $isOwner: Boolean!) {
  InsertMembershipsOneDerived(
    email: $email
    groupId: $groupId
    isOwner: $isOwner
    name: $name
  ) {
    groupId
    userId
  }
}
    `;

export function useInsertClientUserMutation() {
  return Urql.useMutation<InsertClientUserMutation, InsertClientUserMutationVariables>(InsertClientUserDocument);
};
export const DeleteStaffDocument = gql`
    mutation DeleteStaff($id: uuid!) {
  delete_staffs_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteStaffMutation() {
  return Urql.useMutation<DeleteStaffMutation, DeleteStaffMutationVariables>(DeleteStaffDocument);
};
export const InsertStaffDocument = gql`
    mutation InsertStaff($email: String!, $name: String!) {
  InsertStaffsOneDerived(email: $email, name: $name) {
    id
    staffInvitation {
      email
      name
    }
  }
}
    `;

export function useInsertStaffMutation() {
  return Urql.useMutation<InsertStaffMutation, InsertStaffMutationVariables>(InsertStaffDocument);
};
export const InsertClientDocument = gql`
    mutation InsertClient($name: String!) {
  insert_groups_one(object: {name: $name}) {
    id
    name
  }
}
    `;

export function useInsertClientMutation() {
  return Urql.useMutation<InsertClientMutation, InsertClientMutationVariables>(InsertClientDocument);
};
export const FetchClientListDocument = gql`
    query FetchClientList {
  groups {
    id
    name
    memberships_aggregate {
      aggregate {
        count
      }
    }
    inactiveGroup {
      id
    }
  }
}
    `;

export function useFetchClientListQuery(options?: Omit<Urql.UseQueryArgs<FetchClientListQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchClientListQuery, FetchClientListQueryVariables>({ query: FetchClientListDocument, ...options });
};
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: uuid!) {
  delete_events_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteEventMutation() {
  return Urql.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument);
};
export const UpdateEventDocument = gql`
    mutation UpdateEvent($id: uuid!, $name: String!, $enableFileUpload: Boolean!, $fileUploadDescription: String!, $fileUploadType: String!, $areaObjects: [eventAreaAssignments_insert_input!]!, $tagObjects: [eventTagAssignments_insert_input!]!) {
  update_events_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, enableFileUpload: $enableFileUpload, fileUploadDescription: $fileUploadDescription, fileUploadType: $fileUploadType}
  ) {
    name
    enableFileUpload
    fileUploadDescription
    fileUploadType
  }
  insert_eventAreaAssignments(
    objects: $areaObjects
    on_conflict: {constraint: eventAreaAssignments_pkey}
  ) {
    affected_rows
  }
  insert_eventTagAssignments(
    objects: $tagObjects
    on_conflict: {constraint: eventTagAssignments_pkey}
  ) {
    affected_rows
  }
}
    `;

export function useUpdateEventMutation() {
  return Urql.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument);
};
export const InsertEventBeginningDocument = gql`
    mutation InsertEventBeginning($eventId: uuid!, $groupId: uuid!, $timestamp: timestamp!) {
  insert_eventBeginnings_one(
    object: {groupId: $groupId, eventId: $eventId, timestamp: $timestamp}
    on_conflict: {constraint: eventBeginnings_groupId_eventId_key, update_columns: timestamp}
  ) {
    eventId
    groupId
    timestamp
  }
}
    `;

export function useInsertEventBeginningMutation() {
  return Urql.useMutation<InsertEventBeginningMutation, InsertEventBeginningMutationVariables>(InsertEventBeginningDocument);
};
export const DeleteEventBeginningDocument = gql`
    mutation DeleteEventBeginning($eventId: uuid!) {
  delete_eventBeginnings_by_pk(eventId: $eventId) {
    eventId
    groupId
    timestamp
  }
}
    `;

export function useDeleteEventBeginningMutation() {
  return Urql.useMutation<DeleteEventBeginningMutation, DeleteEventBeginningMutationVariables>(DeleteEventBeginningDocument);
};
export const InsertEventExpirationDocument = gql`
    mutation InsertEventExpiration($eventId: uuid!, $groupId: uuid!, $timestamp: timestamp!) {
  insert_eventExpirations_one(
    object: {groupId: $groupId, eventId: $eventId, timestamp: $timestamp}
    on_conflict: {constraint: eventExpirations_groupId_eventId_key, update_columns: timestamp}
  ) {
    eventId
    groupId
    timestamp
  }
}
    `;

export function useInsertEventExpirationMutation() {
  return Urql.useMutation<InsertEventExpirationMutation, InsertEventExpirationMutationVariables>(InsertEventExpirationDocument);
};
export const DeleteEventExpirationDocument = gql`
    mutation DeleteEventExpiration($eventId: uuid!) {
  delete_eventExpirations_by_pk(eventId: $eventId) {
    eventId
    groupId
    timestamp
  }
}
    `;

export function useDeleteEventExpirationMutation() {
  return Urql.useMutation<DeleteEventExpirationMutation, DeleteEventExpirationMutationVariables>(DeleteEventExpirationDocument);
};
export const InsertEventLimitTimeDocument = gql`
    mutation InsertEventLimitTime($eventId: uuid!, $groupId: uuid!, $value: bigint!) {
  insert_eventLimitTimes_one(
    object: {groupId: $groupId, eventId: $eventId, value: $value}
    on_conflict: {constraint: eventLimitTimes_groupId_eventId_key, update_columns: value}
  ) {
    eventId
    groupId
    value
  }
}
    `;

export function useInsertEventLimitTimeMutation() {
  return Urql.useMutation<InsertEventLimitTimeMutation, InsertEventLimitTimeMutationVariables>(InsertEventLimitTimeDocument);
};
export const DeleteEventLimitTimeDocument = gql`
    mutation DeleteEventLimitTime($eventId: uuid!) {
  delete_eventLimitTimes_by_pk(eventId: $eventId) {
    eventId
    groupId
    value
  }
}
    `;

export function useDeleteEventLimitTimeMutation() {
  return Urql.useMutation<DeleteEventLimitTimeMutation, DeleteEventLimitTimeMutationVariables>(DeleteEventLimitTimeDocument);
};
export const InsertInactiveGroupEventDocument = gql`
    mutation InsertInactiveGroupEvent($id: uuid!, $groupId: uuid!) {
  insert_inactiveGroupEvents_one(object: {id: $id, groupId: $groupId}) {
    id
    groupId
  }
}
    `;

export function useInsertInactiveGroupEventMutation() {
  return Urql.useMutation<InsertInactiveGroupEventMutation, InsertInactiveGroupEventMutationVariables>(InsertInactiveGroupEventDocument);
};
export const DeleteInactiveGroupEventDocument = gql`
    mutation DeleteInactiveGroupEvent($id: uuid!) {
  delete_inactiveGroupEvents_by_pk(id: $id) {
    id
    groupId
  }
}
    `;

export function useDeleteInactiveGroupEventMutation() {
  return Urql.useMutation<DeleteInactiveGroupEventMutation, DeleteInactiveGroupEventMutationVariables>(DeleteInactiveGroupEventDocument);
};
export const InsertEventDocument = gql`
    mutation InsertEvent($object: events_insert_input!) {
  insert_events_one(object: $object) {
    id
    name
    eventTagAssignments {
      eventTag {
        name
      }
    }
    eventAreaAssignments {
      eventArea {
        name
      }
    }
  }
}
    `;

export function useInsertEventMutation() {
  return Urql.useMutation<InsertEventMutation, InsertEventMutationVariables>(InsertEventDocument);
};
export const DeleteExaminationDocument = gql`
    mutation DeleteExamination($guestExamineeId: uuid!, $examinationId: uuid!) {
  delete_guestExaminees_by_pk(id: $guestExamineeId) {
    id
  }
  delete_examinations_by_pk(id: $examinationId) {
    id
  }
}
    `;

export function useDeleteExaminationMutation() {
  return Urql.useMutation<DeleteExaminationMutation, DeleteExaminationMutationVariables>(DeleteExaminationDocument);
};
export const FetchDiagnoseListDocument = gql`
    query FetchDiagnoseList {
  diagnoses(order_by: {id: asc}) {
    id
    name
    questions_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

export function useFetchDiagnoseListQuery(options?: Omit<Urql.UseQueryArgs<FetchDiagnoseListQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchDiagnoseListQuery, FetchDiagnoseListQueryVariables>({ query: FetchDiagnoseListDocument, ...options });
};
export const FetchStaffListDocument = gql`
    query FetchStaffList {
  staffs(order_by: {id: asc}) {
    id
    staffInvitation {
      email
      name
    }
    user {
      email
      name
    }
  }
}
    `;

export function useFetchStaffListQuery(options?: Omit<Urql.UseQueryArgs<FetchStaffListQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchStaffListQuery, FetchStaffListQueryVariables>({ query: FetchStaffListDocument, ...options });
};
export const InsertGuestExamineesDocument = gql`
    mutation InsertGuestExaminees($eventId: uuid!, $groupId: uuid!, $guestExaminees: [InsertGuestExaineesDerivedInput!]!) {
  InsertGuestExamineesDerived(
    eventId: $eventId
    groupId: $groupId
    guestExaminees: $guestExaminees
  ) {
    guestExamineeIds
  }
}
    `;

export function useInsertGuestExamineesMutation() {
  return Urql.useMutation<InsertGuestExamineesMutation, InsertGuestExamineesMutationVariables>(InsertGuestExamineesDocument);
};
export const UpdateGuestExamineeDocument = gql`
    mutation UpdateGuestExaminee($id: uuid!, $email: String!, $name: String!) {
  guestExmaminee: update_guestExaminees_by_pk(
    pk_columns: {id: $id}
    _set: {email: $email, name: $name}
  ) {
    email
    name
  }
}
    `;

export function useUpdateGuestExamineeMutation() {
  return Urql.useMutation<UpdateGuestExamineeMutation, UpdateGuestExamineeMutationVariables>(UpdateGuestExamineeDocument);
};
export const InsertGuestExamineeMailsDocument = gql`
    mutation InsertGuestExamineeMails($guestExamineeIds: [uuid!]!) {
  mails: InsertGuestExamineeMails(guestExamineeIds: $guestExamineeIds) {
    guestExamineeIds
  }
}
    `;

export function useInsertGuestExamineeMailsMutation() {
  return Urql.useMutation<InsertGuestExamineeMailsMutation, InsertGuestExamineeMailsMutationVariables>(InsertGuestExamineeMailsDocument);
};
export const InsertGuestExamineeDocument = gql`
    mutation InsertGuestExaminee($eventId: uuid!, $groupId: uuid!, $guestExaminees: [InsertGuestExaineesDerivedInput!]!) {
  InsertGuestExamineesDerived(
    eventId: $eventId
    groupId: $groupId
    guestExaminees: $guestExaminees
  ) {
    guestExamineeIds
  }
}
    `;

export function useInsertGuestExamineeMutation() {
  return Urql.useMutation<InsertGuestExamineeMutation, InsertGuestExamineeMutationVariables>(InsertGuestExamineeDocument);
};
export const FetchGuestEventByIdDocument = gql`
    query FetchGuestEventById($eventId: uuid!, $guestExamineeIds: [uuid!] = []) {
  event: events_by_pk(id: $eventId) {
    id
    groupId
    name
    enableFileUpload
    fileUploadDescription
    fileUploadType
    public
    group {
      name
      groupContent {
        imagePath
      }
    }
    eventDiagnoses {
      diagnosis {
        name
        questions {
          diagnosis {
            name
          }
          text
          id
          diagnosisId
          questionChoices {
            text
            id
          }
        }
      }
    }
    guestExaminees(where: {id: {_in: $guestExamineeIds}}) {
      id
    }
  }
}
    `;

export function useFetchGuestEventByIdQuery(options: Omit<Urql.UseQueryArgs<FetchGuestEventByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchGuestEventByIdQuery, FetchGuestEventByIdQueryVariables>({ query: FetchGuestEventByIdDocument, ...options });
};
export const FetchGroupEventListDocument = gql`
    query FetchGroupEventList($groupId: uuid) {
  diagnoses(order_by: {id: asc}) {
    id
    name
  }
  events(order_by: {id: asc}, where: {groupId: {_eq: $groupId}}) {
    id
    name
    groupId
    group {
      name
    }
    eventTagAssignments(order_by: {eventTag: {name: asc}}) {
      eventTag {
        name
      }
    }
    inactiveGroupEvent {
      id
    }
    guestExaminees_aggregate {
      aggregate {
        count
      }
    }
    eventDiagnoses {
      diagnosis {
        name
      }
    }
  }
}
    `;

export function useFetchGroupEventListQuery(options?: Omit<Urql.UseQueryArgs<FetchGroupEventListQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchGroupEventListQuery, FetchGroupEventListQueryVariables>({ query: FetchGroupEventListDocument, ...options });
};
export const GroupExamineesDocument = gql`
    query GroupExaminees($limit: Int!, $offset: Int!, $where: guestExaminees_bool_exp!) {
  guestExaminees: guestExaminees_aggregate(
    distinct_on: [email, groupId]
    limit: $limit
    offset: $offset
    where: $where
  ) {
    aggregate {
      count
    }
    nodes {
      email
      guestExaminees_aggregate: groupGuestExaminees_aggregate {
        aggregate {
          count
        }
      }
      guestExaminees: groupGuestExaminees(
        limit: 1
        order_by: {guestExamineeExamination: {examination: {timestamp: desc}}}
      ) {
        name
        guestExamineeExamination {
          examination {
            timestamp
            id
          }
        }
      }
    }
  }
  guestExaminees_aggregate(distinct_on: [email, groupId], where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useGroupExamineesQuery(options: Omit<Urql.UseQueryArgs<GroupExamineesQueryVariables>, 'query'>) {
  return Urql.useQuery<GroupExamineesQuery, GroupExamineesQueryVariables>({ query: GroupExamineesDocument, ...options });
};
export const FetchClientDocument = gql`
    query FetchClient($id: uuid!) {
  group: groups_by_pk(id: $id) {
    id
    name
    groupContent {
      imagePath
    }
    inactiveGroup {
      id
    }
    memberships(order_by: {userId: asc}) {
      groupId
      userId
      groupInvitation {
        name
        email
      }
      user {
        name
        email
      }
    }
  }
}
    `;

export function useFetchClientQuery(options: Omit<Urql.UseQueryArgs<FetchClientQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchClientQuery, FetchClientQueryVariables>({ query: FetchClientDocument, ...options });
};
export const FetchEventDocument = gql`
    query FetchEvent($id: uuid!, $limit: Int!, $offset: Int!, $examinationsWhere: examinations_bool_exp!) {
  event: events_by_pk(id: $id) {
    id
    name
    enableFileUpload
    fileUploadDescription
    fileUploadType
    public
    group {
      id
      name
    }
    eventTagAssignments(order_by: {eventTag: {name: asc}}) {
      eventTag {
        name
      }
    }
    eventAreaAssignments(order_by: {eventArea: {name: asc}}) {
      eventArea {
        name
      }
    }
    eventBeginning {
      timestamp
    }
    eventExpiration {
      timestamp
    }
    eventLimitTime {
      value
    }
    inactiveGroupEvent {
      id
    }
    eventDiagnoses {
      diagnosis {
        id
        name
      }
    }
    examinations(
      limit: $limit
      offset: $offset
      order_by: {timestamp: desc}
      where: $examinationsWhere
    ) {
      id
      timestamp
      guestExamineeExamination {
        guestExaminee {
          email
          name
        }
      }
      examinationDiagnoses {
        diagnosisId
        personalityDiagnosisResult {
          A
          Att
          C
          E
          F
          N
          O
          basicCode
          code
        }
        resilienceDiagnosisResult {
          proactiveness
          thoughtfulness
        }
        stressDiagnosisResult {
          A
          B
          C
        }
      }
    }
    guestExaminees {
      id
      email
      name
    }
    examinations_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

export function useFetchEventQuery(options: Omit<Urql.UseQueryArgs<FetchEventQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchEventQuery, FetchEventQueryVariables>({ query: FetchEventDocument, ...options });
};
export const FetchEventListDocument = gql`
    query FetchEventList {
  groups(order_by: {id: asc}) {
    id
    name
  }
  diagnoses(order_by: {id: asc}) {
    id
    name
  }
  events(order_by: {id: asc}) {
    id
    groupId
    name
    group {
      name
    }
    eventTagAssignments(order_by: {eventTag: {name: asc}}) {
      eventTag {
        name
      }
    }
    inactiveGroupEvent {
      id
    }
    guestExaminees_aggregate {
      aggregate {
        count
      }
    }
    eventDiagnoses {
      diagnosis {
        name
      }
    }
  }
}
    `;

export function useFetchEventListQuery(options?: Omit<Urql.UseQueryArgs<FetchEventListQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchEventListQuery, FetchEventListQueryVariables>({ query: FetchEventListDocument, ...options });
};
export const FetchExaminationByIdDocument = gql`
    query FetchExaminationById($examinationId: uuid!) {
  examination: examinations_by_pk(id: $examinationId) {
    id
    eventId
    groupId
    event {
      name
      group {
        name
      }
      enableFileUpload
    }
    timestamp
    guestExamineeExamination {
      guestExaminee {
        name
        email
      }
    }
    gender {
      translatedGenders {
        text
        languageCode
      }
    }
    examinationDiagnoses {
      diagnosisId
      eventDiagnosis {
        diagnosis {
          name
        }
      }
      examinationDiagnosisAnswers {
        question {
          text
          questionChoices {
            text
            id
            questionScores {
              scoreTypeCode
              value
            }
          }
        }
        questionChoiceId
      }
      personalityDiagnosisResult {
        A
        Att
        C
        E
        F
        N
        O
        basicCode
        code
      }
      resilienceDiagnosisResult {
        thoughtfulness
        proactiveness
        behavior
        S4
        S3
        S2
        S1
        H4
        H3
        H2
        H1
      }
      stressDiagnosisResult {
        A
        B
        C
        resilience
        resilienceGrade
      }
    }
  }
}
    `;

export function useFetchExaminationByIdQuery(options: Omit<Urql.UseQueryArgs<FetchExaminationByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchExaminationByIdQuery, FetchExaminationByIdQueryVariables>({ query: FetchExaminationByIdDocument, ...options });
};
export const FetchExaminationsDocument = gql`
    query FetchExaminations($email: String!) {
  examinations(
    where: {guestExamineeExamination: {guestExaminee: {email: {_eq: $email}}}}
  ) {
    id
    timestamp
    guestExamineeExamination {
      guestExaminee {
        id
        name
        email
      }
    }
    group {
      name
    }
    event {
      name
      eventDiagnoses {
        diagnosis {
          name
        }
      }
    }
  }
}
    `;

export function useFetchExaminationsQuery(options: Omit<Urql.UseQueryArgs<FetchExaminationsQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchExaminationsQuery, FetchExaminationsQueryVariables>({ query: FetchExaminationsDocument, ...options });
};
export const ExamineesDocument = gql`
    query Examinees($limit: Int!, $offset: Int!, $where: guestExaminees_bool_exp!) {
  guestExaminees: guestExaminees_aggregate(
    distinct_on: [email]
    limit: $limit
    offset: $offset
    where: $where
  ) {
    nodes {
      email
      guestExaminees_aggregate: emailGuestExaminees_aggregate {
        aggregate {
          count
        }
      }
      guestExaminees: emailGuestExaminees(
        limit: 1
        order_by: {guestExamineeExamination: {examination: {timestamp: desc}}, email: asc}
      ) {
        name
        guestExamineeExamination {
          examination {
            timestamp
            id
          }
        }
      }
    }
  }
  guestExaminees_aggregate(distinct_on: [email], where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useExamineesQuery(options: Omit<Urql.UseQueryArgs<ExamineesQueryVariables>, 'query'>) {
  return Urql.useQuery<ExamineesQuery, ExamineesQueryVariables>({ query: ExamineesDocument, ...options });
};
export const StaffDashboardDocument = gql`
    query StaffDashboard {
  groups_aggregate {
    aggregate {
      count
    }
  }
  memberships_aggregate {
    aggregate {
      count
    }
  }
  diagnoses_aggregate {
    aggregate {
      count
    }
  }
}
    `;

export function useStaffDashboardQuery(options?: Omit<Urql.UseQueryArgs<StaffDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<StaffDashboardQuery, StaffDashboardQueryVariables>({ query: StaffDashboardDocument, ...options });
};
export const UserDashboardDocument = gql`
    query UserDashboard($groupId: uuid!) {
  personalityDiagnosisResultCounts {
    groupId
    count
    basicCode
  }
  monthlyExaminationCounts(
    where: {groupId: {_eq: $groupId}}
    order_by: {month: desc}
  ) {
    month
    groupId
    count
  }
  group: groups_by_pk(id: $groupId) {
    events {
      name
      examinations_aggregate {
        aggregate {
          count
        }
      }
    }
    examinations(order_by: {timestamp: desc}, limit: 10) {
      id
      event {
        name
      }
      guestExamineeExamination {
        guestExaminee {
          name
          email
        }
      }
      timestamp
    }
  }
}
    `;

export function useUserDashboardQuery(options: Omit<Urql.UseQueryArgs<UserDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<UserDashboardQuery, UserDashboardQueryVariables>({ query: UserDashboardDocument, ...options });
};
export const InsertGroupContentDocument = gql`
    mutation InsertGroupContent($id: uuid!, $imagePath: String!) {
  insert_groupContents_one(object: {id: $id, imagePath: $imagePath}) {
    imagePath
  }
}
    `;

export function useInsertGroupContentMutation() {
  return Urql.useMutation<InsertGroupContentMutation, InsertGroupContentMutationVariables>(InsertGroupContentDocument);
};
export const InsertInactiveGroupDocument = gql`
    mutation InsertInactiveGroup($id: uuid!) {
  insert_inactiveGroups_one(object: {id: $id}) {
    id
  }
}
    `;

export function useInsertInactiveGroupMutation() {
  return Urql.useMutation<InsertInactiveGroupMutation, InsertInactiveGroupMutationVariables>(InsertInactiveGroupDocument);
};
export const DeleteInactiveGroupDocument = gql`
    mutation DeleteInactiveGroup($id: uuid!) {
  delete_inactiveGroups_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteInactiveGroupMutation() {
  return Urql.useMutation<DeleteInactiveGroupMutation, DeleteInactiveGroupMutationVariables>(DeleteInactiveGroupDocument);
};
export const InsertExaminationDocument = gql`
    mutation InsertExamination($guestExaminees: [guestExaminees_insert_input!]!, $examinations: [examinations_insert_input!]!) {
  insert_guestExaminees(objects: $guestExaminees) {
    affected_rows
  }
  insert_examinations(objects: $examinations) {
    affected_rows
  }
}
    `;

export function useInsertExaminationMutation() {
  return Urql.useMutation<InsertExaminationMutation, InsertExaminationMutationVariables>(InsertExaminationDocument);
};
export const FetchDiagnoseDocument = gql`
    query FetchDiagnose($id: uuid!) {
  diagnose: diagnoses_by_pk(id: $id) {
    id
    name
    questions {
      id
      text
      questionChoices {
        text
        questionScores {
          scoreTypeCode
          value
        }
      }
    }
  }
}
    `;

export function useFetchDiagnoseQuery(options: Omit<Urql.UseQueryArgs<FetchDiagnoseQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchDiagnoseQuery, FetchDiagnoseQueryVariables>({ query: FetchDiagnoseDocument, ...options });
};
export const FetchUserByPkDocument = gql`
    query FetchUserByPk($id: uuid!) {
  users_by_pk(id: $id) {
    id
    uid
    email
    name
    memberships {
      groupId
    }
  }
}
    `;

export function useFetchUserByPkQuery(options: Omit<Urql.UseQueryArgs<FetchUserByPkQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchUserByPkQuery, FetchUserByPkQueryVariables>({ query: FetchUserByPkDocument, ...options });
};
export const FetchMembershipsByUserIdDocument = gql`
    query FetchMembershipsByUserId($userId: uuid!) {
  memberships(where: {userId: {_eq: $userId}}, limit: 1) {
    groupId
  }
}
    `;

export function useFetchMembershipsByUserIdQuery(options: Omit<Urql.UseQueryArgs<FetchMembershipsByUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchMembershipsByUserIdQuery, FetchMembershipsByUserIdQueryVariables>({ query: FetchMembershipsByUserIdDocument, ...options });
};